"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj &&
        typeof Symbol === "function" &&
        obj.constructor === Symbol &&
        obj !== Symbol.prototype
        ? "symbol"
        : typeof obj;
    };
  }
  return _typeof(obj);
}

window.slate = window.slate || {};
window.theme = window.theme || {};
$.code = $.code || {};
/****************************************************************
 * Js imports
 ****************************************************************/

/* external scripts */

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function pageLinkFocus($element) {
    var focusClass = "js-focus-hidden";
    $element
      .first()
      .attr("tabIndex", "-1")
      .focus()
      .addClass(focusClass)
      .one("blur", callback);

    function callback() {
      $element.first().removeClass(focusClass).removeAttr("tabindex");
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function focusHash() {
    var hash = window.location.hash; // is there a hash in the url? is it an element on the page?

    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function bindInPageLinks() {
    $("a[href*=#]").on(
      "click",
      function (evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function trapFocus(options) {
    var eventName = options.namespace
      ? "focusin." + options.namespace
      : "focusin";

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr("tabindex", "-1");
    options.$elementToFocus.focus();
    $(document).on(eventName, function (evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function removeTrapFocus(options) {
    var eventName = options.namespace
      ? "focusin." + options.namespace
      : "focusin";

    if (options.$container && options.$container.length) {
      options.$container.removeAttr("tabindex");
    }

    $(document).off(eventName);
  },
};
/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function cookiesEnabled() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = "testcookie";
      cookieEnabled = document.cookie.indexOf("testcookie") !== -1;
    }

    return cookieEnabled;
  },
};
/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function findInstance(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function removeInstance(array, key, value) {
    var i = array.length;

    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function compact(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];

      if (value) {
        result[resIndex++] = value;
      }
    }

    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  },
};
/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {
  wrapTable: function wrapTable() {
    $(".content-text table").wrap('<div class="rte__table-wrapper"></div>');
  },
  iframeReset: function iframeReset() {
    var $iframeVideo = $(
      '.content-text iframe[src*="youtube.com/embed"], .content-text iframe[src*="player.vimeo"]'
    );
    var $iframeReset = $iframeVideo.add(
      ".content-text iframe#admin_bar_iframe"
    );
    $iframeVideo.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });
    $iframeReset.each(function () {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  },
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];
  $(document)
    .on("shopify:section:load", this._onSectionLoad.bind(this))
    .on("shopify:section:unload", this._onSectionUnload.bind(this))
    .on("shopify:section:select", this._onSelect.bind(this))
    .on("shopify:section:deselect", this._onDeselect.bind(this))
    .on("shopify:section:reorder", this._onReorder.bind(this))
    .on("shopify:block:select", this._onBlockSelect.bind(this))
    .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function _createInstance(container, constructor) {
    var $container = $(container);
    var id = $container.attr("data-section-id");
    var type = $container.attr("data-section-type");
    constructor = constructor || this.constructors[type];

    if (typeof constructor === "undefined") {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });
    this.instances.push(instance);
  },
  _onSectionLoad: function _onSectionLoad(evt) {
    var container = $("[data-section-id]", evt.target)[0];

    if (container) {
      this._createInstance(container);
    }
  },
  _onSectionUnload: function _onSectionUnload(evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === "function") {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );
  },
  _onSelect: function _onSelect(evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onSelect === "function") {
      instance.onSelect(evt);
    }
  },
  _onDeselect: function _onDeselect(evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onDeselect === "function") {
      instance.onDeselect(evt);
    }
  },
  _onReorder: function _onReorder(evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onReorder === "function") {
      instance.onReorder(evt);
    }
  },
  _onBlockSelect: function _onBlockSelect(evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onBlockSelect === "function") {
      instance.onBlockSelect(evt);
    }
  },
  _onBlockDeselect: function _onBlockDeselect(evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onBlockDeselect === "function") {
      instance.onBlockDeselect(evt);
    }
  },
  register: function register(type, constructor) {
    this.constructors[type] = constructor;
    $("[data-section-type=" + type + "]").each(
      function (index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});
/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = "${{amount}}";
  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */

  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }

    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;
    var moneyCentsDelimiter = theme.moneyCentsDelimiter;
    var moneyThousandsDelimiter = theme.moneyThousandsDelimiter;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, moneyThousandsDelimiter);
      decimal = slate.utils.defaultTo(decimal, moneyCentsDelimiter);

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);
      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;

      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;

      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", moneyCentsDelimiter);
        break;

      case "amount_with_comma_separator":
        value = formatWithDelimiters(
          cents,
          2,
          moneyThousandsDelimiter,
          moneyCentsDelimiter
        );
        break;

      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(
          cents,
          0,
          moneyThousandsDelimiter,
          moneyCentsDelimiter
        );
        break;

      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney,
  };
})();
/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */
  function preload(images, size) {
    if (typeof images === "string") {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }
  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */

  function loadImage(path) {
    new Image().src = path;
  }
  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */

  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
    );

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }
  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */

  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === "master") {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];
      return this.removeProtocol(prefix[0] + "_" + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, "");
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol,
  };
})();
/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    $(this.$container).on(
      "change",
      this.singleOptionSelector,
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = $.extend({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function _getCurrentOptions() {
      var currentOptions = $.map(
        $(this.singleOptionSelector, this.$container),
        function (element) {
          var $element = $(element);
          var type = $element.attr("type");
          var currentOption = {};

          if (type === "radio" || type === "checkbox") {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data("index");
              $element.closest("label").addClass("checked");
              return currentOption;
            } else {
              $element.closest("label").removeClass("checked");
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data("index");
            return currentOption;
          }
        }
      ); // remove any unchecked input values if using radio buttons or checkboxes

      currentOptions = slate.utils.compact(currentOptions);
      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function _getVariantFromOptions() {
      var selectedValues = this._getCurrentOptions();

      var variants = this.product.variants;
      var found = false;
      variants.forEach(function (variant) {
        var satisfied = true;
        selectedValues.forEach(function (option) {
          if (satisfied) {
            satisfied = option.value === variant[option.index];
          }
        });

        if (satisfied) {
          found = variant;
        }
      });
      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function _onSelectChange() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: "variantChange",
        variant: variant,
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);

      this._updateImages(variant);

      this._updatePrice(variant);

      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function _updateImages(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantImageChange",
        variant: variant,
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function _updatePrice(variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantPriceChange",
        variant: variant,
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function _updateHistoryState(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?variant=" +
        variant.id;
      window.history.replaceState(
        {
          path: newurl,
        },
        "",
        newurl
      );
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function _updateMasterSelect(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
      this.$container.trigger({
        type: "masterSelectChange",
        variant: variant,
      });
    },
  });
  return Variants;
})();

$(document).ready(function () {
  var sections = new slate.Sections();
  sections.register("product", theme.Product); // Common a11y fixes

  slate.a11y.pageLinkFocus($(window.location.hash));
  $("[data-page-link-focus]").on("click", function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  }); // Wrap videos in div to force responsive layout.

  slate.rte.wrapTable();
  slate.rte.iframeReset(); // Apply a specific class to the html element for browser support of cookies.

  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className =
      document.documentElement.className.replace(
        "supports-no-cookies",
        "supports-cookies"
      );
  }
});
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function () {
  var selectors = {
    addToCart: "[data-add-to-cart]",
    addToCartText: "[data-add-to-cart-text]",
    comparePrice: "[data-compare-price]",
    comparePriceText: "[data-compare-text]",
    originalSelectorId: "[data-product-select]",
    priceWrapper: "[data-price-wrapper]",
    productFeaturedImage: "[data-product-featured-image]",
    productJson: "[data-product-json]",
    productPrice: "[data-product-price]",
    productThumbs: "[data-product-single-thumbnail]",
    productIsGiftCard: "[data-product-is-gift-card]",
    outOfStockMessage: "[data-product-out-of-stock-message]",
    outOfStockButton: "[data-product-out-of-stock-button]",
    singleOptionSelector: "[data-single-option-selector]",
  };
  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */

  function Product(container) {
    this.$container = $(container); // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor

    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr("data-section-id");
    this.productSingleObject = JSON.parse(
      $(selectors.productJson, this.$container).html()
    );
    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data("enable-history-state") || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject,
      outOfStockMessage: selectors.outOfStockMessage,
    };
    this.settings = {};
    this.namespace = ".product";
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);
    this.$container.on(
      "variantChange" + this.namespace,
      this.updateAddToCartState.bind(this)
    );
    this.$container.on(
      "variantPriceChange" + this.namespace,
      this.updateProductPrices.bind(this)
    );

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(
        this.$featuredImage.attr("src")
      );
      slate.Image.preload(
        this.productSingleObject.images,
        this.settings.imageSize
      );
      this.$container.on(
        "variantImageChange" + this.namespace,
        this.updateProductImage.bind(this)
      );
    } // Trigger click event when using the email when available option

    $(selectors.outOfStockButton, this.$container).on("click", function () {
      $(".BIS_trigger").trigger("click");
    });
  }

  Product.prototype = $.extend({}, Product.prototype, {
    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function updateAddToCartState(evt) {
      var variant = evt.variant;
      var isGiftCardProduct = $(selectors.productIsGiftCard);

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass("hide");
      } else {
        $(selectors.addToCart, this.$container).prop("disabled", true);
        $(selectors.addToCartText, this.$container).html(
          theme.strings.unavailable
        );
        $(selectors.priceWrapper, this.$container).addClass("hide");
        return;
      } // if product is gift card product do not update add to cart button

      if (isGiftCardProduct.length === 1) {
        return;
      } else if (variant.available && isGiftCardProduct.length === 0) {
        $(selectors.addToCart, this.$container)
          .prop("disabled", false)
          .removeClass("hidden");
        $(selectors.outOfStockMessage, this.$container).addClass("hidden");
        $(selectors.outOfStockButton, this.$container).addClass("hidden");
        $(selectors.addToCartText, this.$container).html(
          theme.strings.addToCart
        );
      } else {
        $(selectors.addToCart, this.$container)
          .prop("disabled", true)
          .addClass("hidden");
        $(selectors.outOfStockButton, this.$container).removeClass("hidden");
        $(selectors.outOfStockMessage, this.$container).removeClass("hidden");
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function updateProductPrices(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(
        selectors.comparePriceText,
        this.$container
      );
      $(selectors.productPrice, this.$container).html(
        slate.Currency.formatMoney(variant.price, theme.moneyFormat)
      );

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(
          slate.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          )
        );
        $compareEls.removeClass("hide");
      } else {
        $comparePrice.html("");
        $compareEls.addClass("hide");
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function updateProductImage(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(
        variant.featured_image.src,
        this.settings.imageSize
      ); // this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function onUnload() {
      this.$container.off(this.namespace);
    },
  });
  return Product;
})();
/*!
 * getParameterByName.min.js
 */

function getParameterByName(e, n) {
  n || (n = window.location.href), (e = e.replace(/[\[\]]/g, "\\$&"));
  var r = new RegExp("[?&]" + e + "(=([^&#]*)|&|#|$)").exec(n);
  return r ? (r[2] ? decodeURIComponent(r[2].replace(/\+/g, " ")) : "") : null;
} // ==================================================
// fancyBox v3.5.6
//
// Licensed GPLv3 for open source use
// or fancyBox Commercial License for commercial use
//
// http://fancyapps.com/fancybox/
// Copyright 2018 fancyApps
//
// ==================================================

!(function (t, e, n, o) {
  "use strict";

  function i(t, e) {
    var o,
      i,
      a,
      s = [],
      r = 0;
    (t && t.isDefaultPrevented()) ||
      (t.preventDefault(),
      (e = e || {}),
      t && t.data && (e = h(t.data.options, e)),
      (o = e.$target || n(t.currentTarget).trigger("blur")),
      ((a = n.fancybox.getInstance()) && a.$trigger && a.$trigger.is(o)) ||
        (e.selector
          ? (s = n(e.selector))
          : ((i = o.attr("data-fancybox") || ""),
            i
              ? ((s = t.data ? t.data.items : []),
                (s = s.length
                  ? s.filter('[data-fancybox="' + i + '"]')
                  : n('[data-fancybox="' + i + '"]')))
              : (s = [o])),
        (r = n(s).index(o)),
        r < 0 && (r = 0),
        (a = n.fancybox.open(s, e, r)),
        (a.$trigger = o)));
  }

  if (
    ((t.console = t.console || {
      info: function info(t) {},
    }),
    n)
  ) {
    if (n.fn.fancybox) return void console.info("fancyBox already initialized");

    var a = {
        closeExisting: !1,
        loop: !1,
        gutter: 50,
        keyboard: !0,
        preventCaptionOverlap: !0,
        arrows: !0,
        infobar: !0,
        smallBtn: "auto",
        toolbar: "auto",
        buttons: ["zoom", "slideShow", "thumbs", "close"],
        idleTime: 3,
        protect: !1,
        modal: !1,
        image: {
          preload: !1,
        },
        ajax: {
          settings: {
            data: {
              fancybox: !0,
            },
          },
        },
        iframe: {
          tpl: '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" allowfullscreen="allowfullscreen" allow="autoplay; fullscreen" src=""></iframe>',
          preload: !0,
          css: {},
          attr: {
            scrolling: "auto",
          },
        },
        video: {
          tpl: '<video class="fancybox-video" controls controlsList="nodownload" poster="{{poster}}"><source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!</video>',
          format: "",
          autoStart: !0,
        },
        defaultType: "image",
        animationEffect: "zoom",
        animationDuration: 366,
        zoomOpacity: "auto",
        transitionEffect: "fade",
        transitionDuration: 366,
        slideClass: "",
        baseClass: "",
        baseTpl:
          '<div class="fancybox-container" role="dialog" tabindex="-1"><div class="fancybox-bg"></div><div class="fancybox-inner"><div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div><div class="fancybox-toolbar">{{buttons}}</div><div class="fancybox-navigation">{{arrows}}</div><div class="fancybox-stage"></div><div class="fancybox-caption"><div class="fancybox-caption__body"></div></div></div></div>',
        spinnerTpl: '<div class="fancybox-loading"></div>',
        errorTpl: '<div class="fancybox-error"><p>{{ERROR}}</p></div>',
        btnTpl: {
          download:
            '<a download data-fancybox-download class="fancybox-button fancybox-button--download" title="{{DOWNLOAD}}" href="javascript:;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.62 17.09V19H5.38v-1.91zm-2.97-6.96L17 11.45l-5 4.87-5-4.87 1.36-1.32 2.68 2.64V5h1.92v7.77z"/></svg></a>',
          zoom: '<button data-fancybox-zoom class="fancybox-button fancybox-button--zoom" title="{{ZOOM}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.7 17.3l-3-3a5.9 5.9 0 0 0-.6-7.6 5.9 5.9 0 0 0-8.4 0 5.9 5.9 0 0 0 0 8.4 5.9 5.9 0 0 0 7.7.7l3 3a1 1 0 0 0 1.3 0c.4-.5.4-1 0-1.5zM8.1 13.8a4 4 0 0 1 0-5.7 4 4 0 0 1 5.7 0 4 4 0 0 1 0 5.7 4 4 0 0 1-5.7 0z"/></svg></button>',
          close:
            '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/></svg></button>',
          arrowLeft:
            '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"/></svg></div></button>',
          arrowRight:
            '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"/></svg></div></button>',
          smallBtn:
            '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg></button>',
        },
        parentEl: "body",
        hideScrollbar: !0,
        autoFocus: !0,
        backFocus: !0,
        trapFocus: !0,
        fullScreen: {
          autoStart: !1,
        },
        touch: {
          vertical: !0,
          momentum: !0,
        },
        hash: null,
        media: {},
        slideShow: {
          autoStart: !1,
          speed: 3e3,
        },
        thumbs: {
          autoStart: !1,
          hideOnClose: !0,
          parentEl: ".fancybox-container",
          axis: "y",
        },
        wheel: "auto",
        onInit: n.noop,
        beforeLoad: n.noop,
        afterLoad: n.noop,
        beforeShow: n.noop,
        afterShow: n.noop,
        beforeClose: n.noop,
        afterClose: n.noop,
        onActivate: n.noop,
        onDeactivate: n.noop,
        clickContent: function clickContent(t, e) {
          return "image" === t.type && "zoom";
        },
        clickSlide: "close",
        clickOutside: "close",
        dblclickContent: !1,
        dblclickSlide: !1,
        dblclickOutside: !1,
        mobile: {
          preventCaptionOverlap: !1,
          idleTime: !1,
          clickContent: function clickContent(t, e) {
            return "image" === t.type && "toggleControls";
          },
          clickSlide: function clickSlide(t, e) {
            return "image" === t.type ? "toggleControls" : "close";
          },
          dblclickContent: function dblclickContent(t, e) {
            return "image" === t.type && "zoom";
          },
          dblclickSlide: function dblclickSlide(t, e) {
            return "image" === t.type && "zoom";
          },
        },
        lang: "en",
        i18n: {
          en: {
            CLOSE: "Close",
            NEXT: "Next",
            PREV: "Previous",
            ERROR:
              "The requested content cannot be loaded. <br/> Please try again later.",
            PLAY_START: "Start slideshow",
            PLAY_STOP: "Pause slideshow",
            FULL_SCREEN: "Full screen",
            THUMBS: "Thumbnails",
            DOWNLOAD: "Download",
            SHARE: "Share",
            ZOOM: "Zoom",
          },
          de: {
            CLOSE: "Schlie&szlig;en",
            NEXT: "Weiter",
            PREV: "Zur&uuml;ck",
            ERROR:
              "Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es sp&auml;ter nochmal.",
            PLAY_START: "Diaschau starten",
            PLAY_STOP: "Diaschau beenden",
            FULL_SCREEN: "Vollbild",
            THUMBS: "Vorschaubilder",
            DOWNLOAD: "Herunterladen",
            SHARE: "Teilen",
            ZOOM: "Vergr&ouml;&szlig;ern",
          },
        },
      },
      s = n(t),
      r = n(e),
      c = 0,
      l = function l(t) {
        return t && t.hasOwnProperty && t instanceof n;
      },
      d = (function () {
        return (
          t.requestAnimationFrame ||
          t.webkitRequestAnimationFrame ||
          t.mozRequestAnimationFrame ||
          t.oRequestAnimationFrame ||
          function (e) {
            return t.setTimeout(e, 1e3 / 60);
          }
        );
      })(),
      u = (function () {
        return (
          t.cancelAnimationFrame ||
          t.webkitCancelAnimationFrame ||
          t.mozCancelAnimationFrame ||
          t.oCancelAnimationFrame ||
          function (e) {
            t.clearTimeout(e);
          }
        );
      })(),
      f = (function () {
        var t,
          n = e.createElement("fakeelement"),
          o = {
            transition: "transitionend",
            OTransition: "oTransitionEnd",
            MozTransition: "transitionend",
            WebkitTransition: "webkitTransitionEnd",
          };

        for (t in o) {
          if (void 0 !== n.style[t]) return o[t];
        }

        return "transitionend";
      })(),
      p = function p(t) {
        return t && t.length && t[0].offsetHeight;
      },
      h = function h(t, e) {
        var o = n.extend(!0, {}, t, e);
        return (
          n.each(e, function (t, e) {
            n.isArray(e) && (o[t] = e);
          }),
          o
        );
      },
      g = function g(t) {
        var o, i;
        return (
          !(!t || t.ownerDocument !== e) &&
          (n(".fancybox-container").css("pointer-events", "none"),
          (o = {
            x: t.getBoundingClientRect().left + t.offsetWidth / 2,
            y: t.getBoundingClientRect().top + t.offsetHeight / 2,
          }),
          (i = e.elementFromPoint(o.x, o.y) === t),
          n(".fancybox-container").css("pointer-events", ""),
          i)
        );
      },
      b = function b(t, e, o) {
        var i = this;
        (i.opts = h(
          {
            index: o,
          },
          n.fancybox.defaults
        )),
          n.isPlainObject(e) && (i.opts = h(i.opts, e)),
          n.fancybox.isMobile && (i.opts = h(i.opts, i.opts.mobile)),
          (i.id = i.opts.id || ++c),
          (i.currIndex = parseInt(i.opts.index, 10) || 0),
          (i.prevIndex = null),
          (i.prevPos = null),
          (i.currPos = 0),
          (i.firstRun = !0),
          (i.group = []),
          (i.slides = {}),
          i.addContent(t),
          i.group.length && i.init();
      };

    n.extend(b.prototype, {
      init: function init() {
        var o,
          i,
          a = this,
          s = a.group[a.currIndex],
          r = s.opts;
        r.closeExisting && n.fancybox.close(!0),
          n("body").addClass("fancybox-active"),
          !n.fancybox.getInstance() &&
            !1 !== r.hideScrollbar &&
            !n.fancybox.isMobile &&
            e.body.scrollHeight > t.innerHeight &&
            (n("head").append(
              '<style id="fancybox-style-noscroll" type="text/css">.compensate-for-scrollbar{margin-right:' +
                (t.innerWidth - e.documentElement.clientWidth) +
                "px;}</style>"
            ),
            n("body").addClass("compensate-for-scrollbar")),
          (i = ""),
          n.each(r.buttons, function (t, e) {
            i += r.btnTpl[e] || "";
          }),
          (o = n(
            a.translate(
              a,
              r.baseTpl
                .replace("{{buttons}}", i)
                .replace("{{arrows}}", r.btnTpl.arrowLeft + r.btnTpl.arrowRight)
            )
          )
            .attr("id", "fancybox-container-" + a.id)
            .addClass(r.baseClass)
            .data("FancyBox", a)
            .appendTo(r.parentEl)),
          (a.$refs = {
            container: o,
          }),
          [
            "bg",
            "inner",
            "infobar",
            "toolbar",
            "stage",
            "caption",
            "navigation",
          ].forEach(function (t) {
            a.$refs[t] = o.find(".fancybox-" + t);
          }),
          a.trigger("onInit"),
          a.activate(),
          a.jumpTo(a.currIndex);
      },
      translate: function translate(t, e) {
        var n = t.opts.i18n[t.opts.lang] || t.opts.i18n.en;
        return e.replace(/\{\{(\w+)\}\}/g, function (t, e) {
          return void 0 === n[e] ? t : n[e];
        });
      },
      addContent: function addContent(t) {
        var e,
          o = this,
          i = n.makeArray(t);
        n.each(i, function (t, e) {
          var i,
            a,
            s,
            r,
            c,
            l = {},
            d = {};
          n.isPlainObject(e)
            ? ((l = e), (d = e.opts || e))
            : "object" === n.type(e) && n(e).length
            ? ((i = n(e)),
              (d = i.data() || {}),
              (d = n.extend(!0, {}, d, d.options)),
              (d.$orig = i),
              (l.src = o.opts.src || d.src || i.attr("href")),
              l.type || l.src || ((l.type = "inline"), (l.src = e)))
            : (l = {
                type: "html",
                src: e + "",
              }),
            (l.opts = n.extend(!0, {}, o.opts, d)),
            n.isArray(d.buttons) && (l.opts.buttons = d.buttons),
            n.fancybox.isMobile &&
              l.opts.mobile &&
              (l.opts = h(l.opts, l.opts.mobile)),
            (a = l.type || l.opts.type),
            (r = l.src || ""),
            !a &&
              r &&
              ((s = r.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i))
                ? ((a = "video"),
                  l.opts.video.format ||
                    (l.opts.video.format =
                      "video/" + ("ogv" === s[1] ? "ogg" : s[1])))
                : r.match(
                    /(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i
                  )
                ? (a = "image")
                : r.match(/\.(pdf)((\?|#).*)?$/i)
                ? ((a = "iframe"),
                  (l = n.extend(!0, l, {
                    contentType: "pdf",
                    opts: {
                      iframe: {
                        preload: !1,
                      },
                    },
                  })))
                : "#" === r.charAt(0) && (a = "inline")),
            a ? (l.type = a) : o.trigger("objectNeedsType", l),
            l.contentType ||
              (l.contentType =
                n.inArray(l.type, ["html", "inline", "ajax"]) > -1
                  ? "html"
                  : l.type),
            (l.index = o.group.length),
            "auto" == l.opts.smallBtn &&
              (l.opts.smallBtn =
                n.inArray(l.type, ["html", "inline", "ajax"]) > -1),
            "auto" === l.opts.toolbar && (l.opts.toolbar = !l.opts.smallBtn),
            (l.$thumb = l.opts.$thumb || null),
            l.opts.$trigger &&
              l.index === o.opts.index &&
              ((l.$thumb = l.opts.$trigger.find("img:first")),
              l.$thumb.length && (l.opts.$orig = l.opts.$trigger)),
            (l.$thumb && l.$thumb.length) ||
              !l.opts.$orig ||
              (l.$thumb = l.opts.$orig.find("img:first")),
            l.$thumb && !l.$thumb.length && (l.$thumb = null),
            (l.thumb = l.opts.thumb || (l.$thumb ? l.$thumb[0].src : null)),
            "function" === n.type(l.opts.caption) &&
              (l.opts.caption = l.opts.caption.apply(e, [o, l])),
            "function" === n.type(o.opts.caption) &&
              (l.opts.caption = o.opts.caption.apply(e, [o, l])),
            l.opts.caption instanceof n ||
              (l.opts.caption =
                void 0 === l.opts.caption ? "" : l.opts.caption + ""),
            "ajax" === l.type &&
              ((c = r.split(/\s+/, 2)),
              c.length > 1 &&
                ((l.src = c.shift()), (l.opts.filter = c.shift()))),
            l.opts.modal &&
              (l.opts = n.extend(!0, l.opts, {
                trapFocus: !0,
                infobar: 0,
                toolbar: 0,
                smallBtn: 0,
                keyboard: 0,
                slideShow: 0,
                fullScreen: 0,
                thumbs: 0,
                touch: 0,
                clickContent: !1,
                clickSlide: !1,
                clickOutside: !1,
                dblclickContent: !1,
                dblclickSlide: !1,
                dblclickOutside: !1,
              })),
            o.group.push(l);
        }),
          Object.keys(o.slides).length &&
            (o.updateControls(),
            (e = o.Thumbs) && e.isActive && (e.create(), e.focus()));
      },
      addEvents: function addEvents() {
        var e = this;
        e.removeEvents(),
          e.$refs.container
            .on("click.fb-close", "[data-fancybox-close]", function (t) {
              t.stopPropagation(), t.preventDefault(), e.close(t);
            })
            .on(
              "touchstart.fb-prev click.fb-prev",
              "[data-fancybox-prev]",
              function (t) {
                t.stopPropagation(), t.preventDefault(), e.previous();
              }
            )
            .on(
              "touchstart.fb-next click.fb-next",
              "[data-fancybox-next]",
              function (t) {
                t.stopPropagation(), t.preventDefault(), e.next();
              }
            )
            .on("click.fb", "[data-fancybox-zoom]", function (t) {
              e[e.isScaledDown() ? "scaleToActual" : "scaleToFit"]();
            }),
          s.on("orientationchange.fb resize.fb", function (t) {
            t && t.originalEvent && "resize" === t.originalEvent.type
              ? (e.requestId && u(e.requestId),
                (e.requestId = d(function () {
                  e.update(t);
                })))
              : (e.current &&
                  "iframe" === e.current.type &&
                  e.$refs.stage.hide(),
                setTimeout(
                  function () {
                    e.$refs.stage.show(), e.update(t);
                  },
                  n.fancybox.isMobile ? 600 : 250
                ));
          }),
          r.on("keydown.fb", function (t) {
            var o = n.fancybox ? n.fancybox.getInstance() : null,
              i = o.current,
              a = t.keyCode || t.which;
            if (9 == a) return void (i.opts.trapFocus && e.focus(t));
            if (
              !(
                !i.opts.keyboard ||
                t.ctrlKey ||
                t.altKey ||
                t.shiftKey ||
                n(t.target).is("input,textarea,video,audio")
              )
            )
              return 8 === a || 27 === a
                ? (t.preventDefault(), void e.close(t))
                : 37 === a || 38 === a
                ? (t.preventDefault(), void e.previous())
                : 39 === a || 40 === a
                ? (t.preventDefault(), void e.next())
                : void e.trigger("afterKeydown", t, a);
          }),
          e.group[e.currIndex].opts.idleTime &&
            ((e.idleSecondsCounter = 0),
            r.on(
              "mousemove.fb-idle mouseleave.fb-idle mousedown.fb-idle touchstart.fb-idle touchmove.fb-idle scroll.fb-idle keydown.fb-idle",
              function (t) {
                (e.idleSecondsCounter = 0),
                  e.isIdle && e.showControls(),
                  (e.isIdle = !1);
              }
            ),
            (e.idleInterval = t.setInterval(function () {
              ++e.idleSecondsCounter >= e.group[e.currIndex].opts.idleTime &&
                !e.isDragging &&
                ((e.isIdle = !0), (e.idleSecondsCounter = 0), e.hideControls());
            }, 1e3)));
      },
      removeEvents: function removeEvents() {
        var e = this;
        s.off("orientationchange.fb resize.fb"),
          r.off("keydown.fb .fb-idle"),
          this.$refs.container.off(".fb-close .fb-prev .fb-next"),
          e.idleInterval &&
            (t.clearInterval(e.idleInterval), (e.idleInterval = null));
      },
      previous: function previous(t) {
        return this.jumpTo(this.currPos - 1, t);
      },
      next: function next(t) {
        return this.jumpTo(this.currPos + 1, t);
      },
      jumpTo: function jumpTo(t, e) {
        var o,
          i,
          a,
          s,
          r,
          c,
          l,
          d,
          u,
          f = this,
          h = f.group.length;

        if (!(f.isDragging || f.isClosing || (f.isAnimating && f.firstRun))) {
          if (
            ((t = parseInt(t, 10)),
            !(a = f.current ? f.current.opts.loop : f.opts.loop) &&
              (t < 0 || t >= h))
          )
            return !1;
          if (
            ((o = f.firstRun = !Object.keys(f.slides).length),
            (r = f.current),
            (f.prevIndex = f.currIndex),
            (f.prevPos = f.currPos),
            (s = f.createSlide(t)),
            h > 1 &&
              ((a || s.index < h - 1) && f.createSlide(t + 1),
              (a || s.index > 0) && f.createSlide(t - 1)),
            (f.current = s),
            (f.currIndex = s.index),
            (f.currPos = s.pos),
            f.trigger("beforeShow", o),
            f.updateControls(),
            (s.forcedDuration = void 0),
            n.isNumeric(e)
              ? (s.forcedDuration = e)
              : (e = s.opts[o ? "animationDuration" : "transitionDuration"]),
            (e = parseInt(e, 10)),
            (i = f.isMoved(s)),
            s.$slide.addClass("fancybox-slide--current"),
            o)
          )
            return (
              s.opts.animationEffect &&
                e &&
                f.$refs.container.css("transition-duration", e + "ms"),
              f.$refs.container.addClass("fancybox-is-open").trigger("focus"),
              f.loadSlide(s),
              void f.preload("image")
            );
          (c = n.fancybox.getTranslate(r.$slide)),
            (l = n.fancybox.getTranslate(f.$refs.stage)),
            n.each(f.slides, function (t, e) {
              n.fancybox.stop(e.$slide, !0);
            }),
            r.pos !== s.pos && (r.isComplete = !1),
            r.$slide.removeClass(
              "fancybox-slide--complete fancybox-slide--current"
            ),
            i
              ? ((u = c.left - (r.pos * c.width + r.pos * r.opts.gutter)),
                n.each(f.slides, function (t, o) {
                  o.$slide
                    .removeClass("fancybox-animated")
                    .removeClass(function (t, e) {
                      return (e.match(/(^|\s)fancybox-fx-\S+/g) || []).join(
                        " "
                      );
                    });
                  var i = o.pos * c.width + o.pos * o.opts.gutter;
                  n.fancybox.setTranslate(o.$slide, {
                    top: 0,
                    left: i - l.left + u,
                  }),
                    o.pos !== s.pos &&
                      o.$slide.addClass(
                        "fancybox-slide--" +
                          (o.pos > s.pos ? "next" : "previous")
                      ),
                    p(o.$slide),
                    n.fancybox.animate(
                      o.$slide,
                      {
                        top: 0,
                        left:
                          (o.pos - s.pos) * c.width +
                          (o.pos - s.pos) * o.opts.gutter,
                      },
                      e,
                      function () {
                        o.$slide
                          .css({
                            transform: "",
                            opacity: "",
                          })
                          .removeClass(
                            "fancybox-slide--next fancybox-slide--previous"
                          ),
                          o.pos === f.currPos && f.complete();
                      }
                    );
                }))
              : e &&
                s.opts.transitionEffect &&
                ((d =
                  "fancybox-animated fancybox-fx-" + s.opts.transitionEffect),
                r.$slide.addClass(
                  "fancybox-slide--" + (r.pos > s.pos ? "next" : "previous")
                ),
                n.fancybox.animate(
                  r.$slide,
                  d,
                  e,
                  function () {
                    r.$slide
                      .removeClass(d)
                      .removeClass(
                        "fancybox-slide--next fancybox-slide--previous"
                      );
                  },
                  !1
                )),
            s.isLoaded ? f.revealContent(s) : f.loadSlide(s),
            f.preload("image");
        }
      },
      createSlide: function createSlide(t) {
        var e,
          o,
          i = this;
        return (
          (o = t % i.group.length),
          (o = o < 0 ? i.group.length + o : o),
          !i.slides[t] &&
            i.group[o] &&
            ((e = n('<div class="fancybox-slide"></div>').appendTo(
              i.$refs.stage
            )),
            (i.slides[t] = n.extend(!0, {}, i.group[o], {
              pos: t,
              $slide: e,
              isLoaded: !1,
            })),
            i.updateSlide(i.slides[t])),
          i.slides[t]
        );
      },
      scaleToActual: function scaleToActual(t, e, o) {
        var i,
          a,
          s,
          r,
          c,
          l = this,
          d = l.current,
          u = d.$content,
          f = n.fancybox.getTranslate(d.$slide).width,
          p = n.fancybox.getTranslate(d.$slide).height,
          h = d.width,
          g = d.height;
        l.isAnimating ||
          l.isMoved() ||
          !u ||
          "image" != d.type ||
          !d.isLoaded ||
          d.hasError ||
          ((l.isAnimating = !0),
          n.fancybox.stop(u),
          (t = void 0 === t ? 0.5 * f : t),
          (e = void 0 === e ? 0.5 * p : e),
          (i = n.fancybox.getTranslate(u)),
          (i.top -= n.fancybox.getTranslate(d.$slide).top),
          (i.left -= n.fancybox.getTranslate(d.$slide).left),
          (r = h / i.width),
          (c = g / i.height),
          (a = 0.5 * f - 0.5 * h),
          (s = 0.5 * p - 0.5 * g),
          h > f &&
            ((a = i.left * r - (t * r - t)),
            a > 0 && (a = 0),
            a < f - h && (a = f - h)),
          g > p &&
            ((s = i.top * c - (e * c - e)),
            s > 0 && (s = 0),
            s < p - g && (s = p - g)),
          l.updateCursor(h, g),
          n.fancybox.animate(
            u,
            {
              top: s,
              left: a,
              scaleX: r,
              scaleY: c,
            },
            o || 366,
            function () {
              l.isAnimating = !1;
            }
          ),
          l.SlideShow && l.SlideShow.isActive && l.SlideShow.stop());
      },
      scaleToFit: function scaleToFit(t) {
        var e,
          o = this,
          i = o.current,
          a = i.$content;
        o.isAnimating ||
          o.isMoved() ||
          !a ||
          "image" != i.type ||
          !i.isLoaded ||
          i.hasError ||
          ((o.isAnimating = !0),
          n.fancybox.stop(a),
          (e = o.getFitPos(i)),
          o.updateCursor(e.width, e.height),
          n.fancybox.animate(
            a,
            {
              top: e.top,
              left: e.left,
              scaleX: e.width / a.width(),
              scaleY: e.height / a.height(),
            },
            t || 366,
            function () {
              o.isAnimating = !1;
            }
          ));
      },
      getFitPos: function getFitPos(t) {
        var e,
          o,
          i,
          a,
          s = this,
          r = t.$content,
          c = t.$slide,
          l = t.width || t.opts.width,
          d = t.height || t.opts.height,
          u = {};
        return (
          !!(t.isLoaded && r && r.length) &&
          ((e = n.fancybox.getTranslate(s.$refs.stage).width),
          (o = n.fancybox.getTranslate(s.$refs.stage).height),
          (e -=
            parseFloat(c.css("paddingLeft")) +
            parseFloat(c.css("paddingRight")) +
            parseFloat(r.css("marginLeft")) +
            parseFloat(r.css("marginRight"))),
          (o -=
            parseFloat(c.css("paddingTop")) +
            parseFloat(c.css("paddingBottom")) +
            parseFloat(r.css("marginTop")) +
            parseFloat(r.css("marginBottom"))),
          (l && d) || ((l = e), (d = o)),
          (i = Math.min(1, e / l, o / d)),
          (l *= i),
          (d *= i),
          l > e - 0.5 && (l = e),
          d > o - 0.5 && (d = o),
          "image" === t.type
            ? ((u.top =
                Math.floor(0.5 * (o - d)) + parseFloat(c.css("paddingTop"))),
              (u.left =
                Math.floor(0.5 * (e - l)) + parseFloat(c.css("paddingLeft"))))
            : "video" === t.contentType &&
              ((a =
                t.opts.width && t.opts.height ? l / d : t.opts.ratio || 16 / 9),
              d > l / a ? (d = l / a) : l > d * a && (l = d * a)),
          (u.width = l),
          (u.height = d),
          u)
        );
      },
      update: function update(t) {
        var e = this;
        n.each(e.slides, function (n, o) {
          e.updateSlide(o, t);
        });
      },
      updateSlide: function updateSlide(t, e) {
        var o = this,
          i = t && t.$content,
          a = t.width || t.opts.width,
          s = t.height || t.opts.height,
          r = t.$slide;
        o.adjustCaption(t),
          i &&
            (a || s || "video" === t.contentType) &&
            !t.hasError &&
            (n.fancybox.stop(i),
            n.fancybox.setTranslate(i, o.getFitPos(t)),
            t.pos === o.currPos && ((o.isAnimating = !1), o.updateCursor())),
          o.adjustLayout(t),
          r.length &&
            (r.trigger("refresh"),
            t.pos === o.currPos &&
              o.$refs.toolbar
                .add(o.$refs.navigation.find(".fancybox-button--arrow_right"))
                .toggleClass(
                  "compensate-for-scrollbar",
                  r.get(0).scrollHeight > r.get(0).clientHeight
                )),
          o.trigger("onUpdate", t, e);
      },
      centerSlide: function centerSlide(t) {
        var e = this,
          o = e.current,
          i = o.$slide;
        !e.isClosing &&
          o &&
          (i.siblings().css({
            transform: "",
            opacity: "",
          }),
          i
            .parent()
            .children()
            .removeClass("fancybox-slide--previous fancybox-slide--next"),
          n.fancybox.animate(
            i,
            {
              top: 0,
              left: 0,
              opacity: 1,
            },
            void 0 === t ? 0 : t,
            function () {
              i.css({
                transform: "",
                opacity: "",
              }),
                o.isComplete || e.complete();
            },
            !1
          ));
      },
      isMoved: function isMoved(t) {
        var e,
          o,
          i = t || this.current;
        return (
          !!i &&
          ((o = n.fancybox.getTranslate(this.$refs.stage)),
          (e = n.fancybox.getTranslate(i.$slide)),
          !i.$slide.hasClass("fancybox-animated") &&
            (Math.abs(e.top - o.top) > 0.5 || Math.abs(e.left - o.left) > 0.5))
        );
      },
      updateCursor: function updateCursor(t, e) {
        var o,
          i,
          a = this,
          s = a.current,
          r = a.$refs.container;
        s &&
          !a.isClosing &&
          a.Guestures &&
          (r.removeClass(
            "fancybox-is-zoomable fancybox-can-zoomIn fancybox-can-zoomOut fancybox-can-swipe fancybox-can-pan"
          ),
          (o = a.canPan(t, e)),
          (i = !!o || a.isZoomable()),
          r.toggleClass("fancybox-is-zoomable", i),
          n("[data-fancybox-zoom]").prop("disabled", !i),
          o
            ? r.addClass("fancybox-can-pan")
            : i &&
              ("zoom" === s.opts.clickContent ||
                (n.isFunction(s.opts.clickContent) &&
                  "zoom" == s.opts.clickContent(s)))
            ? r.addClass("fancybox-can-zoomIn")
            : s.opts.touch &&
              (s.opts.touch.vertical || a.group.length > 1) &&
              "video" !== s.contentType &&
              r.addClass("fancybox-can-swipe"));
      },
      isZoomable: function isZoomable() {
        var t,
          e = this,
          n = e.current;

        if (n && !e.isClosing && "image" === n.type && !n.hasError) {
          if (!n.isLoaded) return !0;
          if (
            (t = e.getFitPos(n)) &&
            (n.width > t.width || n.height > t.height)
          )
            return !0;
        }

        return !1;
      },
      isScaledDown: function isScaledDown(t, e) {
        var o = this,
          i = !1,
          a = o.current,
          s = a.$content;
        return (
          void 0 !== t && void 0 !== e
            ? (i = t < a.width && e < a.height)
            : s &&
              ((i = n.fancybox.getTranslate(s)),
              (i = i.width < a.width && i.height < a.height)),
          i
        );
      },
      canPan: function canPan(t, e) {
        var o = this,
          i = o.current,
          a = null,
          s = !1;
        return (
          "image" === i.type &&
            (i.isComplete || (t && e)) &&
            !i.hasError &&
            ((s = o.getFitPos(i)),
            void 0 !== t && void 0 !== e
              ? (a = {
                  width: t,
                  height: e,
                })
              : i.isComplete && (a = n.fancybox.getTranslate(i.$content)),
            a &&
              s &&
              (s =
                Math.abs(a.width - s.width) > 1.5 ||
                Math.abs(a.height - s.height) > 1.5)),
          s
        );
      },
      loadSlide: function loadSlide(t) {
        var e,
          o,
          i,
          a = this;

        if (!t.isLoading && !t.isLoaded) {
          if (((t.isLoading = !0), !1 === a.trigger("beforeLoad", t)))
            return (t.isLoading = !1), !1;

          switch (
            ((e = t.type),
            (o = t.$slide),
            o.off("refresh").trigger("onReset").addClass(t.opts.slideClass),
            e)
          ) {
            case "image":
              a.setImage(t);
              break;

            case "iframe":
              a.setIframe(t);
              break;

            case "html":
              a.setContent(t, t.src || t.content);
              break;

            case "video":
              a.setContent(
                t,
                t.opts.video.tpl
                  .replace(/\{\{src\}\}/gi, t.src)
                  .replace(
                    "{{format}}",
                    t.opts.videoFormat || t.opts.video.format || ""
                  )
                  .replace("{{poster}}", t.thumb || "")
              );
              break;

            case "inline":
              n(t.src).length ? a.setContent(t, n(t.src)) : a.setError(t);
              break;

            case "ajax":
              a.showLoading(t),
                (i = n.ajax(
                  n.extend({}, t.opts.ajax.settings, {
                    url: t.src,
                    success: function success(e, n) {
                      "success" === n && a.setContent(t, e);
                    },
                    error: function error(e, n) {
                      e && "abort" !== n && a.setError(t);
                    },
                  })
                )),
                o.one("onReset", function () {
                  i.abort();
                });
              break;

            default:
              a.setError(t);
          }

          return !0;
        }
      },
      setImage: function setImage(t) {
        var o,
          i = this;
        setTimeout(function () {
          var e = t.$image;
          i.isClosing ||
            !t.isLoading ||
            (e && e.length && e[0].complete) ||
            t.hasError ||
            i.showLoading(t);
        }, 50),
          i.checkSrcset(t),
          (t.$content = n('<div class="fancybox-content"></div>')
            .addClass("fancybox-is-hidden")
            .appendTo(t.$slide.addClass("fancybox-slide--image"))),
          !1 !== t.opts.preload &&
            t.opts.width &&
            t.opts.height &&
            t.thumb &&
            ((t.width = t.opts.width),
            (t.height = t.opts.height),
            (o = e.createElement("img")),
            (o.onerror = function () {
              n(this).remove(), (t.$ghost = null);
            }),
            (o.onload = function () {
              i.afterLoad(t);
            }),
            (t.$ghost = n(o)
              .addClass("fancybox-image")
              .appendTo(t.$content)
              .attr("src", t.thumb))),
          i.setBigImage(t);
      },
      checkSrcset: function checkSrcset(e) {
        var n,
          o,
          i,
          a,
          s = e.opts.srcset || e.opts.image.srcset;

        if (s) {
          (i = t.devicePixelRatio || 1),
            (a = t.innerWidth * i),
            (o = s.split(",").map(function (t) {
              var e = {};
              return (
                t
                  .trim()
                  .split(/\s+/)
                  .forEach(function (t, n) {
                    var o = parseInt(t.substring(0, t.length - 1), 10);
                    if (0 === n) return (e.url = t);
                    o && ((e.value = o), (e.postfix = t[t.length - 1]));
                  }),
                e
              );
            })),
            o.sort(function (t, e) {
              return t.value - e.value;
            });

          for (var r = 0; r < o.length; r++) {
            var c = o[r];

            if (
              ("w" === c.postfix && c.value >= a) ||
              ("x" === c.postfix && c.value >= i)
            ) {
              n = c;
              break;
            }
          }

          !n && o.length && (n = o[o.length - 1]),
            n &&
              ((e.src = n.url),
              e.width &&
                e.height &&
                "w" == n.postfix &&
                ((e.height = (e.width / e.height) * n.value),
                (e.width = n.value)),
              (e.opts.srcset = s));
        }
      },
      setBigImage: function setBigImage(t) {
        var o = this,
          i = e.createElement("img"),
          a = n(i);
        (t.$image = a
          .one("error", function () {
            o.setError(t);
          })
          .one("load", function () {
            var e;
            t.$ghost ||
              (o.resolveImageSlideSize(
                t,
                this.naturalWidth,
                this.naturalHeight
              ),
              o.afterLoad(t)),
              o.isClosing ||
                (t.opts.srcset &&
                  ((e = t.opts.sizes),
                  (e && "auto" !== e) ||
                    (e =
                      (t.width / t.height > 1 && s.width() / s.height() > 1
                        ? "100"
                        : Math.round((t.width / t.height) * 100)) + "vw"),
                  a.attr("sizes", e).attr("srcset", t.opts.srcset)),
                t.$ghost &&
                  setTimeout(function () {
                    t.$ghost && !o.isClosing && t.$ghost.hide();
                  }, Math.min(300, Math.max(1e3, t.height / 1600))),
                o.hideLoading(t));
          })
          .addClass("fancybox-image")
          .attr("src", t.src)
          .appendTo(t.$content)),
          (i.complete || "complete" == i.readyState) &&
          a.naturalWidth &&
          a.naturalHeight
            ? a.trigger("load")
            : i.error && a.trigger("error");
      },
      resolveImageSlideSize: function resolveImageSlideSize(t, e, n) {
        var o = parseInt(t.opts.width, 10),
          i = parseInt(t.opts.height, 10);
        (t.width = e),
          (t.height = n),
          o > 0 && ((t.width = o), (t.height = Math.floor((o * n) / e))),
          i > 0 && ((t.width = Math.floor((i * e) / n)), (t.height = i));
      },
      setIframe: function setIframe(t) {
        var e,
          o = this,
          i = t.opts.iframe,
          a = t.$slide;
        (t.$content = n(
          '<div class="fancybox-content' +
            (i.preload ? " fancybox-is-hidden" : "") +
            '"></div>'
        )
          .css(i.css)
          .appendTo(a)),
          a.addClass("fancybox-slide--" + t.contentType),
          (t.$iframe = e =
            n(i.tpl.replace(/\{rnd\}/g, new Date().getTime()))
              .attr(i.attr)
              .appendTo(t.$content)),
          i.preload
            ? (o.showLoading(t),
              e.on("load.fb error.fb", function (e) {
                (this.isReady = 1), t.$slide.trigger("refresh"), o.afterLoad(t);
              }),
              a.on("refresh.fb", function () {
                var n,
                  o,
                  s = t.$content,
                  r = i.css.width,
                  c = i.css.height;

                if (1 === e[0].isReady) {
                  try {
                    (n = e.contents()), (o = n.find("body"));
                  } catch (t) {}

                  o &&
                    o.length &&
                    o.children().length &&
                    (a.css("overflow", "visible"),
                    s.css({
                      width: "100%",
                      "max-width": "100%",
                      height: "9999px",
                    }),
                    void 0 === r &&
                      (r = Math.ceil(
                        Math.max(o[0].clientWidth, o.outerWidth(!0))
                      )),
                    s.css("width", r || "").css("max-width", ""),
                    void 0 === c &&
                      (c = Math.ceil(
                        Math.max(o[0].clientHeight, o.outerHeight(!0))
                      )),
                    s.css("height", c || ""),
                    a.css("overflow", "auto")),
                    s.removeClass("fancybox-is-hidden");
                }
              }))
            : o.afterLoad(t),
          e.attr("src", t.src),
          a.one("onReset", function () {
            try {
              n(this)
                .find("iframe")
                .hide()
                .unbind()
                .attr("src", "//about:blank");
            } catch (t) {}

            n(this).off("refresh.fb").empty(),
              (t.isLoaded = !1),
              (t.isRevealed = !1);
          });
      },
      setContent: function setContent(t, e) {
        var o = this;
        o.isClosing ||
          (o.hideLoading(t),
          t.$content && n.fancybox.stop(t.$content),
          t.$slide.empty(),
          l(e) && e.parent().length
            ? ((e.hasClass("fancybox-content") ||
                e.parent().hasClass("fancybox-content")) &&
                e.parents(".fancybox-slide").trigger("onReset"),
              (t.$placeholder = n("<div>").hide().insertAfter(e)),
              e.css("display", "inline-block"))
            : t.hasError ||
              ("string" === n.type(e) &&
                (e = n("<div>").append(n.trim(e)).contents()),
              t.opts.filter && (e = n("<div>").html(e).find(t.opts.filter))),
          t.$slide.one("onReset", function () {
            n(this).find("video,audio").trigger("pause"),
              t.$placeholder &&
                (t.$placeholder
                  .after(e.removeClass("fancybox-content").hide())
                  .remove(),
                (t.$placeholder = null)),
              t.$smallBtn && (t.$smallBtn.remove(), (t.$smallBtn = null)),
              t.hasError ||
                (n(this).empty(), (t.isLoaded = !1), (t.isRevealed = !1));
          }),
          n(e).appendTo(t.$slide),
          n(e).is("video,audio") &&
            (n(e).addClass("fancybox-video"),
            n(e).wrap("<div></div>"),
            (t.contentType = "video"),
            (t.opts.width = t.opts.width || n(e).attr("width")),
            (t.opts.height = t.opts.height || n(e).attr("height"))),
          (t.$content = t.$slide
            .children()
            .filter("div,form,main,video,audio,article,.fancybox-content")
            .first()),
          t.$content.siblings().hide(),
          t.$content.length ||
            (t.$content = t.$slide.wrapInner("<div></div>").children().first()),
          t.$content.addClass("fancybox-content"),
          t.$slide.addClass("fancybox-slide--" + t.contentType),
          o.afterLoad(t));
      },
      setError: function setError(t) {
        (t.hasError = !0),
          t.$slide
            .trigger("onReset")
            .removeClass("fancybox-slide--" + t.contentType)
            .addClass("fancybox-slide--error"),
          (t.contentType = "html"),
          this.setContent(t, this.translate(t, t.opts.errorTpl)),
          t.pos === this.currPos && (this.isAnimating = !1);
      },
      showLoading: function showLoading(t) {
        var e = this;
        (t = t || e.current) &&
          !t.$spinner &&
          (t.$spinner = n(e.translate(e, e.opts.spinnerTpl))
            .appendTo(t.$slide)
            .hide()
            .fadeIn("fast"));
      },
      hideLoading: function hideLoading(t) {
        var e = this;
        (t = t || e.current) &&
          t.$spinner &&
          (t.$spinner.stop().remove(), delete t.$spinner);
      },
      afterLoad: function afterLoad(t) {
        var e = this;
        e.isClosing ||
          ((t.isLoading = !1),
          (t.isLoaded = !0),
          e.trigger("afterLoad", t),
          e.hideLoading(t),
          !t.opts.smallBtn ||
            (t.$smallBtn && t.$smallBtn.length) ||
            (t.$smallBtn = n(e.translate(t, t.opts.btnTpl.smallBtn)).appendTo(
              t.$content
            )),
          t.opts.protect &&
            t.$content &&
            !t.hasError &&
            (t.$content.on("contextmenu.fb", function (t) {
              return 2 == t.button && t.preventDefault(), !0;
            }),
            "image" === t.type &&
              n('<div class="fancybox-spaceball"></div>').appendTo(t.$content)),
          e.adjustCaption(t),
          e.adjustLayout(t),
          t.pos === e.currPos && e.updateCursor(),
          e.revealContent(t));
      },
      adjustCaption: function adjustCaption(t) {
        var e,
          n = this,
          o = t || n.current,
          i = o.opts.caption,
          a = o.opts.preventCaptionOverlap,
          s = n.$refs.caption,
          r = !1;
        s.toggleClass("fancybox-caption--separate", a),
          a &&
            i &&
            i.length &&
            (o.pos !== n.currPos
              ? ((e = s.clone().appendTo(s.parent())),
                e.children().eq(0).empty().html(i),
                (r = e.outerHeight(!0)),
                e.empty().remove())
              : n.$caption && (r = n.$caption.outerHeight(!0)),
            o.$slide.css("padding-bottom", r || ""));
      },
      adjustLayout: function adjustLayout(t) {
        var e,
          n,
          o,
          i,
          a = this,
          s = t || a.current;
        s.isLoaded &&
          !0 !== s.opts.disableLayoutFix &&
          (s.$content.css("margin-bottom", ""),
          s.$content.outerHeight() > s.$slide.height() + 0.5 &&
            ((o = s.$slide[0].style["padding-bottom"]),
            (i = s.$slide.css("padding-bottom")),
            parseFloat(i) > 0 &&
              ((e = s.$slide[0].scrollHeight),
              s.$slide.css("padding-bottom", 0),
              Math.abs(e - s.$slide[0].scrollHeight) < 1 && (n = i),
              s.$slide.css("padding-bottom", o))),
          s.$content.css("margin-bottom", n));
      },
      revealContent: function revealContent(t) {
        var e,
          o,
          i,
          a,
          s = this,
          r = t.$slide,
          c = !1,
          l = !1,
          d = s.isMoved(t),
          u = t.isRevealed;
        return (
          (t.isRevealed = !0),
          (e = t.opts[s.firstRun ? "animationEffect" : "transitionEffect"]),
          (i = t.opts[s.firstRun ? "animationDuration" : "transitionDuration"]),
          (i = parseInt(
            void 0 === t.forcedDuration ? i : t.forcedDuration,
            10
          )),
          (!d && t.pos === s.currPos && i) || (e = !1),
          "zoom" === e &&
            (t.pos === s.currPos &&
            i &&
            "image" === t.type &&
            !t.hasError &&
            (l = s.getThumbPos(t))
              ? (c = s.getFitPos(t))
              : (e = "fade")),
          "zoom" === e
            ? ((s.isAnimating = !0),
              (c.scaleX = c.width / l.width),
              (c.scaleY = c.height / l.height),
              (a = t.opts.zoomOpacity),
              "auto" == a &&
                (a = Math.abs(t.width / t.height - l.width / l.height) > 0.1),
              a && ((l.opacity = 0.1), (c.opacity = 1)),
              n.fancybox.setTranslate(
                t.$content.removeClass("fancybox-is-hidden"),
                l
              ),
              p(t.$content),
              void n.fancybox.animate(t.$content, c, i, function () {
                (s.isAnimating = !1), s.complete();
              }))
            : (s.updateSlide(t),
              e
                ? (n.fancybox.stop(r),
                  (o =
                    "fancybox-slide--" +
                    (t.pos >= s.prevPos ? "next" : "previous") +
                    " fancybox-animated fancybox-fx-" +
                    e),
                  r.addClass(o).removeClass("fancybox-slide--current"),
                  t.$content.removeClass("fancybox-is-hidden"),
                  p(r),
                  "image" !== t.type && t.$content.hide().show(0),
                  void n.fancybox.animate(
                    r,
                    "fancybox-slide--current",
                    i,
                    function () {
                      r.removeClass(o).css({
                        transform: "",
                        opacity: "",
                      }),
                        t.pos === s.currPos && s.complete();
                    },
                    !0
                  ))
                : (t.$content.removeClass("fancybox-is-hidden"),
                  u ||
                    !d ||
                    "image" !== t.type ||
                    t.hasError ||
                    t.$content.hide().fadeIn("fast"),
                  void (t.pos === s.currPos && s.complete())))
        );
      },
      getThumbPos: function getThumbPos(t) {
        var e,
          o,
          i,
          a,
          s,
          r = !1,
          c = t.$thumb;
        return (
          !(!c || !g(c[0])) &&
          ((e = n.fancybox.getTranslate(c)),
          (o = parseFloat(c.css("border-top-width") || 0)),
          (i = parseFloat(c.css("border-right-width") || 0)),
          (a = parseFloat(c.css("border-bottom-width") || 0)),
          (s = parseFloat(c.css("border-left-width") || 0)),
          (r = {
            top: e.top + o,
            left: e.left + s,
            width: e.width - i - s,
            height: e.height - o - a,
            scaleX: 1,
            scaleY: 1,
          }),
          e.width > 0 && e.height > 0 && r)
        );
      },
      complete: function complete() {
        var t,
          e = this,
          o = e.current,
          i = {};
        !e.isMoved() &&
          o.isLoaded &&
          (o.isComplete ||
            ((o.isComplete = !0),
            o.$slide.siblings().trigger("onReset"),
            e.preload("inline"),
            p(o.$slide),
            o.$slide.addClass("fancybox-slide--complete"),
            n.each(e.slides, function (t, o) {
              o.pos >= e.currPos - 1 && o.pos <= e.currPos + 1
                ? (i[o.pos] = o)
                : o && (n.fancybox.stop(o.$slide), o.$slide.off().remove());
            }),
            (e.slides = i)),
          (e.isAnimating = !1),
          e.updateCursor(),
          e.trigger("afterShow"),
          o.opts.video.autoStart &&
            o.$slide
              .find("video,audio")
              .filter(":visible:first")
              .trigger("play")
              .one("ended", function () {
                this.webkitExitFullscreen && this.webkitExitFullscreen(),
                  e.next();
              }),
          o.opts.autoFocus &&
            "html" === o.contentType &&
            ((t = o.$content.find("input[autofocus]:enabled:visible:first")),
            t.length ? t.trigger("focus") : e.focus(null, !0)),
          o.$slide.scrollTop(0).scrollLeft(0));
      },
      preload: function preload(t) {
        var e,
          n,
          o = this;
        o.group.length < 2 ||
          ((n = o.slides[o.currPos + 1]),
          (e = o.slides[o.currPos - 1]),
          e && e.type === t && o.loadSlide(e),
          n && n.type === t && o.loadSlide(n));
      },
      focus: function focus(t, o) {
        var i,
          a,
          s = this,
          r = [
            "a[href]",
            "area[href]",
            'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
            "select:not([disabled]):not([aria-hidden])",
            "textarea:not([disabled]):not([aria-hidden])",
            "button:not([disabled]):not([aria-hidden])",
            "iframe",
            "object",
            "embed",
            "video",
            "audio",
            "[contenteditable]",
            '[tabindex]:not([tabindex^="-"])',
          ].join(",");
        s.isClosing ||
          ((i =
            !t && s.current && s.current.isComplete
              ? s.current.$slide.find(
                  "*:visible" + (o ? ":not(.fancybox-close-small)" : "")
                )
              : s.$refs.container.find("*:visible")),
          (i = i.filter(r).filter(function () {
            return (
              "hidden" !== n(this).css("visibility") &&
              !n(this).hasClass("disabled")
            );
          })),
          i.length
            ? ((a = i.index(e.activeElement)),
              t && t.shiftKey
                ? (a < 0 || 0 == a) &&
                  (t.preventDefault(), i.eq(i.length - 1).trigger("focus"))
                : (a < 0 || a == i.length - 1) &&
                  (t && t.preventDefault(), i.eq(0).trigger("focus")))
            : s.$refs.container.trigger("focus"));
      },
      activate: function activate() {
        var t = this;
        n(".fancybox-container").each(function () {
          var e = n(this).data("FancyBox");
          e &&
            e.id !== t.id &&
            !e.isClosing &&
            (e.trigger("onDeactivate"), e.removeEvents(), (e.isVisible = !1));
        }),
          (t.isVisible = !0),
          (t.current || t.isIdle) && (t.update(), t.updateControls()),
          t.trigger("onActivate"),
          t.addEvents();
      },
      close: function close(t, e) {
        var o,
          i,
          a,
          s,
          r,
          c,
          l,
          u = this,
          f = u.current,
          h = function h() {
            u.cleanUp(t);
          };

        return (
          !u.isClosing &&
          ((u.isClosing = !0),
          !1 === u.trigger("beforeClose", t)
            ? ((u.isClosing = !1),
              d(function () {
                u.update();
              }),
              !1)
            : (u.removeEvents(),
              (a = f.$content),
              (o = f.opts.animationEffect),
              (i = n.isNumeric(e) ? e : o ? f.opts.animationDuration : 0),
              f.$slide.removeClass(
                "fancybox-slide--complete fancybox-slide--next fancybox-slide--previous fancybox-animated"
              ),
              !0 !== t ? n.fancybox.stop(f.$slide) : (o = !1),
              f.$slide.siblings().trigger("onReset").remove(),
              i &&
                u.$refs.container
                  .removeClass("fancybox-is-open")
                  .addClass("fancybox-is-closing")
                  .css("transition-duration", i + "ms"),
              u.hideLoading(f),
              u.hideControls(!0),
              u.updateCursor(),
              "zoom" !== o ||
                (a &&
                  i &&
                  "image" === f.type &&
                  !u.isMoved() &&
                  !f.hasError &&
                  (l = u.getThumbPos(f))) ||
                (o = "fade"),
              "zoom" === o
                ? (n.fancybox.stop(a),
                  (s = n.fancybox.getTranslate(a)),
                  (c = {
                    top: s.top,
                    left: s.left,
                    scaleX: s.width / l.width,
                    scaleY: s.height / l.height,
                    width: l.width,
                    height: l.height,
                  }),
                  (r = f.opts.zoomOpacity),
                  "auto" == r &&
                    (r =
                      Math.abs(f.width / f.height - l.width / l.height) > 0.1),
                  r && (l.opacity = 0),
                  n.fancybox.setTranslate(a, c),
                  p(a),
                  n.fancybox.animate(a, l, i, h),
                  !0)
                : (o && i
                    ? n.fancybox.animate(
                        f.$slide
                          .addClass("fancybox-slide--previous")
                          .removeClass("fancybox-slide--current"),
                        "fancybox-animated fancybox-fx-" + o,
                        i,
                        h
                      )
                    : !0 === t
                    ? setTimeout(h, i)
                    : h(),
                  !0)))
        );
      },
      cleanUp: function cleanUp(e) {
        var o,
          i,
          a,
          s = this,
          r = s.current.opts.$orig;
        s.current.$slide.trigger("onReset"),
          s.$refs.container.empty().remove(),
          s.trigger("afterClose", e),
          s.current.opts.backFocus &&
            ((r && r.length && r.is(":visible")) || (r = s.$trigger),
            r &&
              r.length &&
              ((i = t.scrollX),
              (a = t.scrollY),
              r.trigger("focus"),
              n("html, body").scrollTop(a).scrollLeft(i))),
          (s.current = null),
          (o = n.fancybox.getInstance()),
          o
            ? o.activate()
            : (n("body").removeClass(
                "fancybox-active compensate-for-scrollbar"
              ),
              n("#fancybox-style-noscroll").remove());
      },
      trigger: function trigger(t, e) {
        var o,
          i = Array.prototype.slice.call(arguments, 1),
          a = this,
          s = e && e.opts ? e : a.current;
        if (
          (s ? i.unshift(s) : (s = a),
          i.unshift(a),
          n.isFunction(s.opts[t]) && (o = s.opts[t].apply(s, i)),
          !1 === o)
        )
          return o;
        "afterClose" !== t && a.$refs
          ? a.$refs.container.trigger(t + ".fb", i)
          : r.trigger(t + ".fb", i);
      },
      updateControls: function updateControls() {
        var t = this,
          o = t.current,
          i = o.index,
          a = t.$refs.container,
          s = t.$refs.caption,
          r = o.opts.caption;
        o.$slide.trigger("refresh"),
          r && r.length
            ? ((t.$caption = s), s.children().eq(0).html(r))
            : (t.$caption = null),
          t.hasHiddenControls || t.isIdle || t.showControls(),
          a.find("[data-fancybox-count]").html(t.group.length),
          a.find("[data-fancybox-index]").html(i + 1),
          a
            .find("[data-fancybox-prev]")
            .prop("disabled", !o.opts.loop && i <= 0),
          a
            .find("[data-fancybox-next]")
            .prop("disabled", !o.opts.loop && i >= t.group.length - 1),
          "image" === o.type
            ? a
                .find("[data-fancybox-zoom]")
                .show()
                .end()
                .find("[data-fancybox-download]")
                .attr("href", o.opts.image.src || o.src)
                .show()
            : o.opts.toolbar &&
              a.find("[data-fancybox-download],[data-fancybox-zoom]").hide(),
          n(e.activeElement).is(":hidden,[disabled]") &&
            t.$refs.container.trigger("focus");
      },
      hideControls: function hideControls(t) {
        var e = this,
          n = ["infobar", "toolbar", "nav"];
        (!t && e.current.opts.preventCaptionOverlap) || n.push("caption"),
          this.$refs.container.removeClass(
            n
              .map(function (t) {
                return "fancybox-show-" + t;
              })
              .join(" ")
          ),
          (this.hasHiddenControls = !0);
      },
      showControls: function showControls() {
        var t = this,
          e = t.current ? t.current.opts : t.opts,
          n = t.$refs.container;
        (t.hasHiddenControls = !1),
          (t.idleSecondsCounter = 0),
          n
            .toggleClass("fancybox-show-toolbar", !(!e.toolbar || !e.buttons))
            .toggleClass(
              "fancybox-show-infobar",
              !!(e.infobar && t.group.length > 1)
            )
            .toggleClass("fancybox-show-caption", !!t.$caption)
            .toggleClass(
              "fancybox-show-nav",
              !!(e.arrows && t.group.length > 1)
            )
            .toggleClass("fancybox-is-modal", !!e.modal);
      },
      toggleControls: function toggleControls() {
        this.hasHiddenControls ? this.showControls() : this.hideControls();
      },
    }),
      (n.fancybox = {
        version: "3.5.6",
        defaults: a,
        getInstance: function getInstance(t) {
          var e = n(
              '.fancybox-container:not(".fancybox-is-closing"):last'
            ).data("FancyBox"),
            o = Array.prototype.slice.call(arguments, 1);
          return (
            e instanceof b &&
            ("string" === n.type(t)
              ? e[t].apply(e, o)
              : "function" === n.type(t) && t.apply(e, o),
            e)
          );
        },
        open: function open(t, e, n) {
          return new b(t, e, n);
        },
        close: function close(t) {
          var e = this.getInstance();
          e && (e.close(), !0 === t && this.close(t));
        },
        destroy: function destroy() {
          this.close(!0), r.add("body").off("click.fb-start", "**");
        },
        isMobile:
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          ),
        use3d: (function () {
          var n = e.createElement("div");
          return (
            t.getComputedStyle &&
            t.getComputedStyle(n) &&
            t.getComputedStyle(n).getPropertyValue("transform") &&
            !(e.documentMode && e.documentMode < 11)
          );
        })(),
        getTranslate: function getTranslate(t) {
          var e;
          return (
            !(!t || !t.length) &&
            ((e = t[0].getBoundingClientRect()),
            {
              top: e.top || 0,
              left: e.left || 0,
              width: e.width,
              height: e.height,
              opacity: parseFloat(t.css("opacity")),
            })
          );
        },
        setTranslate: function setTranslate(t, e) {
          var n = "",
            o = {};
          if (t && e)
            return (
              (void 0 === e.left && void 0 === e.top) ||
                ((n =
                  (void 0 === e.left ? t.position().left : e.left) +
                  "px, " +
                  (void 0 === e.top ? t.position().top : e.top) +
                  "px"),
                (n = this.use3d
                  ? "translate3d(" + n + ", 0px)"
                  : "translate(" + n + ")")),
              void 0 !== e.scaleX && void 0 !== e.scaleY
                ? (n += " scale(" + e.scaleX + ", " + e.scaleY + ")")
                : void 0 !== e.scaleX && (n += " scaleX(" + e.scaleX + ")"),
              n.length && (o.transform = n),
              void 0 !== e.opacity && (o.opacity = e.opacity),
              void 0 !== e.width && (o.width = e.width),
              void 0 !== e.height && (o.height = e.height),
              t.css(o)
            );
        },
        animate: function animate(t, e, o, i, a) {
          var s,
            r = this;
          n.isFunction(o) && ((i = o), (o = null)),
            r.stop(t),
            (s = r.getTranslate(t)),
            t.on(f, function (c) {
              (!c ||
                !c.originalEvent ||
                (t.is(c.originalEvent.target) &&
                  "z-index" != c.originalEvent.propertyName)) &&
                (r.stop(t),
                n.isNumeric(o) && t.css("transition-duration", ""),
                n.isPlainObject(e)
                  ? void 0 !== e.scaleX &&
                    void 0 !== e.scaleY &&
                    r.setTranslate(t, {
                      top: e.top,
                      left: e.left,
                      width: s.width * e.scaleX,
                      height: s.height * e.scaleY,
                      scaleX: 1,
                      scaleY: 1,
                    })
                  : !0 !== a && t.removeClass(e),
                n.isFunction(i) && i(c));
            }),
            n.isNumeric(o) && t.css("transition-duration", o + "ms"),
            n.isPlainObject(e)
              ? (void 0 !== e.scaleX &&
                  void 0 !== e.scaleY &&
                  (delete e.width,
                  delete e.height,
                  t.parent().hasClass("fancybox-slide--image") &&
                    t.parent().addClass("fancybox-is-scaling")),
                n.fancybox.setTranslate(t, e))
              : t.addClass(e),
            t.data(
              "timer",
              setTimeout(function () {
                t.trigger(f);
              }, o + 33)
            );
        },
        stop: function stop(t, e) {
          t &&
            t.length &&
            (clearTimeout(t.data("timer")),
            e && t.trigger(f),
            t.off(f).css("transition-duration", ""),
            t.parent().removeClass("fancybox-is-scaling"));
        },
      }),
      (n.fn.fancybox = function (t) {
        var e;
        return (
          (t = t || {}),
          (e = t.selector || !1),
          e
            ? n("body").off("click.fb-start", e).on(
                "click.fb-start",
                e,
                {
                  options: t,
                },
                i
              )
            : this.off("click.fb-start").on(
                "click.fb-start",
                {
                  items: this,
                  options: t,
                },
                i
              ),
          this
        );
      }),
      r.on("click.fb-start", "[data-fancybox]", i),
      r.on("click.fb-start", "[data-fancybox-trigger]", function (t) {
        n('[data-fancybox="' + n(this).attr("data-fancybox-trigger") + '"]')
          .eq(n(this).attr("data-fancybox-index") || 0)
          .trigger("click.fb-start", {
            $trigger: n(this),
          });
      }),
      (function () {
        var t = null;
        r.on("mousedown mouseup focus blur", ".fancybox-button", function (e) {
          switch (e.type) {
            case "mousedown":
              t = n(this);
              break;

            case "mouseup":
              t = null;
              break;

            case "focusin":
              n(".fancybox-button").removeClass("fancybox-focus"),
                n(this).is(t) ||
                  n(this).is("[disabled]") ||
                  n(this).addClass("fancybox-focus");
              break;

            case "focusout":
              n(".fancybox-button").removeClass("fancybox-focus");
          }
        });
      })();
  }
})(window, document, jQuery),
  (function (t) {
    "use strict";

    var e = {
        youtube: {
          matcher:
            /(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(watch\?(.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*))(.*)/i,
          params: {
            autoplay: 1,
            autohide: 1,
            fs: 1,
            rel: 0,
            hd: 1,
            wmode: "transparent",
            enablejsapi: 1,
            html5: 1,
          },
          paramPlace: 8,
          type: "iframe",
          url: "https://www.youtube-nocookie.com/embed/$4",
          thumb: "https://img.youtube.com/vi/$4/hqdefault.jpg",
        },
        vimeo: {
          matcher: /^.+vimeo.com\/(.*\/)?([\d]+)(.*)?/,
          params: {
            autoplay: 1,
            hd: 1,
            show_title: 1,
            show_byline: 1,
            show_portrait: 0,
            fullscreen: 1,
          },
          paramPlace: 3,
          type: "iframe",
          url: "//player.vimeo.com/video/$2",
        },
        instagram: {
          matcher: /(instagr\.am|instagram\.com)\/p\/([a-zA-Z0-9_\-]+)\/?/i,
          type: "image",
          url: "//$1/p/$2/media/?size=l",
        },
        gmap_place: {
          matcher:
            /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(((maps\/(place\/(.*)\/)?\@(.*),(\d+.?\d+?)z))|(\?ll=))(.*)?/i,
          type: "iframe",
          url: function url(t) {
            return (
              "//maps.google." +
              t[2] +
              "/?ll=" +
              (t[9]
                ? t[9] +
                  "&z=" +
                  Math.floor(t[10]) +
                  (t[12] ? t[12].replace(/^\//, "&") : "")
                : t[12] + ""
              ).replace(/\?/, "&") +
              "&output=" +
              (t[12] && t[12].indexOf("layer=c") > 0 ? "svembed" : "embed")
            );
          },
        },
        gmap_search: {
          matcher:
            /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(maps\/search\/)(.*)/i,
          type: "iframe",
          url: function url(t) {
            return (
              "//maps.google." +
              t[2] +
              "/maps?q=" +
              t[5].replace("query=", "q=").replace("api=1", "") +
              "&output=embed"
            );
          },
        },
      },
      n = function n(e, _n, o) {
        if (e)
          return (
            (o = o || ""),
            "object" === t.type(o) && (o = t.param(o, !0)),
            t.each(_n, function (t, n) {
              e = e.replace("$" + t, n || "");
            }),
            o.length && (e += (e.indexOf("?") > 0 ? "&" : "?") + o),
            e
          );
      };

    t(document).on("objectNeedsType.fb", function (o, i, a) {
      var s,
        r,
        c,
        l,
        d,
        u,
        f,
        p = a.src || "",
        h = !1;
      (s = t.extend(!0, {}, e, a.opts.media)),
        t.each(s, function (e, o) {
          if ((c = p.match(o.matcher))) {
            if (
              ((h = o.type), (f = e), (u = {}), o.paramPlace && c[o.paramPlace])
            ) {
              (d = c[o.paramPlace]),
                "?" == d[0] && (d = d.substring(1)),
                (d = d.split("&"));

              for (var i = 0; i < d.length; ++i) {
                var s = d[i].split("=", 2);
                2 == s.length &&
                  (u[s[0]] = decodeURIComponent(s[1].replace(/\+/g, " ")));
              }
            }

            return (
              (l = t.extend(!0, {}, o.params, a.opts[e], u)),
              (p =
                "function" === t.type(o.url)
                  ? o.url.call(this, c, l, a)
                  : n(o.url, c, l)),
              (r =
                "function" === t.type(o.thumb)
                  ? o.thumb.call(this, c, l, a)
                  : n(o.thumb, c)),
              "youtube" === e
                ? (p = p.replace(/&t=((\d+)m)?(\d+)s/, function (t, e, n, o) {
                    return (
                      "&start=" +
                      ((n ? 60 * parseInt(n, 10) : 0) + parseInt(o, 10))
                    );
                  }))
                : "vimeo" === e && (p = p.replace("&%23", "#")),
              !1
            );
          }
        }),
        h
          ? (a.opts.thumb ||
              (a.opts.$thumb && a.opts.$thumb.length) ||
              (a.opts.thumb = r),
            "iframe" === h &&
              (a.opts = t.extend(!0, a.opts, {
                iframe: {
                  preload: !1,
                  attr: {
                    scrolling: "no",
                  },
                },
              })),
            t.extend(a, {
              type: h,
              src: p,
              origSrc: a.src,
              contentSource: f,
              contentType:
                "image" === h
                  ? "image"
                  : "gmap_place" == f || "gmap_search" == f
                  ? "map"
                  : "video",
            }))
          : p && (a.type = a.opts.defaultType);
    });
    var o = {
      youtube: {
        src: "https://www.youtube.com/iframe_api",
        class: "YT",
        loading: !1,
        loaded: !1,
      },
      vimeo: {
        src: "https://player.vimeo.com/api/player.js",
        class: "Vimeo",
        loading: !1,
        loaded: !1,
      },
      load: function load(t) {
        var e,
          n = this;
        if (this[t].loaded)
          return void setTimeout(function () {
            n.done(t);
          });
        this[t].loading ||
          ((this[t].loading = !0),
          (e = document.createElement("script")),
          (e.type = "text/javascript"),
          (e.src = this[t].src),
          "youtube" === t
            ? (window.onYouTubeIframeAPIReady = function () {
                (n[t].loaded = !0), n.done(t);
              })
            : (e.onload = function () {
                (n[t].loaded = !0), n.done(t);
              }),
          document.body.appendChild(e));
      },
      done: function done(e) {
        var n, o, i;
        "youtube" === e && delete window.onYouTubeIframeAPIReady,
          (n = t.fancybox.getInstance()) &&
            ((o = n.current.$content.find("iframe")),
            "youtube" === e && void 0 !== YT && YT
              ? (i = new YT.Player(o.attr("id"), {
                  events: {
                    onStateChange: function onStateChange(t) {
                      0 == t.data && n.next();
                    },
                  },
                }))
              : "vimeo" === e &&
                void 0 !== Vimeo &&
                Vimeo &&
                ((i = new Vimeo.Player(o)),
                i.on("ended", function () {
                  n.next();
                })));
      },
    };
    t(document).on({
      "afterShow.fb": function afterShowFb(t, e, n) {
        e.group.length > 1 &&
          ("youtube" === n.contentSource || "vimeo" === n.contentSource) &&
          o.load(n.contentSource);
      },
    });
  })(jQuery),
  (function (t, e, n) {
    "use strict";

    var o = (function () {
        return (
          t.requestAnimationFrame ||
          t.webkitRequestAnimationFrame ||
          t.mozRequestAnimationFrame ||
          t.oRequestAnimationFrame ||
          function (e) {
            return t.setTimeout(e, 1e3 / 60);
          }
        );
      })(),
      i = (function () {
        return (
          t.cancelAnimationFrame ||
          t.webkitCancelAnimationFrame ||
          t.mozCancelAnimationFrame ||
          t.oCancelAnimationFrame ||
          function (e) {
            t.clearTimeout(e);
          }
        );
      })(),
      a = function a(e) {
        var n = [];
        (e = e.originalEvent || e || t.e),
          (e =
            e.touches && e.touches.length
              ? e.touches
              : e.changedTouches && e.changedTouches.length
              ? e.changedTouches
              : [e]);

        for (var o in e) {
          e[o].pageX
            ? n.push({
                x: e[o].pageX,
                y: e[o].pageY,
              })
            : e[o].clientX &&
              n.push({
                x: e[o].clientX,
                y: e[o].clientY,
              });
        }

        return n;
      },
      s = function s(t, e, n) {
        return e && t
          ? "x" === n
            ? t.x - e.x
            : "y" === n
            ? t.y - e.y
            : Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2))
          : 0;
      },
      r = function r(t) {
        if (
          t.is(
            'a,area,button,[role="button"],input,label,select,summary,textarea,video,audio,iframe'
          ) ||
          n.isFunction(t.get(0).onclick) ||
          t.data("selectable")
        )
          return !0;

        for (var e = 0, o = t[0].attributes, i = o.length; e < i; e++) {
          if ("data-fancybox-" === o[e].nodeName.substr(0, 14)) return !0;
        }

        return !1;
      },
      c = function c(e) {
        var n = t.getComputedStyle(e)["overflow-y"],
          o = t.getComputedStyle(e)["overflow-x"],
          i =
            ("scroll" === n || "auto" === n) && e.scrollHeight > e.clientHeight,
          a = ("scroll" === o || "auto" === o) && e.scrollWidth > e.clientWidth;
        return i || a;
      },
      l = function l(t) {
        for (var e = !1; ; ) {
          if ((e = c(t.get(0)))) break;
          if (
            ((t = t.parent()),
            !t.length || t.hasClass("fancybox-stage") || t.is("body"))
          )
            break;
        }

        return e;
      },
      d = function d(t) {
        var e = this;
        (e.instance = t),
          (e.$bg = t.$refs.bg),
          (e.$stage = t.$refs.stage),
          (e.$container = t.$refs.container),
          e.destroy(),
          e.$container.on(
            "touchstart.fb.touch mousedown.fb.touch",
            n.proxy(e, "ontouchstart")
          );
      };

    (d.prototype.destroy = function () {
      var t = this;
      t.$container.off(".fb.touch"),
        n(e).off(".fb.touch"),
        t.requestId && (i(t.requestId), (t.requestId = null)),
        t.tapped && (clearTimeout(t.tapped), (t.tapped = null));
    }),
      (d.prototype.ontouchstart = function (o) {
        var i = this,
          c = n(o.target),
          d = i.instance,
          u = d.current,
          f = u.$slide,
          p = u.$content,
          h = "touchstart" == o.type;

        if (
          (h && i.$container.off("mousedown.fb.touch"),
          (!o.originalEvent || 2 != o.originalEvent.button) &&
            f.length &&
            c.length &&
            !r(c) &&
            !r(c.parent()) &&
            (c.is("img") ||
              !(o.originalEvent.clientX > c[0].clientWidth + c.offset().left)))
        ) {
          if (!u || d.isAnimating || u.$slide.hasClass("fancybox-animated"))
            return o.stopPropagation(), void o.preventDefault();
          (i.realPoints = i.startPoints = a(o)),
            i.startPoints.length &&
              (u.touch && o.stopPropagation(),
              (i.startEvent = o),
              (i.canTap = !0),
              (i.$target = c),
              (i.$content = p),
              (i.opts = u.opts.touch),
              (i.isPanning = !1),
              (i.isSwiping = !1),
              (i.isZooming = !1),
              (i.isScrolling = !1),
              (i.canPan = d.canPan()),
              (i.startTime = new Date().getTime()),
              (i.distanceX = i.distanceY = i.distance = 0),
              (i.canvasWidth = Math.round(f[0].clientWidth)),
              (i.canvasHeight = Math.round(f[0].clientHeight)),
              (i.contentLastPos = null),
              (i.contentStartPos = n.fancybox.getTranslate(i.$content) || {
                top: 0,
                left: 0,
              }),
              (i.sliderStartPos = n.fancybox.getTranslate(f)),
              (i.stagePos = n.fancybox.getTranslate(d.$refs.stage)),
              (i.sliderStartPos.top -= i.stagePos.top),
              (i.sliderStartPos.left -= i.stagePos.left),
              (i.contentStartPos.top -= i.stagePos.top),
              (i.contentStartPos.left -= i.stagePos.left),
              n(e)
                .off(".fb.touch")
                .on(
                  h
                    ? "touchend.fb.touch touchcancel.fb.touch"
                    : "mouseup.fb.touch mouseleave.fb.touch",
                  n.proxy(i, "ontouchend")
                )
                .on(
                  h ? "touchmove.fb.touch" : "mousemove.fb.touch",
                  n.proxy(i, "ontouchmove")
                ),
              n.fancybox.isMobile &&
                e.addEventListener("scroll", i.onscroll, !0),
              (((i.opts || i.canPan) &&
                (c.is(i.$stage) || i.$stage.find(c).length)) ||
                (c.is(".fancybox-image") && o.preventDefault(),
                n.fancybox.isMobile &&
                  c.parents(".fancybox-caption").length)) &&
                ((i.isScrollable = l(c) || l(c.parent())),
                (n.fancybox.isMobile && i.isScrollable) || o.preventDefault(),
                (1 === i.startPoints.length || u.hasError) &&
                  (i.canPan
                    ? (n.fancybox.stop(i.$content), (i.isPanning = !0))
                    : (i.isSwiping = !0),
                  i.$container.addClass("fancybox-is-grabbing")),
                2 === i.startPoints.length &&
                  "image" === u.type &&
                  (u.isLoaded || u.$ghost) &&
                  ((i.canTap = !1),
                  (i.isSwiping = !1),
                  (i.isPanning = !1),
                  (i.isZooming = !0),
                  n.fancybox.stop(i.$content),
                  (i.centerPointStartX =
                    0.5 * (i.startPoints[0].x + i.startPoints[1].x) -
                    n(t).scrollLeft()),
                  (i.centerPointStartY =
                    0.5 * (i.startPoints[0].y + i.startPoints[1].y) -
                    n(t).scrollTop()),
                  (i.percentageOfImageAtPinchPointX =
                    (i.centerPointStartX - i.contentStartPos.left) /
                    i.contentStartPos.width),
                  (i.percentageOfImageAtPinchPointY =
                    (i.centerPointStartY - i.contentStartPos.top) /
                    i.contentStartPos.height),
                  (i.startDistanceBetweenFingers = s(
                    i.startPoints[0],
                    i.startPoints[1]
                  )))));
        }
      }),
      (d.prototype.onscroll = function (t) {
        var n = this;
        (n.isScrolling = !0), e.removeEventListener("scroll", n.onscroll, !0);
      }),
      (d.prototype.ontouchmove = function (t) {
        var e = this;
        return void 0 !== t.originalEvent.buttons &&
          0 === t.originalEvent.buttons
          ? void e.ontouchend(t)
          : e.isScrolling
          ? void (e.canTap = !1)
          : ((e.newPoints = a(t)),
            void (
              (e.opts || e.canPan) &&
              e.newPoints.length &&
              e.newPoints.length &&
              ((e.isSwiping && !0 === e.isSwiping) || t.preventDefault(),
              (e.distanceX = s(e.newPoints[0], e.startPoints[0], "x")),
              (e.distanceY = s(e.newPoints[0], e.startPoints[0], "y")),
              (e.distance = s(e.newPoints[0], e.startPoints[0])),
              e.distance > 0 &&
                (e.isSwiping
                  ? e.onSwipe(t)
                  : e.isPanning
                  ? e.onPan()
                  : e.isZooming && e.onZoom()))
            ));
      }),
      (d.prototype.onSwipe = function (e) {
        var a,
          s = this,
          r = s.instance,
          c = s.isSwiping,
          l = s.sliderStartPos.left || 0;
        if (!0 !== c)
          "x" == c &&
            (s.distanceX > 0 &&
            (s.instance.group.length < 2 ||
              (0 === s.instance.current.index && !s.instance.current.opts.loop))
              ? (l += Math.pow(s.distanceX, 0.8))
              : s.distanceX < 0 &&
                (s.instance.group.length < 2 ||
                  (s.instance.current.index === s.instance.group.length - 1 &&
                    !s.instance.current.opts.loop))
              ? (l -= Math.pow(-s.distanceX, 0.8))
              : (l += s.distanceX)),
            (s.sliderLastPos = {
              top: "x" == c ? 0 : s.sliderStartPos.top + s.distanceY,
              left: l,
            }),
            s.requestId && (i(s.requestId), (s.requestId = null)),
            (s.requestId = o(function () {
              s.sliderLastPos &&
                (n.each(s.instance.slides, function (t, e) {
                  var o = e.pos - s.instance.currPos;
                  n.fancybox.setTranslate(e.$slide, {
                    top: s.sliderLastPos.top,
                    left:
                      s.sliderLastPos.left +
                      o * s.canvasWidth +
                      o * e.opts.gutter,
                  });
                }),
                s.$container.addClass("fancybox-is-sliding"));
            }));
        else if (Math.abs(s.distance) > 10) {
          if (
            ((s.canTap = !1),
            r.group.length < 2 && s.opts.vertical
              ? (s.isSwiping = "y")
              : r.isDragging ||
                !1 === s.opts.vertical ||
                ("auto" === s.opts.vertical && n(t).width() > 800)
              ? (s.isSwiping = "x")
              : ((a = Math.abs(
                  (180 * Math.atan2(s.distanceY, s.distanceX)) / Math.PI
                )),
                (s.isSwiping = a > 45 && a < 135 ? "y" : "x")),
            "y" === s.isSwiping && n.fancybox.isMobile && s.isScrollable)
          )
            return void (s.isScrolling = !0);
          (r.isDragging = s.isSwiping),
            (s.startPoints = s.newPoints),
            n.each(r.slides, function (t, e) {
              var o, i;
              n.fancybox.stop(e.$slide),
                (o = n.fancybox.getTranslate(e.$slide)),
                (i = n.fancybox.getTranslate(r.$refs.stage)),
                e.$slide
                  .css({
                    transform: "",
                    opacity: "",
                    "transition-duration": "",
                  })
                  .removeClass("fancybox-animated")
                  .removeClass(function (t, e) {
                    return (e.match(/(^|\s)fancybox-fx-\S+/g) || []).join(" ");
                  }),
                e.pos === r.current.pos &&
                  ((s.sliderStartPos.top = o.top - i.top),
                  (s.sliderStartPos.left = o.left - i.left)),
                n.fancybox.setTranslate(e.$slide, {
                  top: o.top - i.top,
                  left: o.left - i.left,
                });
            }),
            r.SlideShow && r.SlideShow.isActive && r.SlideShow.stop();
        }
      }),
      (d.prototype.onPan = function () {
        var t = this;
        if (s(t.newPoints[0], t.realPoints[0]) < (n.fancybox.isMobile ? 10 : 5))
          return void (t.startPoints = t.newPoints);
        (t.canTap = !1),
          (t.contentLastPos = t.limitMovement()),
          t.requestId && i(t.requestId),
          (t.requestId = o(function () {
            n.fancybox.setTranslate(t.$content, t.contentLastPos);
          }));
      }),
      (d.prototype.limitMovement = function () {
        var t,
          e,
          n,
          o,
          i,
          a,
          s = this,
          r = s.canvasWidth,
          c = s.canvasHeight,
          l = s.distanceX,
          d = s.distanceY,
          u = s.contentStartPos,
          f = u.left,
          p = u.top,
          h = u.width,
          g = u.height;
        return (
          (i = h > r ? f + l : f),
          (a = p + d),
          (t = Math.max(0, 0.5 * r - 0.5 * h)),
          (e = Math.max(0, 0.5 * c - 0.5 * g)),
          (n = Math.min(r - h, 0.5 * r - 0.5 * h)),
          (o = Math.min(c - g, 0.5 * c - 0.5 * g)),
          l > 0 && i > t && (i = t - 1 + Math.pow(-t + f + l, 0.8) || 0),
          l < 0 && i < n && (i = n + 1 - Math.pow(n - f - l, 0.8) || 0),
          d > 0 && a > e && (a = e - 1 + Math.pow(-e + p + d, 0.8) || 0),
          d < 0 && a < o && (a = o + 1 - Math.pow(o - p - d, 0.8) || 0),
          {
            top: a,
            left: i,
          }
        );
      }),
      (d.prototype.limitPosition = function (t, e, n, o) {
        var i = this,
          a = i.canvasWidth,
          s = i.canvasHeight;
        return (
          n > a
            ? ((t = t > 0 ? 0 : t), (t = t < a - n ? a - n : t))
            : (t = Math.max(0, a / 2 - n / 2)),
          o > s
            ? ((e = e > 0 ? 0 : e), (e = e < s - o ? s - o : e))
            : (e = Math.max(0, s / 2 - o / 2)),
          {
            top: e,
            left: t,
          }
        );
      }),
      (d.prototype.onZoom = function () {
        var e = this,
          a = e.contentStartPos,
          r = a.width,
          c = a.height,
          l = a.left,
          d = a.top,
          u = s(e.newPoints[0], e.newPoints[1]),
          f = u / e.startDistanceBetweenFingers,
          p = Math.floor(r * f),
          h = Math.floor(c * f),
          g = (r - p) * e.percentageOfImageAtPinchPointX,
          b = (c - h) * e.percentageOfImageAtPinchPointY,
          m = (e.newPoints[0].x + e.newPoints[1].x) / 2 - n(t).scrollLeft(),
          v = (e.newPoints[0].y + e.newPoints[1].y) / 2 - n(t).scrollTop(),
          y = m - e.centerPointStartX,
          x = v - e.centerPointStartY,
          w = l + (g + y),
          $ = d + (b + x),
          S = {
            top: $,
            left: w,
            scaleX: f,
            scaleY: f,
          };
        (e.canTap = !1),
          (e.newWidth = p),
          (e.newHeight = h),
          (e.contentLastPos = S),
          e.requestId && i(e.requestId),
          (e.requestId = o(function () {
            n.fancybox.setTranslate(e.$content, e.contentLastPos);
          }));
      }),
      (d.prototype.ontouchend = function (t) {
        var o = this,
          s = o.isSwiping,
          r = o.isPanning,
          c = o.isZooming,
          l = o.isScrolling;
        if (
          ((o.endPoints = a(t)),
          (o.dMs = Math.max(new Date().getTime() - o.startTime, 1)),
          o.$container.removeClass("fancybox-is-grabbing"),
          n(e).off(".fb.touch"),
          e.removeEventListener("scroll", o.onscroll, !0),
          o.requestId && (i(o.requestId), (o.requestId = null)),
          (o.isSwiping = !1),
          (o.isPanning = !1),
          (o.isZooming = !1),
          (o.isScrolling = !1),
          (o.instance.isDragging = !1),
          o.canTap)
        )
          return o.onTap(t);
        (o.speed = 100),
          (o.velocityX = (o.distanceX / o.dMs) * 0.5),
          (o.velocityY = (o.distanceY / o.dMs) * 0.5),
          r ? o.endPanning() : c ? o.endZooming() : o.endSwiping(s, l);
      }),
      (d.prototype.endSwiping = function (t, e) {
        var o = this,
          i = !1,
          a = o.instance.group.length,
          s = Math.abs(o.distanceX),
          r = "x" == t && a > 1 && ((o.dMs > 130 && s > 10) || s > 50);
        (o.sliderLastPos = null),
          "y" == t && !e && Math.abs(o.distanceY) > 50
            ? (n.fancybox.animate(
                o.instance.current.$slide,
                {
                  top: o.sliderStartPos.top + o.distanceY + 150 * o.velocityY,
                  opacity: 0,
                },
                200
              ),
              (i = o.instance.close(!0, 250)))
            : r && o.distanceX > 0
            ? (i = o.instance.previous(300))
            : r && o.distanceX < 0 && (i = o.instance.next(300)),
          !1 !== i || ("x" != t && "y" != t) || o.instance.centerSlide(200),
          o.$container.removeClass("fancybox-is-sliding");
      }),
      (d.prototype.endPanning = function () {
        var t,
          e,
          o,
          i = this;
        i.contentLastPos &&
          (!1 === i.opts.momentum || i.dMs > 350
            ? ((t = i.contentLastPos.left), (e = i.contentLastPos.top))
            : ((t = i.contentLastPos.left + 500 * i.velocityX),
              (e = i.contentLastPos.top + 500 * i.velocityY)),
          (o = i.limitPosition(
            t,
            e,
            i.contentStartPos.width,
            i.contentStartPos.height
          )),
          (o.width = i.contentStartPos.width),
          (o.height = i.contentStartPos.height),
          n.fancybox.animate(i.$content, o, 366));
      }),
      (d.prototype.endZooming = function () {
        var t,
          e,
          o,
          i,
          a = this,
          s = a.instance.current,
          r = a.newWidth,
          c = a.newHeight;
        a.contentLastPos &&
          ((t = a.contentLastPos.left),
          (e = a.contentLastPos.top),
          (i = {
            top: e,
            left: t,
            width: r,
            height: c,
            scaleX: 1,
            scaleY: 1,
          }),
          n.fancybox.setTranslate(a.$content, i),
          r < a.canvasWidth && c < a.canvasHeight
            ? a.instance.scaleToFit(150)
            : r > s.width || c > s.height
            ? a.instance.scaleToActual(
                a.centerPointStartX,
                a.centerPointStartY,
                150
              )
            : ((o = a.limitPosition(t, e, r, c)),
              n.fancybox.animate(a.$content, o, 150)));
      }),
      (d.prototype.onTap = function (e) {
        var o,
          i = this,
          s = n(e.target),
          r = i.instance,
          c = r.current,
          l = (e && a(e)) || i.startPoints,
          d = l[0] ? l[0].x - n(t).scrollLeft() - i.stagePos.left : 0,
          u = l[0] ? l[0].y - n(t).scrollTop() - i.stagePos.top : 0,
          f = function f(t) {
            var o = c.opts[t];
            if ((n.isFunction(o) && (o = o.apply(r, [c, e])), o))
              switch (o) {
                case "close":
                  r.close(i.startEvent);
                  break;

                case "toggleControls":
                  r.toggleControls();
                  break;

                case "next":
                  r.next();
                  break;

                case "nextOrClose":
                  r.group.length > 1 ? r.next() : r.close(i.startEvent);
                  break;

                case "zoom":
                  "image" == c.type &&
                    (c.isLoaded || c.$ghost) &&
                    (r.canPan()
                      ? r.scaleToFit()
                      : r.isScaledDown()
                      ? r.scaleToActual(d, u)
                      : r.group.length < 2 && r.close(i.startEvent));
              }
          };

        if (
          (!e.originalEvent || 2 != e.originalEvent.button) &&
          (s.is("img") || !(d > s[0].clientWidth + s.offset().left))
        ) {
          if (
            s.is(
              ".fancybox-bg,.fancybox-inner,.fancybox-outer,.fancybox-container"
            )
          )
            o = "Outside";
          else if (s.is(".fancybox-slide")) o = "Slide";
          else {
            if (
              !r.current.$content ||
              !r.current.$content.find(s).addBack().filter(s).length
            )
              return;
            o = "Content";
          }

          if (i.tapped) {
            if (
              (clearTimeout(i.tapped),
              (i.tapped = null),
              Math.abs(d - i.tapX) > 50 || Math.abs(u - i.tapY) > 50)
            )
              return this;
            f("dblclick" + o);
          } else
            (i.tapX = d),
              (i.tapY = u),
              c.opts["dblclick" + o] &&
              c.opts["dblclick" + o] !== c.opts["click" + o]
                ? (i.tapped = setTimeout(function () {
                    (i.tapped = null), r.isAnimating || f("click" + o);
                  }, 500))
                : f("click" + o);

          return this;
        }
      }),
      n(e)
        .on("onActivate.fb", function (t, e) {
          e && !e.Guestures && (e.Guestures = new d(e));
        })
        .on("beforeClose.fb", function (t, e) {
          e && e.Guestures && e.Guestures.destroy();
        });
  })(window, document, jQuery),
  (function (t, e) {
    "use strict";

    e.extend(!0, e.fancybox.defaults, {
      btnTpl: {
        slideShow:
          '<button data-fancybox-play class="fancybox-button fancybox-button--play" title="{{PLAY_START}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M6.5 5.4v13.2l11-6.6z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8.33 5.75h2.2v12.5h-2.2V5.75zm5.15 0h2.2v12.5h-2.2V5.75z"/></svg></button>',
      },
      slideShow: {
        autoStart: !1,
        speed: 3e3,
        progress: !0,
      },
    });

    var n = function n(t) {
      (this.instance = t), this.init();
    };

    e.extend(n.prototype, {
      timer: null,
      isActive: !1,
      $button: null,
      init: function init() {
        var t = this,
          n = t.instance,
          o = n.group[n.currIndex].opts.slideShow;
        (t.$button = n.$refs.toolbar
          .find("[data-fancybox-play]")
          .on("click", function () {
            t.toggle();
          })),
          n.group.length < 2 || !o
            ? t.$button.hide()
            : o.progress &&
              (t.$progress = e(
                '<div class="fancybox-progress"></div>'
              ).appendTo(n.$refs.inner));
      },
      set: function set(t) {
        var n = this,
          o = n.instance,
          i = o.current;
        i && (!0 === t || i.opts.loop || o.currIndex < o.group.length - 1)
          ? n.isActive &&
            "video" !== i.contentType &&
            (n.$progress &&
              e.fancybox.animate(
                n.$progress.show(),
                {
                  scaleX: 1,
                },
                i.opts.slideShow.speed
              ),
            (n.timer = setTimeout(function () {
              o.current.opts.loop || o.current.index != o.group.length - 1
                ? o.next()
                : o.jumpTo(0);
            }, i.opts.slideShow.speed)))
          : (n.stop(), (o.idleSecondsCounter = 0), o.showControls());
      },
      clear: function clear() {
        var t = this;
        clearTimeout(t.timer),
          (t.timer = null),
          t.$progress && t.$progress.removeAttr("style").hide();
      },
      start: function start() {
        var t = this,
          e = t.instance.current;
        e &&
          (t.$button
            .attr(
              "title",
              (e.opts.i18n[e.opts.lang] || e.opts.i18n.en).PLAY_STOP
            )
            .removeClass("fancybox-button--play")
            .addClass("fancybox-button--pause"),
          (t.isActive = !0),
          e.isComplete && t.set(!0),
          t.instance.trigger("onSlideShowChange", !0));
      },
      stop: function stop() {
        var t = this,
          e = t.instance.current;
        t.clear(),
          t.$button
            .attr(
              "title",
              (e.opts.i18n[e.opts.lang] || e.opts.i18n.en).PLAY_START
            )
            .removeClass("fancybox-button--pause")
            .addClass("fancybox-button--play"),
          (t.isActive = !1),
          t.instance.trigger("onSlideShowChange", !1),
          t.$progress && t.$progress.removeAttr("style").hide();
      },
      toggle: function toggle() {
        var t = this;
        t.isActive ? t.stop() : t.start();
      },
    }),
      e(t).on({
        "onInit.fb": function onInitFb(t, e) {
          e && !e.SlideShow && (e.SlideShow = new n(e));
        },
        "beforeShow.fb": function beforeShowFb(t, e, n, o) {
          var i = e && e.SlideShow;
          o
            ? i && n.opts.slideShow.autoStart && i.start()
            : i && i.isActive && i.clear();
        },
        "afterShow.fb": function afterShowFb(t, e, n) {
          var o = e && e.SlideShow;
          o && o.isActive && o.set();
        },
        "afterKeydown.fb": function afterKeydownFb(n, o, i, a, s) {
          var r = o && o.SlideShow;
          !r ||
            !i.opts.slideShow ||
            (80 !== s && 32 !== s) ||
            e(t.activeElement).is("button,a,input") ||
            (a.preventDefault(), r.toggle());
        },
        "beforeClose.fb onDeactivate.fb": function beforeCloseFbOnDeactivateFb(
          t,
          e
        ) {
          var n = e && e.SlideShow;
          n && n.stop();
        },
      }),
      e(t).on("visibilitychange", function () {
        var n = e.fancybox.getInstance(),
          o = n && n.SlideShow;
        o && o.isActive && (t.hidden ? o.clear() : o.set());
      });
  })(document, jQuery),
  (function (t, e) {
    "use strict";

    var n = (function () {
      for (
        var e = [
            [
              "requestFullscreen",
              "exitFullscreen",
              "fullscreenElement",
              "fullscreenEnabled",
              "fullscreenchange",
              "fullscreenerror",
            ],
            [
              "webkitRequestFullscreen",
              "webkitExitFullscreen",
              "webkitFullscreenElement",
              "webkitFullscreenEnabled",
              "webkitfullscreenchange",
              "webkitfullscreenerror",
            ],
            [
              "webkitRequestFullScreen",
              "webkitCancelFullScreen",
              "webkitCurrentFullScreenElement",
              "webkitCancelFullScreen",
              "webkitfullscreenchange",
              "webkitfullscreenerror",
            ],
            [
              "mozRequestFullScreen",
              "mozCancelFullScreen",
              "mozFullScreenElement",
              "mozFullScreenEnabled",
              "mozfullscreenchange",
              "mozfullscreenerror",
            ],
            [
              "msRequestFullscreen",
              "msExitFullscreen",
              "msFullscreenElement",
              "msFullscreenEnabled",
              "MSFullscreenChange",
              "MSFullscreenError",
            ],
          ],
          n = {},
          o = 0;
        o < e.length;
        o++
      ) {
        var i = e[o];

        if (i && i[1] in t) {
          for (var a = 0; a < i.length; a++) {
            n[e[0][a]] = i[a];
          }

          return n;
        }
      }

      return !1;
    })();

    if (n) {
      var o = {
        request: function request(e) {
          (e = e || t.documentElement),
            e[n.requestFullscreen](e.ALLOW_KEYBOARD_INPUT);
        },
        exit: function exit() {
          t[n.exitFullscreen]();
        },
        toggle: function toggle(e) {
          (e = e || t.documentElement),
            this.isFullscreen() ? this.exit() : this.request(e);
        },
        isFullscreen: function isFullscreen() {
          return Boolean(t[n.fullscreenElement]);
        },
        enabled: function enabled() {
          return Boolean(t[n.fullscreenEnabled]);
        },
      };
      e.extend(!0, e.fancybox.defaults, {
        btnTpl: {
          fullScreen:
            '<button data-fancybox-fullscreen class="fancybox-button fancybox-button--fsenter" title="{{FULL_SCREEN}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 16h3v3h2v-5H5zm3-8H5v2h5V5H8zm6 11h2v-3h3v-2h-5zm2-11V5h-2v5h5V8z"/></svg></button>',
        },
        fullScreen: {
          autoStart: !1,
        },
      }),
        e(t).on(n.fullscreenchange, function () {
          var t = o.isFullscreen(),
            n = e.fancybox.getInstance();
          n &&
            (n.current &&
              "image" === n.current.type &&
              n.isAnimating &&
              ((n.isAnimating = !1),
              n.update(!0, !0, 0),
              n.isComplete || n.complete()),
            n.trigger("onFullscreenChange", t),
            n.$refs.container.toggleClass("fancybox-is-fullscreen", t),
            n.$refs.toolbar
              .find("[data-fancybox-fullscreen]")
              .toggleClass("fancybox-button--fsenter", !t)
              .toggleClass("fancybox-button--fsexit", t));
        });
    }

    e(t).on({
      "onInit.fb": function onInitFb(t, e) {
        var i;
        if (!n)
          return void e.$refs.toolbar
            .find("[data-fancybox-fullscreen]")
            .remove();
        e && e.group[e.currIndex].opts.fullScreen
          ? ((i = e.$refs.container),
            i.on(
              "click.fb-fullscreen",
              "[data-fancybox-fullscreen]",
              function (t) {
                t.stopPropagation(), t.preventDefault(), o.toggle();
              }
            ),
            e.opts.fullScreen &&
              !0 === e.opts.fullScreen.autoStart &&
              o.request(),
            (e.FullScreen = o))
          : e && e.$refs.toolbar.find("[data-fancybox-fullscreen]").hide();
      },
      "afterKeydown.fb": function afterKeydownFb(t, e, n, o, i) {
        e &&
          e.FullScreen &&
          70 === i &&
          (o.preventDefault(), e.FullScreen.toggle());
      },
      "beforeClose.fb": function beforeCloseFb(t, e) {
        e &&
          e.FullScreen &&
          e.$refs.container.hasClass("fancybox-is-fullscreen") &&
          o.exit();
      },
    });
  })(document, jQuery),
  (function (t, e) {
    "use strict";

    var n = "fancybox-thumbs";
    e.fancybox.defaults = e.extend(
      !0,
      {
        btnTpl: {
          thumbs:
            '<button data-fancybox-thumbs class="fancybox-button fancybox-button--thumbs" title="{{THUMBS}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M14.59 14.59h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76H5.65V5.65z"/></svg></button>',
        },
        thumbs: {
          autoStart: !1,
          hideOnClose: !0,
          parentEl: ".fancybox-container",
          axis: "y",
        },
      },
      e.fancybox.defaults
    );

    var o = function o(t) {
      this.init(t);
    };

    e.extend(o.prototype, {
      $button: null,
      $grid: null,
      $list: null,
      isVisible: !1,
      isActive: !1,
      init: function init(t) {
        var e = this,
          n = t.group,
          o = 0;
        (e.instance = t),
          (e.opts = n[t.currIndex].opts.thumbs),
          (t.Thumbs = e),
          (e.$button = t.$refs.toolbar.find("[data-fancybox-thumbs]"));

        for (
          var i = 0, a = n.length;
          i < a && (n[i].thumb && o++, !(o > 1));
          i++
        ) {}

        o > 1 && e.opts
          ? (e.$button.removeAttr("style").on("click", function () {
              e.toggle();
            }),
            (e.isActive = !0))
          : e.$button.hide();
      },
      create: function create() {
        var t,
          o = this,
          i = o.instance,
          a = o.opts.parentEl,
          s = [];
        o.$grid ||
          ((o.$grid = e(
            '<div class="' + n + " " + n + "-" + o.opts.axis + '"></div>'
          ).appendTo(i.$refs.container.find(a).addBack().filter(a))),
          o.$grid.on("click", "a", function () {
            i.jumpTo(e(this).attr("data-index"));
          })),
          o.$list ||
            (o.$list = e('<div class="' + n + '__list">').appendTo(o.$grid)),
          e.each(i.group, function (e, n) {
            (t = n.thumb),
              t || "image" !== n.type || (t = n.src),
              s.push(
                '<a href="javascript:;" tabindex="0" data-index="' +
                  e +
                  '"' +
                  (t && t.length
                    ? ' style="background-image:url(' + t + ')"'
                    : 'class="fancybox-thumbs-missing"') +
                  "></a>"
              );
          }),
          (o.$list[0].innerHTML = s.join("")),
          "x" === o.opts.axis &&
            o.$list.width(
              parseInt(o.$grid.css("padding-right"), 10) +
                i.group.length * o.$list.children().eq(0).outerWidth(!0)
            );
      },
      focus: function focus(t) {
        var e,
          n,
          o = this,
          i = o.$list,
          a = o.$grid;
        o.instance.current &&
          ((e = i
            .children()
            .removeClass("fancybox-thumbs-active")
            .filter('[data-index="' + o.instance.current.index + '"]')
            .addClass("fancybox-thumbs-active")),
          (n = e.position()),
          "y" === o.opts.axis &&
          (n.top < 0 || n.top > i.height() - e.outerHeight())
            ? i.stop().animate(
                {
                  scrollTop: i.scrollTop() + n.top,
                },
                t
              )
            : "x" === o.opts.axis &&
              (n.left < a.scrollLeft() ||
                n.left > a.scrollLeft() + (a.width() - e.outerWidth())) &&
              i.parent().stop().animate(
                {
                  scrollLeft: n.left,
                },
                t
              ));
      },
      update: function update() {
        var t = this;
        t.instance.$refs.container.toggleClass(
          "fancybox-show-thumbs",
          this.isVisible
        ),
          t.isVisible
            ? (t.$grid || t.create(),
              t.instance.trigger("onThumbsShow"),
              t.focus(0))
            : t.$grid && t.instance.trigger("onThumbsHide"),
          t.instance.update();
      },
      hide: function hide() {
        (this.isVisible = !1), this.update();
      },
      show: function show() {
        (this.isVisible = !0), this.update();
      },
      toggle: function toggle() {
        (this.isVisible = !this.isVisible), this.update();
      },
    }),
      e(t).on({
        "onInit.fb": function onInitFb(t, e) {
          var n;
          e &&
            !e.Thumbs &&
            ((n = new o(e)), n.isActive && !0 === n.opts.autoStart && n.show());
        },
        "beforeShow.fb": function beforeShowFb(t, e, n, o) {
          var i = e && e.Thumbs;
          i && i.isVisible && i.focus(o ? 0 : 250);
        },
        "afterKeydown.fb": function afterKeydownFb(t, e, n, o, i) {
          var a = e && e.Thumbs;
          a && a.isActive && 71 === i && (o.preventDefault(), a.toggle());
        },
        "beforeClose.fb": function beforeCloseFb(t, e) {
          var n = e && e.Thumbs;
          n && n.isVisible && !1 !== n.opts.hideOnClose && n.$grid.hide();
        },
      });
  })(document, jQuery),
  (function (t, e) {
    "use strict";

    function n(t) {
      var e = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
        "/": "&#x2F;",
        "`": "&#x60;",
        "=": "&#x3D;",
      };
      return String(t).replace(/[&<>"'`=\/]/g, function (t) {
        return e[t];
      });
    }

    e.extend(!0, e.fancybox.defaults, {
      btnTpl: {
        share:
          '<button data-fancybox-share class="fancybox-button fancybox-button--share" title="{{SHARE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M2.55 19c1.4-8.4 9.1-9.8 11.9-9.8V5l7 7-7 6.3v-3.5c-2.8 0-10.5 2.1-11.9 4.2z"/></svg></button>',
      },
      share: {
        url: function url(t, e) {
          return (
            (!t.currentHash &&
              "inline" !== e.type &&
              "html" !== e.type &&
              (e.origSrc || e.src)) ||
            window.location
          );
        },
        tpl: '<div class="fancybox-share"><h1>{{SHARE}}</h1><p><a class="fancybox-share__button fancybox-share__button--fb" href="https://www.facebook.com/sharer/sharer.php?u={{url}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m287 456v-299c0-21 6-35 35-35h38v-63c-7-1-29-3-55-3-54 0-91 33-91 94v306m143-254h-205v72h196" /></svg><span>Facebook</span></a><a class="fancybox-share__button fancybox-share__button--tw" href="https://twitter.com/intent/tweet?url={{url}}&text={{descr}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m456 133c-14 7-31 11-47 13 17-10 30-27 37-46-15 10-34 16-52 20-61-62-157-7-141 75-68-3-129-35-169-85-22 37-11 86 26 109-13 0-26-4-37-9 0 39 28 72 65 80-12 3-25 4-37 2 10 33 41 57 77 57-42 30-77 38-122 34 170 111 378-32 359-208 16-11 30-25 41-42z" /></svg><span>Twitter</span></a><a class="fancybox-share__button fancybox-share__button--pt" href="https://www.pinterest.com/pin/create/button/?url={{url}}&description={{descr}}&media={{media}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m265 56c-109 0-164 78-164 144 0 39 15 74 47 87 5 2 10 0 12-5l4-19c2-6 1-8-3-13-9-11-15-25-15-45 0-58 43-110 113-110 62 0 96 38 96 88 0 67-30 122-73 122-24 0-42-19-36-44 6-29 20-60 20-81 0-19-10-35-31-35-25 0-44 26-44 60 0 21 7 36 7 36l-30 125c-8 37-1 83 0 87 0 3 4 4 5 2 2-3 32-39 42-75l16-64c8 16 31 29 56 29 74 0 124-67 124-157 0-69-58-132-146-132z" fill="#fff"/></svg><span>Pinterest</span></a></p><p><input class="fancybox-share__input" type="text" value="{{url_raw}}" onclick="select()" /></p></div>',
      },
    }),
      e(t).on("click", "[data-fancybox-share]", function () {
        var t,
          o,
          i = e.fancybox.getInstance(),
          a = i.current || null;
        a &&
          ("function" === e.type(a.opts.share.url) &&
            (t = a.opts.share.url.apply(a, [i, a])),
          (o = a.opts.share.tpl
            .replace(
              /\{\{media\}\}/g,
              "image" === a.type ? encodeURIComponent(a.src) : ""
            )
            .replace(/\{\{url\}\}/g, encodeURIComponent(t))
            .replace(/\{\{url_raw\}\}/g, n(t))
            .replace(
              /\{\{descr\}\}/g,
              i.$caption ? encodeURIComponent(i.$caption.text()) : ""
            )),
          e.fancybox.open({
            src: i.translate(i, o),
            type: "html",
            opts: {
              touch: !1,
              animationEffect: !1,
              afterLoad: function afterLoad(t, e) {
                i.$refs.container.one("beforeClose.fb", function () {
                  t.close(null, 0);
                }),
                  e.$content.find(".fancybox-share__button").click(function () {
                    return (
                      window.open(this.href, "Share", "width=550, height=450"),
                      !1
                    );
                  });
              },
              mobile: {
                autoFocus: !1,
              },
            },
          }));
      });
  })(document, jQuery),
  (function (t, e, n) {
    "use strict";

    function o() {
      var e = t.location.hash.substr(1),
        n = e.split("-"),
        o =
          n.length > 1 && /^\+?\d+$/.test(n[n.length - 1])
            ? parseInt(n.pop(-1), 10) || 1
            : 1,
        i = n.join("-");
      return {
        hash: e,
        index: o < 1 ? 1 : o,
        gallery: i,
      };
    }

    function i(t) {
      "" !== t.gallery &&
        n("[data-fancybox='" + n.escapeSelector(t.gallery) + "']")
          .eq(t.index - 1)
          .focus()
          .trigger("click.fb-start");
    }

    function a(t) {
      var e, n;
      return (
        !!t &&
        ((e = t.current ? t.current.opts : t.opts),
        "" !==
          (n =
            e.hash ||
            (e.$orig
              ? e.$orig.data("fancybox") || e.$orig.data("fancybox-trigger")
              : "")) && n)
      );
    }

    n.escapeSelector ||
      (n.escapeSelector = function (t) {
        return (t + "").replace(
          /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g,
          function (t, e) {
            return e
              ? "\0" === t
                ? "�"
                : t.slice(0, -1) +
                  "\\" +
                  t.charCodeAt(t.length - 1).toString(16) +
                  " "
              : "\\" + t;
          }
        );
      }),
      n(function () {
        !1 !== n.fancybox.defaults.hash &&
          (n(e).on({
            "onInit.fb": function onInitFb(t, e) {
              var n, i;
              !1 !== e.group[e.currIndex].opts.hash &&
                ((n = o()),
                (i = a(e)) &&
                  n.gallery &&
                  i == n.gallery &&
                  (e.currIndex = n.index - 1));
            },
            "beforeShow.fb": function beforeShowFb(n, o, i, s) {
              var r;
              i &&
                !1 !== i.opts.hash &&
                (r = a(o)) &&
                ((o.currentHash =
                  r + (o.group.length > 1 ? "-" + (i.index + 1) : "")),
                t.location.hash !== "#" + o.currentHash &&
                  (s && !o.origHash && (o.origHash = t.location.hash),
                  o.hashTimer && clearTimeout(o.hashTimer),
                  (o.hashTimer = setTimeout(function () {
                    "replaceState" in t.history
                      ? (t.history[s ? "pushState" : "replaceState"](
                          {},
                          e.title,
                          t.location.pathname +
                            t.location.search +
                            "#" +
                            o.currentHash
                        ),
                        s && (o.hasCreatedHistory = !0))
                      : (t.location.hash = o.currentHash),
                      (o.hashTimer = null);
                  }, 300))));
            },
            "beforeClose.fb": function beforeCloseFb(n, o, i) {
              i &&
                !1 !== i.opts.hash &&
                (clearTimeout(o.hashTimer),
                o.currentHash && o.hasCreatedHistory
                  ? t.history.back()
                  : o.currentHash &&
                    ("replaceState" in t.history
                      ? t.history.replaceState(
                          {},
                          e.title,
                          t.location.pathname +
                            t.location.search +
                            (o.origHash || "")
                        )
                      : (t.location.hash = o.origHash)),
                (o.currentHash = null));
            },
          }),
          n(t).on("hashchange.fb", function () {
            var t = o(),
              e = null;
            n.each(n(".fancybox-container").get().reverse(), function (t, o) {
              var i = n(o).data("FancyBox");
              if (i && i.currentHash) return (e = i), !1;
            }),
              e
                ? e.currentHash === t.gallery + "-" + t.index ||
                  (1 === t.index && e.currentHash == t.gallery) ||
                  ((e.currentHash = null), e.close())
                : "" !== t.gallery && i(t);
          }),
          setTimeout(function () {
            n.fancybox.getInstance() || i(o());
          }, 50));
      });
  })(window, document, jQuery),
  (function (t, e) {
    "use strict";

    var n = new Date().getTime();
    e(t).on({
      "onInit.fb": function onInitFb(t, e, o) {
        e.$refs.stage.on(
          "mousewheel DOMMouseScroll wheel MozMousePixelScroll",
          function (t) {
            var o = e.current,
              i = new Date().getTime();
            e.group.length < 2 ||
              !1 === o.opts.wheel ||
              ("auto" === o.opts.wheel && "image" !== o.type) ||
              (t.preventDefault(),
              t.stopPropagation(),
              o.$slide.hasClass("fancybox-animated") ||
                ((t = t.originalEvent || t),
                i - n < 250 ||
                  ((n = i),
                  e[
                    (-t.deltaY || -t.deltaX || t.wheelDelta || -t.detail) < 0
                      ? "next"
                      : "previous"
                  ]())));
          }
        );
      },
    });
  })(document, jQuery);
/*! lazysizes - v5.3.2 */

!(function (e, t) {
  var a = function a() {
    t(e.lazySizes), e.removeEventListener("lazyunveilread", a, !0);
  };

  (t = t.bind(null, e, e.document)),
    "object" ==
      (typeof module === "undefined" ? "undefined" : _typeof(module)) &&
    module.exports
      ? t(require("lazysizes"))
      : "function" == typeof define && define.amd
      ? define(["lazysizes"], t)
      : e.lazySizes
      ? a()
      : e.addEventListener("lazyunveilread", a, !0);
})(window, function (e, z, c) {
  "use strict";

  var g, y, b, f, r, l, s, v, m;
  e.addEventListener &&
    ((g = c.cfg),
    (y = /\s+/g),
    (b = /\s*\|\s+|\s+\|\s*/g),
    (f = /^(.+?)(?:\s+\[\s*(.+?)\s*\])(?:\s+\[\s*(.+?)\s*\])?$/),
    (r = /^\s*\(*\s*type\s*:\s*(.+?)\s*\)*\s*$/),
    (l = /\(|\)|'/),
    (s = {
      contain: 1,
      cover: 1,
    }),
    (v = function v(e, t) {
      var a;
      t &&
        ((a = t.match(r)) && a[1]
          ? e.setAttribute("type", a[1])
          : e.setAttribute("media", g.customMedia[t] || t));
    }),
    (m = function m(e) {
      var t, a, r, i, s;
      e.target._lazybgset &&
        ((a = (t = e.target)._lazybgset),
        (r = t.currentSrc || t.src) &&
          ((i = l.test(r) ? JSON.stringify(r) : r),
          (s = c.fire(a, "bgsetproxy", {
            src: r,
            useSrc: i,
            fullSrc: null,
          })).defaultPrevented ||
            (a.style.backgroundImage =
              s.detail.fullSrc || "url(" + s.detail.useSrc + ")")),
        t._lazybgsetLoading &&
          (c.fire(a, "_lazyloaded", {}, !1, !0), delete t._lazybgsetLoading));
    }),
    addEventListener("lazybeforeunveil", function (e) {
      var t, a, r, i, s, l, n, d, u, o;
      !e.defaultPrevented &&
        (t = e.target.getAttribute("data-bgset")) &&
        ((u = e.target),
        ((o = z.createElement("img")).alt = ""),
        (o._lazybgsetLoading = !0),
        (e.detail.firesLoad = !0),
        (a = t),
        (r = u),
        (i = o),
        (s = z.createElement("picture")),
        (l = r.getAttribute(g.sizesAttr)),
        (n = r.getAttribute("data-ratio")),
        (d = r.getAttribute("data-optimumx")),
        r._lazybgset &&
          r._lazybgset.parentNode == r &&
          r.removeChild(r._lazybgset),
        Object.defineProperty(i, "_lazybgset", {
          value: r,
          writable: !0,
        }),
        Object.defineProperty(r, "_lazybgset", {
          value: s,
          writable: !0,
        }),
        (a = a.replace(y, " ").split(b)),
        (s.style.display = "none"),
        (i.className = g.lazyClass),
        1 != a.length || l || (l = "auto"),
        a.forEach(function (e) {
          var t,
            a = z.createElement("source");
          l && "auto" != l && a.setAttribute("sizes", l),
            (t = e.match(f))
              ? (a.setAttribute(g.srcsetAttr, t[1]), v(a, t[2]), v(a, t[3]))
              : a.setAttribute(g.srcsetAttr, e),
            s.appendChild(a);
        }),
        l &&
          (i.setAttribute(g.sizesAttr, l),
          r.removeAttribute(g.sizesAttr),
          r.removeAttribute("sizes")),
        d && i.setAttribute("data-optimumx", d),
        n && i.setAttribute("data-ratio", n),
        s.appendChild(i),
        r.appendChild(s),
        setTimeout(function () {
          c.loader.unveil(o),
            c.rAF(function () {
              c.fire(o, "_lazyloaded", {}, !0, !0),
                o.complete &&
                  m({
                    target: o,
                  });
            });
        }));
    }),
    z.addEventListener("load", m, !0),
    e.addEventListener(
      "lazybeforesizes",
      function (e) {
        var t, a, r, i;
        e.detail.instance == c &&
          e.target._lazybgset &&
          e.detail.dataAttr &&
          ((t = e.target._lazybgset),
          (r = t),
          (i = (
            getComputedStyle(r) || {
              getPropertyValue: function getPropertyValue() {},
            }
          ).getPropertyValue("background-size")),
          !s[i] && s[r.style.backgroundSize] && (i = r.style.backgroundSize),
          s[(a = i)] &&
            ((e.target._lazysizesParentFit = a),
            c.rAF(function () {
              e.target.setAttribute("data-parent-fit", a),
                e.target._lazysizesParentFit &&
                  delete e.target._lazysizesParentFit;
            })));
      },
      !0
    ),
    z.documentElement.addEventListener("lazybeforesizes", function (e) {
      var t, a;
      !e.defaultPrevented &&
        e.target._lazybgset &&
        e.detail.instance == c &&
        (e.detail.width =
          ((t = e.target._lazybgset),
          (a = c.gW(t, t.parentNode)),
          (!t._lazysizesWidth || a > t._lazysizesWidth) &&
            (t._lazysizesWidth = a),
          t._lazysizesWidth));
    }));
});
/*! lazysizes - v5.3.2 */

!(function (e) {
  var t = (function (u, D, f) {
    "use strict";

    var k, H;

    if (
      ((function () {
        var e;
        var t = {
          lazyClass: "lazyload",
          loadedClass: "lazyloaded",
          loadingClass: "lazyloading",
          preloadClass: "lazypreload",
          errorClass: "lazyerror",
          autosizesClass: "lazyautosizes",
          fastLoadedClass: "ls-is-cached",
          iframeLoadMode: 0,
          srcAttr: "data-src",
          srcsetAttr: "data-srcset",
          sizesAttr: "data-sizes",
          minSize: 40,
          customMedia: {},
          init: true,
          expFactor: 1.5,
          hFac: 0.8,
          loadMode: 2,
          loadHidden: true,
          ricTimeout: 0,
          throttleDelay: 125,
        };
        H = u.lazySizesConfig || u.lazysizesConfig || {};

        for (e in t) {
          if (!(e in H)) {
            H[e] = t[e];
          }
        }
      })(),
      !D || !D.getElementsByClassName)
    ) {
      return {
        init: function init() {},
        cfg: H,
        noSupport: true,
      };
    }

    var O = D.documentElement,
      i = u.HTMLPictureElement,
      P = "addEventListener",
      $ = "getAttribute",
      q = u[P].bind(u),
      I = u.setTimeout,
      U = u.requestAnimationFrame || I,
      o = u.requestIdleCallback,
      j = /^picture$/i,
      r = ["load", "error", "lazyincluded", "_lazyloaded"],
      a = {},
      G = Array.prototype.forEach,
      J = function J(e, t) {
        if (!a[t]) {
          a[t] = new RegExp("(\\s|^)" + t + "(\\s|$)");
        }

        return a[t].test(e[$]("class") || "") && a[t];
      },
      K = function K(e, t) {
        if (!J(e, t)) {
          e.setAttribute("class", (e[$]("class") || "").trim() + " " + t);
        }
      },
      Q = function Q(e, t) {
        var a;

        if ((a = J(e, t))) {
          e.setAttribute("class", (e[$]("class") || "").replace(a, " "));
        }
      },
      V = function V(t, a, e) {
        var i = e ? P : "removeEventListener";

        if (e) {
          V(t, a);
        }

        r.forEach(function (e) {
          t[i](e, a);
        });
      },
      X = function X(e, t, a, i, r) {
        var n = D.createEvent("Event");

        if (!a) {
          a = {};
        }

        a.instance = k;
        n.initEvent(t, !i, !r);
        n.detail = a;
        e.dispatchEvent(n);
        return n;
      },
      Y = function Y(e, t) {
        var a;

        if (!i && (a = u.picturefill || H.pf)) {
          if (t && t.src && !e[$]("srcset")) {
            e.setAttribute("srcset", t.src);
          }

          a({
            reevaluate: true,
            elements: [e],
          });
        } else if (t && t.src) {
          e.src = t.src;
        }
      },
      Z = function Z(e, t) {
        return (getComputedStyle(e, null) || {})[t];
      },
      s = function s(e, t, a) {
        a = a || e.offsetWidth;

        while (a < H.minSize && t && !e._lazysizesWidth) {
          a = t.offsetWidth;
          t = t.parentNode;
        }

        return a;
      },
      ee = (function () {
        var a, i;
        var t = [];
        var r = [];
        var n = t;

        var s = function s() {
          var e = n;
          n = t.length ? r : t;
          a = true;
          i = false;

          while (e.length) {
            e.shift()();
          }

          a = false;
        };

        var e = function e(_e, t) {
          if (a && !t) {
            _e.apply(this, arguments);
          } else {
            n.push(_e);

            if (!i) {
              i = true;
              (D.hidden ? I : U)(s);
            }
          }
        };

        e._lsFlush = s;
        return e;
      })(),
      te = function te(a, e) {
        return e
          ? function () {
              ee(a);
            }
          : function () {
              var e = this;
              var t = arguments;
              ee(function () {
                a.apply(e, t);
              });
            };
      },
      ae = function ae(e) {
        var a;
        var i = 0;
        var r = H.throttleDelay;
        var n = H.ricTimeout;

        var t = function t() {
          a = false;
          i = f.now();
          e();
        };

        var s =
          o && n > 49
            ? function () {
                o(t, {
                  timeout: n,
                });

                if (n !== H.ricTimeout) {
                  n = H.ricTimeout;
                }
              }
            : te(function () {
                I(t);
              }, true);
        return function (e) {
          var t;

          if ((e = e === true)) {
            n = 33;
          }

          if (a) {
            return;
          }

          a = true;
          t = r - (f.now() - i);

          if (t < 0) {
            t = 0;
          }

          if (e || t < 9) {
            s();
          } else {
            I(s, t);
          }
        };
      },
      ie = function ie(e) {
        var t, a;
        var i = 99;

        var r = function r() {
          t = null;
          e();
        };

        var n = function n() {
          var e = f.now() - a;

          if (e < i) {
            I(n, i - e);
          } else {
            (o || r)(r);
          }
        };

        return function () {
          a = f.now();

          if (!t) {
            t = I(n, i);
          }
        };
      },
      e = (function () {
        var v, m, c, h, e;
        var y, z, g, p, C, b, A;
        var n = /^img$/i;
        var d = /^iframe$/i;
        var E = "onscroll" in u && !/(gle|ing)bot/.test(navigator.userAgent);
        var _ = 0;
        var w = 0;
        var M = 0;
        var N = -1;

        var L = function L(e) {
          M--;

          if (!e || M < 0 || !e.target) {
            M = 0;
          }
        };

        var x = function x(e) {
          if (A == null) {
            A = Z(D.body, "visibility") == "hidden";
          }

          return (
            A ||
            !(
              Z(e.parentNode, "visibility") == "hidden" &&
              Z(e, "visibility") == "hidden"
            )
          );
        };

        var W = function W(e, t) {
          var a;
          var i = e;
          var r = x(e);
          g -= t;
          b += t;
          p -= t;
          C += t;

          while (r && (i = i.offsetParent) && i != D.body && i != O) {
            r = (Z(i, "opacity") || 1) > 0;

            if (r && Z(i, "overflow") != "visible") {
              a = i.getBoundingClientRect();
              r =
                C > a.left && p < a.right && b > a.top - 1 && g < a.bottom + 1;
            }
          }

          return r;
        };

        var t = function t() {
          var e, t, a, i, r, n, s, o, l, u, f, c;
          var d = k.elements;

          if ((h = H.loadMode) && M < 8 && (e = d.length)) {
            t = 0;
            N++;

            for (; t < e; t++) {
              if (!d[t] || d[t]._lazyRace) {
                continue;
              }

              if (!E || (k.prematureUnveil && k.prematureUnveil(d[t]))) {
                R(d[t]);
                continue;
              }

              if (!(o = d[t][$]("data-expand")) || !(n = o * 1)) {
                n = w;
              }

              if (!u) {
                u =
                  !H.expand || H.expand < 1
                    ? O.clientHeight > 500 && O.clientWidth > 500
                      ? 500
                      : 370
                    : H.expand;
                k._defEx = u;
                f = u * H.expFactor;
                c = H.hFac;
                A = null;

                if (w < f && M < 1 && N > 2 && h > 2 && !D.hidden) {
                  w = f;
                  N = 0;
                } else if (h > 1 && N > 1 && M < 6) {
                  w = u;
                } else {
                  w = _;
                }
              }

              if (l !== n) {
                y = innerWidth + n * c;
                z = innerHeight + n;
                s = n * -1;
                l = n;
              }

              a = d[t].getBoundingClientRect();

              if (
                (b = a.bottom) >= s &&
                (g = a.top) <= z &&
                (C = a.right) >= s * c &&
                (p = a.left) <= y &&
                (b || C || p || g) &&
                (H.loadHidden || x(d[t])) &&
                ((m && M < 3 && !o && (h < 3 || N < 4)) || W(d[t], n))
              ) {
                R(d[t]);
                r = true;

                if (M > 9) {
                  break;
                }
              } else if (
                !r &&
                m &&
                !i &&
                M < 4 &&
                N < 4 &&
                h > 2 &&
                (v[0] || H.preloadAfterLoad) &&
                (v[0] ||
                  (!o && (b || C || p || g || d[t][$](H.sizesAttr) != "auto")))
              ) {
                i = v[0] || d[t];
              }
            }

            if (i && !r) {
              R(i);
            }
          }
        };

        var a = ae(t);

        var S = function S(e) {
          var t = e.target;

          if (t._lazyCache) {
            delete t._lazyCache;
            return;
          }

          L(e);
          K(t, H.loadedClass);
          Q(t, H.loadingClass);
          V(t, B);
          X(t, "lazyloaded");
        };

        var i = te(S);

        var B = function B(e) {
          i({
            target: e.target,
          });
        };

        var T = function T(e, t) {
          var a = e.getAttribute("data-load-mode") || H.iframeLoadMode;

          if (a == 0) {
            e.contentWindow.location.replace(t);
          } else if (a == 1) {
            e.src = t;
          }
        };

        var F = function F(e) {
          var t;
          var a = e[$](H.srcsetAttr);

          if ((t = H.customMedia[e[$]("data-media") || e[$]("media")])) {
            e.setAttribute("media", t);
          }

          if (a) {
            e.setAttribute("srcset", a);
          }
        };

        var s = te(function (t, e, a, i, r) {
          var n, s, o, l, u, f;

          if (!(u = X(t, "lazybeforeunveil", e)).defaultPrevented) {
            if (i) {
              if (a) {
                K(t, H.autosizesClass);
              } else {
                t.setAttribute("sizes", i);
              }
            }

            s = t[$](H.srcsetAttr);
            n = t[$](H.srcAttr);

            if (r) {
              o = t.parentNode;
              l = o && j.test(o.nodeName || "");
            }

            f = e.firesLoad || ("src" in t && (s || n || l));
            u = {
              target: t,
            };
            K(t, H.loadingClass);

            if (f) {
              clearTimeout(c);
              c = I(L, 2500);
              V(t, B, true);
            }

            if (l) {
              G.call(o.getElementsByTagName("source"), F);
            }

            if (s) {
              t.setAttribute("srcset", s);
            } else if (n && !l) {
              if (d.test(t.nodeName)) {
                T(t, n);
              } else {
                t.src = n;
              }
            }

            if (r && (s || l)) {
              Y(t, {
                src: n,
              });
            }
          }

          if (t._lazyRace) {
            delete t._lazyRace;
          }

          Q(t, H.lazyClass);
          ee(function () {
            var e = t.complete && t.naturalWidth > 1;

            if (!f || e) {
              if (e) {
                K(t, H.fastLoadedClass);
              }

              S(u);
              t._lazyCache = true;
              I(function () {
                if ("_lazyCache" in t) {
                  delete t._lazyCache;
                }
              }, 9);
            }

            if (t.loading == "lazy") {
              M--;
            }
          }, true);
        });

        var R = function R(e) {
          if (e._lazyRace) {
            return;
          }

          var t;
          var a = n.test(e.nodeName);
          var i = a && (e[$](H.sizesAttr) || e[$]("sizes"));
          var r = i == "auto";

          if (
            (r || !m) &&
            a &&
            (e[$]("src") || e.srcset) &&
            !e.complete &&
            !J(e, H.errorClass) &&
            J(e, H.lazyClass)
          ) {
            return;
          }

          t = X(e, "lazyunveilread").detail;

          if (r) {
            re.updateElem(e, true, e.offsetWidth);
          }

          e._lazyRace = true;
          M++;
          s(e, t, r, i, a);
        };

        var r = ie(function () {
          H.loadMode = 3;
          a();
        });

        var o = function o() {
          if (H.loadMode == 3) {
            H.loadMode = 2;
          }

          r();
        };

        var l = function l() {
          if (m) {
            return;
          }

          if (f.now() - e < 999) {
            I(l, 999);
            return;
          }

          m = true;
          H.loadMode = 3;
          a();
          q("scroll", o, true);
        };

        return {
          _: function _() {
            e = f.now();
            k.elements = D.getElementsByClassName(H.lazyClass);
            v = D.getElementsByClassName(H.lazyClass + " " + H.preloadClass);
            q("scroll", a, true);
            q("resize", a, true);
            q("pageshow", function (e) {
              if (e.persisted) {
                var t = D.querySelectorAll("." + H.loadingClass);

                if (t.length && t.forEach) {
                  U(function () {
                    t.forEach(function (e) {
                      if (e.complete) {
                        R(e);
                      }
                    });
                  });
                }
              }
            });

            if (u.MutationObserver) {
              new MutationObserver(a).observe(O, {
                childList: true,
                subtree: true,
                attributes: true,
              });
            } else {
              O[P]("DOMNodeInserted", a, true);
              O[P]("DOMAttrModified", a, true);
              setInterval(a, 999);
            }

            q("hashchange", a, true);
            [
              "focus",
              "mouseover",
              "click",
              "load",
              "transitionend",
              "animationend",
            ].forEach(function (e) {
              D[P](e, a, true);
            });

            if (/d$|^c/.test(D.readyState)) {
              l();
            } else {
              q("load", l);
              D[P]("DOMContentLoaded", a);
              I(l, 2e4);
            }

            if (k.elements.length) {
              t();

              ee._lsFlush();
            } else {
              a();
            }
          },
          checkElems: a,
          unveil: R,
          _aLSL: o,
        };
      })(),
      re = (function () {
        var a;
        var n = te(function (e, t, a, i) {
          var r, n, s;
          e._lazysizesWidth = i;
          i += "px";
          e.setAttribute("sizes", i);

          if (j.test(t.nodeName || "")) {
            r = t.getElementsByTagName("source");

            for (n = 0, s = r.length; n < s; n++) {
              r[n].setAttribute("sizes", i);
            }
          }

          if (!a.detail.dataAttr) {
            Y(e, a.detail);
          }
        });

        var i = function i(e, t, a) {
          var i;
          var r = e.parentNode;

          if (r) {
            a = s(e, r, a);
            i = X(e, "lazybeforesizes", {
              width: a,
              dataAttr: !!t,
            });

            if (!i.defaultPrevented) {
              a = i.detail.width;

              if (a && a !== e._lazysizesWidth) {
                n(e, r, i, a);
              }
            }
          }
        };

        var e = function e() {
          var e;
          var t = a.length;

          if (t) {
            e = 0;

            for (; e < t; e++) {
              i(a[e]);
            }
          }
        };

        var t = ie(e);
        return {
          _: function _() {
            a = D.getElementsByClassName(H.autosizesClass);
            q("resize", t);
          },
          checkElems: t,
          updateElem: i,
        };
      })(),
      t = function t() {
        if (!t.i && D.getElementsByClassName) {
          t.i = true;

          re._();

          e._();
        }
      };

    return (
      I(function () {
        H.init && t();
      }),
      (k = {
        cfg: H,
        autoSizer: re,
        loader: e,
        init: t,
        uP: Y,
        aC: K,
        rC: Q,
        hC: J,
        fire: X,
        gW: s,
        rAF: ee,
      })
    );
  })(e, e.document, Date);

  (e.lazySizes = t),
    "object" ==
      (typeof module === "undefined" ? "undefined" : _typeof(module)) &&
      module.exports &&
      (module.exports = t);
})("undefined" != typeof window ? window : {});
document.addEventListener("DOMContentLoaded", function () {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy-video"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];

            if (
              typeof videoSource.tagName === "string" &&
              videoSource.tagName === "SOURCE"
            ) {
              console.log(videoSource);
              videoSource.src = videoSource.dataset.videoSrc;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });
    lazyVideos.forEach(function (lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
});
/**
 * Swiper 6.5.3
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2021 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: March 31, 2021
 */

!(function (e, t) {
  "object" ==
    (typeof exports === "undefined" ? "undefined" : _typeof(exports)) &&
  "undefined" != typeof module
    ? (module.exports = t())
    : "function" == typeof define && define.amd
    ? define(t)
    : ((e = "undefined" != typeof globalThis ? globalThis : e || self).Swiper =
        t());
})(this, function () {
  "use strict";

  function e(e, t) {
    for (var a = 0; a < t.length; a++) {
      var i = t[a];
      (i.enumerable = i.enumerable || !1),
        (i.configurable = !0),
        "value" in i && (i.writable = !0),
        Object.defineProperty(e, i.key, i);
    }
  }

  function t() {
    return (t =
      Object.assign ||
      function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var a = arguments[t];

          for (var i in a) {
            Object.prototype.hasOwnProperty.call(a, i) && (e[i] = a[i]);
          }
        }

        return e;
      }).apply(this, arguments);
  }

  function a(e) {
    return (
      null !== e &&
      "object" == _typeof(e) &&
      "constructor" in e &&
      e.constructor === Object
    );
  }

  function i(e, t) {
    void 0 === e && (e = {}),
      void 0 === t && (t = {}),
      Object.keys(t).forEach(function (s) {
        void 0 === e[s]
          ? (e[s] = t[s])
          : a(t[s]) && a(e[s]) && Object.keys(t[s]).length > 0 && i(e[s], t[s]);
      });
  }

  var s = {
    body: {},
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    activeElement: {
      blur: function blur() {},
      nodeName: "",
    },
    querySelector: function querySelector() {
      return null;
    },
    querySelectorAll: function querySelectorAll() {
      return [];
    },
    getElementById: function getElementById() {
      return null;
    },
    createEvent: function createEvent() {
      return {
        initEvent: function initEvent() {},
      };
    },
    createElement: function createElement() {
      return {
        children: [],
        childNodes: [],
        style: {},
        setAttribute: function setAttribute() {},
        getElementsByTagName: function getElementsByTagName() {
          return [];
        },
      };
    },
    createElementNS: function createElementNS() {
      return {};
    },
    importNode: function importNode() {
      return null;
    },
    location: {
      hash: "",
      host: "",
      hostname: "",
      href: "",
      origin: "",
      pathname: "",
      protocol: "",
      search: "",
    },
  };

  function r() {
    var e = "undefined" != typeof document ? document : {};
    return i(e, s), e;
  }

  var n = {
    document: s,
    navigator: {
      userAgent: "",
    },
    location: {
      hash: "",
      host: "",
      hostname: "",
      href: "",
      origin: "",
      pathname: "",
      protocol: "",
      search: "",
    },
    history: {
      replaceState: function replaceState() {},
      pushState: function pushState() {},
      go: function go() {},
      back: function back() {},
    },
    CustomEvent: function CustomEvent() {
      return this;
    },
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    getComputedStyle: function getComputedStyle() {
      return {
        getPropertyValue: function getPropertyValue() {
          return "";
        },
      };
    },
    Image: function Image() {},
    Date: function Date() {},
    screen: {},
    setTimeout: function setTimeout() {},
    clearTimeout: function clearTimeout() {},
    matchMedia: function matchMedia() {
      return {};
    },
    requestAnimationFrame: function requestAnimationFrame(e) {
      return "undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0);
    },
    cancelAnimationFrame: function cancelAnimationFrame(e) {
      "undefined" != typeof setTimeout && clearTimeout(e);
    },
  };

  function l() {
    var e = "undefined" != typeof window ? window : {};
    return i(e, n), e;
  }

  function o(e) {
    return (o = Object.setPrototypeOf
      ? Object.getPrototypeOf
      : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
  }

  function d(e, t) {
    return (d =
      Object.setPrototypeOf ||
      function (e, t) {
        return (e.__proto__ = t), e;
      })(e, t);
  }

  function p() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return (
        Date.prototype.toString.call(
          Reflect.construct(Date, [], function () {})
        ),
        !0
      );
    } catch (e) {
      return !1;
    }
  }

  function c(e, t, a) {
    return (c = p()
      ? Reflect.construct
      : function (e, t, a) {
          var i = [null];
          i.push.apply(i, t);
          var s = new (Function.bind.apply(e, i))();
          return a && d(s, a.prototype), s;
        }).apply(null, arguments);
  }

  function u(e) {
    var t = "function" == typeof Map ? new Map() : void 0;
    return (u = function u(e) {
      if (
        null === e ||
        ((a = e), -1 === Function.toString.call(a).indexOf("[native code]"))
      )
        return e;
      var a;
      if ("function" != typeof e)
        throw new TypeError(
          "Super expression must either be null or a function"
        );

      if (void 0 !== t) {
        if (t.has(e)) return t.get(e);
        t.set(e, i);
      }

      function i() {
        return c(e, arguments, o(this).constructor);
      }

      return (
        (i.prototype = Object.create(e.prototype, {
          constructor: {
            value: i,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
        d(i, e)
      );
    })(e);
  }

  var h = (function (e) {
    var t, a;

    function i(t) {
      var a, i, s;
      return (
        (a = e.call.apply(e, [this].concat(t)) || this),
        (i = (function (e) {
          if (void 0 === e)
            throw new ReferenceError(
              "this hasn't been initialised - super() hasn't been called"
            );
          return e;
        })(a)),
        (s = i.__proto__),
        Object.defineProperty(i, "__proto__", {
          get: function get() {
            return s;
          },
          set: function set(e) {
            s.__proto__ = e;
          },
        }),
        a
      );
    }

    return (
      (a = e),
      ((t = i).prototype = Object.create(a.prototype)),
      (t.prototype.constructor = t),
      (t.__proto__ = a),
      i
    );
  })(u(Array));

  function v(e) {
    void 0 === e && (e = []);
    var t = [];
    return (
      e.forEach(function (e) {
        Array.isArray(e) ? t.push.apply(t, v(e)) : t.push(e);
      }),
      t
    );
  }

  function f(e, t) {
    return Array.prototype.filter.call(e, t);
  }

  function m(e, t) {
    var a = l(),
      i = r(),
      s = [];
    if (!t && e instanceof h) return e;
    if (!e) return new h(s);

    if ("string" == typeof e) {
      var n = e.trim();

      if (n.indexOf("<") >= 0 && n.indexOf(">") >= 0) {
        var o = "div";
        0 === n.indexOf("<li") && (o = "ul"),
          0 === n.indexOf("<tr") && (o = "tbody"),
          (0 !== n.indexOf("<td") && 0 !== n.indexOf("<th")) || (o = "tr"),
          0 === n.indexOf("<tbody") && (o = "table"),
          0 === n.indexOf("<option") && (o = "select");
        var d = i.createElement(o);
        d.innerHTML = n;

        for (var p = 0; p < d.childNodes.length; p += 1) {
          s.push(d.childNodes[p]);
        }
      } else
        s = (function (e, t) {
          if ("string" != typeof e) return [e];

          for (
            var a = [], i = t.querySelectorAll(e), s = 0;
            s < i.length;
            s += 1
          ) {
            a.push(i[s]);
          }

          return a;
        })(e.trim(), t || i);
    } else if (e.nodeType || e === a || e === i) s.push(e);
    else if (Array.isArray(e)) {
      if (e instanceof h) return e;
      s = e;
    }

    return new h(
      (function (e) {
        for (var t = [], a = 0; a < e.length; a += 1) {
          -1 === t.indexOf(e[a]) && t.push(e[a]);
        }

        return t;
      })(s)
    );
  }

  m.fn = h.prototype;
  var g,
    b,
    w,
    y = {
      addClass: function addClass() {
        for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++) {
          t[a] = arguments[a];
        }

        var i = v(
          t.map(function (e) {
            return e.split(" ");
          })
        );
        return (
          this.forEach(function (e) {
            var t;
            (t = e.classList).add.apply(t, i);
          }),
          this
        );
      },
      removeClass: function removeClass() {
        for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++) {
          t[a] = arguments[a];
        }

        var i = v(
          t.map(function (e) {
            return e.split(" ");
          })
        );
        return (
          this.forEach(function (e) {
            var t;
            (t = e.classList).remove.apply(t, i);
          }),
          this
        );
      },
      hasClass: function hasClass() {
        for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++) {
          t[a] = arguments[a];
        }

        var i = v(
          t.map(function (e) {
            return e.split(" ");
          })
        );
        return (
          f(this, function (e) {
            return (
              i.filter(function (t) {
                return e.classList.contains(t);
              }).length > 0
            );
          }).length > 0
        );
      },
      toggleClass: function toggleClass() {
        for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++) {
          t[a] = arguments[a];
        }

        var i = v(
          t.map(function (e) {
            return e.split(" ");
          })
        );
        this.forEach(function (e) {
          i.forEach(function (t) {
            e.classList.toggle(t);
          });
        });
      },
      attr: function attr(e, t) {
        if (1 === arguments.length && "string" == typeof e)
          return this[0] ? this[0].getAttribute(e) : void 0;

        for (var a = 0; a < this.length; a += 1) {
          if (2 === arguments.length) this[a].setAttribute(e, t);
          else
            for (var i in e) {
              (this[a][i] = e[i]), this[a].setAttribute(i, e[i]);
            }
        }

        return this;
      },
      removeAttr: function removeAttr(e) {
        for (var t = 0; t < this.length; t += 1) {
          this[t].removeAttribute(e);
        }

        return this;
      },
      transform: function transform(e) {
        for (var t = 0; t < this.length; t += 1) {
          this[t].style.transform = e;
        }

        return this;
      },
      transition: function transition(e) {
        for (var t = 0; t < this.length; t += 1) {
          this[t].style.transitionDuration =
            "string" != typeof e ? e + "ms" : e;
        }

        return this;
      },
      on: function on() {
        for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++) {
          t[a] = arguments[a];
        }

        var i = t[0],
          s = t[1],
          r = t[2],
          n = t[3];

        function l(e) {
          var t = e.target;

          if (t) {
            var a = e.target.dom7EventData || [];
            if ((a.indexOf(e) < 0 && a.unshift(e), m(t).is(s))) r.apply(t, a);
            else
              for (var i = m(t).parents(), n = 0; n < i.length; n += 1) {
                m(i[n]).is(s) && r.apply(i[n], a);
              }
          }
        }

        function o(e) {
          var t = (e && e.target && e.target.dom7EventData) || [];
          t.indexOf(e) < 0 && t.unshift(e), r.apply(this, t);
        }

        "function" == typeof t[1] &&
          ((i = t[0]), (r = t[1]), (n = t[2]), (s = void 0)),
          n || (n = !1);

        for (var d, p = i.split(" "), c = 0; c < this.length; c += 1) {
          var u = this[c];
          if (s)
            for (d = 0; d < p.length; d += 1) {
              var h = p[d];
              u.dom7LiveListeners || (u.dom7LiveListeners = {}),
                u.dom7LiveListeners[h] || (u.dom7LiveListeners[h] = []),
                u.dom7LiveListeners[h].push({
                  listener: r,
                  proxyListener: l,
                }),
                u.addEventListener(h, l, n);
            }
          else
            for (d = 0; d < p.length; d += 1) {
              var v = p[d];
              u.dom7Listeners || (u.dom7Listeners = {}),
                u.dom7Listeners[v] || (u.dom7Listeners[v] = []),
                u.dom7Listeners[v].push({
                  listener: r,
                  proxyListener: o,
                }),
                u.addEventListener(v, o, n);
            }
        }

        return this;
      },
      off: function off() {
        for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++) {
          t[a] = arguments[a];
        }

        var i = t[0],
          s = t[1],
          r = t[2],
          n = t[3];
        "function" == typeof t[1] &&
          ((i = t[0]), (r = t[1]), (n = t[2]), (s = void 0)),
          n || (n = !1);

        for (var l = i.split(" "), o = 0; o < l.length; o += 1) {
          for (var d = l[o], p = 0; p < this.length; p += 1) {
            var c = this[p],
              u = void 0;
            if (
              (!s && c.dom7Listeners
                ? (u = c.dom7Listeners[d])
                : s && c.dom7LiveListeners && (u = c.dom7LiveListeners[d]),
              u && u.length)
            )
              for (var h = u.length - 1; h >= 0; h -= 1) {
                var v = u[h];
                (r && v.listener === r) ||
                (r &&
                  v.listener &&
                  v.listener.dom7proxy &&
                  v.listener.dom7proxy === r)
                  ? (c.removeEventListener(d, v.proxyListener, n),
                    u.splice(h, 1))
                  : r ||
                    (c.removeEventListener(d, v.proxyListener, n),
                    u.splice(h, 1));
              }
          }
        }

        return this;
      },
      trigger: function trigger() {
        for (
          var e = l(), t = arguments.length, a = new Array(t), i = 0;
          i < t;
          i++
        ) {
          a[i] = arguments[i];
        }

        for (var s = a[0].split(" "), r = a[1], n = 0; n < s.length; n += 1) {
          for (var o = s[n], d = 0; d < this.length; d += 1) {
            var p = this[d];

            if (e.CustomEvent) {
              var c = new e.CustomEvent(o, {
                detail: r,
                bubbles: !0,
                cancelable: !0,
              });
              (p.dom7EventData = a.filter(function (e, t) {
                return t > 0;
              })),
                p.dispatchEvent(c),
                (p.dom7EventData = []),
                delete p.dom7EventData;
            }
          }
        }

        return this;
      },
      transitionEnd: function transitionEnd(e) {
        var t = this;
        return (
          e &&
            t.on("transitionend", function a(i) {
              i.target === this && (e.call(this, i), t.off("transitionend", a));
            }),
          this
        );
      },
      outerWidth: function outerWidth(e) {
        if (this.length > 0) {
          if (e) {
            var t = this.styles();
            return (
              this[0].offsetWidth +
              parseFloat(t.getPropertyValue("margin-right")) +
              parseFloat(t.getPropertyValue("margin-left"))
            );
          }

          return this[0].offsetWidth;
        }

        return null;
      },
      outerHeight: function outerHeight(e) {
        if (this.length > 0) {
          if (e) {
            var t = this.styles();
            return (
              this[0].offsetHeight +
              parseFloat(t.getPropertyValue("margin-top")) +
              parseFloat(t.getPropertyValue("margin-bottom"))
            );
          }

          return this[0].offsetHeight;
        }

        return null;
      },
      styles: function styles() {
        var e = l();
        return this[0] ? e.getComputedStyle(this[0], null) : {};
      },
      offset: function offset() {
        if (this.length > 0) {
          var e = l(),
            t = r(),
            a = this[0],
            i = a.getBoundingClientRect(),
            s = t.body,
            n = a.clientTop || s.clientTop || 0,
            o = a.clientLeft || s.clientLeft || 0,
            d = a === e ? e.scrollY : a.scrollTop,
            p = a === e ? e.scrollX : a.scrollLeft;
          return {
            top: i.top + d - n,
            left: i.left + p - o,
          };
        }

        return null;
      },
      css: function css(e, t) {
        var a,
          i = l();

        if (1 === arguments.length) {
          if ("string" != typeof e) {
            for (a = 0; a < this.length; a += 1) {
              for (var s in e) {
                this[a].style[s] = e[s];
              }
            }

            return this;
          }

          if (this[0])
            return i.getComputedStyle(this[0], null).getPropertyValue(e);
        }

        if (2 === arguments.length && "string" == typeof e) {
          for (a = 0; a < this.length; a += 1) {
            this[a].style[e] = t;
          }

          return this;
        }

        return this;
      },
      each: function each(e) {
        return e
          ? (this.forEach(function (t, a) {
              e.apply(t, [t, a]);
            }),
            this)
          : this;
      },
      html: function html(e) {
        if (void 0 === e) return this[0] ? this[0].innerHTML : null;

        for (var t = 0; t < this.length; t += 1) {
          this[t].innerHTML = e;
        }

        return this;
      },
      text: function text(e) {
        if (void 0 === e) return this[0] ? this[0].textContent.trim() : null;

        for (var t = 0; t < this.length; t += 1) {
          this[t].textContent = e;
        }

        return this;
      },
      is: function is(e) {
        var t,
          a,
          i = l(),
          s = r(),
          n = this[0];
        if (!n || void 0 === e) return !1;

        if ("string" == typeof e) {
          if (n.matches) return n.matches(e);
          if (n.webkitMatchesSelector) return n.webkitMatchesSelector(e);
          if (n.msMatchesSelector) return n.msMatchesSelector(e);

          for (t = m(e), a = 0; a < t.length; a += 1) {
            if (t[a] === n) return !0;
          }

          return !1;
        }

        if (e === s) return n === s;
        if (e === i) return n === i;

        if (e.nodeType || e instanceof h) {
          for (t = e.nodeType ? [e] : e, a = 0; a < t.length; a += 1) {
            if (t[a] === n) return !0;
          }

          return !1;
        }

        return !1;
      },
      index: function index() {
        var e,
          t = this[0];

        if (t) {
          for (e = 0; null !== (t = t.previousSibling); ) {
            1 === t.nodeType && (e += 1);
          }

          return e;
        }
      },
      eq: function eq(e) {
        if (void 0 === e) return this;
        var t = this.length;
        if (e > t - 1) return m([]);

        if (e < 0) {
          var a = t + e;
          return m(a < 0 ? [] : [this[a]]);
        }

        return m([this[e]]);
      },
      append: function append() {
        for (var e, t = r(), a = 0; a < arguments.length; a += 1) {
          e = a < 0 || arguments.length <= a ? void 0 : arguments[a];

          for (var i = 0; i < this.length; i += 1) {
            if ("string" == typeof e) {
              var s = t.createElement("div");

              for (s.innerHTML = e; s.firstChild; ) {
                this[i].appendChild(s.firstChild);
              }
            } else if (e instanceof h)
              for (var n = 0; n < e.length; n += 1) {
                this[i].appendChild(e[n]);
              }
            else this[i].appendChild(e);
          }
        }

        return this;
      },
      prepend: function prepend(e) {
        var t,
          a,
          i = r();

        for (t = 0; t < this.length; t += 1) {
          if ("string" == typeof e) {
            var s = i.createElement("div");

            for (s.innerHTML = e, a = s.childNodes.length - 1; a >= 0; a -= 1) {
              this[t].insertBefore(s.childNodes[a], this[t].childNodes[0]);
            }
          } else if (e instanceof h)
            for (a = 0; a < e.length; a += 1) {
              this[t].insertBefore(e[a], this[t].childNodes[0]);
            }
          else this[t].insertBefore(e, this[t].childNodes[0]);
        }

        return this;
      },
      next: function next(e) {
        return this.length > 0
          ? e
            ? this[0].nextElementSibling && m(this[0].nextElementSibling).is(e)
              ? m([this[0].nextElementSibling])
              : m([])
            : this[0].nextElementSibling
            ? m([this[0].nextElementSibling])
            : m([])
          : m([]);
      },
      nextAll: function nextAll(e) {
        var t = [],
          a = this[0];
        if (!a) return m([]);

        for (; a.nextElementSibling; ) {
          var i = a.nextElementSibling;
          e ? m(i).is(e) && t.push(i) : t.push(i), (a = i);
        }

        return m(t);
      },
      prev: function prev(e) {
        if (this.length > 0) {
          var t = this[0];
          return e
            ? t.previousElementSibling && m(t.previousElementSibling).is(e)
              ? m([t.previousElementSibling])
              : m([])
            : t.previousElementSibling
            ? m([t.previousElementSibling])
            : m([]);
        }

        return m([]);
      },
      prevAll: function prevAll(e) {
        var t = [],
          a = this[0];
        if (!a) return m([]);

        for (; a.previousElementSibling; ) {
          var i = a.previousElementSibling;
          e ? m(i).is(e) && t.push(i) : t.push(i), (a = i);
        }

        return m(t);
      },
      parent: function parent(e) {
        for (var t = [], a = 0; a < this.length; a += 1) {
          null !== this[a].parentNode &&
            (e
              ? m(this[a].parentNode).is(e) && t.push(this[a].parentNode)
              : t.push(this[a].parentNode));
        }

        return m(t);
      },
      parents: function parents(e) {
        for (var t = [], a = 0; a < this.length; a += 1) {
          for (var i = this[a].parentNode; i; ) {
            e ? m(i).is(e) && t.push(i) : t.push(i), (i = i.parentNode);
          }
        }

        return m(t);
      },
      closest: function closest(e) {
        var t = this;
        return void 0 === e ? m([]) : (t.is(e) || (t = t.parents(e).eq(0)), t);
      },
      find: function find(e) {
        for (var t = [], a = 0; a < this.length; a += 1) {
          for (
            var i = this[a].querySelectorAll(e), s = 0;
            s < i.length;
            s += 1
          ) {
            t.push(i[s]);
          }
        }

        return m(t);
      },
      children: function children(e) {
        for (var t = [], a = 0; a < this.length; a += 1) {
          for (var i = this[a].children, s = 0; s < i.length; s += 1) {
            (e && !m(i[s]).is(e)) || t.push(i[s]);
          }
        }

        return m(t);
      },
      filter: function filter(e) {
        return m(f(this, e));
      },
      remove: function remove() {
        for (var e = 0; e < this.length; e += 1) {
          this[e].parentNode && this[e].parentNode.removeChild(this[e]);
        }

        return this;
      },
    };

  function E(e, t) {
    return void 0 === t && (t = 0), setTimeout(e, t);
  }

  function x() {
    return Date.now();
  }

  function T(e, t) {
    void 0 === t && (t = "x");

    var a,
      i,
      s,
      r = l(),
      n = (function (e) {
        var t,
          a = l();
        return (
          a.getComputedStyle && (t = a.getComputedStyle(e, null)),
          !t && e.currentStyle && (t = e.currentStyle),
          t || (t = e.style),
          t
        );
      })(e);

    return (
      r.WebKitCSSMatrix
        ? ((i = n.transform || n.webkitTransform).split(",").length > 6 &&
            (i = i
              .split(", ")
              .map(function (e) {
                return e.replace(",", ".");
              })
              .join(", ")),
          (s = new r.WebKitCSSMatrix("none" === i ? "" : i)))
        : (a = (s =
            n.MozTransform ||
            n.OTransform ||
            n.MsTransform ||
            n.msTransform ||
            n.transform ||
            n
              .getPropertyValue("transform")
              .replace("translate(", "matrix(1, 0, 0, 1,"))
            .toString()
            .split(",")),
      "x" === t &&
        (i = r.WebKitCSSMatrix
          ? s.m41
          : 16 === a.length
          ? parseFloat(a[12])
          : parseFloat(a[4])),
      "y" === t &&
        (i = r.WebKitCSSMatrix
          ? s.m42
          : 16 === a.length
          ? parseFloat(a[13])
          : parseFloat(a[5])),
      i || 0
    );
  }

  function S(e) {
    return (
      "object" == _typeof(e) &&
      null !== e &&
      e.constructor &&
      "Object" === Object.prototype.toString.call(e).slice(8, -1)
    );
  }

  function C() {
    for (
      var e = Object(arguments.length <= 0 ? void 0 : arguments[0]),
        t = ["__proto__", "constructor", "prototype"],
        a = 1;
      a < arguments.length;
      a += 1
    ) {
      var i = a < 0 || arguments.length <= a ? void 0 : arguments[a];
      if (null != i)
        for (
          var s = Object.keys(Object(i)).filter(function (e) {
              return t.indexOf(e) < 0;
            }),
            r = 0,
            n = s.length;
          r < n;
          r += 1
        ) {
          var l = s[r],
            o = Object.getOwnPropertyDescriptor(i, l);
          void 0 !== o &&
            o.enumerable &&
            (S(e[l]) && S(i[l])
              ? i[l].__swiper__
                ? (e[l] = i[l])
                : C(e[l], i[l])
              : !S(e[l]) && S(i[l])
              ? ((e[l] = {}), i[l].__swiper__ ? (e[l] = i[l]) : C(e[l], i[l]))
              : (e[l] = i[l]));
        }
    }

    return e;
  }

  function M(e, t) {
    Object.keys(t).forEach(function (a) {
      S(t[a]) &&
        Object.keys(t[a]).forEach(function (i) {
          "function" == typeof t[a][i] && (t[a][i] = t[a][i].bind(e));
        }),
        (e[a] = t[a]);
    });
  }

  function z() {
    return (
      g ||
        (g = (function () {
          var e = l(),
            t = r();
          return {
            touch: !!(
              "ontouchstart" in e ||
              (e.DocumentTouch && t instanceof e.DocumentTouch)
            ),
            pointerEvents:
              !!e.PointerEvent &&
              "maxTouchPoints" in e.navigator &&
              e.navigator.maxTouchPoints >= 0,
            observer: "MutationObserver" in e || "WebkitMutationObserver" in e,
            passiveListener: (function () {
              var t = !1;

              try {
                var a = Object.defineProperty({}, "passive", {
                  get: function get() {
                    t = !0;
                  },
                });
                e.addEventListener("testPassiveListener", null, a);
              } catch (e) {}

              return t;
            })(),
            gestures: "ongesturestart" in e,
          };
        })()),
      g
    );
  }

  function P(e) {
    return (
      void 0 === e && (e = {}),
      b ||
        (b = (function (e) {
          var t = (void 0 === e ? {} : e).userAgent,
            a = z(),
            i = l(),
            s = i.navigator.platform,
            r = t || i.navigator.userAgent,
            n = {
              ios: !1,
              android: !1,
            },
            o = i.screen.width,
            d = i.screen.height,
            p = r.match(/(Android);?[\s\/]+([\d.]+)?/),
            c = r.match(/(iPad).*OS\s([\d_]+)/),
            u = r.match(/(iPod)(.*OS\s([\d_]+))?/),
            h = !c && r.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
            v = "Win32" === s,
            f = "MacIntel" === s;
          return (
            !c &&
              f &&
              a.touch &&
              [
                "1024x1366",
                "1366x1024",
                "834x1194",
                "1194x834",
                "834x1112",
                "1112x834",
                "768x1024",
                "1024x768",
                "820x1180",
                "1180x820",
                "810x1080",
                "1080x810",
              ].indexOf(o + "x" + d) >= 0 &&
              ((c = r.match(/(Version)\/([\d.]+)/)) || (c = [0, 1, "13_0_0"]),
              (f = !1)),
            p && !v && ((n.os = "android"), (n.android = !0)),
            (c || h || u) && ((n.os = "ios"), (n.ios = !0)),
            n
          );
        })(e)),
      b
    );
  }

  function k() {
    return (
      w ||
        (w = (function () {
          var e,
            t = l();
          return {
            isEdge: !!t.navigator.userAgent.match(/Edge/g),
            isSafari:
              ((e = t.navigator.userAgent.toLowerCase()),
              e.indexOf("safari") >= 0 &&
                e.indexOf("chrome") < 0 &&
                e.indexOf("android") < 0),
            isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
              t.navigator.userAgent
            ),
          };
        })()),
      w
    );
  }

  Object.keys(y).forEach(function (e) {
    m.fn[e] = y[e];
  });
  var L = {
      name: "resize",
      create: function create() {
        var e = this;
        C(e, {
          resize: {
            observer: null,
            createObserver: function createObserver() {
              e &&
                !e.destroyed &&
                e.initialized &&
                ((e.resize.observer = new ResizeObserver(function (t) {
                  var a = e.width,
                    i = e.height,
                    s = a,
                    r = i;
                  t.forEach(function (t) {
                    var a = t.contentBoxSize,
                      i = t.contentRect,
                      n = t.target;
                    (n && n !== e.el) ||
                      ((s = i ? i.width : (a[0] || a).inlineSize),
                      (r = i ? i.height : (a[0] || a).blockSize));
                  }),
                    (s === a && r === i) || e.resize.resizeHandler();
                })),
                e.resize.observer.observe(e.el));
            },
            removeObserver: function removeObserver() {
              e.resize.observer &&
                e.resize.observer.unobserve &&
                e.el &&
                (e.resize.observer.unobserve(e.el), (e.resize.observer = null));
            },
            resizeHandler: function resizeHandler() {
              e &&
                !e.destroyed &&
                e.initialized &&
                (e.emit("beforeResize"), e.emit("resize"));
            },
            orientationChangeHandler: function orientationChangeHandler() {
              e && !e.destroyed && e.initialized && e.emit("orientationchange");
            },
          },
        });
      },
      on: {
        init: function init(e) {
          var t = l();
          e.params.resizeObserver && void 0 !== l().ResizeObserver
            ? e.resize.createObserver()
            : (t.addEventListener("resize", e.resize.resizeHandler),
              t.addEventListener(
                "orientationchange",
                e.resize.orientationChangeHandler
              ));
        },
        destroy: function destroy(e) {
          var t = l();
          e.resize.removeObserver(),
            t.removeEventListener("resize", e.resize.resizeHandler),
            t.removeEventListener(
              "orientationchange",
              e.resize.orientationChangeHandler
            );
        },
      },
    },
    $ = {
      attach: function attach(e, t) {
        void 0 === t && (t = {});
        var a = l(),
          i = this,
          s = new (a.MutationObserver || a.WebkitMutationObserver)(function (
            e
          ) {
            if (1 !== e.length) {
              var t = function t() {
                i.emit("observerUpdate", e[0]);
              };

              a.requestAnimationFrame
                ? a.requestAnimationFrame(t)
                : a.setTimeout(t, 0);
            } else i.emit("observerUpdate", e[0]);
          });
        s.observe(e, {
          attributes: void 0 === t.attributes || t.attributes,
          childList: void 0 === t.childList || t.childList,
          characterData: void 0 === t.characterData || t.characterData,
        }),
          i.observer.observers.push(s);
      },
      init: function init() {
        var e = this;

        if (e.support.observer && e.params.observer) {
          if (e.params.observeParents)
            for (var t = e.$el.parents(), a = 0; a < t.length; a += 1) {
              e.observer.attach(t[a]);
            }
          e.observer.attach(e.$el[0], {
            childList: e.params.observeSlideChildren,
          }),
            e.observer.attach(e.$wrapperEl[0], {
              attributes: !1,
            });
        }
      },
      destroy: function destroy() {
        this.observer.observers.forEach(function (e) {
          e.disconnect();
        }),
          (this.observer.observers = []);
      },
    },
    I = {
      name: "observer",
      params: {
        observer: !1,
        observeParents: !1,
        observeSlideChildren: !1,
      },
      create: function create() {
        M(this, {
          observer: t({}, $, {
            observers: [],
          }),
        });
      },
      on: {
        init: function init(e) {
          e.observer.init();
        },
        destroy: function destroy(e) {
          e.observer.destroy();
        },
      },
    };

  function O(e) {
    var t = this,
      a = r(),
      i = l(),
      s = t.touchEventsData,
      n = t.params,
      o = t.touches;

    if (!t.animating || !n.preventInteractionOnTransition) {
      var d = e;
      d.originalEvent && (d = d.originalEvent);
      var p = m(d.target);
      if ("wrapper" !== n.touchEventsTarget || p.closest(t.wrapperEl).length)
        if (
          ((s.isTouchEvent = "touchstart" === d.type),
          s.isTouchEvent || !("which" in d) || 3 !== d.which)
        )
          if (!(!s.isTouchEvent && "button" in d && d.button > 0))
            if (!s.isTouched || !s.isMoved)
              if (
                (!!n.noSwipingClass &&
                  "" !== n.noSwipingClass &&
                  d.target &&
                  d.target.shadowRoot &&
                  e.path &&
                  e.path[0] &&
                  (p = m(e.path[0])),
                n.noSwiping &&
                  p.closest(
                    n.noSwipingSelector
                      ? n.noSwipingSelector
                      : "." + n.noSwipingClass
                  )[0])
              )
                t.allowClick = !0;
              else if (!n.swipeHandler || p.closest(n.swipeHandler)[0]) {
                (o.currentX =
                  "touchstart" === d.type ? d.targetTouches[0].pageX : d.pageX),
                  (o.currentY =
                    "touchstart" === d.type
                      ? d.targetTouches[0].pageY
                      : d.pageY);
                var c = o.currentX,
                  u = o.currentY,
                  h = n.edgeSwipeDetection || n.iOSEdgeSwipeDetection,
                  v = n.edgeSwipeThreshold || n.iOSEdgeSwipeThreshold;

                if (h && (c <= v || c >= i.innerWidth - v)) {
                  if ("prevent" !== h) return;
                  e.preventDefault();
                }

                if (
                  (C(s, {
                    isTouched: !0,
                    isMoved: !1,
                    allowTouchCallbacks: !0,
                    isScrolling: void 0,
                    startMoving: void 0,
                  }),
                  (o.startX = c),
                  (o.startY = u),
                  (s.touchStartTime = x()),
                  (t.allowClick = !0),
                  t.updateSize(),
                  (t.swipeDirection = void 0),
                  n.threshold > 0 && (s.allowThresholdMove = !1),
                  "touchstart" !== d.type)
                ) {
                  var f = !0;
                  p.is(s.formElements) && (f = !1),
                    a.activeElement &&
                      m(a.activeElement).is(s.formElements) &&
                      a.activeElement !== p[0] &&
                      a.activeElement.blur();
                  var g = f && t.allowTouchMove && n.touchStartPreventDefault;
                  (!n.touchStartForcePreventDefault && !g) ||
                    p[0].isContentEditable ||
                    d.preventDefault();
                }

                t.emit("touchStart", d);
              }
    }
  }

  function A(e) {
    var t = r(),
      a = this,
      i = a.touchEventsData,
      s = a.params,
      n = a.touches,
      l = a.rtlTranslate,
      o = e;

    if ((o.originalEvent && (o = o.originalEvent), i.isTouched)) {
      if (!i.isTouchEvent || "touchmove" === o.type) {
        var d =
            "touchmove" === o.type &&
            o.targetTouches &&
            (o.targetTouches[0] || o.changedTouches[0]),
          p = "touchmove" === o.type ? d.pageX : o.pageX,
          c = "touchmove" === o.type ? d.pageY : o.pageY;
        if (o.preventedByNestedSwiper)
          return (n.startX = p), void (n.startY = c);
        if (!a.allowTouchMove)
          return (
            (a.allowClick = !1),
            void (
              i.isTouched &&
              (C(n, {
                startX: p,
                startY: c,
                currentX: p,
                currentY: c,
              }),
              (i.touchStartTime = x()))
            )
          );
        if (i.isTouchEvent && s.touchReleaseOnEdges && !s.loop)
          if (a.isVertical()) {
            if (
              (c < n.startY && a.translate <= a.maxTranslate()) ||
              (c > n.startY && a.translate >= a.minTranslate())
            )
              return (i.isTouched = !1), void (i.isMoved = !1);
          } else if (
            (p < n.startX && a.translate <= a.maxTranslate()) ||
            (p > n.startX && a.translate >= a.minTranslate())
          )
            return;
        if (
          i.isTouchEvent &&
          t.activeElement &&
          o.target === t.activeElement &&
          m(o.target).is(i.formElements)
        )
          return (i.isMoved = !0), void (a.allowClick = !1);

        if (
          (i.allowTouchCallbacks && a.emit("touchMove", o),
          !(o.targetTouches && o.targetTouches.length > 1))
        ) {
          (n.currentX = p), (n.currentY = c);
          var u = n.currentX - n.startX,
            h = n.currentY - n.startY;

          if (
            !(
              a.params.threshold &&
              Math.sqrt(Math.pow(u, 2) + Math.pow(h, 2)) < a.params.threshold
            )
          ) {
            var v;
            if (void 0 === i.isScrolling)
              (a.isHorizontal() && n.currentY === n.startY) ||
              (a.isVertical() && n.currentX === n.startX)
                ? (i.isScrolling = !1)
                : u * u + h * h >= 25 &&
                  ((v = (180 * Math.atan2(Math.abs(h), Math.abs(u))) / Math.PI),
                  (i.isScrolling = a.isHorizontal()
                    ? v > s.touchAngle
                    : 90 - v > s.touchAngle));
            if (
              (i.isScrolling && a.emit("touchMoveOpposite", o),
              void 0 === i.startMoving &&
                ((n.currentX === n.startX && n.currentY === n.startY) ||
                  (i.startMoving = !0)),
              i.isScrolling)
            )
              i.isTouched = !1;
            else if (i.startMoving) {
              (a.allowClick = !1),
                !s.cssMode && o.cancelable && o.preventDefault(),
                s.touchMoveStopPropagation && !s.nested && o.stopPropagation(),
                i.isMoved ||
                  (s.loop && a.loopFix(),
                  (i.startTranslate = a.getTranslate()),
                  a.setTransition(0),
                  a.animating &&
                    a.$wrapperEl.trigger("webkitTransitionEnd transitionend"),
                  (i.allowMomentumBounce = !1),
                  !s.grabCursor ||
                    (!0 !== a.allowSlideNext && !0 !== a.allowSlidePrev) ||
                    a.setGrabCursor(!0),
                  a.emit("sliderFirstMove", o)),
                a.emit("sliderMove", o),
                (i.isMoved = !0);
              var f = a.isHorizontal() ? u : h;
              (n.diff = f),
                (f *= s.touchRatio),
                l && (f = -f),
                (a.swipeDirection = f > 0 ? "prev" : "next"),
                (i.currentTranslate = f + i.startTranslate);
              var g = !0,
                b = s.resistanceRatio;

              if (
                (s.touchReleaseOnEdges && (b = 0),
                f > 0 && i.currentTranslate > a.minTranslate()
                  ? ((g = !1),
                    s.resistance &&
                      (i.currentTranslate =
                        a.minTranslate() -
                        1 +
                        Math.pow(-a.minTranslate() + i.startTranslate + f, b)))
                  : f < 0 &&
                    i.currentTranslate < a.maxTranslate() &&
                    ((g = !1),
                    s.resistance &&
                      (i.currentTranslate =
                        a.maxTranslate() +
                        1 -
                        Math.pow(a.maxTranslate() - i.startTranslate - f, b))),
                g && (o.preventedByNestedSwiper = !0),
                !a.allowSlideNext &&
                  "next" === a.swipeDirection &&
                  i.currentTranslate < i.startTranslate &&
                  (i.currentTranslate = i.startTranslate),
                !a.allowSlidePrev &&
                  "prev" === a.swipeDirection &&
                  i.currentTranslate > i.startTranslate &&
                  (i.currentTranslate = i.startTranslate),
                a.allowSlidePrev ||
                  a.allowSlideNext ||
                  (i.currentTranslate = i.startTranslate),
                s.threshold > 0)
              ) {
                if (!(Math.abs(f) > s.threshold || i.allowThresholdMove))
                  return void (i.currentTranslate = i.startTranslate);
                if (!i.allowThresholdMove)
                  return (
                    (i.allowThresholdMove = !0),
                    (n.startX = n.currentX),
                    (n.startY = n.currentY),
                    (i.currentTranslate = i.startTranslate),
                    void (n.diff = a.isHorizontal()
                      ? n.currentX - n.startX
                      : n.currentY - n.startY)
                  );
              }

              s.followFinger &&
                !s.cssMode &&
                ((s.freeMode ||
                  s.watchSlidesProgress ||
                  s.watchSlidesVisibility) &&
                  (a.updateActiveIndex(), a.updateSlidesClasses()),
                s.freeMode &&
                  (0 === i.velocities.length &&
                    i.velocities.push({
                      position: n[a.isHorizontal() ? "startX" : "startY"],
                      time: i.touchStartTime,
                    }),
                  i.velocities.push({
                    position: n[a.isHorizontal() ? "currentX" : "currentY"],
                    time: x(),
                  })),
                a.updateProgress(i.currentTranslate),
                a.setTranslate(i.currentTranslate));
            }
          }
        }
      }
    } else i.startMoving && i.isScrolling && a.emit("touchMoveOpposite", o);
  }

  function D(e) {
    var t = this,
      a = t.touchEventsData,
      i = t.params,
      s = t.touches,
      r = t.rtlTranslate,
      n = t.$wrapperEl,
      l = t.slidesGrid,
      o = t.snapGrid,
      d = e;
    if (
      (d.originalEvent && (d = d.originalEvent),
      a.allowTouchCallbacks && t.emit("touchEnd", d),
      (a.allowTouchCallbacks = !1),
      !a.isTouched)
    )
      return (
        a.isMoved && i.grabCursor && t.setGrabCursor(!1),
        (a.isMoved = !1),
        void (a.startMoving = !1)
      );
    i.grabCursor &&
      a.isMoved &&
      a.isTouched &&
      (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) &&
      t.setGrabCursor(!1);
    var p,
      c = x(),
      u = c - a.touchStartTime;
    if (
      (t.allowClick &&
        (t.updateClickedSlide(d),
        t.emit("tap click", d),
        u < 300 &&
          c - a.lastClickTime < 300 &&
          t.emit("doubleTap doubleClick", d)),
      (a.lastClickTime = x()),
      E(function () {
        t.destroyed || (t.allowClick = !0);
      }),
      !a.isTouched ||
        !a.isMoved ||
        !t.swipeDirection ||
        0 === s.diff ||
        a.currentTranslate === a.startTranslate)
    )
      return (a.isTouched = !1), (a.isMoved = !1), void (a.startMoving = !1);
    if (
      ((a.isTouched = !1),
      (a.isMoved = !1),
      (a.startMoving = !1),
      (p = i.followFinger
        ? r
          ? t.translate
          : -t.translate
        : -a.currentTranslate),
      !i.cssMode)
    )
      if (i.freeMode) {
        if (p < -t.minTranslate()) return void t.slideTo(t.activeIndex);
        if (p > -t.maxTranslate())
          return void (t.slides.length < o.length
            ? t.slideTo(o.length - 1)
            : t.slideTo(t.slides.length - 1));

        if (i.freeModeMomentum) {
          if (a.velocities.length > 1) {
            var h = a.velocities.pop(),
              v = a.velocities.pop(),
              f = h.position - v.position,
              m = h.time - v.time;
            (t.velocity = f / m),
              (t.velocity /= 2),
              Math.abs(t.velocity) < i.freeModeMinimumVelocity &&
                (t.velocity = 0),
              (m > 150 || x() - h.time > 300) && (t.velocity = 0);
          } else t.velocity = 0;

          (t.velocity *= i.freeModeMomentumVelocityRatio),
            (a.velocities.length = 0);
          var g = 1e3 * i.freeModeMomentumRatio,
            b = t.velocity * g,
            w = t.translate + b;
          r && (w = -w);
          var y,
            T,
            S = !1,
            C = 20 * Math.abs(t.velocity) * i.freeModeMomentumBounceRatio;
          if (w < t.maxTranslate())
            i.freeModeMomentumBounce
              ? (w + t.maxTranslate() < -C && (w = t.maxTranslate() - C),
                (y = t.maxTranslate()),
                (S = !0),
                (a.allowMomentumBounce = !0))
              : (w = t.maxTranslate()),
              i.loop && i.centeredSlides && (T = !0);
          else if (w > t.minTranslate())
            i.freeModeMomentumBounce
              ? (w - t.minTranslate() > C && (w = t.minTranslate() + C),
                (y = t.minTranslate()),
                (S = !0),
                (a.allowMomentumBounce = !0))
              : (w = t.minTranslate()),
              i.loop && i.centeredSlides && (T = !0);
          else if (i.freeModeSticky) {
            for (var M, z = 0; z < o.length; z += 1) {
              if (o[z] > -w) {
                M = z;
                break;
              }
            }

            w = -(w =
              Math.abs(o[M] - w) < Math.abs(o[M - 1] - w) ||
              "next" === t.swipeDirection
                ? o[M]
                : o[M - 1]);
          }

          if (
            (T &&
              t.once("transitionEnd", function () {
                t.loopFix();
              }),
            0 !== t.velocity)
          ) {
            if (
              ((g = r
                ? Math.abs((-w - t.translate) / t.velocity)
                : Math.abs((w - t.translate) / t.velocity)),
              i.freeModeSticky)
            ) {
              var P = Math.abs((r ? -w : w) - t.translate),
                k = t.slidesSizesGrid[t.activeIndex];
              g = P < k ? i.speed : P < 2 * k ? 1.5 * i.speed : 2.5 * i.speed;
            }
          } else if (i.freeModeSticky) return void t.slideToClosest();

          i.freeModeMomentumBounce && S
            ? (t.updateProgress(y),
              t.setTransition(g),
              t.setTranslate(w),
              t.transitionStart(!0, t.swipeDirection),
              (t.animating = !0),
              n.transitionEnd(function () {
                t &&
                  !t.destroyed &&
                  a.allowMomentumBounce &&
                  (t.emit("momentumBounce"),
                  t.setTransition(i.speed),
                  setTimeout(function () {
                    t.setTranslate(y),
                      n.transitionEnd(function () {
                        t && !t.destroyed && t.transitionEnd();
                      });
                  }, 0));
              }))
            : t.velocity
            ? (t.updateProgress(w),
              t.setTransition(g),
              t.setTranslate(w),
              t.transitionStart(!0, t.swipeDirection),
              t.animating ||
                ((t.animating = !0),
                n.transitionEnd(function () {
                  t && !t.destroyed && t.transitionEnd();
                })))
            : (t.emit("_freeModeNoMomentumRelease"), t.updateProgress(w)),
            t.updateActiveIndex(),
            t.updateSlidesClasses();
        } else {
          if (i.freeModeSticky) return void t.slideToClosest();
          i.freeMode && t.emit("_freeModeNoMomentumRelease");
        }

        (!i.freeModeMomentum || u >= i.longSwipesMs) &&
          (t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses());
      } else {
        for (
          var L = 0, $ = t.slidesSizesGrid[0], I = 0;
          I < l.length;
          I += I < i.slidesPerGroupSkip ? 1 : i.slidesPerGroup
        ) {
          var O = I < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
          void 0 !== l[I + O]
            ? p >= l[I] && p < l[I + O] && ((L = I), ($ = l[I + O] - l[I]))
            : p >= l[I] && ((L = I), ($ = l[l.length - 1] - l[l.length - 2]));
        }

        var A = (p - l[L]) / $,
          D = L < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;

        if (u > i.longSwipesMs) {
          if (!i.longSwipes) return void t.slideTo(t.activeIndex);
          "next" === t.swipeDirection &&
            (A >= i.longSwipesRatio ? t.slideTo(L + D) : t.slideTo(L)),
            "prev" === t.swipeDirection &&
              (A > 1 - i.longSwipesRatio ? t.slideTo(L + D) : t.slideTo(L));
        } else {
          if (!i.shortSwipes) return void t.slideTo(t.activeIndex);
          t.navigation &&
          (d.target === t.navigation.nextEl || d.target === t.navigation.prevEl)
            ? d.target === t.navigation.nextEl
              ? t.slideTo(L + D)
              : t.slideTo(L)
            : ("next" === t.swipeDirection && t.slideTo(L + D),
              "prev" === t.swipeDirection && t.slideTo(L));
        }
      }
  }

  function N() {
    var e = this,
      t = e.params,
      a = e.el;

    if (!a || 0 !== a.offsetWidth) {
      t.breakpoints && e.setBreakpoint();
      var i = e.allowSlideNext,
        s = e.allowSlidePrev,
        r = e.snapGrid;
      (e.allowSlideNext = !0),
        (e.allowSlidePrev = !0),
        e.updateSize(),
        e.updateSlides(),
        e.updateSlidesClasses(),
        ("auto" === t.slidesPerView || t.slidesPerView > 1) &&
        e.isEnd &&
        !e.isBeginning &&
        !e.params.centeredSlides
          ? e.slideTo(e.slides.length - 1, 0, !1, !0)
          : e.slideTo(e.activeIndex, 0, !1, !0),
        e.autoplay &&
          e.autoplay.running &&
          e.autoplay.paused &&
          e.autoplay.run(),
        (e.allowSlidePrev = s),
        (e.allowSlideNext = i),
        e.params.watchOverflow && r !== e.snapGrid && e.checkOverflow();
    }
  }

  function G(e) {
    var t = this;
    t.allowClick ||
      (t.params.preventClicks && e.preventDefault(),
      t.params.preventClicksPropagation &&
        t.animating &&
        (e.stopPropagation(), e.stopImmediatePropagation()));
  }

  function B() {
    var e = this,
      t = e.wrapperEl,
      a = e.rtlTranslate;
    (e.previousTranslate = e.translate),
      e.isHorizontal()
        ? (e.translate = a
            ? t.scrollWidth - t.offsetWidth - t.scrollLeft
            : -t.scrollLeft)
        : (e.translate = -t.scrollTop),
      -0 === e.translate && (e.translate = 0),
      e.updateActiveIndex(),
      e.updateSlidesClasses();
    var i = e.maxTranslate() - e.minTranslate();
    (0 === i ? 0 : (e.translate - e.minTranslate()) / i) !== e.progress &&
      e.updateProgress(a ? -e.translate : e.translate),
      e.emit("setTranslate", e.translate, !1);
  }

  var H = !1;

  function X() {}

  var Y = {
      init: !0,
      direction: "horizontal",
      touchEventsTarget: "container",
      initialSlide: 0,
      speed: 300,
      cssMode: !1,
      updateOnWindowResize: !0,
      resizeObserver: !1,
      nested: !1,
      width: null,
      height: null,
      preventInteractionOnTransition: !1,
      userAgent: null,
      url: null,
      edgeSwipeDetection: !1,
      edgeSwipeThreshold: 20,
      freeMode: !1,
      freeModeMomentum: !0,
      freeModeMomentumRatio: 1,
      freeModeMomentumBounce: !0,
      freeModeMomentumBounceRatio: 1,
      freeModeMomentumVelocityRatio: 1,
      freeModeSticky: !1,
      freeModeMinimumVelocity: 0.02,
      autoHeight: !1,
      setWrapperSize: !1,
      virtualTranslate: !1,
      effect: "slide",
      breakpoints: void 0,
      breakpointsBase: "window",
      spaceBetween: 0,
      slidesPerView: 1,
      slidesPerColumn: 1,
      slidesPerColumnFill: "column",
      slidesPerGroup: 1,
      slidesPerGroupSkip: 0,
      centeredSlides: !1,
      centeredSlidesBounds: !1,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      normalizeSlideIndex: !0,
      centerInsufficientSlides: !1,
      watchOverflow: !1,
      roundLengths: !1,
      touchRatio: 1,
      touchAngle: 45,
      simulateTouch: !0,
      shortSwipes: !0,
      longSwipes: !0,
      longSwipesRatio: 0.5,
      longSwipesMs: 300,
      followFinger: !0,
      allowTouchMove: !0,
      threshold: 0,
      touchMoveStopPropagation: !1,
      touchStartPreventDefault: !0,
      touchStartForcePreventDefault: !1,
      touchReleaseOnEdges: !1,
      uniqueNavElements: !0,
      resistance: !0,
      resistanceRatio: 0.85,
      watchSlidesProgress: !1,
      watchSlidesVisibility: !1,
      grabCursor: !1,
      preventClicks: !0,
      preventClicksPropagation: !0,
      slideToClickedSlide: !1,
      preloadImages: !0,
      updateOnImagesReady: !0,
      loop: !1,
      loopAdditionalSlides: 0,
      loopedSlides: null,
      loopFillGroupWithBlank: !1,
      loopPreventsSlide: !0,
      allowSlidePrev: !0,
      allowSlideNext: !0,
      swipeHandler: null,
      noSwiping: !0,
      noSwipingClass: "swiper-no-swiping",
      noSwipingSelector: null,
      passiveListeners: !0,
      containerModifierClass: "swiper-container-",
      slideClass: "swiper-slide",
      slideBlankClass: "swiper-slide-invisible-blank",
      slideActiveClass: "swiper-slide-active",
      slideDuplicateActiveClass: "swiper-slide-duplicate-active",
      slideVisibleClass: "swiper-slide-visible",
      slideDuplicateClass: "swiper-slide-duplicate",
      slideNextClass: "swiper-slide-next",
      slideDuplicateNextClass: "swiper-slide-duplicate-next",
      slidePrevClass: "swiper-slide-prev",
      slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
      wrapperClass: "swiper-wrapper",
      runCallbacksOnInit: !0,
      _emitClasses: !1,
    },
    R = {
      modular: {
        useParams: function useParams(e) {
          var t = this;
          t.modules &&
            Object.keys(t.modules).forEach(function (a) {
              var i = t.modules[a];
              i.params && C(e, i.params);
            });
        },
        useModules: function useModules(e) {
          void 0 === e && (e = {});
          var t = this;
          t.modules &&
            Object.keys(t.modules).forEach(function (a) {
              var i = t.modules[a],
                s = e[a] || {};
              i.on &&
                t.on &&
                Object.keys(i.on).forEach(function (e) {
                  t.on(e, i.on[e]);
                }),
                i.create && i.create.bind(t)(s);
            });
        },
      },
      eventsEmitter: {
        on: function on(e, t, a) {
          var i = this;
          if ("function" != typeof t) return i;
          var s = a ? "unshift" : "push";
          return (
            e.split(" ").forEach(function (e) {
              i.eventsListeners[e] || (i.eventsListeners[e] = []),
                i.eventsListeners[e][s](t);
            }),
            i
          );
        },
        once: function once(e, t, a) {
          var i = this;
          if ("function" != typeof t) return i;

          function s() {
            i.off(e, s), s.__emitterProxy && delete s.__emitterProxy;

            for (
              var a = arguments.length, r = new Array(a), n = 0;
              n < a;
              n++
            ) {
              r[n] = arguments[n];
            }

            t.apply(i, r);
          }

          return (s.__emitterProxy = t), i.on(e, s, a);
        },
        onAny: function onAny(e, t) {
          var a = this;
          if ("function" != typeof e) return a;
          var i = t ? "unshift" : "push";
          return (
            a.eventsAnyListeners.indexOf(e) < 0 && a.eventsAnyListeners[i](e), a
          );
        },
        offAny: function offAny(e) {
          var t = this;
          if (!t.eventsAnyListeners) return t;
          var a = t.eventsAnyListeners.indexOf(e);
          return a >= 0 && t.eventsAnyListeners.splice(a, 1), t;
        },
        off: function off(e, t) {
          var a = this;
          return a.eventsListeners
            ? (e.split(" ").forEach(function (e) {
                void 0 === t
                  ? (a.eventsListeners[e] = [])
                  : a.eventsListeners[e] &&
                    a.eventsListeners[e].forEach(function (i, s) {
                      (i === t ||
                        (i.__emitterProxy && i.__emitterProxy === t)) &&
                        a.eventsListeners[e].splice(s, 1);
                    });
              }),
              a)
            : a;
        },
        emit: function emit() {
          var e,
            t,
            a,
            i = this;
          if (!i.eventsListeners) return i;

          for (var s = arguments.length, r = new Array(s), n = 0; n < s; n++) {
            r[n] = arguments[n];
          }

          "string" == typeof r[0] || Array.isArray(r[0])
            ? ((e = r[0]), (t = r.slice(1, r.length)), (a = i))
            : ((e = r[0].events), (t = r[0].data), (a = r[0].context || i)),
            t.unshift(a);
          var l = Array.isArray(e) ? e : e.split(" ");
          return (
            l.forEach(function (e) {
              i.eventsAnyListeners &&
                i.eventsAnyListeners.length &&
                i.eventsAnyListeners.forEach(function (i) {
                  i.apply(a, [e].concat(t));
                }),
                i.eventsListeners &&
                  i.eventsListeners[e] &&
                  i.eventsListeners[e].forEach(function (e) {
                    e.apply(a, t);
                  });
            }),
            i
          );
        },
      },
      update: {
        updateSize: function updateSize() {
          var e,
            t,
            a = this,
            i = a.$el;
          (e =
            void 0 !== a.params.width && null !== a.params.width
              ? a.params.width
              : i[0].clientWidth),
            (t =
              void 0 !== a.params.height && null !== a.params.height
                ? a.params.height
                : i[0].clientHeight),
            (0 === e && a.isHorizontal()) ||
              (0 === t && a.isVertical()) ||
              ((e =
                e -
                parseInt(i.css("padding-left") || 0, 10) -
                parseInt(i.css("padding-right") || 0, 10)),
              (t =
                t -
                parseInt(i.css("padding-top") || 0, 10) -
                parseInt(i.css("padding-bottom") || 0, 10)),
              Number.isNaN(e) && (e = 0),
              Number.isNaN(t) && (t = 0),
              C(a, {
                width: e,
                height: t,
                size: a.isHorizontal() ? e : t,
              }));
        },
        updateSlides: function updateSlides() {
          var e = this,
            t = function t(_t) {
              return e.isHorizontal()
                ? _t
                : {
                    width: "height",
                    "margin-top": "margin-left",
                    "margin-bottom ": "margin-right",
                    "margin-left": "margin-top",
                    "margin-right": "margin-bottom",
                    "padding-left": "padding-top",
                    "padding-right": "padding-bottom",
                    marginRight: "marginBottom",
                  }[_t];
            },
            a = function a(e, _a) {
              return parseFloat(e.getPropertyValue(t(_a)) || 0);
            },
            i = e.params,
            s = e.$wrapperEl,
            r = e.size,
            n = e.rtlTranslate,
            l = e.wrongRTL,
            o = e.virtual && i.virtual.enabled,
            d = o ? e.virtual.slides.length : e.slides.length,
            p = s.children("." + e.params.slideClass),
            c = o ? e.virtual.slides.length : p.length,
            u = [],
            h = [],
            v = [],
            f = i.slidesOffsetBefore;

          "function" == typeof f && (f = i.slidesOffsetBefore.call(e));
          var m = i.slidesOffsetAfter;
          "function" == typeof m && (m = i.slidesOffsetAfter.call(e));
          var g = e.snapGrid.length,
            b = e.slidesGrid.length,
            w = i.spaceBetween,
            y = -f,
            E = 0,
            x = 0;

          if (void 0 !== r) {
            var T, S;
            "string" == typeof w &&
              w.indexOf("%") >= 0 &&
              (w = (parseFloat(w.replace("%", "")) / 100) * r),
              (e.virtualSize = -w),
              n
                ? p.css({
                    marginLeft: "",
                    marginTop: "",
                  })
                : p.css({
                    marginRight: "",
                    marginBottom: "",
                  }),
              i.slidesPerColumn > 1 &&
                ((T =
                  Math.floor(c / i.slidesPerColumn) ===
                  c / e.params.slidesPerColumn
                    ? c
                    : Math.ceil(c / i.slidesPerColumn) * i.slidesPerColumn),
                "auto" !== i.slidesPerView &&
                  "row" === i.slidesPerColumnFill &&
                  (T = Math.max(T, i.slidesPerView * i.slidesPerColumn)));

            for (
              var M,
                z,
                P,
                k = i.slidesPerColumn,
                L = T / k,
                $ = Math.floor(c / i.slidesPerColumn),
                I = 0;
              I < c;
              I += 1
            ) {
              S = 0;
              var O = p.eq(I);

              if (i.slidesPerColumn > 1) {
                var A = void 0,
                  D = void 0,
                  N = void 0;

                if ("row" === i.slidesPerColumnFill && i.slidesPerGroup > 1) {
                  var G = Math.floor(
                      I / (i.slidesPerGroup * i.slidesPerColumn)
                    ),
                    B = I - i.slidesPerColumn * i.slidesPerGroup * G,
                    H =
                      0 === G
                        ? i.slidesPerGroup
                        : Math.min(
                            Math.ceil((c - G * k * i.slidesPerGroup) / k),
                            i.slidesPerGroup
                          );
                  (A =
                    (D =
                      B - (N = Math.floor(B / H)) * H + G * i.slidesPerGroup) +
                    (N * T) / k),
                    O.css({
                      "-webkit-box-ordinal-group": A,
                      "-moz-box-ordinal-group": A,
                      "-ms-flex-order": A,
                      "-webkit-order": A,
                      order: A,
                    });
                } else
                  "column" === i.slidesPerColumnFill
                    ? ((N = I - (D = Math.floor(I / k)) * k),
                      (D > $ || (D === $ && N === k - 1)) &&
                        (N += 1) >= k &&
                        ((N = 0), (D += 1)))
                    : (D = I - (N = Math.floor(I / L)) * L);

                O.css(
                  t("margin-top"),
                  0 !== N && i.spaceBetween && i.spaceBetween + "px"
                );
              }

              if ("none" !== O.css("display")) {
                if ("auto" === i.slidesPerView) {
                  var X = getComputedStyle(O[0]),
                    Y = O[0].style.transform,
                    R = O[0].style.webkitTransform;
                  if (
                    (Y && (O[0].style.transform = "none"),
                    R && (O[0].style.webkitTransform = "none"),
                    i.roundLengths)
                  )
                    S = e.isHorizontal() ? O.outerWidth(!0) : O.outerHeight(!0);
                  else {
                    var V = a(X, "width"),
                      W = a(X, "padding-left"),
                      F = a(X, "padding-right"),
                      _ = a(X, "margin-left"),
                      q = a(X, "margin-right"),
                      j = X.getPropertyValue("box-sizing");

                    if (j && "border-box" === j) S = V + _ + q;
                    else {
                      var U = O[0],
                        K = U.clientWidth;
                      S = V + W + F + _ + q + (U.offsetWidth - K);
                    }
                  }
                  Y && (O[0].style.transform = Y),
                    R && (O[0].style.webkitTransform = R),
                    i.roundLengths && (S = Math.floor(S));
                } else
                  (S = (r - (i.slidesPerView - 1) * w) / i.slidesPerView),
                    i.roundLengths && (S = Math.floor(S)),
                    p[I] && (p[I].style[t("width")] = S + "px");

                p[I] && (p[I].swiperSlideSize = S),
                  v.push(S),
                  i.centeredSlides
                    ? ((y = y + S / 2 + E / 2 + w),
                      0 === E && 0 !== I && (y = y - r / 2 - w),
                      0 === I && (y = y - r / 2 - w),
                      Math.abs(y) < 0.001 && (y = 0),
                      i.roundLengths && (y = Math.floor(y)),
                      x % i.slidesPerGroup == 0 && u.push(y),
                      h.push(y))
                    : (i.roundLengths && (y = Math.floor(y)),
                      (x - Math.min(e.params.slidesPerGroupSkip, x)) %
                        e.params.slidesPerGroup ==
                        0 && u.push(y),
                      h.push(y),
                      (y = y + S + w)),
                  (e.virtualSize += S + w),
                  (E = S),
                  (x += 1);
              }
            }

            if (
              ((e.virtualSize = Math.max(e.virtualSize, r) + m),
              n &&
                l &&
                ("slide" === i.effect || "coverflow" === i.effect) &&
                s.css({
                  width: e.virtualSize + i.spaceBetween + "px",
                }),
              i.setWrapperSize)
            )
              s.css(
                (((z = {})[t("width")] = e.virtualSize + i.spaceBetween + "px"),
                z)
              );
            if (i.slidesPerColumn > 1)
              if (
                ((e.virtualSize = (S + i.spaceBetween) * T),
                (e.virtualSize =
                  Math.ceil(e.virtualSize / i.slidesPerColumn) -
                  i.spaceBetween),
                s.css(
                  (((P = {})[t("width")] =
                    e.virtualSize + i.spaceBetween + "px"),
                  P)
                ),
                i.centeredSlides)
              ) {
                M = [];

                for (var Z = 0; Z < u.length; Z += 1) {
                  var J = u[Z];
                  i.roundLengths && (J = Math.floor(J)),
                    u[Z] < e.virtualSize + u[0] && M.push(J);
                }

                u = M;
              }

            if (!i.centeredSlides) {
              M = [];

              for (var Q = 0; Q < u.length; Q += 1) {
                var ee = u[Q];
                i.roundLengths && (ee = Math.floor(ee)),
                  u[Q] <= e.virtualSize - r && M.push(ee);
              }

              (u = M),
                Math.floor(e.virtualSize - r) - Math.floor(u[u.length - 1]) >
                  1 && u.push(e.virtualSize - r);
            }

            if ((0 === u.length && (u = [0]), 0 !== i.spaceBetween)) {
              var te,
                ae = e.isHorizontal() && n ? "marginLeft" : t("marginRight");
              p.filter(function (e, t) {
                return !i.cssMode || t !== p.length - 1;
              }).css((((te = {})[ae] = w + "px"), te));
            }

            if (i.centeredSlides && i.centeredSlidesBounds) {
              var ie = 0;
              v.forEach(function (e) {
                ie += e + (i.spaceBetween ? i.spaceBetween : 0);
              });
              var se = (ie -= i.spaceBetween) - r;
              u = u.map(function (e) {
                return e < 0 ? -f : e > se ? se + m : e;
              });
            }

            if (i.centerInsufficientSlides) {
              var re = 0;

              if (
                (v.forEach(function (e) {
                  re += e + (i.spaceBetween ? i.spaceBetween : 0);
                }),
                (re -= i.spaceBetween) < r)
              ) {
                var ne = (r - re) / 2;
                u.forEach(function (e, t) {
                  u[t] = e - ne;
                }),
                  h.forEach(function (e, t) {
                    h[t] = e + ne;
                  });
              }
            }

            C(e, {
              slides: p,
              snapGrid: u,
              slidesGrid: h,
              slidesSizesGrid: v,
            }),
              c !== d && e.emit("slidesLengthChange"),
              u.length !== g &&
                (e.params.watchOverflow && e.checkOverflow(),
                e.emit("snapGridLengthChange")),
              h.length !== b && e.emit("slidesGridLengthChange"),
              (i.watchSlidesProgress || i.watchSlidesVisibility) &&
                e.updateSlidesOffset();
          }
        },
        updateAutoHeight: function updateAutoHeight(e) {
          var t,
            a = this,
            i = [],
            s = 0;
          if (
            ("number" == typeof e
              ? a.setTransition(e)
              : !0 === e && a.setTransition(a.params.speed),
            "auto" !== a.params.slidesPerView && a.params.slidesPerView > 1)
          ) {
            if (a.params.centeredSlides)
              a.visibleSlides.each(function (e) {
                i.push(e);
              });
            else
              for (t = 0; t < Math.ceil(a.params.slidesPerView); t += 1) {
                var r = a.activeIndex + t;
                if (r > a.slides.length) break;
                i.push(a.slides.eq(r)[0]);
              }
          } else i.push(a.slides.eq(a.activeIndex)[0]);

          for (t = 0; t < i.length; t += 1) {
            if (void 0 !== i[t]) {
              var n = i[t].offsetHeight;
              s = n > s ? n : s;
            }
          }

          s && a.$wrapperEl.css("height", s + "px");
        },
        updateSlidesOffset: function updateSlidesOffset() {
          for (var e = this.slides, t = 0; t < e.length; t += 1) {
            e[t].swiperSlideOffset = this.isHorizontal()
              ? e[t].offsetLeft
              : e[t].offsetTop;
          }
        },
        updateSlidesProgress: function updateSlidesProgress(e) {
          void 0 === e && (e = (this && this.translate) || 0);
          var t = this,
            a = t.params,
            i = t.slides,
            s = t.rtlTranslate;

          if (0 !== i.length) {
            void 0 === i[0].swiperSlideOffset && t.updateSlidesOffset();
            var r = -e;
            s && (r = e),
              i.removeClass(a.slideVisibleClass),
              (t.visibleSlidesIndexes = []),
              (t.visibleSlides = []);

            for (var n = 0; n < i.length; n += 1) {
              var l = i[n],
                o =
                  (r +
                    (a.centeredSlides ? t.minTranslate() : 0) -
                    l.swiperSlideOffset) /
                  (l.swiperSlideSize + a.spaceBetween);

              if (
                a.watchSlidesVisibility ||
                (a.centeredSlides && a.autoHeight)
              ) {
                var d = -(r - l.swiperSlideOffset),
                  p = d + t.slidesSizesGrid[n];
                ((d >= 0 && d < t.size - 1) ||
                  (p > 1 && p <= t.size) ||
                  (d <= 0 && p >= t.size)) &&
                  (t.visibleSlides.push(l),
                  t.visibleSlidesIndexes.push(n),
                  i.eq(n).addClass(a.slideVisibleClass));
              }

              l.progress = s ? -o : o;
            }

            t.visibleSlides = m(t.visibleSlides);
          }
        },
        updateProgress: function updateProgress(e) {
          var t = this;

          if (void 0 === e) {
            var a = t.rtlTranslate ? -1 : 1;
            e = (t && t.translate && t.translate * a) || 0;
          }

          var i = t.params,
            s = t.maxTranslate() - t.minTranslate(),
            r = t.progress,
            n = t.isBeginning,
            l = t.isEnd,
            o = n,
            d = l;
          0 === s
            ? ((r = 0), (n = !0), (l = !0))
            : ((n = (r = (e - t.minTranslate()) / s) <= 0), (l = r >= 1)),
            C(t, {
              progress: r,
              isBeginning: n,
              isEnd: l,
            }),
            (i.watchSlidesProgress ||
              i.watchSlidesVisibility ||
              (i.centeredSlides && i.autoHeight)) &&
              t.updateSlidesProgress(e),
            n && !o && t.emit("reachBeginning toEdge"),
            l && !d && t.emit("reachEnd toEdge"),
            ((o && !n) || (d && !l)) && t.emit("fromEdge"),
            t.emit("progress", r);
        },
        updateSlidesClasses: function updateSlidesClasses() {
          var e,
            t = this,
            a = t.slides,
            i = t.params,
            s = t.$wrapperEl,
            r = t.activeIndex,
            n = t.realIndex,
            l = t.virtual && i.virtual.enabled;
          a.removeClass(
            i.slideActiveClass +
              " " +
              i.slideNextClass +
              " " +
              i.slidePrevClass +
              " " +
              i.slideDuplicateActiveClass +
              " " +
              i.slideDuplicateNextClass +
              " " +
              i.slideDuplicatePrevClass
          ),
            (e = l
              ? t.$wrapperEl.find(
                  "." + i.slideClass + '[data-swiper-slide-index="' + r + '"]'
                )
              : a.eq(r)).addClass(i.slideActiveClass),
            i.loop &&
              (e.hasClass(i.slideDuplicateClass)
                ? s
                    .children(
                      "." +
                        i.slideClass +
                        ":not(." +
                        i.slideDuplicateClass +
                        ')[data-swiper-slide-index="' +
                        n +
                        '"]'
                    )
                    .addClass(i.slideDuplicateActiveClass)
                : s
                    .children(
                      "." +
                        i.slideClass +
                        "." +
                        i.slideDuplicateClass +
                        '[data-swiper-slide-index="' +
                        n +
                        '"]'
                    )
                    .addClass(i.slideDuplicateActiveClass));
          var o = e
            .nextAll("." + i.slideClass)
            .eq(0)
            .addClass(i.slideNextClass);
          i.loop && 0 === o.length && (o = a.eq(0)).addClass(i.slideNextClass);
          var d = e
            .prevAll("." + i.slideClass)
            .eq(0)
            .addClass(i.slidePrevClass);
          i.loop && 0 === d.length && (d = a.eq(-1)).addClass(i.slidePrevClass),
            i.loop &&
              (o.hasClass(i.slideDuplicateClass)
                ? s
                    .children(
                      "." +
                        i.slideClass +
                        ":not(." +
                        i.slideDuplicateClass +
                        ')[data-swiper-slide-index="' +
                        o.attr("data-swiper-slide-index") +
                        '"]'
                    )
                    .addClass(i.slideDuplicateNextClass)
                : s
                    .children(
                      "." +
                        i.slideClass +
                        "." +
                        i.slideDuplicateClass +
                        '[data-swiper-slide-index="' +
                        o.attr("data-swiper-slide-index") +
                        '"]'
                    )
                    .addClass(i.slideDuplicateNextClass),
              d.hasClass(i.slideDuplicateClass)
                ? s
                    .children(
                      "." +
                        i.slideClass +
                        ":not(." +
                        i.slideDuplicateClass +
                        ')[data-swiper-slide-index="' +
                        d.attr("data-swiper-slide-index") +
                        '"]'
                    )
                    .addClass(i.slideDuplicatePrevClass)
                : s
                    .children(
                      "." +
                        i.slideClass +
                        "." +
                        i.slideDuplicateClass +
                        '[data-swiper-slide-index="' +
                        d.attr("data-swiper-slide-index") +
                        '"]'
                    )
                    .addClass(i.slideDuplicatePrevClass)),
            t.emitSlidesClasses();
        },
        updateActiveIndex: function updateActiveIndex(e) {
          var t,
            a = this,
            i = a.rtlTranslate ? a.translate : -a.translate,
            s = a.slidesGrid,
            r = a.snapGrid,
            n = a.params,
            l = a.activeIndex,
            o = a.realIndex,
            d = a.snapIndex,
            p = e;

          if (void 0 === p) {
            for (var c = 0; c < s.length; c += 1) {
              void 0 !== s[c + 1]
                ? i >= s[c] && i < s[c + 1] - (s[c + 1] - s[c]) / 2
                  ? (p = c)
                  : i >= s[c] && i < s[c + 1] && (p = c + 1)
                : i >= s[c] && (p = c);
            }

            n.normalizeSlideIndex && (p < 0 || void 0 === p) && (p = 0);
          }

          if (r.indexOf(i) >= 0) t = r.indexOf(i);
          else {
            var u = Math.min(n.slidesPerGroupSkip, p);
            t = u + Math.floor((p - u) / n.slidesPerGroup);
          }

          if ((t >= r.length && (t = r.length - 1), p !== l)) {
            var h = parseInt(
              a.slides.eq(p).attr("data-swiper-slide-index") || p,
              10
            );
            C(a, {
              snapIndex: t,
              realIndex: h,
              previousIndex: l,
              activeIndex: p,
            }),
              a.emit("activeIndexChange"),
              a.emit("snapIndexChange"),
              o !== h && a.emit("realIndexChange"),
              (a.initialized || a.params.runCallbacksOnInit) &&
                a.emit("slideChange");
          } else t !== d && ((a.snapIndex = t), a.emit("snapIndexChange"));
        },
        updateClickedSlide: function updateClickedSlide(e) {
          var t,
            a = this,
            i = a.params,
            s = m(e.target).closest("." + i.slideClass)[0],
            r = !1;
          if (s)
            for (var n = 0; n < a.slides.length; n += 1) {
              if (a.slides[n] === s) {
                (r = !0), (t = n);
                break;
              }
            }
          if (!s || !r)
            return (a.clickedSlide = void 0), void (a.clickedIndex = void 0);
          (a.clickedSlide = s),
            a.virtual && a.params.virtual.enabled
              ? (a.clickedIndex = parseInt(
                  m(s).attr("data-swiper-slide-index"),
                  10
                ))
              : (a.clickedIndex = t),
            i.slideToClickedSlide &&
              void 0 !== a.clickedIndex &&
              a.clickedIndex !== a.activeIndex &&
              a.slideToClickedSlide();
        },
      },
      translate: {
        getTranslate: function getTranslate(e) {
          void 0 === e && (e = this.isHorizontal() ? "x" : "y");
          var t = this,
            a = t.params,
            i = t.rtlTranslate,
            s = t.translate,
            r = t.$wrapperEl;
          if (a.virtualTranslate) return i ? -s : s;
          if (a.cssMode) return s;
          var n = T(r[0], e);
          return i && (n = -n), n || 0;
        },
        setTranslate: function setTranslate(e, t) {
          var a = this,
            i = a.rtlTranslate,
            s = a.params,
            r = a.$wrapperEl,
            n = a.wrapperEl,
            l = a.progress,
            o = 0,
            d = 0;
          a.isHorizontal() ? (o = i ? -e : e) : (d = e),
            s.roundLengths && ((o = Math.floor(o)), (d = Math.floor(d))),
            s.cssMode
              ? (n[a.isHorizontal() ? "scrollLeft" : "scrollTop"] =
                  a.isHorizontal() ? -o : -d)
              : s.virtualTranslate ||
                r.transform("translate3d(" + o + "px, " + d + "px, 0px)"),
            (a.previousTranslate = a.translate),
            (a.translate = a.isHorizontal() ? o : d);
          var p = a.maxTranslate() - a.minTranslate();
          (0 === p ? 0 : (e - a.minTranslate()) / p) !== l &&
            a.updateProgress(e),
            a.emit("setTranslate", a.translate, t);
        },
        minTranslate: function minTranslate() {
          return -this.snapGrid[0];
        },
        maxTranslate: function maxTranslate() {
          return -this.snapGrid[this.snapGrid.length - 1];
        },
        translateTo: function translateTo(e, t, a, i, s) {
          void 0 === e && (e = 0),
            void 0 === t && (t = this.params.speed),
            void 0 === a && (a = !0),
            void 0 === i && (i = !0);
          var r = this,
            n = r.params,
            l = r.wrapperEl;
          if (r.animating && n.preventInteractionOnTransition) return !1;
          var o,
            d = r.minTranslate(),
            p = r.maxTranslate();

          if (
            ((o = i && e > d ? d : i && e < p ? p : e),
            r.updateProgress(o),
            n.cssMode)
          ) {
            var c,
              u = r.isHorizontal();
            if (0 === t) l[u ? "scrollLeft" : "scrollTop"] = -o;
            else if (l.scrollTo)
              l.scrollTo(
                (((c = {})[u ? "left" : "top"] = -o),
                (c.behavior = "smooth"),
                c)
              );
            else l[u ? "scrollLeft" : "scrollTop"] = -o;
            return !0;
          }

          return (
            0 === t
              ? (r.setTransition(0),
                r.setTranslate(o),
                a &&
                  (r.emit("beforeTransitionStart", t, s),
                  r.emit("transitionEnd")))
              : (r.setTransition(t),
                r.setTranslate(o),
                a &&
                  (r.emit("beforeTransitionStart", t, s),
                  r.emit("transitionStart")),
                r.animating ||
                  ((r.animating = !0),
                  r.onTranslateToWrapperTransitionEnd ||
                    (r.onTranslateToWrapperTransitionEnd = function (e) {
                      r &&
                        !r.destroyed &&
                        e.target === this &&
                        (r.$wrapperEl[0].removeEventListener(
                          "transitionend",
                          r.onTranslateToWrapperTransitionEnd
                        ),
                        r.$wrapperEl[0].removeEventListener(
                          "webkitTransitionEnd",
                          r.onTranslateToWrapperTransitionEnd
                        ),
                        (r.onTranslateToWrapperTransitionEnd = null),
                        delete r.onTranslateToWrapperTransitionEnd,
                        a && r.emit("transitionEnd"));
                    }),
                  r.$wrapperEl[0].addEventListener(
                    "transitionend",
                    r.onTranslateToWrapperTransitionEnd
                  ),
                  r.$wrapperEl[0].addEventListener(
                    "webkitTransitionEnd",
                    r.onTranslateToWrapperTransitionEnd
                  ))),
            !0
          );
        },
      },
      transition: {
        setTransition: function setTransition(e, t) {
          var a = this;
          a.params.cssMode || a.$wrapperEl.transition(e),
            a.emit("setTransition", e, t);
        },
        transitionStart: function transitionStart(e, t) {
          void 0 === e && (e = !0);
          var a = this,
            i = a.activeIndex,
            s = a.params,
            r = a.previousIndex;

          if (!s.cssMode) {
            s.autoHeight && a.updateAutoHeight();
            var n = t;

            if (
              (n || (n = i > r ? "next" : i < r ? "prev" : "reset"),
              a.emit("transitionStart"),
              e && i !== r)
            ) {
              if ("reset" === n)
                return void a.emit("slideResetTransitionStart");
              a.emit("slideChangeTransitionStart"),
                "next" === n
                  ? a.emit("slideNextTransitionStart")
                  : a.emit("slidePrevTransitionStart");
            }
          }
        },
        transitionEnd: function transitionEnd(e, t) {
          void 0 === e && (e = !0);
          var a = this,
            i = a.activeIndex,
            s = a.previousIndex,
            r = a.params;

          if (((a.animating = !1), !r.cssMode)) {
            a.setTransition(0);
            var n = t;

            if (
              (n || (n = i > s ? "next" : i < s ? "prev" : "reset"),
              a.emit("transitionEnd"),
              e && i !== s)
            ) {
              if ("reset" === n) return void a.emit("slideResetTransitionEnd");
              a.emit("slideChangeTransitionEnd"),
                "next" === n
                  ? a.emit("slideNextTransitionEnd")
                  : a.emit("slidePrevTransitionEnd");
            }
          }
        },
      },
      slide: {
        slideTo: function slideTo(e, t, a, i) {
          if (
            (void 0 === e && (e = 0),
            void 0 === t && (t = this.params.speed),
            void 0 === a && (a = !0),
            "number" != typeof e && "string" != typeof e)
          )
            throw new Error(
              "The 'index' argument cannot have type other than 'number' or 'string'. [" +
                _typeof(e) +
                "] given."
            );

          if ("string" == typeof e) {
            var s = parseInt(e, 10);
            if (!isFinite(s))
              throw new Error(
                "The passed-in 'index' (string) couldn't be converted to 'number'. [" +
                  e +
                  "] given."
              );
            e = s;
          }

          var r = this,
            n = e;
          n < 0 && (n = 0);
          var l = r.params,
            o = r.snapGrid,
            d = r.slidesGrid,
            p = r.previousIndex,
            c = r.activeIndex,
            u = r.rtlTranslate,
            h = r.wrapperEl;
          if (r.animating && l.preventInteractionOnTransition) return !1;
          var v = Math.min(r.params.slidesPerGroupSkip, n),
            f = v + Math.floor((n - v) / r.params.slidesPerGroup);
          f >= o.length && (f = o.length - 1),
            (c || l.initialSlide || 0) === (p || 0) &&
              a &&
              r.emit("beforeSlideChangeStart");
          var m,
            g = -o[f];
          if ((r.updateProgress(g), l.normalizeSlideIndex))
            for (var b = 0; b < d.length; b += 1) {
              var w = -Math.floor(100 * g),
                y = Math.floor(100 * d[b]),
                E = Math.floor(100 * d[b + 1]);
              void 0 !== d[b + 1]
                ? w >= y && w < E - (E - y) / 2
                  ? (n = b)
                  : w >= y && w < E && (n = b + 1)
                : w >= y && (n = b);
            }

          if (r.initialized && n !== c) {
            if (!r.allowSlideNext && g < r.translate && g < r.minTranslate())
              return !1;
            if (
              !r.allowSlidePrev &&
              g > r.translate &&
              g > r.maxTranslate() &&
              (c || 0) !== n
            )
              return !1;
          }

          if (
            ((m = n > c ? "next" : n < c ? "prev" : "reset"),
            (u && -g === r.translate) || (!u && g === r.translate))
          )
            return (
              r.updateActiveIndex(n),
              l.autoHeight && r.updateAutoHeight(),
              r.updateSlidesClasses(),
              "slide" !== l.effect && r.setTranslate(g),
              "reset" !== m && (r.transitionStart(a, m), r.transitionEnd(a, m)),
              !1
            );

          if (l.cssMode) {
            var x,
              T = r.isHorizontal(),
              S = -g;
            if ((u && (S = h.scrollWidth - h.offsetWidth - S), 0 === t))
              h[T ? "scrollLeft" : "scrollTop"] = S;
            else if (h.scrollTo)
              h.scrollTo(
                (((x = {})[T ? "left" : "top"] = S), (x.behavior = "smooth"), x)
              );
            else h[T ? "scrollLeft" : "scrollTop"] = S;
            return !0;
          }

          return (
            0 === t
              ? (r.setTransition(0),
                r.setTranslate(g),
                r.updateActiveIndex(n),
                r.updateSlidesClasses(),
                r.emit("beforeTransitionStart", t, i),
                r.transitionStart(a, m),
                r.transitionEnd(a, m))
              : (r.setTransition(t),
                r.setTranslate(g),
                r.updateActiveIndex(n),
                r.updateSlidesClasses(),
                r.emit("beforeTransitionStart", t, i),
                r.transitionStart(a, m),
                r.animating ||
                  ((r.animating = !0),
                  r.onSlideToWrapperTransitionEnd ||
                    (r.onSlideToWrapperTransitionEnd = function (e) {
                      r &&
                        !r.destroyed &&
                        e.target === this &&
                        (r.$wrapperEl[0].removeEventListener(
                          "transitionend",
                          r.onSlideToWrapperTransitionEnd
                        ),
                        r.$wrapperEl[0].removeEventListener(
                          "webkitTransitionEnd",
                          r.onSlideToWrapperTransitionEnd
                        ),
                        (r.onSlideToWrapperTransitionEnd = null),
                        delete r.onSlideToWrapperTransitionEnd,
                        r.transitionEnd(a, m));
                    }),
                  r.$wrapperEl[0].addEventListener(
                    "transitionend",
                    r.onSlideToWrapperTransitionEnd
                  ),
                  r.$wrapperEl[0].addEventListener(
                    "webkitTransitionEnd",
                    r.onSlideToWrapperTransitionEnd
                  ))),
            !0
          );
        },
        slideToLoop: function slideToLoop(e, t, a, i) {
          void 0 === e && (e = 0),
            void 0 === t && (t = this.params.speed),
            void 0 === a && (a = !0);
          var s = this,
            r = e;
          return s.params.loop && (r += s.loopedSlides), s.slideTo(r, t, a, i);
        },
        slideNext: function slideNext(e, t, a) {
          void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
          var i = this,
            s = i.params,
            r = i.animating,
            n = i.activeIndex < s.slidesPerGroupSkip ? 1 : s.slidesPerGroup;

          if (s.loop) {
            if (r && s.loopPreventsSlide) return !1;
            i.loopFix(), (i._clientLeft = i.$wrapperEl[0].clientLeft);
          }

          return i.slideTo(i.activeIndex + n, e, t, a);
        },
        slidePrev: function slidePrev(e, t, a) {
          void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
          var i = this,
            s = i.params,
            r = i.animating,
            n = i.snapGrid,
            l = i.slidesGrid,
            o = i.rtlTranslate;

          if (s.loop) {
            if (r && s.loopPreventsSlide) return !1;
            i.loopFix(), (i._clientLeft = i.$wrapperEl[0].clientLeft);
          }

          function d(e) {
            return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
          }

          var p = d(o ? i.translate : -i.translate),
            c = n.map(function (e) {
              return d(e);
            });
          n[c.indexOf(p)];
          var u,
            h = n[c.indexOf(p) - 1];
          return (
            void 0 === h &&
              s.cssMode &&
              n.forEach(function (e) {
                !h && p >= e && (h = e);
              }),
            void 0 !== h && (u = l.indexOf(h)) < 0 && (u = i.activeIndex - 1),
            i.slideTo(u, e, t, a)
          );
        },
        slideReset: function slideReset(e, t, a) {
          return (
            void 0 === e && (e = this.params.speed),
            void 0 === t && (t = !0),
            this.slideTo(this.activeIndex, e, t, a)
          );
        },
        slideToClosest: function slideToClosest(e, t, a, i) {
          void 0 === e && (e = this.params.speed),
            void 0 === t && (t = !0),
            void 0 === i && (i = 0.5);
          var s = this,
            r = s.activeIndex,
            n = Math.min(s.params.slidesPerGroupSkip, r),
            l = n + Math.floor((r - n) / s.params.slidesPerGroup),
            o = s.rtlTranslate ? s.translate : -s.translate;

          if (o >= s.snapGrid[l]) {
            var d = s.snapGrid[l];
            o - d > (s.snapGrid[l + 1] - d) * i &&
              (r += s.params.slidesPerGroup);
          } else {
            var p = s.snapGrid[l - 1];
            o - p <= (s.snapGrid[l] - p) * i && (r -= s.params.slidesPerGroup);
          }

          return (
            (r = Math.max(r, 0)),
            (r = Math.min(r, s.slidesGrid.length - 1)),
            s.slideTo(r, e, t, a)
          );
        },
        slideToClickedSlide: function slideToClickedSlide() {
          var e,
            t = this,
            a = t.params,
            i = t.$wrapperEl,
            s =
              "auto" === a.slidesPerView
                ? t.slidesPerViewDynamic()
                : a.slidesPerView,
            r = t.clickedIndex;

          if (a.loop) {
            if (t.animating) return;
            (e = parseInt(
              m(t.clickedSlide).attr("data-swiper-slide-index"),
              10
            )),
              a.centeredSlides
                ? r < t.loopedSlides - s / 2 ||
                  r > t.slides.length - t.loopedSlides + s / 2
                  ? (t.loopFix(),
                    (r = i
                      .children(
                        "." +
                          a.slideClass +
                          '[data-swiper-slide-index="' +
                          e +
                          '"]:not(.' +
                          a.slideDuplicateClass +
                          ")"
                      )
                      .eq(0)
                      .index()),
                    E(function () {
                      t.slideTo(r);
                    }))
                  : t.slideTo(r)
                : r > t.slides.length - s
                ? (t.loopFix(),
                  (r = i
                    .children(
                      "." +
                        a.slideClass +
                        '[data-swiper-slide-index="' +
                        e +
                        '"]:not(.' +
                        a.slideDuplicateClass +
                        ")"
                    )
                    .eq(0)
                    .index()),
                  E(function () {
                    t.slideTo(r);
                  }))
                : t.slideTo(r);
          } else t.slideTo(r);
        },
      },
      loop: {
        loopCreate: function loopCreate() {
          var e = this,
            t = r(),
            a = e.params,
            i = e.$wrapperEl;
          i.children("." + a.slideClass + "." + a.slideDuplicateClass).remove();
          var s = i.children("." + a.slideClass);

          if (a.loopFillGroupWithBlank) {
            var n = a.slidesPerGroup - (s.length % a.slidesPerGroup);

            if (n !== a.slidesPerGroup) {
              for (var l = 0; l < n; l += 1) {
                var o = m(t.createElement("div")).addClass(
                  a.slideClass + " " + a.slideBlankClass
                );
                i.append(o);
              }

              s = i.children("." + a.slideClass);
            }
          }

          "auto" !== a.slidesPerView ||
            a.loopedSlides ||
            (a.loopedSlides = s.length),
            (e.loopedSlides = Math.ceil(
              parseFloat(a.loopedSlides || a.slidesPerView, 10)
            )),
            (e.loopedSlides += a.loopAdditionalSlides),
            e.loopedSlides > s.length && (e.loopedSlides = s.length);
          var d = [],
            p = [];
          s.each(function (t, a) {
            var i = m(t);
            a < e.loopedSlides && p.push(t),
              a < s.length && a >= s.length - e.loopedSlides && d.push(t),
              i.attr("data-swiper-slide-index", a);
          });

          for (var c = 0; c < p.length; c += 1) {
            i.append(m(p[c].cloneNode(!0)).addClass(a.slideDuplicateClass));
          }

          for (var u = d.length - 1; u >= 0; u -= 1) {
            i.prepend(m(d[u].cloneNode(!0)).addClass(a.slideDuplicateClass));
          }
        },
        loopFix: function loopFix() {
          var e = this;
          e.emit("beforeLoopFix");
          var t,
            a = e.activeIndex,
            i = e.slides,
            s = e.loopedSlides,
            r = e.allowSlidePrev,
            n = e.allowSlideNext,
            l = e.snapGrid,
            o = e.rtlTranslate;
          (e.allowSlidePrev = !0), (e.allowSlideNext = !0);
          var d = -l[a] - e.getTranslate();
          if (a < s)
            (t = i.length - 3 * s + a),
              (t += s),
              e.slideTo(t, 0, !1, !0) &&
                0 !== d &&
                e.setTranslate((o ? -e.translate : e.translate) - d);
          else if (a >= i.length - s) {
            (t = -i.length + a + s),
              (t += s),
              e.slideTo(t, 0, !1, !0) &&
                0 !== d &&
                e.setTranslate((o ? -e.translate : e.translate) - d);
          }
          (e.allowSlidePrev = r), (e.allowSlideNext = n), e.emit("loopFix");
        },
        loopDestroy: function loopDestroy() {
          var e = this,
            t = e.$wrapperEl,
            a = e.params,
            i = e.slides;
          t
            .children(
              "." +
                a.slideClass +
                "." +
                a.slideDuplicateClass +
                ",." +
                a.slideClass +
                "." +
                a.slideBlankClass
            )
            .remove(),
            i.removeAttr("data-swiper-slide-index");
        },
      },
      grabCursor: {
        setGrabCursor: function setGrabCursor(e) {
          var t = this;

          if (
            !(
              t.support.touch ||
              !t.params.simulateTouch ||
              (t.params.watchOverflow && t.isLocked) ||
              t.params.cssMode
            )
          ) {
            var a = t.el;
            (a.style.cursor = "move"),
              (a.style.cursor = e ? "-webkit-grabbing" : "-webkit-grab"),
              (a.style.cursor = e ? "-moz-grabbin" : "-moz-grab"),
              (a.style.cursor = e ? "grabbing" : "grab");
          }
        },
        unsetGrabCursor: function unsetGrabCursor() {
          var e = this;
          e.support.touch ||
            (e.params.watchOverflow && e.isLocked) ||
            e.params.cssMode ||
            (e.el.style.cursor = "");
        },
      },
      manipulation: {
        appendSlide: function appendSlide(e) {
          var t = this,
            a = t.$wrapperEl,
            i = t.params;
          if (
            (i.loop && t.loopDestroy(), "object" == _typeof(e) && "length" in e)
          )
            for (var s = 0; s < e.length; s += 1) {
              e[s] && a.append(e[s]);
            }
          else a.append(e);
          i.loop && t.loopCreate(),
            (i.observer && t.support.observer) || t.update();
        },
        prependSlide: function prependSlide(e) {
          var t = this,
            a = t.params,
            i = t.$wrapperEl,
            s = t.activeIndex;
          a.loop && t.loopDestroy();
          var r = s + 1;

          if ("object" == _typeof(e) && "length" in e) {
            for (var n = 0; n < e.length; n += 1) {
              e[n] && i.prepend(e[n]);
            }

            r = s + e.length;
          } else i.prepend(e);

          a.loop && t.loopCreate(),
            (a.observer && t.support.observer) || t.update(),
            t.slideTo(r, 0, !1);
        },
        addSlide: function addSlide(e, t) {
          var a = this,
            i = a.$wrapperEl,
            s = a.params,
            r = a.activeIndex;
          s.loop &&
            ((r -= a.loopedSlides),
            a.loopDestroy(),
            (a.slides = i.children("." + s.slideClass)));
          var n = a.slides.length;
          if (e <= 0) a.prependSlide(t);
          else if (e >= n) a.appendSlide(t);
          else {
            for (var l = r > e ? r + 1 : r, o = [], d = n - 1; d >= e; d -= 1) {
              var p = a.slides.eq(d);
              p.remove(), o.unshift(p);
            }

            if ("object" == _typeof(t) && "length" in t) {
              for (var c = 0; c < t.length; c += 1) {
                t[c] && i.append(t[c]);
              }

              l = r > e ? r + t.length : r;
            } else i.append(t);

            for (var u = 0; u < o.length; u += 1) {
              i.append(o[u]);
            }

            s.loop && a.loopCreate(),
              (s.observer && a.support.observer) || a.update(),
              s.loop
                ? a.slideTo(l + a.loopedSlides, 0, !1)
                : a.slideTo(l, 0, !1);
          }
        },
        removeSlide: function removeSlide(e) {
          var t = this,
            a = t.params,
            i = t.$wrapperEl,
            s = t.activeIndex;
          a.loop &&
            ((s -= t.loopedSlides),
            t.loopDestroy(),
            (t.slides = i.children("." + a.slideClass)));
          var r,
            n = s;

          if ("object" == _typeof(e) && "length" in e) {
            for (var l = 0; l < e.length; l += 1) {
              (r = e[l]),
                t.slides[r] && t.slides.eq(r).remove(),
                r < n && (n -= 1);
            }

            n = Math.max(n, 0);
          } else
            (r = e),
              t.slides[r] && t.slides.eq(r).remove(),
              r < n && (n -= 1),
              (n = Math.max(n, 0));

          a.loop && t.loopCreate(),
            (a.observer && t.support.observer) || t.update(),
            a.loop ? t.slideTo(n + t.loopedSlides, 0, !1) : t.slideTo(n, 0, !1);
        },
        removeAllSlides: function removeAllSlides() {
          for (var e = [], t = 0; t < this.slides.length; t += 1) {
            e.push(t);
          }

          this.removeSlide(e);
        },
      },
      events: {
        attachEvents: function attachEvents() {
          var e = this,
            t = r(),
            a = e.params,
            i = e.touchEvents,
            s = e.el,
            n = e.wrapperEl,
            l = e.device,
            o = e.support;
          (e.onTouchStart = O.bind(e)),
            (e.onTouchMove = A.bind(e)),
            (e.onTouchEnd = D.bind(e)),
            a.cssMode && (e.onScroll = B.bind(e)),
            (e.onClick = G.bind(e));
          var d = !!a.nested;
          if (!o.touch && o.pointerEvents)
            s.addEventListener(i.start, e.onTouchStart, !1),
              t.addEventListener(i.move, e.onTouchMove, d),
              t.addEventListener(i.end, e.onTouchEnd, !1);
          else {
            if (o.touch) {
              var p = !(
                "touchstart" !== i.start ||
                !o.passiveListener ||
                !a.passiveListeners
              ) && {
                passive: !0,
                capture: !1,
              };
              s.addEventListener(i.start, e.onTouchStart, p),
                s.addEventListener(
                  i.move,
                  e.onTouchMove,
                  o.passiveListener
                    ? {
                        passive: !1,
                        capture: d,
                      }
                    : d
                ),
                s.addEventListener(i.end, e.onTouchEnd, p),
                i.cancel && s.addEventListener(i.cancel, e.onTouchEnd, p),
                H || (t.addEventListener("touchstart", X), (H = !0));
            }

            ((a.simulateTouch && !l.ios && !l.android) ||
              (a.simulateTouch && !o.touch && l.ios)) &&
              (s.addEventListener("mousedown", e.onTouchStart, !1),
              t.addEventListener("mousemove", e.onTouchMove, d),
              t.addEventListener("mouseup", e.onTouchEnd, !1));
          }
          (a.preventClicks || a.preventClicksPropagation) &&
            s.addEventListener("click", e.onClick, !0),
            a.cssMode && n.addEventListener("scroll", e.onScroll),
            a.updateOnWindowResize
              ? e.on(
                  l.ios || l.android
                    ? "resize orientationchange observerUpdate"
                    : "resize observerUpdate",
                  N,
                  !0
                )
              : e.on("observerUpdate", N, !0);
        },
        detachEvents: function detachEvents() {
          var e = this,
            t = r(),
            a = e.params,
            i = e.touchEvents,
            s = e.el,
            n = e.wrapperEl,
            l = e.device,
            o = e.support,
            d = !!a.nested;
          if (!o.touch && o.pointerEvents)
            s.removeEventListener(i.start, e.onTouchStart, !1),
              t.removeEventListener(i.move, e.onTouchMove, d),
              t.removeEventListener(i.end, e.onTouchEnd, !1);
          else {
            if (o.touch) {
              var p = !(
                "onTouchStart" !== i.start ||
                !o.passiveListener ||
                !a.passiveListeners
              ) && {
                passive: !0,
                capture: !1,
              };
              s.removeEventListener(i.start, e.onTouchStart, p),
                s.removeEventListener(i.move, e.onTouchMove, d),
                s.removeEventListener(i.end, e.onTouchEnd, p),
                i.cancel && s.removeEventListener(i.cancel, e.onTouchEnd, p);
            }

            ((a.simulateTouch && !l.ios && !l.android) ||
              (a.simulateTouch && !o.touch && l.ios)) &&
              (s.removeEventListener("mousedown", e.onTouchStart, !1),
              t.removeEventListener("mousemove", e.onTouchMove, d),
              t.removeEventListener("mouseup", e.onTouchEnd, !1));
          }
          (a.preventClicks || a.preventClicksPropagation) &&
            s.removeEventListener("click", e.onClick, !0),
            a.cssMode && n.removeEventListener("scroll", e.onScroll),
            e.off(
              l.ios || l.android
                ? "resize orientationchange observerUpdate"
                : "resize observerUpdate",
              N
            );
        },
      },
      breakpoints: {
        setBreakpoint: function setBreakpoint() {
          var e = this,
            t = e.activeIndex,
            a = e.initialized,
            i = e.loopedSlides,
            s = void 0 === i ? 0 : i,
            r = e.params,
            n = e.$el,
            l = r.breakpoints;

          if (l && (!l || 0 !== Object.keys(l).length)) {
            var o = e.getBreakpoint(l, e.params.breakpointsBase, e.el);

            if (o && e.currentBreakpoint !== o) {
              var d = o in l ? l[o] : void 0;
              d &&
                [
                  "slidesPerView",
                  "spaceBetween",
                  "slidesPerGroup",
                  "slidesPerGroupSkip",
                  "slidesPerColumn",
                ].forEach(function (e) {
                  var t = d[e];
                  void 0 !== t &&
                    (d[e] =
                      "slidesPerView" !== e || ("AUTO" !== t && "auto" !== t)
                        ? "slidesPerView" === e
                          ? parseFloat(t)
                          : parseInt(t, 10)
                        : "auto");
                });
              var p = d || e.originalParams,
                c = r.slidesPerColumn > 1,
                u = p.slidesPerColumn > 1;
              c && !u
                ? (n.removeClass(
                    r.containerModifierClass +
                      "multirow " +
                      r.containerModifierClass +
                      "multirow-column"
                  ),
                  e.emitContainerClasses())
                : !c &&
                  u &&
                  (n.addClass(r.containerModifierClass + "multirow"),
                  "column" === p.slidesPerColumnFill &&
                    n.addClass(r.containerModifierClass + "multirow-column"),
                  e.emitContainerClasses());
              var h = p.direction && p.direction !== r.direction,
                v = r.loop && (p.slidesPerView !== r.slidesPerView || h);
              h && a && e.changeDirection(),
                C(e.params, p),
                C(e, {
                  allowTouchMove: e.params.allowTouchMove,
                  allowSlideNext: e.params.allowSlideNext,
                  allowSlidePrev: e.params.allowSlidePrev,
                }),
                (e.currentBreakpoint = o),
                e.emit("_beforeBreakpoint", p),
                v &&
                  a &&
                  (e.loopDestroy(),
                  e.loopCreate(),
                  e.updateSlides(),
                  e.slideTo(t - s + e.loopedSlides, 0, !1)),
                e.emit("breakpoint", p);
            }
          }
        },
        getBreakpoint: function getBreakpoint(e, t, a) {
          if ((void 0 === t && (t = "window"), e && ("container" !== t || a))) {
            var i = !1,
              s = l(),
              r = "window" === t ? s.innerWidth : a.clientWidth,
              n = "window" === t ? s.innerHeight : a.clientHeight,
              o = Object.keys(e).map(function (e) {
                if ("string" == typeof e && 0 === e.indexOf("@")) {
                  var t = parseFloat(e.substr(1));
                  return {
                    value: n * t,
                    point: e,
                  };
                }

                return {
                  value: e,
                  point: e,
                };
              });
            o.sort(function (e, t) {
              return parseInt(e.value, 10) - parseInt(t.value, 10);
            });

            for (var d = 0; d < o.length; d += 1) {
              var p = o[d],
                c = p.point;
              p.value <= r && (i = c);
            }

            return i || "max";
          }
        },
      },
      checkOverflow: {
        checkOverflow: function checkOverflow() {
          var e = this,
            t = e.params,
            a = e.isLocked,
            i =
              e.slides.length > 0 &&
              t.slidesOffsetBefore +
                t.spaceBetween * (e.slides.length - 1) +
                e.slides[0].offsetWidth * e.slides.length;
          t.slidesOffsetBefore && t.slidesOffsetAfter && i
            ? (e.isLocked = i <= e.size)
            : (e.isLocked = 1 === e.snapGrid.length),
            (e.allowSlideNext = !e.isLocked),
            (e.allowSlidePrev = !e.isLocked),
            a !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock"),
            a &&
              a !== e.isLocked &&
              ((e.isEnd = !1), e.navigation && e.navigation.update());
        },
      },
      classes: {
        addClasses: function addClasses() {
          var e,
            t,
            a,
            i = this,
            s = i.classNames,
            r = i.params,
            n = i.rtl,
            l = i.$el,
            o = i.device,
            d = i.support,
            p =
              ((e = [
                "initialized",
                r.direction,
                {
                  "pointer-events": d.pointerEvents && !d.touch,
                },
                {
                  "free-mode": r.freeMode,
                },
                {
                  autoheight: r.autoHeight,
                },
                {
                  rtl: n,
                },
                {
                  multirow: r.slidesPerColumn > 1,
                },
                {
                  "multirow-column":
                    r.slidesPerColumn > 1 && "column" === r.slidesPerColumnFill,
                },
                {
                  android: o.android,
                },
                {
                  ios: o.ios,
                },
                {
                  "css-mode": r.cssMode,
                },
              ]),
              (t = r.containerModifierClass),
              (a = []),
              e.forEach(function (e) {
                "object" == _typeof(e)
                  ? Object.keys(e).forEach(function (i) {
                      e[i] && a.push(t + i);
                    })
                  : "string" == typeof e && a.push(t + e);
              }),
              a);
          s.push.apply(s, p),
            l.addClass([].concat(s).join(" ")),
            i.emitContainerClasses();
        },
        removeClasses: function removeClasses() {
          var e = this,
            t = e.$el,
            a = e.classNames;
          t.removeClass(a.join(" ")), e.emitContainerClasses();
        },
      },
      images: {
        loadImage: function loadImage(e, t, a, i, s, r) {
          var n,
            o = l();

          function d() {
            r && r();
          }

          m(e).parent("picture")[0] || (e.complete && s)
            ? d()
            : t
            ? (((n = new o.Image()).onload = d),
              (n.onerror = d),
              i && (n.sizes = i),
              a && (n.srcset = a),
              t && (n.src = t))
            : d();
        },
        preloadImages: function preloadImages() {
          var e = this;

          function t() {
            null != e &&
              e &&
              !e.destroyed &&
              (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1),
              e.imagesLoaded === e.imagesToLoad.length &&
                (e.params.updateOnImagesReady && e.update(),
                e.emit("imagesReady")));
          }

          e.imagesToLoad = e.$el.find("img");

          for (var a = 0; a < e.imagesToLoad.length; a += 1) {
            var i = e.imagesToLoad[a];
            e.loadImage(
              i,
              i.currentSrc || i.getAttribute("src"),
              i.srcset || i.getAttribute("srcset"),
              i.sizes || i.getAttribute("sizes"),
              !0,
              t
            );
          }
        },
      },
    },
    V = {},
    W = (function () {
      function t() {
        for (
          var e, a, i = arguments.length, s = new Array(i), r = 0;
          r < i;
          r++
        ) {
          s[r] = arguments[r];
        }

        if (
          (1 === s.length &&
          s[0].constructor &&
          "Object" === Object.prototype.toString.call(s[0]).slice(8, -1)
            ? (a = s[0])
            : ((e = s[0]), (a = s[1])),
          a || (a = {}),
          (a = C({}, a)),
          e && !a.el && (a.el = e),
          a.el && m(a.el).length > 1)
        ) {
          var n = [];
          return (
            m(a.el).each(function (e) {
              var i = C({}, a, {
                el: e,
              });
              n.push(new t(i));
            }),
            n
          );
        }

        var l = this;
        (l.__swiper__ = !0),
          (l.support = z()),
          (l.device = P({
            userAgent: a.userAgent,
          })),
          (l.browser = k()),
          (l.eventsListeners = {}),
          (l.eventsAnyListeners = []),
          void 0 === l.modules && (l.modules = {}),
          Object.keys(l.modules).forEach(function (e) {
            var t = l.modules[e];

            if (t.params) {
              var i = Object.keys(t.params)[0],
                s = t.params[i];
              if ("object" != _typeof(s) || null === s) return;
              if (!(i in a) || !("enabled" in s)) return;
              !0 === a[i] &&
                (a[i] = {
                  enabled: !0,
                }),
                "object" != _typeof(a[i]) ||
                  "enabled" in a[i] ||
                  (a[i].enabled = !0),
                a[i] ||
                  (a[i] = {
                    enabled: !1,
                  });
            }
          });
        var o,
          d,
          p = C({}, Y);
        return (
          l.useParams(p),
          (l.params = C({}, p, V, a)),
          (l.originalParams = C({}, l.params)),
          (l.passedParams = C({}, a)),
          l.params &&
            l.params.on &&
            Object.keys(l.params.on).forEach(function (e) {
              l.on(e, l.params.on[e]);
            }),
          l.params && l.params.onAny && l.onAny(l.params.onAny),
          (l.$ = m),
          C(l, {
            el: e,
            classNames: [],
            slides: m(),
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            isHorizontal: function isHorizontal() {
              return "horizontal" === l.params.direction;
            },
            isVertical: function isVertical() {
              return "vertical" === l.params.direction;
            },
            activeIndex: 0,
            realIndex: 0,
            isBeginning: !0,
            isEnd: !1,
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: !1,
            allowSlideNext: l.params.allowSlideNext,
            allowSlidePrev: l.params.allowSlidePrev,
            touchEvents:
              ((o = ["touchstart", "touchmove", "touchend", "touchcancel"]),
              (d = ["mousedown", "mousemove", "mouseup"]),
              l.support.pointerEvents &&
                (d = ["pointerdown", "pointermove", "pointerup"]),
              (l.touchEventsTouch = {
                start: o[0],
                move: o[1],
                end: o[2],
                cancel: o[3],
              }),
              (l.touchEventsDesktop = {
                start: d[0],
                move: d[1],
                end: d[2],
              }),
              l.support.touch || !l.params.simulateTouch
                ? l.touchEventsTouch
                : l.touchEventsDesktop),
            touchEventsData: {
              isTouched: void 0,
              isMoved: void 0,
              allowTouchCallbacks: void 0,
              touchStartTime: void 0,
              isScrolling: void 0,
              currentTranslate: void 0,
              startTranslate: void 0,
              allowThresholdMove: void 0,
              formElements:
                "input, select, option, textarea, button, video, label",
              lastClickTime: x(),
              clickTimeout: void 0,
              velocities: [],
              allowMomentumBounce: void 0,
              isTouchEvent: void 0,
              startMoving: void 0,
            },
            allowClick: !0,
            allowTouchMove: l.params.allowTouchMove,
            touches: {
              startX: 0,
              startY: 0,
              currentX: 0,
              currentY: 0,
              diff: 0,
            },
            imagesToLoad: [],
            imagesLoaded: 0,
          }),
          l.useModules(),
          l.emit("_swiper"),
          l.params.init && l.init(),
          l
        );
      }

      var a,
        i,
        s,
        r = t.prototype;
      return (
        (r.emitContainerClasses = function () {
          var e = this;

          if (e.params._emitClasses && e.el) {
            var t = e.el.className.split(" ").filter(function (t) {
              return (
                0 === t.indexOf("swiper-container") ||
                0 === t.indexOf(e.params.containerModifierClass)
              );
            });
            e.emit("_containerClasses", t.join(" "));
          }
        }),
        (r.getSlideClasses = function (e) {
          var t = this;
          return e.className
            .split(" ")
            .filter(function (e) {
              return (
                0 === e.indexOf("swiper-slide") ||
                0 === e.indexOf(t.params.slideClass)
              );
            })
            .join(" ");
        }),
        (r.emitSlidesClasses = function () {
          var e = this;

          if (e.params._emitClasses && e.el) {
            var t = [];
            e.slides.each(function (a) {
              var i = e.getSlideClasses(a);
              t.push({
                slideEl: a,
                classNames: i,
              }),
                e.emit("_slideClass", a, i);
            }),
              e.emit("_slideClasses", t);
          }
        }),
        (r.slidesPerViewDynamic = function () {
          var e = this,
            t = e.params,
            a = e.slides,
            i = e.slidesGrid,
            s = e.size,
            r = e.activeIndex,
            n = 1;

          if (t.centeredSlides) {
            for (
              var l, o = a[r].swiperSlideSize, d = r + 1;
              d < a.length;
              d += 1
            ) {
              a[d] &&
                !l &&
                ((n += 1), (o += a[d].swiperSlideSize) > s && (l = !0));
            }

            for (var p = r - 1; p >= 0; p -= 1) {
              a[p] &&
                !l &&
                ((n += 1), (o += a[p].swiperSlideSize) > s && (l = !0));
            }
          } else
            for (var c = r + 1; c < a.length; c += 1) {
              i[c] - i[r] < s && (n += 1);
            }

          return n;
        }),
        (r.update = function () {
          var e = this;

          if (e && !e.destroyed) {
            var t = e.snapGrid,
              a = e.params;
            a.breakpoints && e.setBreakpoint(),
              e.updateSize(),
              e.updateSlides(),
              e.updateProgress(),
              e.updateSlidesClasses(),
              e.params.freeMode
                ? (i(), e.params.autoHeight && e.updateAutoHeight())
                : (("auto" === e.params.slidesPerView ||
                    e.params.slidesPerView > 1) &&
                  e.isEnd &&
                  !e.params.centeredSlides
                    ? e.slideTo(e.slides.length - 1, 0, !1, !0)
                    : e.slideTo(e.activeIndex, 0, !1, !0)) || i(),
              a.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
              e.emit("update");
          }

          function i() {
            var t = e.rtlTranslate ? -1 * e.translate : e.translate,
              a = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
            e.setTranslate(a), e.updateActiveIndex(), e.updateSlidesClasses();
          }
        }),
        (r.changeDirection = function (e, t) {
          void 0 === t && (t = !0);
          var a = this,
            i = a.params.direction;
          return (
            e || (e = "horizontal" === i ? "vertical" : "horizontal"),
            e === i ||
              ("horizontal" !== e && "vertical" !== e) ||
              (a.$el
                .removeClass("" + a.params.containerModifierClass + i)
                .addClass("" + a.params.containerModifierClass + e),
              a.emitContainerClasses(),
              (a.params.direction = e),
              a.slides.each(function (t) {
                "vertical" === e ? (t.style.width = "") : (t.style.height = "");
              }),
              a.emit("changeDirection"),
              t && a.update()),
            a
          );
        }),
        (r.mount = function (e) {
          var t = this;
          if (t.mounted) return !0;
          var a,
            i = m(e || t.params.el);
          return (
            !!(e = i[0]) &&
            ((e.swiper = t),
            e && e.shadowRoot && e.shadowRoot.querySelector
              ? ((a = m(
                  e.shadowRoot.querySelector("." + t.params.wrapperClass)
                )).children = function (e) {
                  return i.children(e);
                })
              : (a = i.children("." + t.params.wrapperClass)),
            C(t, {
              $el: i,
              el: e,
              $wrapperEl: a,
              wrapperEl: a[0],
              mounted: !0,
              rtl:
                "rtl" === e.dir.toLowerCase() || "rtl" === i.css("direction"),
              rtlTranslate:
                "horizontal" === t.params.direction &&
                ("rtl" === e.dir.toLowerCase() || "rtl" === i.css("direction")),
              wrongRTL: "-webkit-box" === a.css("display"),
            }),
            !0)
          );
        }),
        (r.init = function (e) {
          var t = this;
          return (
            t.initialized ||
              !1 === t.mount(e) ||
              (t.emit("beforeInit"),
              t.params.breakpoints && t.setBreakpoint(),
              t.addClasses(),
              t.params.loop && t.loopCreate(),
              t.updateSize(),
              t.updateSlides(),
              t.params.watchOverflow && t.checkOverflow(),
              t.params.grabCursor && t.setGrabCursor(),
              t.params.preloadImages && t.preloadImages(),
              t.params.loop
                ? t.slideTo(
                    t.params.initialSlide + t.loopedSlides,
                    0,
                    t.params.runCallbacksOnInit
                  )
                : t.slideTo(
                    t.params.initialSlide,
                    0,
                    t.params.runCallbacksOnInit
                  ),
              t.attachEvents(),
              (t.initialized = !0),
              t.emit("init"),
              t.emit("afterInit")),
            t
          );
        }),
        (r.destroy = function (e, t) {
          void 0 === e && (e = !0), void 0 === t && (t = !0);
          var a,
            i = this,
            s = i.params,
            r = i.$el,
            n = i.$wrapperEl,
            l = i.slides;
          return (
            void 0 === i.params ||
              i.destroyed ||
              (i.emit("beforeDestroy"),
              (i.initialized = !1),
              i.detachEvents(),
              s.loop && i.loopDestroy(),
              t &&
                (i.removeClasses(),
                r.removeAttr("style"),
                n.removeAttr("style"),
                l &&
                  l.length &&
                  l
                    .removeClass(
                      [
                        s.slideVisibleClass,
                        s.slideActiveClass,
                        s.slideNextClass,
                        s.slidePrevClass,
                      ].join(" ")
                    )
                    .removeAttr("style")
                    .removeAttr("data-swiper-slide-index")),
              i.emit("destroy"),
              Object.keys(i.eventsListeners).forEach(function (e) {
                i.off(e);
              }),
              !1 !== e &&
                ((i.$el[0].swiper = null),
                (a = i),
                Object.keys(a).forEach(function (e) {
                  try {
                    a[e] = null;
                  } catch (e) {}

                  try {
                    delete a[e];
                  } catch (e) {}
                })),
              (i.destroyed = !0)),
            null
          );
        }),
        (t.extendDefaults = function (e) {
          C(V, e);
        }),
        (t.installModule = function (e) {
          t.prototype.modules || (t.prototype.modules = {});
          var a = e.name || Object.keys(t.prototype.modules).length + "_" + x();
          t.prototype.modules[a] = e;
        }),
        (t.use = function (e) {
          return Array.isArray(e)
            ? (e.forEach(function (e) {
                return t.installModule(e);
              }),
              t)
            : (t.installModule(e), t);
        }),
        (a = t),
        (s = [
          {
            key: "extendedDefaults",
            get: function get() {
              return V;
            },
          },
          {
            key: "defaults",
            get: function get() {
              return Y;
            },
          },
        ]),
        (i = null) && e(a.prototype, i),
        s && e(a, s),
        t
      );
    })();

  Object.keys(R).forEach(function (e) {
    Object.keys(R[e]).forEach(function (t) {
      W.prototype[t] = R[e][t];
    });
  }),
    W.use([L, I]);
  var F = {
      update: function update(e) {
        var t = this,
          a = t.params,
          i = a.slidesPerView,
          s = a.slidesPerGroup,
          r = a.centeredSlides,
          n = t.params.virtual,
          l = n.addSlidesBefore,
          o = n.addSlidesAfter,
          d = t.virtual,
          p = d.from,
          c = d.to,
          u = d.slides,
          h = d.slidesGrid,
          v = d.renderSlide,
          f = d.offset;
        t.updateActiveIndex();
        var m,
          g,
          b,
          w = t.activeIndex || 0;
        (m = t.rtlTranslate ? "right" : t.isHorizontal() ? "left" : "top"),
          r
            ? ((g = Math.floor(i / 2) + s + o), (b = Math.floor(i / 2) + s + l))
            : ((g = i + (s - 1) + o), (b = s + l));
        var y = Math.max((w || 0) - b, 0),
          E = Math.min((w || 0) + g, u.length - 1),
          x = (t.slidesGrid[y] || 0) - (t.slidesGrid[0] || 0);

        function T() {
          t.updateSlides(),
            t.updateProgress(),
            t.updateSlidesClasses(),
            t.lazy && t.params.lazy.enabled && t.lazy.load();
        }

        if (
          (C(t.virtual, {
            from: y,
            to: E,
            offset: x,
            slidesGrid: t.slidesGrid,
          }),
          p === y && c === E && !e)
        )
          return (
            t.slidesGrid !== h && x !== f && t.slides.css(m, x + "px"),
            void t.updateProgress()
          );
        if (t.params.virtual.renderExternal)
          return (
            t.params.virtual.renderExternal.call(t, {
              offset: x,
              from: y,
              to: E,
              slides: (function () {
                for (var e = [], t = y; t <= E; t += 1) {
                  e.push(u[t]);
                }

                return e;
              })(),
            }),
            void (t.params.virtual.renderExternalUpdate && T())
          );
        var S = [],
          M = [];
        if (e) t.$wrapperEl.find("." + t.params.slideClass).remove();
        else
          for (var z = p; z <= c; z += 1) {
            (z < y || z > E) &&
              t.$wrapperEl
                .find(
                  "." +
                    t.params.slideClass +
                    '[data-swiper-slide-index="' +
                    z +
                    '"]'
                )
                .remove();
          }

        for (var P = 0; P < u.length; P += 1) {
          P >= y &&
            P <= E &&
            (void 0 === c || e
              ? M.push(P)
              : (P > c && M.push(P), P < p && S.push(P)));
        }

        M.forEach(function (e) {
          t.$wrapperEl.append(v(u[e], e));
        }),
          S.sort(function (e, t) {
            return t - e;
          }).forEach(function (e) {
            t.$wrapperEl.prepend(v(u[e], e));
          }),
          t.$wrapperEl.children(".swiper-slide").css(m, x + "px"),
          T();
      },
      renderSlide: function renderSlide(e, t) {
        var a = this,
          i = a.params.virtual;
        if (i.cache && a.virtual.cache[t]) return a.virtual.cache[t];
        var s = i.renderSlide
          ? m(i.renderSlide.call(a, e, t))
          : m(
              '<div class="' +
                a.params.slideClass +
                '" data-swiper-slide-index="' +
                t +
                '">' +
                e +
                "</div>"
            );
        return (
          s.attr("data-swiper-slide-index") ||
            s.attr("data-swiper-slide-index", t),
          i.cache && (a.virtual.cache[t] = s),
          s
        );
      },
      appendSlide: function appendSlide(e) {
        var t = this;
        if ("object" == _typeof(e) && "length" in e)
          for (var a = 0; a < e.length; a += 1) {
            e[a] && t.virtual.slides.push(e[a]);
          }
        else t.virtual.slides.push(e);
        t.virtual.update(!0);
      },
      prependSlide: function prependSlide(e) {
        var t = this,
          a = t.activeIndex,
          i = a + 1,
          s = 1;

        if (Array.isArray(e)) {
          for (var r = 0; r < e.length; r += 1) {
            e[r] && t.virtual.slides.unshift(e[r]);
          }

          (i = a + e.length), (s = e.length);
        } else t.virtual.slides.unshift(e);

        if (t.params.virtual.cache) {
          var n = t.virtual.cache,
            l = {};
          Object.keys(n).forEach(function (e) {
            var t = n[e],
              a = t.attr("data-swiper-slide-index");
            a && t.attr("data-swiper-slide-index", parseInt(a, 10) + 1),
              (l[parseInt(e, 10) + s] = t);
          }),
            (t.virtual.cache = l);
        }

        t.virtual.update(!0), t.slideTo(i, 0);
      },
      removeSlide: function removeSlide(e) {
        var t = this;

        if (null != e) {
          var a = t.activeIndex;
          if (Array.isArray(e))
            for (var i = e.length - 1; i >= 0; i -= 1) {
              t.virtual.slides.splice(e[i], 1),
                t.params.virtual.cache && delete t.virtual.cache[e[i]],
                e[i] < a && (a -= 1),
                (a = Math.max(a, 0));
            }
          else
            t.virtual.slides.splice(e, 1),
              t.params.virtual.cache && delete t.virtual.cache[e],
              e < a && (a -= 1),
              (a = Math.max(a, 0));
          t.virtual.update(!0), t.slideTo(a, 0);
        }
      },
      removeAllSlides: function removeAllSlides() {
        var e = this;
        (e.virtual.slides = []),
          e.params.virtual.cache && (e.virtual.cache = {}),
          e.virtual.update(!0),
          e.slideTo(0, 0);
      },
    },
    _ = {
      name: "virtual",
      params: {
        virtual: {
          enabled: !1,
          slides: [],
          cache: !0,
          renderSlide: null,
          renderExternal: null,
          renderExternalUpdate: !0,
          addSlidesBefore: 0,
          addSlidesAfter: 0,
        },
      },
      create: function create() {
        M(this, {
          virtual: t({}, F, {
            slides: this.params.virtual.slides,
            cache: {},
          }),
        });
      },
      on: {
        beforeInit: function beforeInit(e) {
          if (e.params.virtual.enabled) {
            e.classNames.push(e.params.containerModifierClass + "virtual");
            var t = {
              watchSlidesProgress: !0,
            };
            C(e.params, t),
              C(e.originalParams, t),
              e.params.initialSlide || e.virtual.update();
          }
        },
        setTranslate: function setTranslate(e) {
          e.params.virtual.enabled && e.virtual.update();
        },
      },
    },
    q = {
      handle: function handle(e) {
        var t = this,
          a = l(),
          i = r(),
          s = t.rtlTranslate,
          n = e;
        n.originalEvent && (n = n.originalEvent);
        var o = n.keyCode || n.charCode,
          d = t.params.keyboard.pageUpDown,
          p = d && 33 === o,
          c = d && 34 === o,
          u = 37 === o,
          h = 39 === o,
          v = 38 === o,
          f = 40 === o;
        if (
          !t.allowSlideNext &&
          ((t.isHorizontal() && h) || (t.isVertical() && f) || c)
        )
          return !1;
        if (
          !t.allowSlidePrev &&
          ((t.isHorizontal() && u) || (t.isVertical() && v) || p)
        )
          return !1;

        if (
          !(
            n.shiftKey ||
            n.altKey ||
            n.ctrlKey ||
            n.metaKey ||
            (i.activeElement &&
              i.activeElement.nodeName &&
              ("input" === i.activeElement.nodeName.toLowerCase() ||
                "textarea" === i.activeElement.nodeName.toLowerCase()))
          )
        ) {
          if (
            t.params.keyboard.onlyInViewport &&
            (p || c || u || h || v || f)
          ) {
            var m = !1;
            if (
              t.$el.parents("." + t.params.slideClass).length > 0 &&
              0 === t.$el.parents("." + t.params.slideActiveClass).length
            )
              return;
            var g = t.$el,
              b = g[0].clientWidth,
              w = g[0].clientHeight,
              y = a.innerWidth,
              E = a.innerHeight,
              x = t.$el.offset();
            s && (x.left -= t.$el[0].scrollLeft);

            for (
              var T = [
                  [x.left, x.top],
                  [x.left + b, x.top],
                  [x.left, x.top + w],
                  [x.left + b, x.top + w],
                ],
                S = 0;
              S < T.length;
              S += 1
            ) {
              var C = T[S];

              if (C[0] >= 0 && C[0] <= y && C[1] >= 0 && C[1] <= E) {
                if (0 === C[0] && 0 === C[1]) continue;
                m = !0;
              }
            }

            if (!m) return;
          }

          t.isHorizontal()
            ? ((p || c || u || h) &&
                (n.preventDefault ? n.preventDefault() : (n.returnValue = !1)),
              (((c || h) && !s) || ((p || u) && s)) && t.slideNext(),
              (((p || u) && !s) || ((c || h) && s)) && t.slidePrev())
            : ((p || c || v || f) &&
                (n.preventDefault ? n.preventDefault() : (n.returnValue = !1)),
              (c || f) && t.slideNext(),
              (p || v) && t.slidePrev()),
            t.emit("keyPress", o);
        }
      },
      enable: function enable() {
        var e = this,
          t = r();
        e.keyboard.enabled ||
          (m(t).on("keydown", e.keyboard.handle), (e.keyboard.enabled = !0));
      },
      disable: function disable() {
        var e = this,
          t = r();
        e.keyboard.enabled &&
          (m(t).off("keydown", e.keyboard.handle), (e.keyboard.enabled = !1));
      },
    },
    j = {
      name: "keyboard",
      params: {
        keyboard: {
          enabled: !1,
          onlyInViewport: !0,
          pageUpDown: !0,
        },
      },
      create: function create() {
        M(this, {
          keyboard: t(
            {
              enabled: !1,
            },
            q
          ),
        });
      },
      on: {
        init: function init(e) {
          e.params.keyboard.enabled && e.keyboard.enable();
        },
        destroy: function destroy(e) {
          e.keyboard.enabled && e.keyboard.disable();
        },
      },
    };
  var U = {
      lastScrollTime: x(),
      lastEventBeforeSnap: void 0,
      recentWheelEvents: [],
      event: function event() {
        return l().navigator.userAgent.indexOf("firefox") > -1
          ? "DOMMouseScroll"
          : (function () {
              var e = r(),
                t = "onwheel",
                a = t in e;

              if (!a) {
                var i = e.createElement("div");
                i.setAttribute(t, "return;"),
                  (a = "function" == typeof i.onwheel);
              }

              return (
                !a &&
                  e.implementation &&
                  e.implementation.hasFeature &&
                  !0 !== e.implementation.hasFeature("", "") &&
                  (a = e.implementation.hasFeature("Events.wheel", "3.0")),
                a
              );
            })()
          ? "wheel"
          : "mousewheel";
      },
      normalize: function normalize(e) {
        var t = 0,
          a = 0,
          i = 0,
          s = 0;
        return (
          "detail" in e && (a = e.detail),
          "wheelDelta" in e && (a = -e.wheelDelta / 120),
          "wheelDeltaY" in e && (a = -e.wheelDeltaY / 120),
          "wheelDeltaX" in e && (t = -e.wheelDeltaX / 120),
          "axis" in e && e.axis === e.HORIZONTAL_AXIS && ((t = a), (a = 0)),
          (i = 10 * t),
          (s = 10 * a),
          "deltaY" in e && (s = e.deltaY),
          "deltaX" in e && (i = e.deltaX),
          e.shiftKey && !i && ((i = s), (s = 0)),
          (i || s) &&
            e.deltaMode &&
            (1 === e.deltaMode
              ? ((i *= 40), (s *= 40))
              : ((i *= 800), (s *= 800))),
          i && !t && (t = i < 1 ? -1 : 1),
          s && !a && (a = s < 1 ? -1 : 1),
          {
            spinX: t,
            spinY: a,
            pixelX: i,
            pixelY: s,
          }
        );
      },
      handleMouseEnter: function handleMouseEnter() {
        this.mouseEntered = !0;
      },
      handleMouseLeave: function handleMouseLeave() {
        this.mouseEntered = !1;
      },
      handle: function handle(e) {
        var t = e,
          a = this,
          i = a.params.mousewheel;
        a.params.cssMode && t.preventDefault();
        var s = a.$el;
        if (
          ("container" !== a.params.mousewheel.eventsTarget &&
            (s = m(a.params.mousewheel.eventsTarget)),
          !a.mouseEntered && !s[0].contains(t.target) && !i.releaseOnEdges)
        )
          return !0;
        t.originalEvent && (t = t.originalEvent);
        var r = 0,
          n = a.rtlTranslate ? -1 : 1,
          l = U.normalize(t);
        if (i.forceToAxis) {
          if (a.isHorizontal()) {
            if (!(Math.abs(l.pixelX) > Math.abs(l.pixelY))) return !0;
            r = -l.pixelX * n;
          } else {
            if (!(Math.abs(l.pixelY) > Math.abs(l.pixelX))) return !0;
            r = -l.pixelY;
          }
        } else
          r =
            Math.abs(l.pixelX) > Math.abs(l.pixelY) ? -l.pixelX * n : -l.pixelY;
        if (0 === r) return !0;
        i.invert && (r = -r);
        var o = a.getTranslate() + r * i.sensitivity;

        if (
          (o >= a.minTranslate() && (o = a.minTranslate()),
          o <= a.maxTranslate() && (o = a.maxTranslate()),
          (!!a.params.loop ||
            !(o === a.minTranslate() || o === a.maxTranslate())) &&
            a.params.nested &&
            t.stopPropagation(),
          a.params.freeMode)
        ) {
          var d = {
              time: x(),
              delta: Math.abs(r),
              direction: Math.sign(r),
            },
            p = a.mousewheel.lastEventBeforeSnap,
            c =
              p &&
              d.time < p.time + 500 &&
              d.delta <= p.delta &&
              d.direction === p.direction;

          if (!c) {
            (a.mousewheel.lastEventBeforeSnap = void 0),
              a.params.loop && a.loopFix();
            var u = a.getTranslate() + r * i.sensitivity,
              h = a.isBeginning,
              v = a.isEnd;

            if (
              (u >= a.minTranslate() && (u = a.minTranslate()),
              u <= a.maxTranslate() && (u = a.maxTranslate()),
              a.setTransition(0),
              a.setTranslate(u),
              a.updateProgress(),
              a.updateActiveIndex(),
              a.updateSlidesClasses(),
              ((!h && a.isBeginning) || (!v && a.isEnd)) &&
                a.updateSlidesClasses(),
              a.params.freeModeSticky)
            ) {
              clearTimeout(a.mousewheel.timeout),
                (a.mousewheel.timeout = void 0);
              var f = a.mousewheel.recentWheelEvents;
              f.length >= 15 && f.shift();
              var g = f.length ? f[f.length - 1] : void 0,
                b = f[0];
              if (
                (f.push(d),
                g && (d.delta > g.delta || d.direction !== g.direction))
              )
                f.splice(0);
              else if (
                f.length >= 15 &&
                d.time - b.time < 500 &&
                b.delta - d.delta >= 1 &&
                d.delta <= 6
              ) {
                var w = r > 0 ? 0.8 : 0.2;
                (a.mousewheel.lastEventBeforeSnap = d),
                  f.splice(0),
                  (a.mousewheel.timeout = E(function () {
                    a.slideToClosest(a.params.speed, !0, void 0, w);
                  }, 0));
              }
              a.mousewheel.timeout ||
                (a.mousewheel.timeout = E(function () {
                  (a.mousewheel.lastEventBeforeSnap = d),
                    f.splice(0),
                    a.slideToClosest(a.params.speed, !0, void 0, 0.5);
                }, 500));
            }

            if (
              (c || a.emit("scroll", t),
              a.params.autoplay &&
                a.params.autoplayDisableOnInteraction &&
                a.autoplay.stop(),
              u === a.minTranslate() || u === a.maxTranslate())
            )
              return !0;
          }
        } else {
          var y = {
              time: x(),
              delta: Math.abs(r),
              direction: Math.sign(r),
              raw: e,
            },
            T = a.mousewheel.recentWheelEvents;
          T.length >= 2 && T.shift();
          var S = T.length ? T[T.length - 1] : void 0;
          if (
            (T.push(y),
            S
              ? (y.direction !== S.direction ||
                  y.delta > S.delta ||
                  y.time > S.time + 150) &&
                a.mousewheel.animateSlider(y)
              : a.mousewheel.animateSlider(y),
            a.mousewheel.releaseScroll(y))
          )
            return !0;
        }

        return t.preventDefault ? t.preventDefault() : (t.returnValue = !1), !1;
      },
      animateSlider: function animateSlider(e) {
        var t = this,
          a = l();
        return (
          !(
            this.params.mousewheel.thresholdDelta &&
            e.delta < this.params.mousewheel.thresholdDelta
          ) &&
          !(
            this.params.mousewheel.thresholdTime &&
            x() - t.mousewheel.lastScrollTime <
              this.params.mousewheel.thresholdTime
          ) &&
          ((e.delta >= 6 && x() - t.mousewheel.lastScrollTime < 60) ||
            (e.direction < 0
              ? (t.isEnd && !t.params.loop) ||
                t.animating ||
                (t.slideNext(), t.emit("scroll", e.raw))
              : (t.isBeginning && !t.params.loop) ||
                t.animating ||
                (t.slidePrev(), t.emit("scroll", e.raw)),
            (t.mousewheel.lastScrollTime = new a.Date().getTime()),
            !1))
        );
      },
      releaseScroll: function releaseScroll(e) {
        var t = this,
          a = t.params.mousewheel;

        if (e.direction < 0) {
          if (t.isEnd && !t.params.loop && a.releaseOnEdges) return !0;
        } else if (t.isBeginning && !t.params.loop && a.releaseOnEdges)
          return !0;

        return !1;
      },
      enable: function enable() {
        var e = this,
          t = U.event();
        if (e.params.cssMode)
          return e.wrapperEl.removeEventListener(t, e.mousewheel.handle), !0;
        if (!t) return !1;
        if (e.mousewheel.enabled) return !1;
        var a = e.$el;
        return (
          "container" !== e.params.mousewheel.eventsTarget &&
            (a = m(e.params.mousewheel.eventsTarget)),
          a.on("mouseenter", e.mousewheel.handleMouseEnter),
          a.on("mouseleave", e.mousewheel.handleMouseLeave),
          a.on(t, e.mousewheel.handle),
          (e.mousewheel.enabled = !0),
          !0
        );
      },
      disable: function disable() {
        var e = this,
          t = U.event();
        if (e.params.cssMode)
          return e.wrapperEl.addEventListener(t, e.mousewheel.handle), !0;
        if (!t) return !1;
        if (!e.mousewheel.enabled) return !1;
        var a = e.$el;
        return (
          "container" !== e.params.mousewheel.eventsTarget &&
            (a = m(e.params.mousewheel.eventsTarget)),
          a.off(t, e.mousewheel.handle),
          (e.mousewheel.enabled = !1),
          !0
        );
      },
    },
    K = {
      toggleEl: function toggleEl(e, t) {
        e[t ? "addClass" : "removeClass"](this.params.navigation.disabledClass),
          e[0] && "BUTTON" === e[0].tagName && (e[0].disabled = t);
      },
      update: function update() {
        var e = this,
          t = e.params.navigation,
          a = e.navigation.toggleEl;

        if (!e.params.loop) {
          var i = e.navigation,
            s = i.$nextEl,
            r = i.$prevEl;
          r &&
            r.length > 0 &&
            (e.isBeginning ? a(r, !0) : a(r, !1),
            r[
              e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"
            ](t.lockClass)),
            s &&
              s.length > 0 &&
              (e.isEnd ? a(s, !0) : a(s, !1),
              s[
                e.params.watchOverflow && e.isLocked
                  ? "addClass"
                  : "removeClass"
              ](t.lockClass));
        }
      },
      onPrevClick: function onPrevClick(e) {
        var t = this;
        e.preventDefault(), (t.isBeginning && !t.params.loop) || t.slidePrev();
      },
      onNextClick: function onNextClick(e) {
        var t = this;
        e.preventDefault(), (t.isEnd && !t.params.loop) || t.slideNext();
      },
      init: function init() {
        var e,
          t,
          a = this,
          i = a.params.navigation;
        (i.nextEl || i.prevEl) &&
          (i.nextEl &&
            ((e = m(i.nextEl)),
            a.params.uniqueNavElements &&
              "string" == typeof i.nextEl &&
              e.length > 1 &&
              1 === a.$el.find(i.nextEl).length &&
              (e = a.$el.find(i.nextEl))),
          i.prevEl &&
            ((t = m(i.prevEl)),
            a.params.uniqueNavElements &&
              "string" == typeof i.prevEl &&
              t.length > 1 &&
              1 === a.$el.find(i.prevEl).length &&
              (t = a.$el.find(i.prevEl))),
          e && e.length > 0 && e.on("click", a.navigation.onNextClick),
          t && t.length > 0 && t.on("click", a.navigation.onPrevClick),
          C(a.navigation, {
            $nextEl: e,
            nextEl: e && e[0],
            $prevEl: t,
            prevEl: t && t[0],
          }));
      },
      destroy: function destroy() {
        var e = this,
          t = e.navigation,
          a = t.$nextEl,
          i = t.$prevEl;
        a &&
          a.length &&
          (a.off("click", e.navigation.onNextClick),
          a.removeClass(e.params.navigation.disabledClass)),
          i &&
            i.length &&
            (i.off("click", e.navigation.onPrevClick),
            i.removeClass(e.params.navigation.disabledClass));
      },
    },
    Z = {
      update: function update() {
        var e = this,
          t = e.rtl,
          a = e.params.pagination;

        if (
          a.el &&
          e.pagination.el &&
          e.pagination.$el &&
          0 !== e.pagination.$el.length
        ) {
          var i,
            s =
              e.virtual && e.params.virtual.enabled
                ? e.virtual.slides.length
                : e.slides.length,
            r = e.pagination.$el,
            n = e.params.loop
              ? Math.ceil((s - 2 * e.loopedSlides) / e.params.slidesPerGroup)
              : e.snapGrid.length;

          if (
            (e.params.loop
              ? ((i = Math.ceil(
                  (e.activeIndex - e.loopedSlides) / e.params.slidesPerGroup
                )) >
                  s - 1 - 2 * e.loopedSlides && (i -= s - 2 * e.loopedSlides),
                i > n - 1 && (i -= n),
                i < 0 && "bullets" !== e.params.paginationType && (i = n + i))
              : (i = void 0 !== e.snapIndex ? e.snapIndex : e.activeIndex || 0),
            "bullets" === a.type &&
              e.pagination.bullets &&
              e.pagination.bullets.length > 0)
          ) {
            var l,
              o,
              d,
              p = e.pagination.bullets;
            if (
              (a.dynamicBullets &&
                ((e.pagination.bulletSize = p
                  .eq(0)
                  [e.isHorizontal() ? "outerWidth" : "outerHeight"](!0)),
                r.css(
                  e.isHorizontal() ? "width" : "height",
                  e.pagination.bulletSize * (a.dynamicMainBullets + 4) + "px"
                ),
                a.dynamicMainBullets > 1 &&
                  void 0 !== e.previousIndex &&
                  ((e.pagination.dynamicBulletIndex += i - e.previousIndex),
                  e.pagination.dynamicBulletIndex > a.dynamicMainBullets - 1
                    ? (e.pagination.dynamicBulletIndex =
                        a.dynamicMainBullets - 1)
                    : e.pagination.dynamicBulletIndex < 0 &&
                      (e.pagination.dynamicBulletIndex = 0)),
                (l = i - e.pagination.dynamicBulletIndex),
                (d =
                  ((o = l + (Math.min(p.length, a.dynamicMainBullets) - 1)) +
                    l) /
                  2)),
              p.removeClass(
                a.bulletActiveClass +
                  " " +
                  a.bulletActiveClass +
                  "-next " +
                  a.bulletActiveClass +
                  "-next-next " +
                  a.bulletActiveClass +
                  "-prev " +
                  a.bulletActiveClass +
                  "-prev-prev " +
                  a.bulletActiveClass +
                  "-main"
              ),
              r.length > 1)
            )
              p.each(function (e) {
                var t = m(e),
                  s = t.index();
                s === i && t.addClass(a.bulletActiveClass),
                  a.dynamicBullets &&
                    (s >= l &&
                      s <= o &&
                      t.addClass(a.bulletActiveClass + "-main"),
                    s === l &&
                      t
                        .prev()
                        .addClass(a.bulletActiveClass + "-prev")
                        .prev()
                        .addClass(a.bulletActiveClass + "-prev-prev"),
                    s === o &&
                      t
                        .next()
                        .addClass(a.bulletActiveClass + "-next")
                        .next()
                        .addClass(a.bulletActiveClass + "-next-next"));
              });
            else {
              var c = p.eq(i),
                u = c.index();

              if ((c.addClass(a.bulletActiveClass), a.dynamicBullets)) {
                for (var h = p.eq(l), v = p.eq(o), f = l; f <= o; f += 1) {
                  p.eq(f).addClass(a.bulletActiveClass + "-main");
                }

                if (e.params.loop) {
                  if (u >= p.length - a.dynamicMainBullets) {
                    for (var g = a.dynamicMainBullets; g >= 0; g -= 1) {
                      p.eq(p.length - g).addClass(
                        a.bulletActiveClass + "-main"
                      );
                    }

                    p.eq(p.length - a.dynamicMainBullets - 1).addClass(
                      a.bulletActiveClass + "-prev"
                    );
                  } else
                    h
                      .prev()
                      .addClass(a.bulletActiveClass + "-prev")
                      .prev()
                      .addClass(a.bulletActiveClass + "-prev-prev"),
                      v
                        .next()
                        .addClass(a.bulletActiveClass + "-next")
                        .next()
                        .addClass(a.bulletActiveClass + "-next-next");
                } else
                  h
                    .prev()
                    .addClass(a.bulletActiveClass + "-prev")
                    .prev()
                    .addClass(a.bulletActiveClass + "-prev-prev"),
                    v
                      .next()
                      .addClass(a.bulletActiveClass + "-next")
                      .next()
                      .addClass(a.bulletActiveClass + "-next-next");
              }
            }

            if (a.dynamicBullets) {
              var b = Math.min(p.length, a.dynamicMainBullets + 4),
                w =
                  (e.pagination.bulletSize * b - e.pagination.bulletSize) / 2 -
                  d * e.pagination.bulletSize,
                y = t ? "right" : "left";
              p.css(e.isHorizontal() ? y : "top", w + "px");
            }
          }

          if (
            ("fraction" === a.type &&
              (r
                .find("." + a.currentClass)
                .text(a.formatFractionCurrent(i + 1)),
              r.find("." + a.totalClass).text(a.formatFractionTotal(n))),
            "progressbar" === a.type)
          ) {
            var E;
            E = a.progressbarOpposite
              ? e.isHorizontal()
                ? "vertical"
                : "horizontal"
              : e.isHorizontal()
              ? "horizontal"
              : "vertical";
            var x = (i + 1) / n,
              T = 1,
              S = 1;
            "horizontal" === E ? (T = x) : (S = x),
              r
                .find("." + a.progressbarFillClass)
                .transform(
                  "translate3d(0,0,0) scaleX(" + T + ") scaleY(" + S + ")"
                )
                .transition(e.params.speed);
          }

          "custom" === a.type && a.renderCustom
            ? (r.html(a.renderCustom(e, i + 1, n)),
              e.emit("paginationRender", r[0]))
            : e.emit("paginationUpdate", r[0]),
            r[
              e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"
            ](a.lockClass);
        }
      },
      render: function render() {
        var e = this,
          t = e.params.pagination;

        if (
          t.el &&
          e.pagination.el &&
          e.pagination.$el &&
          0 !== e.pagination.$el.length
        ) {
          var a =
              e.virtual && e.params.virtual.enabled
                ? e.virtual.slides.length
                : e.slides.length,
            i = e.pagination.$el,
            s = "";

          if ("bullets" === t.type) {
            var r = e.params.loop
              ? Math.ceil((a - 2 * e.loopedSlides) / e.params.slidesPerGroup)
              : e.snapGrid.length;
            e.params.freeMode && !e.params.loop && r > a && (r = a);

            for (var n = 0; n < r; n += 1) {
              t.renderBullet
                ? (s += t.renderBullet.call(e, n, t.bulletClass))
                : (s +=
                    "<" +
                    t.bulletElement +
                    ' class="' +
                    t.bulletClass +
                    '"></' +
                    t.bulletElement +
                    ">");
            }

            i.html(s),
              (e.pagination.bullets = i.find(
                "." + t.bulletClass.replace(/ /g, ".")
              ));
          }

          "fraction" === t.type &&
            ((s = t.renderFraction
              ? t.renderFraction.call(e, t.currentClass, t.totalClass)
              : '<span class="' +
                t.currentClass +
                '"></span> / <span class="' +
                t.totalClass +
                '"></span>'),
            i.html(s)),
            "progressbar" === t.type &&
              ((s = t.renderProgressbar
                ? t.renderProgressbar.call(e, t.progressbarFillClass)
                : '<span class="' + t.progressbarFillClass + '"></span>'),
              i.html(s)),
            "custom" !== t.type &&
              e.emit("paginationRender", e.pagination.$el[0]);
        }
      },
      init: function init() {
        var e = this,
          t = e.params.pagination;

        if (t.el) {
          var a = m(t.el);
          0 !== a.length &&
            (e.params.uniqueNavElements &&
              "string" == typeof t.el &&
              a.length > 1 &&
              (a = e.$el.find(t.el)),
            "bullets" === t.type && t.clickable && a.addClass(t.clickableClass),
            a.addClass(t.modifierClass + t.type),
            "bullets" === t.type &&
              t.dynamicBullets &&
              (a.addClass("" + t.modifierClass + t.type + "-dynamic"),
              (e.pagination.dynamicBulletIndex = 0),
              t.dynamicMainBullets < 1 && (t.dynamicMainBullets = 1)),
            "progressbar" === t.type &&
              t.progressbarOpposite &&
              a.addClass(t.progressbarOppositeClass),
            t.clickable &&
              a.on(
                "click",
                "." + t.bulletClass.replace(/ /g, "."),
                function (t) {
                  t.preventDefault();
                  var a = m(this).index() * e.params.slidesPerGroup;
                  e.params.loop && (a += e.loopedSlides), e.slideTo(a);
                }
              ),
            C(e.pagination, {
              $el: a,
              el: a[0],
            }));
        }
      },
      destroy: function destroy() {
        var e = this,
          t = e.params.pagination;

        if (
          t.el &&
          e.pagination.el &&
          e.pagination.$el &&
          0 !== e.pagination.$el.length
        ) {
          var a = e.pagination.$el;
          a.removeClass(t.hiddenClass),
            a.removeClass(t.modifierClass + t.type),
            e.pagination.bullets &&
              e.pagination.bullets.removeClass(t.bulletActiveClass),
            t.clickable &&
              a.off("click", "." + t.bulletClass.replace(/ /g, "."));
        }
      },
    },
    J = {
      setTranslate: function setTranslate() {
        var e = this;

        if (e.params.scrollbar.el && e.scrollbar.el) {
          var t = e.scrollbar,
            a = e.rtlTranslate,
            i = e.progress,
            s = t.dragSize,
            r = t.trackSize,
            n = t.$dragEl,
            l = t.$el,
            o = e.params.scrollbar,
            d = s,
            p = (r - s) * i;
          a
            ? (p = -p) > 0
              ? ((d = s - p), (p = 0))
              : -p + s > r && (d = r + p)
            : p < 0
            ? ((d = s + p), (p = 0))
            : p + s > r && (d = r - p),
            e.isHorizontal()
              ? (n.transform("translate3d(" + p + "px, 0, 0)"),
                (n[0].style.width = d + "px"))
              : (n.transform("translate3d(0px, " + p + "px, 0)"),
                (n[0].style.height = d + "px")),
            o.hide &&
              (clearTimeout(e.scrollbar.timeout),
              (l[0].style.opacity = 1),
              (e.scrollbar.timeout = setTimeout(function () {
                (l[0].style.opacity = 0), l.transition(400);
              }, 1e3)));
        }
      },
      setTransition: function setTransition(e) {
        var t = this;
        t.params.scrollbar.el &&
          t.scrollbar.el &&
          t.scrollbar.$dragEl.transition(e);
      },
      updateSize: function updateSize() {
        var e = this;

        if (e.params.scrollbar.el && e.scrollbar.el) {
          var t = e.scrollbar,
            a = t.$dragEl,
            i = t.$el;
          (a[0].style.width = ""), (a[0].style.height = "");
          var s,
            r = e.isHorizontal() ? i[0].offsetWidth : i[0].offsetHeight,
            n = e.size / e.virtualSize,
            l = n * (r / e.size);
          (s =
            "auto" === e.params.scrollbar.dragSize
              ? r * n
              : parseInt(e.params.scrollbar.dragSize, 10)),
            e.isHorizontal()
              ? (a[0].style.width = s + "px")
              : (a[0].style.height = s + "px"),
            (i[0].style.display = n >= 1 ? "none" : ""),
            e.params.scrollbar.hide && (i[0].style.opacity = 0),
            C(t, {
              trackSize: r,
              divider: n,
              moveDivider: l,
              dragSize: s,
            }),
            t.$el[
              e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"
            ](e.params.scrollbar.lockClass);
        }
      },
      getPointerPosition: function getPointerPosition(e) {
        return this.isHorizontal()
          ? "touchstart" === e.type || "touchmove" === e.type
            ? e.targetTouches[0].clientX
            : e.clientX
          : "touchstart" === e.type || "touchmove" === e.type
          ? e.targetTouches[0].clientY
          : e.clientY;
      },
      setDragPosition: function setDragPosition(e) {
        var t,
          a = this,
          i = a.scrollbar,
          s = a.rtlTranslate,
          r = i.$el,
          n = i.dragSize,
          l = i.trackSize,
          o = i.dragStartPos;
        (t =
          (i.getPointerPosition(e) -
            r.offset()[a.isHorizontal() ? "left" : "top"] -
            (null !== o ? o : n / 2)) /
          (l - n)),
          (t = Math.max(Math.min(t, 1), 0)),
          s && (t = 1 - t);
        var d = a.minTranslate() + (a.maxTranslate() - a.minTranslate()) * t;
        a.updateProgress(d),
          a.setTranslate(d),
          a.updateActiveIndex(),
          a.updateSlidesClasses();
      },
      onDragStart: function onDragStart(e) {
        var t = this,
          a = t.params.scrollbar,
          i = t.scrollbar,
          s = t.$wrapperEl,
          r = i.$el,
          n = i.$dragEl;
        (t.scrollbar.isTouched = !0),
          (t.scrollbar.dragStartPos =
            e.target === n[0] || e.target === n
              ? i.getPointerPosition(e) -
                e.target.getBoundingClientRect()[
                  t.isHorizontal() ? "left" : "top"
                ]
              : null),
          e.preventDefault(),
          e.stopPropagation(),
          s.transition(100),
          n.transition(100),
          i.setDragPosition(e),
          clearTimeout(t.scrollbar.dragTimeout),
          r.transition(0),
          a.hide && r.css("opacity", 1),
          t.params.cssMode && t.$wrapperEl.css("scroll-snap-type", "none"),
          t.emit("scrollbarDragStart", e);
      },
      onDragMove: function onDragMove(e) {
        var t = this,
          a = t.scrollbar,
          i = t.$wrapperEl,
          s = a.$el,
          r = a.$dragEl;
        t.scrollbar.isTouched &&
          (e.preventDefault ? e.preventDefault() : (e.returnValue = !1),
          a.setDragPosition(e),
          i.transition(0),
          s.transition(0),
          r.transition(0),
          t.emit("scrollbarDragMove", e));
      },
      onDragEnd: function onDragEnd(e) {
        var t = this,
          a = t.params.scrollbar,
          i = t.scrollbar,
          s = t.$wrapperEl,
          r = i.$el;
        t.scrollbar.isTouched &&
          ((t.scrollbar.isTouched = !1),
          t.params.cssMode &&
            (t.$wrapperEl.css("scroll-snap-type", ""), s.transition("")),
          a.hide &&
            (clearTimeout(t.scrollbar.dragTimeout),
            (t.scrollbar.dragTimeout = E(function () {
              r.css("opacity", 0), r.transition(400);
            }, 1e3))),
          t.emit("scrollbarDragEnd", e),
          a.snapOnRelease && t.slideToClosest());
      },
      enableDraggable: function enableDraggable() {
        var e = this;

        if (e.params.scrollbar.el) {
          var t = r(),
            a = e.scrollbar,
            i = e.touchEventsTouch,
            s = e.touchEventsDesktop,
            n = e.params,
            l = e.support,
            o = a.$el[0],
            d = !(!l.passiveListener || !n.passiveListeners) && {
              passive: !1,
              capture: !1,
            },
            p = !(!l.passiveListener || !n.passiveListeners) && {
              passive: !0,
              capture: !1,
            };
          o &&
            (l.touch
              ? (o.addEventListener(i.start, e.scrollbar.onDragStart, d),
                o.addEventListener(i.move, e.scrollbar.onDragMove, d),
                o.addEventListener(i.end, e.scrollbar.onDragEnd, p))
              : (o.addEventListener(s.start, e.scrollbar.onDragStart, d),
                t.addEventListener(s.move, e.scrollbar.onDragMove, d),
                t.addEventListener(s.end, e.scrollbar.onDragEnd, p)));
        }
      },
      disableDraggable: function disableDraggable() {
        var e = this;

        if (e.params.scrollbar.el) {
          var t = r(),
            a = e.scrollbar,
            i = e.touchEventsTouch,
            s = e.touchEventsDesktop,
            n = e.params,
            l = e.support,
            o = a.$el[0],
            d = !(!l.passiveListener || !n.passiveListeners) && {
              passive: !1,
              capture: !1,
            },
            p = !(!l.passiveListener || !n.passiveListeners) && {
              passive: !0,
              capture: !1,
            };
          o &&
            (l.touch
              ? (o.removeEventListener(i.start, e.scrollbar.onDragStart, d),
                o.removeEventListener(i.move, e.scrollbar.onDragMove, d),
                o.removeEventListener(i.end, e.scrollbar.onDragEnd, p))
              : (o.removeEventListener(s.start, e.scrollbar.onDragStart, d),
                t.removeEventListener(s.move, e.scrollbar.onDragMove, d),
                t.removeEventListener(s.end, e.scrollbar.onDragEnd, p)));
        }
      },
      init: function init() {
        var e = this;

        if (e.params.scrollbar.el) {
          var t = e.scrollbar,
            a = e.$el,
            i = e.params.scrollbar,
            s = m(i.el);
          e.params.uniqueNavElements &&
            "string" == typeof i.el &&
            s.length > 1 &&
            1 === a.find(i.el).length &&
            (s = a.find(i.el));
          var r = s.find("." + e.params.scrollbar.dragClass);
          0 === r.length &&
            ((r = m(
              '<div class="' + e.params.scrollbar.dragClass + '"></div>'
            )),
            s.append(r)),
            C(t, {
              $el: s,
              el: s[0],
              $dragEl: r,
              dragEl: r[0],
            }),
            i.draggable && t.enableDraggable();
        }
      },
      destroy: function destroy() {
        this.scrollbar.disableDraggable();
      },
    },
    Q = {
      setTransform: function setTransform(e, t) {
        var a = this.rtl,
          i = m(e),
          s = a ? -1 : 1,
          r = i.attr("data-swiper-parallax") || "0",
          n = i.attr("data-swiper-parallax-x"),
          l = i.attr("data-swiper-parallax-y"),
          o = i.attr("data-swiper-parallax-scale"),
          d = i.attr("data-swiper-parallax-opacity");

        if (
          (n || l
            ? ((n = n || "0"), (l = l || "0"))
            : this.isHorizontal()
            ? ((n = r), (l = "0"))
            : ((l = r), (n = "0")),
          (n =
            n.indexOf("%") >= 0
              ? parseInt(n, 10) * t * s + "%"
              : n * t * s + "px"),
          (l = l.indexOf("%") >= 0 ? parseInt(l, 10) * t + "%" : l * t + "px"),
          null != d)
        ) {
          var p = d - (d - 1) * (1 - Math.abs(t));
          i[0].style.opacity = p;
        }

        if (null == o) i.transform("translate3d(" + n + ", " + l + ", 0px)");
        else {
          var c = o - (o - 1) * (1 - Math.abs(t));
          i.transform(
            "translate3d(" + n + ", " + l + ", 0px) scale(" + c + ")"
          );
        }
      },
      setTranslate: function setTranslate() {
        var e = this,
          t = e.$el,
          a = e.slides,
          i = e.progress,
          s = e.snapGrid;
        t
          .children(
            "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
          )
          .each(function (t) {
            e.parallax.setTransform(t, i);
          }),
          a.each(function (t, a) {
            var r = t.progress;
            e.params.slidesPerGroup > 1 &&
              "auto" !== e.params.slidesPerView &&
              (r += Math.ceil(a / 2) - i * (s.length - 1)),
              (r = Math.min(Math.max(r, -1), 1)),
              m(t)
                .find(
                  "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
                )
                .each(function (t) {
                  e.parallax.setTransform(t, r);
                });
          });
      },
      setTransition: function setTransition(e) {
        void 0 === e && (e = this.params.speed);
        this.$el
          .find(
            "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
          )
          .each(function (t) {
            var a = m(t),
              i = parseInt(a.attr("data-swiper-parallax-duration"), 10) || e;
            0 === e && (i = 0), a.transition(i);
          });
      },
    },
    ee = {
      getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
        if (e.targetTouches.length < 2) return 1;
        var t = e.targetTouches[0].pageX,
          a = e.targetTouches[0].pageY,
          i = e.targetTouches[1].pageX,
          s = e.targetTouches[1].pageY;
        return Math.sqrt(Math.pow(i - t, 2) + Math.pow(s - a, 2));
      },
      onGestureStart: function onGestureStart(e) {
        var t = this,
          a = t.support,
          i = t.params.zoom,
          s = t.zoom,
          r = s.gesture;

        if (
          ((s.fakeGestureTouched = !1), (s.fakeGestureMoved = !1), !a.gestures)
        ) {
          if (
            "touchstart" !== e.type ||
            ("touchstart" === e.type && e.targetTouches.length < 2)
          )
            return;
          (s.fakeGestureTouched = !0),
            (r.scaleStart = ee.getDistanceBetweenTouches(e));
        }

        (r.$slideEl && r.$slideEl.length) ||
        ((r.$slideEl = m(e.target).closest("." + t.params.slideClass)),
        0 === r.$slideEl.length && (r.$slideEl = t.slides.eq(t.activeIndex)),
        (r.$imageEl = r.$slideEl.find(
          "img, svg, canvas, picture, .swiper-zoom-target"
        )),
        (r.$imageWrapEl = r.$imageEl.parent("." + i.containerClass)),
        (r.maxRatio = r.$imageWrapEl.attr("data-swiper-zoom") || i.maxRatio),
        0 !== r.$imageWrapEl.length)
          ? (r.$imageEl && r.$imageEl.transition(0), (t.zoom.isScaling = !0))
          : (r.$imageEl = void 0);
      },
      onGestureChange: function onGestureChange(e) {
        var t = this,
          a = t.support,
          i = t.params.zoom,
          s = t.zoom,
          r = s.gesture;

        if (!a.gestures) {
          if (
            "touchmove" !== e.type ||
            ("touchmove" === e.type && e.targetTouches.length < 2)
          )
            return;
          (s.fakeGestureMoved = !0),
            (r.scaleMove = ee.getDistanceBetweenTouches(e));
        }

        r.$imageEl && 0 !== r.$imageEl.length
          ? (a.gestures
              ? (s.scale = e.scale * s.currentScale)
              : (s.scale = (r.scaleMove / r.scaleStart) * s.currentScale),
            s.scale > r.maxRatio &&
              (s.scale =
                r.maxRatio - 1 + Math.pow(s.scale - r.maxRatio + 1, 0.5)),
            s.scale < i.minRatio &&
              (s.scale =
                i.minRatio + 1 - Math.pow(i.minRatio - s.scale + 1, 0.5)),
            r.$imageEl.transform("translate3d(0,0,0) scale(" + s.scale + ")"))
          : "gesturechange" === e.type && s.onGestureStart(e);
      },
      onGestureEnd: function onGestureEnd(e) {
        var t = this,
          a = t.device,
          i = t.support,
          s = t.params.zoom,
          r = t.zoom,
          n = r.gesture;

        if (!i.gestures) {
          if (!r.fakeGestureTouched || !r.fakeGestureMoved) return;
          if (
            "touchend" !== e.type ||
            ("touchend" === e.type && e.changedTouches.length < 2 && !a.android)
          )
            return;
          (r.fakeGestureTouched = !1), (r.fakeGestureMoved = !1);
        }

        n.$imageEl &&
          0 !== n.$imageEl.length &&
          ((r.scale = Math.max(Math.min(r.scale, n.maxRatio), s.minRatio)),
          n.$imageEl
            .transition(t.params.speed)
            .transform("translate3d(0,0,0) scale(" + r.scale + ")"),
          (r.currentScale = r.scale),
          (r.isScaling = !1),
          1 === r.scale && (n.$slideEl = void 0));
      },
      onTouchStart: function onTouchStart(e) {
        var t = this.device,
          a = this.zoom,
          i = a.gesture,
          s = a.image;
        i.$imageEl &&
          0 !== i.$imageEl.length &&
          (s.isTouched ||
            (t.android && e.cancelable && e.preventDefault(),
            (s.isTouched = !0),
            (s.touchesStart.x =
              "touchstart" === e.type ? e.targetTouches[0].pageX : e.pageX),
            (s.touchesStart.y =
              "touchstart" === e.type ? e.targetTouches[0].pageY : e.pageY)));
      },
      onTouchMove: function onTouchMove(e) {
        var t = this,
          a = t.zoom,
          i = a.gesture,
          s = a.image,
          r = a.velocity;

        if (
          i.$imageEl &&
          0 !== i.$imageEl.length &&
          ((t.allowClick = !1), s.isTouched && i.$slideEl)
        ) {
          s.isMoved ||
            ((s.width = i.$imageEl[0].offsetWidth),
            (s.height = i.$imageEl[0].offsetHeight),
            (s.startX = T(i.$imageWrapEl[0], "x") || 0),
            (s.startY = T(i.$imageWrapEl[0], "y") || 0),
            (i.slideWidth = i.$slideEl[0].offsetWidth),
            (i.slideHeight = i.$slideEl[0].offsetHeight),
            i.$imageWrapEl.transition(0),
            t.rtl && ((s.startX = -s.startX), (s.startY = -s.startY)));
          var n = s.width * a.scale,
            l = s.height * a.scale;

          if (!(n < i.slideWidth && l < i.slideHeight)) {
            if (
              ((s.minX = Math.min(i.slideWidth / 2 - n / 2, 0)),
              (s.maxX = -s.minX),
              (s.minY = Math.min(i.slideHeight / 2 - l / 2, 0)),
              (s.maxY = -s.minY),
              (s.touchesCurrent.x =
                "touchmove" === e.type ? e.targetTouches[0].pageX : e.pageX),
              (s.touchesCurrent.y =
                "touchmove" === e.type ? e.targetTouches[0].pageY : e.pageY),
              !s.isMoved && !a.isScaling)
            ) {
              if (
                t.isHorizontal() &&
                ((Math.floor(s.minX) === Math.floor(s.startX) &&
                  s.touchesCurrent.x < s.touchesStart.x) ||
                  (Math.floor(s.maxX) === Math.floor(s.startX) &&
                    s.touchesCurrent.x > s.touchesStart.x))
              )
                return void (s.isTouched = !1);
              if (
                !t.isHorizontal() &&
                ((Math.floor(s.minY) === Math.floor(s.startY) &&
                  s.touchesCurrent.y < s.touchesStart.y) ||
                  (Math.floor(s.maxY) === Math.floor(s.startY) &&
                    s.touchesCurrent.y > s.touchesStart.y))
              )
                return void (s.isTouched = !1);
            }

            e.cancelable && e.preventDefault(),
              e.stopPropagation(),
              (s.isMoved = !0),
              (s.currentX = s.touchesCurrent.x - s.touchesStart.x + s.startX),
              (s.currentY = s.touchesCurrent.y - s.touchesStart.y + s.startY),
              s.currentX < s.minX &&
                (s.currentX =
                  s.minX + 1 - Math.pow(s.minX - s.currentX + 1, 0.8)),
              s.currentX > s.maxX &&
                (s.currentX =
                  s.maxX - 1 + Math.pow(s.currentX - s.maxX + 1, 0.8)),
              s.currentY < s.minY &&
                (s.currentY =
                  s.minY + 1 - Math.pow(s.minY - s.currentY + 1, 0.8)),
              s.currentY > s.maxY &&
                (s.currentY =
                  s.maxY - 1 + Math.pow(s.currentY - s.maxY + 1, 0.8)),
              r.prevPositionX || (r.prevPositionX = s.touchesCurrent.x),
              r.prevPositionY || (r.prevPositionY = s.touchesCurrent.y),
              r.prevTime || (r.prevTime = Date.now()),
              (r.x =
                (s.touchesCurrent.x - r.prevPositionX) /
                (Date.now() - r.prevTime) /
                2),
              (r.y =
                (s.touchesCurrent.y - r.prevPositionY) /
                (Date.now() - r.prevTime) /
                2),
              Math.abs(s.touchesCurrent.x - r.prevPositionX) < 2 && (r.x = 0),
              Math.abs(s.touchesCurrent.y - r.prevPositionY) < 2 && (r.y = 0),
              (r.prevPositionX = s.touchesCurrent.x),
              (r.prevPositionY = s.touchesCurrent.y),
              (r.prevTime = Date.now()),
              i.$imageWrapEl.transform(
                "translate3d(" + s.currentX + "px, " + s.currentY + "px,0)"
              );
          }
        }
      },
      onTouchEnd: function onTouchEnd() {
        var e = this.zoom,
          t = e.gesture,
          a = e.image,
          i = e.velocity;

        if (t.$imageEl && 0 !== t.$imageEl.length) {
          if (!a.isTouched || !a.isMoved)
            return (a.isTouched = !1), void (a.isMoved = !1);
          (a.isTouched = !1), (a.isMoved = !1);
          var s = 300,
            r = 300,
            n = i.x * s,
            l = a.currentX + n,
            o = i.y * r,
            d = a.currentY + o;
          0 !== i.x && (s = Math.abs((l - a.currentX) / i.x)),
            0 !== i.y && (r = Math.abs((d - a.currentY) / i.y));
          var p = Math.max(s, r);
          (a.currentX = l), (a.currentY = d);
          var c = a.width * e.scale,
            u = a.height * e.scale;
          (a.minX = Math.min(t.slideWidth / 2 - c / 2, 0)),
            (a.maxX = -a.minX),
            (a.minY = Math.min(t.slideHeight / 2 - u / 2, 0)),
            (a.maxY = -a.minY),
            (a.currentX = Math.max(Math.min(a.currentX, a.maxX), a.minX)),
            (a.currentY = Math.max(Math.min(a.currentY, a.maxY), a.minY)),
            t.$imageWrapEl
              .transition(p)
              .transform(
                "translate3d(" + a.currentX + "px, " + a.currentY + "px,0)"
              );
        }
      },
      onTransitionEnd: function onTransitionEnd() {
        var e = this,
          t = e.zoom,
          a = t.gesture;
        a.$slideEl &&
          e.previousIndex !== e.activeIndex &&
          (a.$imageEl && a.$imageEl.transform("translate3d(0,0,0) scale(1)"),
          a.$imageWrapEl && a.$imageWrapEl.transform("translate3d(0,0,0)"),
          (t.scale = 1),
          (t.currentScale = 1),
          (a.$slideEl = void 0),
          (a.$imageEl = void 0),
          (a.$imageWrapEl = void 0));
      },
      toggle: function toggle(e) {
        var t = this.zoom;
        t.scale && 1 !== t.scale ? t.out() : t.in(e);
      },
      in: function _in(e) {
        var t,
          a,
          i,
          s,
          r,
          n,
          o,
          d,
          p,
          c,
          u,
          h,
          v,
          f,
          m,
          g,
          b = this,
          w = l(),
          y = b.zoom,
          E = b.params.zoom,
          x = y.gesture,
          T = y.image;
        (x.$slideEl ||
          (b.params.virtual && b.params.virtual.enabled && b.virtual
            ? (x.$slideEl = b.$wrapperEl.children(
                "." + b.params.slideActiveClass
              ))
            : (x.$slideEl = b.slides.eq(b.activeIndex)),
          (x.$imageEl = x.$slideEl.find(
            "img, svg, canvas, picture, .swiper-zoom-target"
          )),
          (x.$imageWrapEl = x.$imageEl.parent("." + E.containerClass))),
        x.$imageEl && 0 !== x.$imageEl.length) &&
          (x.$slideEl.addClass("" + E.zoomedSlideClass),
          void 0 === T.touchesStart.x && e
            ? ((t =
                "touchend" === e.type ? e.changedTouches[0].pageX : e.pageX),
              (a = "touchend" === e.type ? e.changedTouches[0].pageY : e.pageY))
            : ((t = T.touchesStart.x), (a = T.touchesStart.y)),
          (y.scale = x.$imageWrapEl.attr("data-swiper-zoom") || E.maxRatio),
          (y.currentScale =
            x.$imageWrapEl.attr("data-swiper-zoom") || E.maxRatio),
          e
            ? ((m = x.$slideEl[0].offsetWidth),
              (g = x.$slideEl[0].offsetHeight),
              (i = x.$slideEl.offset().left + w.scrollX + m / 2 - t),
              (s = x.$slideEl.offset().top + w.scrollY + g / 2 - a),
              (o = x.$imageEl[0].offsetWidth),
              (d = x.$imageEl[0].offsetHeight),
              (p = o * y.scale),
              (c = d * y.scale),
              (v = -(u = Math.min(m / 2 - p / 2, 0))),
              (f = -(h = Math.min(g / 2 - c / 2, 0))),
              (r = i * y.scale) < u && (r = u),
              r > v && (r = v),
              (n = s * y.scale) < h && (n = h),
              n > f && (n = f))
            : ((r = 0), (n = 0)),
          x.$imageWrapEl
            .transition(300)
            .transform("translate3d(" + r + "px, " + n + "px,0)"),
          x.$imageEl
            .transition(300)
            .transform("translate3d(0,0,0) scale(" + y.scale + ")"));
      },
      out: function out() {
        var e = this,
          t = e.zoom,
          a = e.params.zoom,
          i = t.gesture;
        i.$slideEl ||
          (e.params.virtual && e.params.virtual.enabled && e.virtual
            ? (i.$slideEl = e.$wrapperEl.children(
                "." + e.params.slideActiveClass
              ))
            : (i.$slideEl = e.slides.eq(e.activeIndex)),
          (i.$imageEl = i.$slideEl.find(
            "img, svg, canvas, picture, .swiper-zoom-target"
          )),
          (i.$imageWrapEl = i.$imageEl.parent("." + a.containerClass))),
          i.$imageEl &&
            0 !== i.$imageEl.length &&
            ((t.scale = 1),
            (t.currentScale = 1),
            i.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"),
            i.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)"),
            i.$slideEl.removeClass("" + a.zoomedSlideClass),
            (i.$slideEl = void 0));
      },
      toggleGestures: function toggleGestures(e) {
        var t = this,
          a = t.zoom,
          i = a.slideSelector,
          s = a.passiveListener;
        t.$wrapperEl[e]("gesturestart", i, a.onGestureStart, s),
          t.$wrapperEl[e]("gesturechange", i, a.onGestureChange, s),
          t.$wrapperEl[e]("gestureend", i, a.onGestureEnd, s);
      },
      enableGestures: function enableGestures() {
        this.zoom.gesturesEnabled ||
          ((this.zoom.gesturesEnabled = !0), this.zoom.toggleGestures("on"));
      },
      disableGestures: function disableGestures() {
        this.zoom.gesturesEnabled &&
          ((this.zoom.gesturesEnabled = !1), this.zoom.toggleGestures("off"));
      },
      enable: function enable() {
        var e = this,
          t = e.support,
          a = e.zoom;

        if (!a.enabled) {
          a.enabled = !0;
          var i = !(
              "touchstart" !== e.touchEvents.start ||
              !t.passiveListener ||
              !e.params.passiveListeners
            ) && {
              passive: !0,
              capture: !1,
            },
            s = !t.passiveListener || {
              passive: !1,
              capture: !0,
            },
            r = "." + e.params.slideClass;
          (e.zoom.passiveListener = i),
            (e.zoom.slideSelector = r),
            t.gestures
              ? (e.$wrapperEl.on(e.touchEvents.start, e.zoom.enableGestures, i),
                e.$wrapperEl.on(e.touchEvents.end, e.zoom.disableGestures, i))
              : "touchstart" === e.touchEvents.start &&
                (e.$wrapperEl.on(e.touchEvents.start, r, a.onGestureStart, i),
                e.$wrapperEl.on(e.touchEvents.move, r, a.onGestureChange, s),
                e.$wrapperEl.on(e.touchEvents.end, r, a.onGestureEnd, i),
                e.touchEvents.cancel &&
                  e.$wrapperEl.on(e.touchEvents.cancel, r, a.onGestureEnd, i)),
            e.$wrapperEl.on(
              e.touchEvents.move,
              "." + e.params.zoom.containerClass,
              a.onTouchMove,
              s
            );
        }
      },
      disable: function disable() {
        var e = this,
          t = e.zoom;

        if (t.enabled) {
          var a = e.support;
          e.zoom.enabled = !1;
          var i = !(
              "touchstart" !== e.touchEvents.start ||
              !a.passiveListener ||
              !e.params.passiveListeners
            ) && {
              passive: !0,
              capture: !1,
            },
            s = !a.passiveListener || {
              passive: !1,
              capture: !0,
            },
            r = "." + e.params.slideClass;
          a.gestures
            ? (e.$wrapperEl.off(e.touchEvents.start, e.zoom.enableGestures, i),
              e.$wrapperEl.off(e.touchEvents.end, e.zoom.disableGestures, i))
            : "touchstart" === e.touchEvents.start &&
              (e.$wrapperEl.off(e.touchEvents.start, r, t.onGestureStart, i),
              e.$wrapperEl.off(e.touchEvents.move, r, t.onGestureChange, s),
              e.$wrapperEl.off(e.touchEvents.end, r, t.onGestureEnd, i),
              e.touchEvents.cancel &&
                e.$wrapperEl.off(e.touchEvents.cancel, r, t.onGestureEnd, i)),
            e.$wrapperEl.off(
              e.touchEvents.move,
              "." + e.params.zoom.containerClass,
              t.onTouchMove,
              s
            );
        }
      },
    },
    te = {
      loadInSlide: function loadInSlide(e, t) {
        void 0 === t && (t = !0);
        var a = this,
          i = a.params.lazy;

        if (void 0 !== e && 0 !== a.slides.length) {
          var s =
              a.virtual && a.params.virtual.enabled
                ? a.$wrapperEl.children(
                    "." +
                      a.params.slideClass +
                      '[data-swiper-slide-index="' +
                      e +
                      '"]'
                  )
                : a.slides.eq(e),
            r = s.find(
              "." +
                i.elementClass +
                ":not(." +
                i.loadedClass +
                "):not(." +
                i.loadingClass +
                ")"
            );
          !s.hasClass(i.elementClass) ||
            s.hasClass(i.loadedClass) ||
            s.hasClass(i.loadingClass) ||
            r.push(s[0]),
            0 !== r.length &&
              r.each(function (e) {
                var r = m(e);
                r.addClass(i.loadingClass);
                var n = r.attr("data-background"),
                  l = r.attr("data-src"),
                  o = r.attr("data-srcset"),
                  d = r.attr("data-sizes"),
                  p = r.parent("picture");
                a.loadImage(r[0], l || n, o, d, !1, function () {
                  if (null != a && a && (!a || a.params) && !a.destroyed) {
                    if (
                      (n
                        ? (r.css("background-image", 'url("' + n + '")'),
                          r.removeAttr("data-background"))
                        : (o &&
                            (r.attr("srcset", o), r.removeAttr("data-srcset")),
                          d && (r.attr("sizes", d), r.removeAttr("data-sizes")),
                          p.length &&
                            p.children("source").each(function (e) {
                              var t = m(e);
                              t.attr("data-srcset") &&
                                (t.attr("srcset", t.attr("data-srcset")),
                                t.removeAttr("data-srcset"));
                            }),
                          l && (r.attr("src", l), r.removeAttr("data-src"))),
                      r.addClass(i.loadedClass).removeClass(i.loadingClass),
                      s.find("." + i.preloaderClass).remove(),
                      a.params.loop && t)
                    ) {
                      var e = s.attr("data-swiper-slide-index");

                      if (s.hasClass(a.params.slideDuplicateClass)) {
                        var c = a.$wrapperEl.children(
                          '[data-swiper-slide-index="' +
                            e +
                            '"]:not(.' +
                            a.params.slideDuplicateClass +
                            ")"
                        );
                        a.lazy.loadInSlide(c.index(), !1);
                      } else {
                        var u = a.$wrapperEl.children(
                          "." +
                            a.params.slideDuplicateClass +
                            '[data-swiper-slide-index="' +
                            e +
                            '"]'
                        );
                        a.lazy.loadInSlide(u.index(), !1);
                      }
                    }

                    a.emit("lazyImageReady", s[0], r[0]),
                      a.params.autoHeight && a.updateAutoHeight();
                  }
                }),
                  a.emit("lazyImageLoad", s[0], r[0]);
              });
        }
      },
      load: function load() {
        var e = this,
          t = e.$wrapperEl,
          a = e.params,
          i = e.slides,
          s = e.activeIndex,
          r = e.virtual && a.virtual.enabled,
          n = a.lazy,
          l = a.slidesPerView;

        function o(e) {
          if (r) {
            if (
              t.children(
                "." + a.slideClass + '[data-swiper-slide-index="' + e + '"]'
              ).length
            )
              return !0;
          } else if (i[e]) return !0;

          return !1;
        }

        function d(e) {
          return r ? m(e).attr("data-swiper-slide-index") : m(e).index();
        }

        if (
          ("auto" === l && (l = 0),
          e.lazy.initialImageLoaded || (e.lazy.initialImageLoaded = !0),
          e.params.watchSlidesVisibility)
        )
          t.children("." + a.slideVisibleClass).each(function (t) {
            var a = r ? m(t).attr("data-swiper-slide-index") : m(t).index();
            e.lazy.loadInSlide(a);
          });
        else if (l > 1)
          for (var p = s; p < s + l; p += 1) {
            o(p) && e.lazy.loadInSlide(p);
          }
        else e.lazy.loadInSlide(s);
        if (n.loadPrevNext)
          if (l > 1 || (n.loadPrevNextAmount && n.loadPrevNextAmount > 1)) {
            for (
              var c = n.loadPrevNextAmount,
                u = l,
                h = Math.min(s + u + Math.max(c, u), i.length),
                v = Math.max(s - Math.max(u, c), 0),
                f = s + l;
              f < h;
              f += 1
            ) {
              o(f) && e.lazy.loadInSlide(f);
            }

            for (var g = v; g < s; g += 1) {
              o(g) && e.lazy.loadInSlide(g);
            }
          } else {
            var b = t.children("." + a.slideNextClass);
            b.length > 0 && e.lazy.loadInSlide(d(b));
            var w = t.children("." + a.slidePrevClass);
            w.length > 0 && e.lazy.loadInSlide(d(w));
          }
      },
      checkInViewOnLoad: function checkInViewOnLoad() {
        var e = l(),
          t = this;

        if (t && !t.destroyed) {
          var a = t.params.lazy.scrollingElement
              ? m(t.params.lazy.scrollingElement)
              : m(e),
            i = a[0] === e,
            s = i ? e.innerWidth : a[0].offsetWidth,
            r = i ? e.innerHeight : a[0].offsetHeight,
            n = t.$el.offset(),
            o = !1;
          t.rtlTranslate && (n.left -= t.$el[0].scrollLeft);

          for (
            var d = [
                [n.left, n.top],
                [n.left + t.width, n.top],
                [n.left, n.top + t.height],
                [n.left + t.width, n.top + t.height],
              ],
              p = 0;
            p < d.length;
            p += 1
          ) {
            var c = d[p];

            if (c[0] >= 0 && c[0] <= s && c[1] >= 0 && c[1] <= r) {
              if (0 === c[0] && 0 === c[1]) continue;
              o = !0;
            }
          }

          o
            ? (t.lazy.load(), a.off("scroll", t.lazy.checkInViewOnLoad))
            : t.lazy.scrollHandlerAttached ||
              ((t.lazy.scrollHandlerAttached = !0),
              a.on("scroll", t.lazy.checkInViewOnLoad));
        }
      },
    },
    ae = {
      LinearSpline: function LinearSpline(e, t) {
        var a,
          i,
          s,
          r,
          n,
          l = function l(e, t) {
            for (i = -1, a = e.length; a - i > 1; ) {
              e[(s = (a + i) >> 1)] <= t ? (i = s) : (a = s);
            }

            return a;
          };

        return (
          (this.x = e),
          (this.y = t),
          (this.lastIndex = e.length - 1),
          (this.interpolate = function (e) {
            return e
              ? ((n = l(this.x, e)),
                (r = n - 1),
                ((e - this.x[r]) * (this.y[n] - this.y[r])) /
                  (this.x[n] - this.x[r]) +
                  this.y[r])
              : 0;
          }),
          this
        );
      },
      getInterpolateFunction: function getInterpolateFunction(e) {
        var t = this;
        t.controller.spline ||
          (t.controller.spline = t.params.loop
            ? new ae.LinearSpline(t.slidesGrid, e.slidesGrid)
            : new ae.LinearSpline(t.snapGrid, e.snapGrid));
      },
      setTranslate: function setTranslate(e, t) {
        var a,
          i,
          s = this,
          r = s.controller.control,
          n = s.constructor;

        function l(e) {
          var t = s.rtlTranslate ? -s.translate : s.translate;
          "slide" === s.params.controller.by &&
            (s.controller.getInterpolateFunction(e),
            (i = -s.controller.spline.interpolate(-t))),
            (i && "container" !== s.params.controller.by) ||
              ((a =
                (e.maxTranslate() - e.minTranslate()) /
                (s.maxTranslate() - s.minTranslate())),
              (i = (t - s.minTranslate()) * a + e.minTranslate())),
            s.params.controller.inverse && (i = e.maxTranslate() - i),
            e.updateProgress(i),
            e.setTranslate(i, s),
            e.updateActiveIndex(),
            e.updateSlidesClasses();
        }

        if (Array.isArray(r))
          for (var o = 0; o < r.length; o += 1) {
            r[o] !== t && r[o] instanceof n && l(r[o]);
          }
        else r instanceof n && t !== r && l(r);
      },
      setTransition: function setTransition(e, t) {
        var a,
          i = this,
          s = i.constructor,
          r = i.controller.control;

        function n(t) {
          t.setTransition(e, i),
            0 !== e &&
              (t.transitionStart(),
              t.params.autoHeight &&
                E(function () {
                  t.updateAutoHeight();
                }),
              t.$wrapperEl.transitionEnd(function () {
                r &&
                  (t.params.loop &&
                    "slide" === i.params.controller.by &&
                    t.loopFix(),
                  t.transitionEnd());
              }));
        }

        if (Array.isArray(r))
          for (a = 0; a < r.length; a += 1) {
            r[a] !== t && r[a] instanceof s && n(r[a]);
          }
        else r instanceof s && t !== r && n(r);
      },
    },
    ie = {
      getRandomNumber: function getRandomNumber(e) {
        void 0 === e && (e = 16);
        return "x".repeat(e).replace(/x/g, function () {
          return Math.round(16 * Math.random()).toString(16);
        });
      },
      makeElFocusable: function makeElFocusable(e) {
        return e.attr("tabIndex", "0"), e;
      },
      makeElNotFocusable: function makeElNotFocusable(e) {
        return e.attr("tabIndex", "-1"), e;
      },
      addElRole: function addElRole(e, t) {
        return e.attr("role", t), e;
      },
      addElRoleDescription: function addElRoleDescription(e, t) {
        return e.attr("aria-roledescription", t), e;
      },
      addElControls: function addElControls(e, t) {
        return e.attr("aria-controls", t), e;
      },
      addElLabel: function addElLabel(e, t) {
        return e.attr("aria-label", t), e;
      },
      addElId: function addElId(e, t) {
        return e.attr("id", t), e;
      },
      addElLive: function addElLive(e, t) {
        return e.attr("aria-live", t), e;
      },
      disableEl: function disableEl(e) {
        return e.attr("aria-disabled", !0), e;
      },
      enableEl: function enableEl(e) {
        return e.attr("aria-disabled", !1), e;
      },
      onEnterOrSpaceKey: function onEnterOrSpaceKey(e) {
        if (13 === e.keyCode || 32 === e.keyCode) {
          var t = this,
            a = t.params.a11y,
            i = m(e.target);
          t.navigation &&
            t.navigation.$nextEl &&
            i.is(t.navigation.$nextEl) &&
            ((t.isEnd && !t.params.loop) || t.slideNext(),
            t.isEnd
              ? t.a11y.notify(a.lastSlideMessage)
              : t.a11y.notify(a.nextSlideMessage)),
            t.navigation &&
              t.navigation.$prevEl &&
              i.is(t.navigation.$prevEl) &&
              ((t.isBeginning && !t.params.loop) || t.slidePrev(),
              t.isBeginning
                ? t.a11y.notify(a.firstSlideMessage)
                : t.a11y.notify(a.prevSlideMessage)),
            t.pagination &&
              i.is("." + t.params.pagination.bulletClass.replace(/ /g, ".")) &&
              i[0].click();
        }
      },
      notify: function notify(e) {
        var t = this.a11y.liveRegion;
        0 !== t.length && (t.html(""), t.html(e));
      },
      updateNavigation: function updateNavigation() {
        var e = this;

        if (!e.params.loop && e.navigation) {
          var t = e.navigation,
            a = t.$nextEl,
            i = t.$prevEl;
          i &&
            i.length > 0 &&
            (e.isBeginning
              ? (e.a11y.disableEl(i), e.a11y.makeElNotFocusable(i))
              : (e.a11y.enableEl(i), e.a11y.makeElFocusable(i))),
            a &&
              a.length > 0 &&
              (e.isEnd
                ? (e.a11y.disableEl(a), e.a11y.makeElNotFocusable(a))
                : (e.a11y.enableEl(a), e.a11y.makeElFocusable(a)));
        }
      },
      updatePagination: function updatePagination() {
        var e = this,
          t = e.params.a11y;
        e.pagination &&
          e.params.pagination.clickable &&
          e.pagination.bullets &&
          e.pagination.bullets.length &&
          e.pagination.bullets.each(function (a) {
            var i = m(a);
            e.a11y.makeElFocusable(i),
              e.params.pagination.renderBullet ||
                (e.a11y.addElRole(i, "button"),
                e.a11y.addElLabel(
                  i,
                  t.paginationBulletMessage.replace(
                    /\{\{index\}\}/,
                    i.index() + 1
                  )
                ));
          });
      },
      init: function init() {
        var e = this,
          t = e.params.a11y;
        e.$el.append(e.a11y.liveRegion);
        var a = e.$el;
        t.containerRoleDescriptionMessage &&
          e.a11y.addElRoleDescription(a, t.containerRoleDescriptionMessage),
          t.containerMessage && e.a11y.addElLabel(a, t.containerMessage);
        var i,
          s,
          r,
          n = e.$wrapperEl,
          l = n.attr("id") || "swiper-wrapper-" + e.a11y.getRandomNumber(16);
        e.a11y.addElId(n, l),
          (i =
            e.params.autoplay && e.params.autoplay.enabled ? "off" : "polite"),
          e.a11y.addElLive(n, i),
          t.itemRoleDescriptionMessage &&
            e.a11y.addElRoleDescription(
              m(e.slides),
              t.itemRoleDescriptionMessage
            ),
          e.a11y.addElRole(m(e.slides), "group"),
          e.slides.each(function (a) {
            var i = m(a),
              s = t.slideLabelMessage
                .replace(/\{\{index\}\}/, i.index() + 1)
                .replace(/\{\{slidesLength\}\}/, e.slides.length);
            e.a11y.addElLabel(i, s);
          }),
          e.navigation && e.navigation.$nextEl && (s = e.navigation.$nextEl),
          e.navigation && e.navigation.$prevEl && (r = e.navigation.$prevEl),
          s &&
            s.length &&
            (e.a11y.makeElFocusable(s),
            "BUTTON" !== s[0].tagName &&
              (e.a11y.addElRole(s, "button"),
              s.on("keydown", e.a11y.onEnterOrSpaceKey)),
            e.a11y.addElLabel(s, t.nextSlideMessage),
            e.a11y.addElControls(s, l)),
          r &&
            r.length &&
            (e.a11y.makeElFocusable(r),
            "BUTTON" !== r[0].tagName &&
              (e.a11y.addElRole(r, "button"),
              r.on("keydown", e.a11y.onEnterOrSpaceKey)),
            e.a11y.addElLabel(r, t.prevSlideMessage),
            e.a11y.addElControls(r, l)),
          e.pagination &&
            e.params.pagination.clickable &&
            e.pagination.bullets &&
            e.pagination.bullets.length &&
            e.pagination.$el.on(
              "keydown",
              "." + e.params.pagination.bulletClass.replace(/ /g, "."),
              e.a11y.onEnterOrSpaceKey
            );
      },
      destroy: function destroy() {
        var e,
          t,
          a = this;
        a.a11y.liveRegion &&
          a.a11y.liveRegion.length > 0 &&
          a.a11y.liveRegion.remove(),
          a.navigation && a.navigation.$nextEl && (e = a.navigation.$nextEl),
          a.navigation && a.navigation.$prevEl && (t = a.navigation.$prevEl),
          e && e.off("keydown", a.a11y.onEnterOrSpaceKey),
          t && t.off("keydown", a.a11y.onEnterOrSpaceKey),
          a.pagination &&
            a.params.pagination.clickable &&
            a.pagination.bullets &&
            a.pagination.bullets.length &&
            a.pagination.$el.off(
              "keydown",
              "." + a.params.pagination.bulletClass.replace(/ /g, "."),
              a.a11y.onEnterOrSpaceKey
            );
      },
    },
    se = {
      init: function init() {
        var e = this,
          t = l();

        if (e.params.history) {
          if (!t.history || !t.history.pushState)
            return (
              (e.params.history.enabled = !1),
              void (e.params.hashNavigation.enabled = !0)
            );
          var a = e.history;
          (a.initialized = !0),
            (a.paths = se.getPathValues(e.params.url)),
            (a.paths.key || a.paths.value) &&
              (a.scrollToSlide(0, a.paths.value, e.params.runCallbacksOnInit),
              e.params.history.replaceState ||
                t.addEventListener("popstate", e.history.setHistoryPopState));
        }
      },
      destroy: function destroy() {
        var e = l();
        this.params.history.replaceState ||
          e.removeEventListener("popstate", this.history.setHistoryPopState);
      },
      setHistoryPopState: function setHistoryPopState() {
        var e = this;
        (e.history.paths = se.getPathValues(e.params.url)),
          e.history.scrollToSlide(e.params.speed, e.history.paths.value, !1);
      },
      getPathValues: function getPathValues(e) {
        var t = l(),
          a = (e ? new URL(e) : t.location).pathname
            .slice(1)
            .split("/")
            .filter(function (e) {
              return "" !== e;
            }),
          i = a.length;
        return {
          key: a[i - 2],
          value: a[i - 1],
        };
      },
      setHistory: function setHistory(e, t) {
        var a = this,
          i = l();

        if (a.history.initialized && a.params.history.enabled) {
          var s;
          s = a.params.url ? new URL(a.params.url) : i.location;
          var r = a.slides.eq(t),
            n = se.slugify(r.attr("data-history"));
          s.pathname.includes(e) || (n = e + "/" + n);
          var o = i.history.state;
          (o && o.value === n) ||
            (a.params.history.replaceState
              ? i.history.replaceState(
                  {
                    value: n,
                  },
                  null,
                  n
                )
              : i.history.pushState(
                  {
                    value: n,
                  },
                  null,
                  n
                ));
        }
      },
      slugify: function slugify(e) {
        return e
          .toString()
          .replace(/\s+/g, "-")
          .replace(/[^\w-]+/g, "")
          .replace(/--+/g, "-")
          .replace(/^-+/, "")
          .replace(/-+$/, "");
      },
      scrollToSlide: function scrollToSlide(e, t, a) {
        var i = this;
        if (t)
          for (var s = 0, r = i.slides.length; s < r; s += 1) {
            var n = i.slides.eq(s);

            if (
              se.slugify(n.attr("data-history")) === t &&
              !n.hasClass(i.params.slideDuplicateClass)
            ) {
              var l = n.index();
              i.slideTo(l, e, a);
            }
          }
        else i.slideTo(0, e, a);
      },
    },
    re = {
      onHashCange: function onHashCange() {
        var e = this,
          t = r();
        e.emit("hashChange");
        var a = t.location.hash.replace("#", "");

        if (a !== e.slides.eq(e.activeIndex).attr("data-hash")) {
          var i = e.$wrapperEl
            .children("." + e.params.slideClass + '[data-hash="' + a + '"]')
            .index();
          if (void 0 === i) return;
          e.slideTo(i);
        }
      },
      setHash: function setHash() {
        var e = this,
          t = l(),
          a = r();
        if (e.hashNavigation.initialized && e.params.hashNavigation.enabled)
          if (
            e.params.hashNavigation.replaceState &&
            t.history &&
            t.history.replaceState
          )
            t.history.replaceState(
              null,
              null,
              "#" + e.slides.eq(e.activeIndex).attr("data-hash") || ""
            ),
              e.emit("hashSet");
          else {
            var i = e.slides.eq(e.activeIndex),
              s = i.attr("data-hash") || i.attr("data-history");
            (a.location.hash = s || ""), e.emit("hashSet");
          }
      },
      init: function init() {
        var e = this,
          t = r(),
          a = l();

        if (
          !(
            !e.params.hashNavigation.enabled ||
            (e.params.history && e.params.history.enabled)
          )
        ) {
          e.hashNavigation.initialized = !0;
          var i = t.location.hash.replace("#", "");
          if (i)
            for (var s = 0, n = e.slides.length; s < n; s += 1) {
              var o = e.slides.eq(s);

              if (
                (o.attr("data-hash") || o.attr("data-history")) === i &&
                !o.hasClass(e.params.slideDuplicateClass)
              ) {
                var d = o.index();
                e.slideTo(d, 0, e.params.runCallbacksOnInit, !0);
              }
            }
          e.params.hashNavigation.watchState &&
            m(a).on("hashchange", e.hashNavigation.onHashCange);
        }
      },
      destroy: function destroy() {
        var e = l();
        this.params.hashNavigation.watchState &&
          m(e).off("hashchange", this.hashNavigation.onHashCange);
      },
    },
    ne = {
      run: function run() {
        var e = this,
          t = e.slides.eq(e.activeIndex),
          a = e.params.autoplay.delay;
        t.attr("data-swiper-autoplay") &&
          (a = t.attr("data-swiper-autoplay") || e.params.autoplay.delay),
          clearTimeout(e.autoplay.timeout),
          (e.autoplay.timeout = E(function () {
            var t;
            e.params.autoplay.reverseDirection
              ? e.params.loop
                ? (e.loopFix(),
                  (t = e.slidePrev(e.params.speed, !0, !0)),
                  e.emit("autoplay"))
                : e.isBeginning
                ? e.params.autoplay.stopOnLastSlide
                  ? e.autoplay.stop()
                  : ((t = e.slideTo(
                      e.slides.length - 1,
                      e.params.speed,
                      !0,
                      !0
                    )),
                    e.emit("autoplay"))
                : ((t = e.slidePrev(e.params.speed, !0, !0)),
                  e.emit("autoplay"))
              : e.params.loop
              ? (e.loopFix(),
                (t = e.slideNext(e.params.speed, !0, !0)),
                e.emit("autoplay"))
              : e.isEnd
              ? e.params.autoplay.stopOnLastSlide
                ? e.autoplay.stop()
                : ((t = e.slideTo(0, e.params.speed, !0, !0)),
                  e.emit("autoplay"))
              : ((t = e.slideNext(e.params.speed, !0, !0)), e.emit("autoplay")),
              ((e.params.cssMode && e.autoplay.running) || !1 === t) &&
                e.autoplay.run();
          }, a));
      },
      start: function start() {
        var e = this;
        return (
          void 0 === e.autoplay.timeout &&
          !e.autoplay.running &&
          ((e.autoplay.running = !0),
          e.emit("autoplayStart"),
          e.autoplay.run(),
          !0)
        );
      },
      stop: function stop() {
        var e = this;
        return (
          !!e.autoplay.running &&
          void 0 !== e.autoplay.timeout &&
          (e.autoplay.timeout &&
            (clearTimeout(e.autoplay.timeout), (e.autoplay.timeout = void 0)),
          (e.autoplay.running = !1),
          e.emit("autoplayStop"),
          !0)
        );
      },
      pause: function pause(e) {
        var t = this;
        t.autoplay.running &&
          (t.autoplay.paused ||
            (t.autoplay.timeout && clearTimeout(t.autoplay.timeout),
            (t.autoplay.paused = !0),
            0 !== e && t.params.autoplay.waitForTransition
              ? (t.$wrapperEl[0].addEventListener(
                  "transitionend",
                  t.autoplay.onTransitionEnd
                ),
                t.$wrapperEl[0].addEventListener(
                  "webkitTransitionEnd",
                  t.autoplay.onTransitionEnd
                ))
              : ((t.autoplay.paused = !1), t.autoplay.run())));
      },
      onVisibilityChange: function onVisibilityChange() {
        var e = this,
          t = r();
        "hidden" === t.visibilityState &&
          e.autoplay.running &&
          e.autoplay.pause(),
          "visible" === t.visibilityState &&
            e.autoplay.paused &&
            (e.autoplay.run(), (e.autoplay.paused = !1));
      },
      onTransitionEnd: function onTransitionEnd(e) {
        var t = this;
        t &&
          !t.destroyed &&
          t.$wrapperEl &&
          e.target === t.$wrapperEl[0] &&
          (t.$wrapperEl[0].removeEventListener(
            "transitionend",
            t.autoplay.onTransitionEnd
          ),
          t.$wrapperEl[0].removeEventListener(
            "webkitTransitionEnd",
            t.autoplay.onTransitionEnd
          ),
          (t.autoplay.paused = !1),
          t.autoplay.running ? t.autoplay.run() : t.autoplay.stop());
      },
    },
    le = {
      setTranslate: function setTranslate() {
        for (var e = this, t = e.slides, a = 0; a < t.length; a += 1) {
          var i = e.slides.eq(a),
            s = -i[0].swiperSlideOffset;
          e.params.virtualTranslate || (s -= e.translate);
          var r = 0;
          e.isHorizontal() || ((r = s), (s = 0));
          var n = e.params.fadeEffect.crossFade
            ? Math.max(1 - Math.abs(i[0].progress), 0)
            : 1 + Math.min(Math.max(i[0].progress, -1), 0);
          i.css({
            opacity: n,
          }).transform("translate3d(" + s + "px, " + r + "px, 0px)");
        }
      },
      setTransition: function setTransition(e) {
        var t = this,
          a = t.slides,
          i = t.$wrapperEl;

        if ((a.transition(e), t.params.virtualTranslate && 0 !== e)) {
          var s = !1;
          a.transitionEnd(function () {
            if (!s && t && !t.destroyed) {
              (s = !0), (t.animating = !1);

              for (
                var e = ["webkitTransitionEnd", "transitionend"], a = 0;
                a < e.length;
                a += 1
              ) {
                i.trigger(e[a]);
              }
            }
          });
        }
      },
    },
    oe = {
      setTranslate: function setTranslate() {
        var e,
          t = this,
          a = t.$el,
          i = t.$wrapperEl,
          s = t.slides,
          r = t.width,
          n = t.height,
          l = t.rtlTranslate,
          o = t.size,
          d = t.browser,
          p = t.params.cubeEffect,
          c = t.isHorizontal(),
          u = t.virtual && t.params.virtual.enabled,
          h = 0;
        p.shadow &&
          (c
            ? (0 === (e = i.find(".swiper-cube-shadow")).length &&
                ((e = m('<div class="swiper-cube-shadow"></div>')),
                i.append(e)),
              e.css({
                height: r + "px",
              }))
            : 0 === (e = a.find(".swiper-cube-shadow")).length &&
              ((e = m('<div class="swiper-cube-shadow"></div>')), a.append(e)));

        for (var v = 0; v < s.length; v += 1) {
          var f = s.eq(v),
            g = v;
          u && (g = parseInt(f.attr("data-swiper-slide-index"), 10));
          var b = 90 * g,
            w = Math.floor(b / 360);
          l && ((b = -b), (w = Math.floor(-b / 360)));
          var y = Math.max(Math.min(f[0].progress, 1), -1),
            E = 0,
            x = 0,
            T = 0;
          g % 4 == 0
            ? ((E = 4 * -w * o), (T = 0))
            : (g - 1) % 4 == 0
            ? ((E = 0), (T = 4 * -w * o))
            : (g - 2) % 4 == 0
            ? ((E = o + 4 * w * o), (T = o))
            : (g - 3) % 4 == 0 && ((E = -o), (T = 3 * o + 4 * o * w)),
            l && (E = -E),
            c || ((x = E), (E = 0));
          var S =
            "rotateX(" +
            (c ? 0 : -b) +
            "deg) rotateY(" +
            (c ? b : 0) +
            "deg) translate3d(" +
            E +
            "px, " +
            x +
            "px, " +
            T +
            "px)";

          if (
            (y <= 1 &&
              y > -1 &&
              ((h = 90 * g + 90 * y), l && (h = 90 * -g - 90 * y)),
            f.transform(S),
            p.slideShadows)
          ) {
            var C = c
                ? f.find(".swiper-slide-shadow-left")
                : f.find(".swiper-slide-shadow-top"),
              M = c
                ? f.find(".swiper-slide-shadow-right")
                : f.find(".swiper-slide-shadow-bottom");
            0 === C.length &&
              ((C = m(
                '<div class="swiper-slide-shadow-' +
                  (c ? "left" : "top") +
                  '"></div>'
              )),
              f.append(C)),
              0 === M.length &&
                ((M = m(
                  '<div class="swiper-slide-shadow-' +
                    (c ? "right" : "bottom") +
                    '"></div>'
                )),
                f.append(M)),
              C.length && (C[0].style.opacity = Math.max(-y, 0)),
              M.length && (M[0].style.opacity = Math.max(y, 0));
          }
        }

        if (
          (i.css({
            "-webkit-transform-origin": "50% 50% -" + o / 2 + "px",
            "-moz-transform-origin": "50% 50% -" + o / 2 + "px",
            "-ms-transform-origin": "50% 50% -" + o / 2 + "px",
            "transform-origin": "50% 50% -" + o / 2 + "px",
          }),
          p.shadow)
        )
          if (c)
            e.transform(
              "translate3d(0px, " +
                (r / 2 + p.shadowOffset) +
                "px, " +
                -r / 2 +
                "px) rotateX(90deg) rotateZ(0deg) scale(" +
                p.shadowScale +
                ")"
            );
          else {
            var z = Math.abs(h) - 90 * Math.floor(Math.abs(h) / 90),
              P =
                1.5 -
                (Math.sin((2 * z * Math.PI) / 360) / 2 +
                  Math.cos((2 * z * Math.PI) / 360) / 2),
              k = p.shadowScale,
              L = p.shadowScale / P,
              $ = p.shadowOffset;
            e.transform(
              "scale3d(" +
                k +
                ", 1, " +
                L +
                ") translate3d(0px, " +
                (n / 2 + $) +
                "px, " +
                -n / 2 / L +
                "px) rotateX(-90deg)"
            );
          }
        var I = d.isSafari || d.isWebView ? -o / 2 : 0;
        i.transform(
          "translate3d(0px,0," +
            I +
            "px) rotateX(" +
            (t.isHorizontal() ? 0 : h) +
            "deg) rotateY(" +
            (t.isHorizontal() ? -h : 0) +
            "deg)"
        );
      },
      setTransition: function setTransition(e) {
        var t = this,
          a = t.$el;
        t.slides
          .transition(e)
          .find(
            ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
          )
          .transition(e),
          t.params.cubeEffect.shadow &&
            !t.isHorizontal() &&
            a.find(".swiper-cube-shadow").transition(e);
      },
    },
    de = {
      setTranslate: function setTranslate() {
        for (
          var e = this, t = e.slides, a = e.rtlTranslate, i = 0;
          i < t.length;
          i += 1
        ) {
          var s = t.eq(i),
            r = s[0].progress;
          e.params.flipEffect.limitRotation &&
            (r = Math.max(Math.min(s[0].progress, 1), -1));
          var n = -180 * r,
            l = 0,
            o = -s[0].swiperSlideOffset,
            d = 0;

          if (
            (e.isHorizontal()
              ? a && (n = -n)
              : ((d = o), (o = 0), (l = -n), (n = 0)),
            (s[0].style.zIndex = -Math.abs(Math.round(r)) + t.length),
            e.params.flipEffect.slideShadows)
          ) {
            var p = e.isHorizontal()
                ? s.find(".swiper-slide-shadow-left")
                : s.find(".swiper-slide-shadow-top"),
              c = e.isHorizontal()
                ? s.find(".swiper-slide-shadow-right")
                : s.find(".swiper-slide-shadow-bottom");
            0 === p.length &&
              ((p = m(
                '<div class="swiper-slide-shadow-' +
                  (e.isHorizontal() ? "left" : "top") +
                  '"></div>'
              )),
              s.append(p)),
              0 === c.length &&
                ((c = m(
                  '<div class="swiper-slide-shadow-' +
                    (e.isHorizontal() ? "right" : "bottom") +
                    '"></div>'
                )),
                s.append(c)),
              p.length && (p[0].style.opacity = Math.max(-r, 0)),
              c.length && (c[0].style.opacity = Math.max(r, 0));
          }

          s.transform(
            "translate3d(" +
              o +
              "px, " +
              d +
              "px, 0px) rotateX(" +
              l +
              "deg) rotateY(" +
              n +
              "deg)"
          );
        }
      },
      setTransition: function setTransition(e) {
        var t = this,
          a = t.slides,
          i = t.activeIndex,
          s = t.$wrapperEl;

        if (
          (a
            .transition(e)
            .find(
              ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
            )
            .transition(e),
          t.params.virtualTranslate && 0 !== e)
        ) {
          var r = !1;
          a.eq(i).transitionEnd(function () {
            if (!r && t && !t.destroyed) {
              (r = !0), (t.animating = !1);

              for (
                var e = ["webkitTransitionEnd", "transitionend"], a = 0;
                a < e.length;
                a += 1
              ) {
                s.trigger(e[a]);
              }
            }
          });
        }
      },
    },
    pe = {
      setTranslate: function setTranslate() {
        for (
          var e = this,
            t = e.width,
            a = e.height,
            i = e.slides,
            s = e.slidesSizesGrid,
            r = e.params.coverflowEffect,
            n = e.isHorizontal(),
            l = e.translate,
            o = n ? t / 2 - l : a / 2 - l,
            d = n ? r.rotate : -r.rotate,
            p = r.depth,
            c = 0,
            u = i.length;
          c < u;
          c += 1
        ) {
          var h = i.eq(c),
            v = s[c],
            f = ((o - h[0].swiperSlideOffset - v / 2) / v) * r.modifier,
            g = n ? d * f : 0,
            b = n ? 0 : d * f,
            w = -p * Math.abs(f),
            y = r.stretch;
          "string" == typeof y &&
            -1 !== y.indexOf("%") &&
            (y = (parseFloat(r.stretch) / 100) * v);
          var E = n ? 0 : y * f,
            x = n ? y * f : 0,
            T = 1 - (1 - r.scale) * Math.abs(f);
          Math.abs(x) < 0.001 && (x = 0),
            Math.abs(E) < 0.001 && (E = 0),
            Math.abs(w) < 0.001 && (w = 0),
            Math.abs(g) < 0.001 && (g = 0),
            Math.abs(b) < 0.001 && (b = 0),
            Math.abs(T) < 0.001 && (T = 0);
          var S =
            "translate3d(" +
            x +
            "px," +
            E +
            "px," +
            w +
            "px)  rotateX(" +
            b +
            "deg) rotateY(" +
            g +
            "deg) scale(" +
            T +
            ")";

          if (
            (h.transform(S),
            (h[0].style.zIndex = 1 - Math.abs(Math.round(f))),
            r.slideShadows)
          ) {
            var C = n
                ? h.find(".swiper-slide-shadow-left")
                : h.find(".swiper-slide-shadow-top"),
              M = n
                ? h.find(".swiper-slide-shadow-right")
                : h.find(".swiper-slide-shadow-bottom");
            0 === C.length &&
              ((C = m(
                '<div class="swiper-slide-shadow-' +
                  (n ? "left" : "top") +
                  '"></div>'
              )),
              h.append(C)),
              0 === M.length &&
                ((M = m(
                  '<div class="swiper-slide-shadow-' +
                    (n ? "right" : "bottom") +
                    '"></div>'
                )),
                h.append(M)),
              C.length && (C[0].style.opacity = f > 0 ? f : 0),
              M.length && (M[0].style.opacity = -f > 0 ? -f : 0);
          }
        }
      },
      setTransition: function setTransition(e) {
        this.slides
          .transition(e)
          .find(
            ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
          )
          .transition(e);
      },
    },
    ce = {
      init: function init() {
        var e = this,
          t = e.params.thumbs;
        if (e.thumbs.initialized) return !1;
        e.thumbs.initialized = !0;
        var a = e.constructor;
        return (
          t.swiper instanceof a
            ? ((e.thumbs.swiper = t.swiper),
              C(e.thumbs.swiper.originalParams, {
                watchSlidesProgress: !0,
                slideToClickedSlide: !1,
              }),
              C(e.thumbs.swiper.params, {
                watchSlidesProgress: !0,
                slideToClickedSlide: !1,
              }))
            : S(t.swiper) &&
              ((e.thumbs.swiper = new a(
                C({}, t.swiper, {
                  watchSlidesVisibility: !0,
                  watchSlidesProgress: !0,
                  slideToClickedSlide: !1,
                })
              )),
              (e.thumbs.swiperCreated = !0)),
          e.thumbs.swiper.$el.addClass(e.params.thumbs.thumbsContainerClass),
          e.thumbs.swiper.on("tap", e.thumbs.onThumbClick),
          !0
        );
      },
      onThumbClick: function onThumbClick() {
        var e = this,
          t = e.thumbs.swiper;

        if (t) {
          var a = t.clickedIndex,
            i = t.clickedSlide;

          if (
            !(
              (i && m(i).hasClass(e.params.thumbs.slideThumbActiveClass)) ||
              null == a
            )
          ) {
            var s;

            if (
              ((s = t.params.loop
                ? parseInt(
                    m(t.clickedSlide).attr("data-swiper-slide-index"),
                    10
                  )
                : a),
              e.params.loop)
            ) {
              var r = e.activeIndex;
              e.slides.eq(r).hasClass(e.params.slideDuplicateClass) &&
                (e.loopFix(),
                (e._clientLeft = e.$wrapperEl[0].clientLeft),
                (r = e.activeIndex));
              var n = e.slides
                  .eq(r)
                  .prevAll('[data-swiper-slide-index="' + s + '"]')
                  .eq(0)
                  .index(),
                l = e.slides
                  .eq(r)
                  .nextAll('[data-swiper-slide-index="' + s + '"]')
                  .eq(0)
                  .index();
              s = void 0 === n ? l : void 0 === l ? n : l - r < r - n ? l : n;
            }

            e.slideTo(s);
          }
        }
      },
      update: function update(e) {
        var t = this,
          a = t.thumbs.swiper;

        if (a) {
          var i =
              "auto" === a.params.slidesPerView
                ? a.slidesPerViewDynamic()
                : a.params.slidesPerView,
            s = t.params.thumbs.autoScrollOffset,
            r = s && !a.params.loop;

          if (t.realIndex !== a.realIndex || r) {
            var n,
              l,
              o = a.activeIndex;

            if (a.params.loop) {
              a.slides.eq(o).hasClass(a.params.slideDuplicateClass) &&
                (a.loopFix(),
                (a._clientLeft = a.$wrapperEl[0].clientLeft),
                (o = a.activeIndex));
              var d = a.slides
                  .eq(o)
                  .prevAll('[data-swiper-slide-index="' + t.realIndex + '"]')
                  .eq(0)
                  .index(),
                p = a.slides
                  .eq(o)
                  .nextAll('[data-swiper-slide-index="' + t.realIndex + '"]')
                  .eq(0)
                  .index();
              (n =
                void 0 === d
                  ? p
                  : void 0 === p
                  ? d
                  : p - o == o - d
                  ? o
                  : p - o < o - d
                  ? p
                  : d),
                (l = t.activeIndex > t.previousIndex ? "next" : "prev");
            } else l = (n = t.realIndex) > t.previousIndex ? "next" : "prev";

            r && (n += "next" === l ? s : -1 * s),
              a.visibleSlidesIndexes &&
                a.visibleSlidesIndexes.indexOf(n) < 0 &&
                (a.params.centeredSlides
                  ? (n =
                      n > o
                        ? n - Math.floor(i / 2) + 1
                        : n + Math.floor(i / 2) - 1)
                  : n > o && (n = n - i + 1),
                a.slideTo(n, e ? 0 : void 0));
          }

          var c = 1,
            u = t.params.thumbs.slideThumbActiveClass;
          if (
            (t.params.slidesPerView > 1 &&
              !t.params.centeredSlides &&
              (c = t.params.slidesPerView),
            t.params.thumbs.multipleActiveThumbs || (c = 1),
            (c = Math.floor(c)),
            a.slides.removeClass(u),
            a.params.loop || (a.params.virtual && a.params.virtual.enabled))
          )
            for (var h = 0; h < c; h += 1) {
              a.$wrapperEl
                .children(
                  '[data-swiper-slide-index="' + (t.realIndex + h) + '"]'
                )
                .addClass(u);
            }
          else
            for (var v = 0; v < c; v += 1) {
              a.slides.eq(t.realIndex + v).addClass(u);
            }
        }
      },
    },
    ue = [
      _,
      j,
      {
        name: "mousewheel",
        params: {
          mousewheel: {
            enabled: !1,
            releaseOnEdges: !1,
            invert: !1,
            forceToAxis: !1,
            sensitivity: 1,
            eventsTarget: "container",
            thresholdDelta: null,
            thresholdTime: null,
          },
        },
        create: function create() {
          M(this, {
            mousewheel: {
              enabled: !1,
              lastScrollTime: x(),
              lastEventBeforeSnap: void 0,
              recentWheelEvents: [],
              enable: U.enable,
              disable: U.disable,
              handle: U.handle,
              handleMouseEnter: U.handleMouseEnter,
              handleMouseLeave: U.handleMouseLeave,
              animateSlider: U.animateSlider,
              releaseScroll: U.releaseScroll,
            },
          });
        },
        on: {
          init: function init(e) {
            !e.params.mousewheel.enabled &&
              e.params.cssMode &&
              e.mousewheel.disable(),
              e.params.mousewheel.enabled && e.mousewheel.enable();
          },
          destroy: function destroy(e) {
            e.params.cssMode && e.mousewheel.enable(),
              e.mousewheel.enabled && e.mousewheel.disable();
          },
        },
      },
      {
        name: "navigation",
        params: {
          navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: !1,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
          },
        },
        create: function create() {
          M(this, {
            navigation: t({}, K),
          });
        },
        on: {
          init: function init(e) {
            e.navigation.init(), e.navigation.update();
          },
          toEdge: function toEdge(e) {
            e.navigation.update();
          },
          fromEdge: function fromEdge(e) {
            e.navigation.update();
          },
          destroy: function destroy(e) {
            e.navigation.destroy();
          },
          click: function click(e, t) {
            var a = e.navigation,
              i = a.$nextEl,
              s = a.$prevEl,
              r = t.target;

            if (e.params.navigation.hideOnClick && !m(r).is(s) && !m(r).is(i)) {
              if (
                e.pagination &&
                e.params.pagination &&
                e.params.pagination.clickable &&
                (e.pagination.el === r || e.pagination.el.contains(r))
              )
                return;
              var n;
              i
                ? (n = i.hasClass(e.params.navigation.hiddenClass))
                : s && (n = s.hasClass(e.params.navigation.hiddenClass)),
                !0 === n ? e.emit("navigationShow") : e.emit("navigationHide"),
                i && i.toggleClass(e.params.navigation.hiddenClass),
                s && s.toggleClass(e.params.navigation.hiddenClass);
            }
          },
        },
      },
      {
        name: "pagination",
        params: {
          pagination: {
            el: null,
            bulletElement: "span",
            clickable: !1,
            hideOnClick: !1,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: !1,
            type: "bullets",
            dynamicBullets: !1,
            dynamicMainBullets: 1,
            formatFractionCurrent: function formatFractionCurrent(e) {
              return e;
            },
            formatFractionTotal: function formatFractionTotal(e) {
              return e;
            },
            bulletClass: "swiper-pagination-bullet",
            bulletActiveClass: "swiper-pagination-bullet-active",
            modifierClass: "swiper-pagination-",
            currentClass: "swiper-pagination-current",
            totalClass: "swiper-pagination-total",
            hiddenClass: "swiper-pagination-hidden",
            progressbarFillClass: "swiper-pagination-progressbar-fill",
            progressbarOppositeClass: "swiper-pagination-progressbar-opposite",
            clickableClass: "swiper-pagination-clickable",
            lockClass: "swiper-pagination-lock",
          },
        },
        create: function create() {
          M(this, {
            pagination: t(
              {
                dynamicBulletIndex: 0,
              },
              Z
            ),
          });
        },
        on: {
          init: function init(e) {
            e.pagination.init(), e.pagination.render(), e.pagination.update();
          },
          activeIndexChange: function activeIndexChange(e) {
            (e.params.loop || void 0 === e.snapIndex) && e.pagination.update();
          },
          snapIndexChange: function snapIndexChange(e) {
            e.params.loop || e.pagination.update();
          },
          slidesLengthChange: function slidesLengthChange(e) {
            e.params.loop && (e.pagination.render(), e.pagination.update());
          },
          snapGridLengthChange: function snapGridLengthChange(e) {
            e.params.loop || (e.pagination.render(), e.pagination.update());
          },
          destroy: function destroy(e) {
            e.pagination.destroy();
          },
          click: function click(e, t) {
            var a = t.target;

            if (
              e.params.pagination.el &&
              e.params.pagination.hideOnClick &&
              e.pagination.$el.length > 0 &&
              !m(a).hasClass(e.params.pagination.bulletClass)
            ) {
              if (
                e.navigation &&
                ((e.navigation.nextEl && a === e.navigation.nextEl) ||
                  (e.navigation.prevEl && a === e.navigation.prevEl))
              )
                return;
              !0 === e.pagination.$el.hasClass(e.params.pagination.hiddenClass)
                ? e.emit("paginationShow")
                : e.emit("paginationHide"),
                e.pagination.$el.toggleClass(e.params.pagination.hiddenClass);
            }
          },
        },
      },
      {
        name: "scrollbar",
        params: {
          scrollbar: {
            el: null,
            dragSize: "auto",
            hide: !1,
            draggable: !1,
            snapOnRelease: !0,
            lockClass: "swiper-scrollbar-lock",
            dragClass: "swiper-scrollbar-drag",
          },
        },
        create: function create() {
          M(this, {
            scrollbar: t(
              {
                isTouched: !1,
                timeout: null,
                dragTimeout: null,
              },
              J
            ),
          });
        },
        on: {
          init: function init(e) {
            e.scrollbar.init(),
              e.scrollbar.updateSize(),
              e.scrollbar.setTranslate();
          },
          update: function update(e) {
            e.scrollbar.updateSize();
          },
          resize: function resize(e) {
            e.scrollbar.updateSize();
          },
          observerUpdate: function observerUpdate(e) {
            e.scrollbar.updateSize();
          },
          setTranslate: function setTranslate(e) {
            e.scrollbar.setTranslate();
          },
          setTransition: function setTransition(e, t) {
            e.scrollbar.setTransition(t);
          },
          destroy: function destroy(e) {
            e.scrollbar.destroy();
          },
        },
      },
      {
        name: "parallax",
        params: {
          parallax: {
            enabled: !1,
          },
        },
        create: function create() {
          M(this, {
            parallax: t({}, Q),
          });
        },
        on: {
          beforeInit: function beforeInit(e) {
            e.params.parallax.enabled &&
              ((e.params.watchSlidesProgress = !0),
              (e.originalParams.watchSlidesProgress = !0));
          },
          init: function init(e) {
            e.params.parallax.enabled && e.parallax.setTranslate();
          },
          setTranslate: function setTranslate(e) {
            e.params.parallax.enabled && e.parallax.setTranslate();
          },
          setTransition: function setTransition(e, t) {
            e.params.parallax.enabled && e.parallax.setTransition(t);
          },
        },
      },
      {
        name: "zoom",
        params: {
          zoom: {
            enabled: !1,
            maxRatio: 3,
            minRatio: 1,
            toggle: !0,
            containerClass: "swiper-zoom-container",
            zoomedSlideClass: "swiper-slide-zoomed",
          },
        },
        create: function create() {
          var e = this;
          M(e, {
            zoom: t(
              {
                enabled: !1,
                scale: 1,
                currentScale: 1,
                isScaling: !1,
                gesture: {
                  $slideEl: void 0,
                  slideWidth: void 0,
                  slideHeight: void 0,
                  $imageEl: void 0,
                  $imageWrapEl: void 0,
                  maxRatio: 3,
                },
                image: {
                  isTouched: void 0,
                  isMoved: void 0,
                  currentX: void 0,
                  currentY: void 0,
                  minX: void 0,
                  minY: void 0,
                  maxX: void 0,
                  maxY: void 0,
                  width: void 0,
                  height: void 0,
                  startX: void 0,
                  startY: void 0,
                  touchesStart: {},
                  touchesCurrent: {},
                },
                velocity: {
                  x: void 0,
                  y: void 0,
                  prevPositionX: void 0,
                  prevPositionY: void 0,
                  prevTime: void 0,
                },
              },
              ee
            ),
          });
          var a = 1;
          Object.defineProperty(e.zoom, "scale", {
            get: function get() {
              return a;
            },
            set: function set(t) {
              if (a !== t) {
                var i = e.zoom.gesture.$imageEl
                    ? e.zoom.gesture.$imageEl[0]
                    : void 0,
                  s = e.zoom.gesture.$slideEl
                    ? e.zoom.gesture.$slideEl[0]
                    : void 0;
                e.emit("zoomChange", t, i, s);
              }

              a = t;
            },
          });
        },
        on: {
          init: function init(e) {
            e.params.zoom.enabled && e.zoom.enable();
          },
          destroy: function destroy(e) {
            e.zoom.disable();
          },
          touchStart: function touchStart(e, t) {
            e.zoom.enabled && e.zoom.onTouchStart(t);
          },
          touchEnd: function touchEnd(e, t) {
            e.zoom.enabled && e.zoom.onTouchEnd(t);
          },
          doubleTap: function doubleTap(e, t) {
            !e.animating &&
              e.params.zoom.enabled &&
              e.zoom.enabled &&
              e.params.zoom.toggle &&
              e.zoom.toggle(t);
          },
          transitionEnd: function transitionEnd(e) {
            e.zoom.enabled && e.params.zoom.enabled && e.zoom.onTransitionEnd();
          },
          slideChange: function slideChange(e) {
            e.zoom.enabled &&
              e.params.zoom.enabled &&
              e.params.cssMode &&
              e.zoom.onTransitionEnd();
          },
        },
      },
      {
        name: "lazy",
        params: {
          lazy: {
            checkInView: !1,
            enabled: !1,
            loadPrevNext: !1,
            loadPrevNextAmount: 1,
            loadOnTransitionStart: !1,
            scrollingElement: "",
            elementClass: "swiper-lazy",
            loadingClass: "swiper-lazy-loading",
            loadedClass: "swiper-lazy-loaded",
            preloaderClass: "swiper-lazy-preloader",
          },
        },
        create: function create() {
          M(this, {
            lazy: t(
              {
                initialImageLoaded: !1,
              },
              te
            ),
          });
        },
        on: {
          beforeInit: function beforeInit(e) {
            e.params.lazy.enabled &&
              e.params.preloadImages &&
              (e.params.preloadImages = !1);
          },
          init: function init(e) {
            e.params.lazy.enabled &&
              !e.params.loop &&
              0 === e.params.initialSlide &&
              (e.params.lazy.checkInView
                ? e.lazy.checkInViewOnLoad()
                : e.lazy.load());
          },
          scroll: function scroll(e) {
            e.params.freeMode && !e.params.freeModeSticky && e.lazy.load();
          },
          "scrollbarDragMove resize _freeModeNoMomentumRelease":
            function scrollbarDragMoveResize_freeModeNoMomentumRelease(e) {
              e.params.lazy.enabled && e.lazy.load();
            },
          transitionStart: function transitionStart(e) {
            e.params.lazy.enabled &&
              (e.params.lazy.loadOnTransitionStart ||
                (!e.params.lazy.loadOnTransitionStart &&
                  !e.lazy.initialImageLoaded)) &&
              e.lazy.load();
          },
          transitionEnd: function transitionEnd(e) {
            e.params.lazy.enabled &&
              !e.params.lazy.loadOnTransitionStart &&
              e.lazy.load();
          },
          slideChange: function slideChange(e) {
            e.params.lazy.enabled && e.params.cssMode && e.lazy.load();
          },
        },
      },
      {
        name: "controller",
        params: {
          controller: {
            control: void 0,
            inverse: !1,
            by: "slide",
          },
        },
        create: function create() {
          M(this, {
            controller: t(
              {
                control: this.params.controller.control,
              },
              ae
            ),
          });
        },
        on: {
          update: function update(e) {
            e.controller.control &&
              e.controller.spline &&
              ((e.controller.spline = void 0), delete e.controller.spline);
          },
          resize: function resize(e) {
            e.controller.control &&
              e.controller.spline &&
              ((e.controller.spline = void 0), delete e.controller.spline);
          },
          observerUpdate: function observerUpdate(e) {
            e.controller.control &&
              e.controller.spline &&
              ((e.controller.spline = void 0), delete e.controller.spline);
          },
          setTranslate: function setTranslate(e, t, a) {
            e.controller.control && e.controller.setTranslate(t, a);
          },
          setTransition: function setTransition(e, t, a) {
            e.controller.control && e.controller.setTransition(t, a);
          },
        },
      },
      {
        name: "a11y",
        params: {
          a11y: {
            enabled: !0,
            notificationClass: "swiper-notification",
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}",
            slideLabelMessage: "{{index}} / {{slidesLength}}",
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            itemRoleDescriptionMessage: null,
          },
        },
        create: function create() {
          M(this, {
            a11y: t({}, ie, {
              liveRegion: m(
                '<span class="' +
                  this.params.a11y.notificationClass +
                  '" aria-live="assertive" aria-atomic="true"></span>'
              ),
            }),
          });
        },
        on: {
          afterInit: function afterInit(e) {
            e.params.a11y.enabled && (e.a11y.init(), e.a11y.updateNavigation());
          },
          toEdge: function toEdge(e) {
            e.params.a11y.enabled && e.a11y.updateNavigation();
          },
          fromEdge: function fromEdge(e) {
            e.params.a11y.enabled && e.a11y.updateNavigation();
          },
          paginationUpdate: function paginationUpdate(e) {
            e.params.a11y.enabled && e.a11y.updatePagination();
          },
          destroy: function destroy(e) {
            e.params.a11y.enabled && e.a11y.destroy();
          },
        },
      },
      {
        name: "history",
        params: {
          history: {
            enabled: !1,
            replaceState: !1,
            key: "slides",
          },
        },
        create: function create() {
          M(this, {
            history: t({}, se),
          });
        },
        on: {
          init: function init(e) {
            e.params.history.enabled && e.history.init();
          },
          destroy: function destroy(e) {
            e.params.history.enabled && e.history.destroy();
          },
          transitionEnd: function transitionEnd(e) {
            e.history.initialized &&
              e.history.setHistory(e.params.history.key, e.activeIndex);
          },
          slideChange: function slideChange(e) {
            e.history.initialized &&
              e.params.cssMode &&
              e.history.setHistory(e.params.history.key, e.activeIndex);
          },
        },
      },
      {
        name: "hash-navigation",
        params: {
          hashNavigation: {
            enabled: !1,
            replaceState: !1,
            watchState: !1,
          },
        },
        create: function create() {
          M(this, {
            hashNavigation: t(
              {
                initialized: !1,
              },
              re
            ),
          });
        },
        on: {
          init: function init(e) {
            e.params.hashNavigation.enabled && e.hashNavigation.init();
          },
          destroy: function destroy(e) {
            e.params.hashNavigation.enabled && e.hashNavigation.destroy();
          },
          transitionEnd: function transitionEnd(e) {
            e.hashNavigation.initialized && e.hashNavigation.setHash();
          },
          slideChange: function slideChange(e) {
            e.hashNavigation.initialized &&
              e.params.cssMode &&
              e.hashNavigation.setHash();
          },
        },
      },
      {
        name: "autoplay",
        params: {
          autoplay: {
            enabled: !1,
            delay: 3e3,
            waitForTransition: !0,
            disableOnInteraction: !0,
            stopOnLastSlide: !1,
            reverseDirection: !1,
          },
        },
        create: function create() {
          M(this, {
            autoplay: t({}, ne, {
              running: !1,
              paused: !1,
            }),
          });
        },
        on: {
          init: function init(e) {
            e.params.autoplay.enabled &&
              (e.autoplay.start(),
              r().addEventListener(
                "visibilitychange",
                e.autoplay.onVisibilityChange
              ));
          },
          beforeTransitionStart: function beforeTransitionStart(e, t, a) {
            e.autoplay.running &&
              (a || !e.params.autoplay.disableOnInteraction
                ? e.autoplay.pause(t)
                : e.autoplay.stop());
          },
          sliderFirstMove: function sliderFirstMove(e) {
            e.autoplay.running &&
              (e.params.autoplay.disableOnInteraction
                ? e.autoplay.stop()
                : e.autoplay.pause());
          },
          touchEnd: function touchEnd(e) {
            e.params.cssMode &&
              e.autoplay.paused &&
              !e.params.autoplay.disableOnInteraction &&
              e.autoplay.run();
          },
          destroy: function destroy(e) {
            e.autoplay.running && e.autoplay.stop(),
              r().removeEventListener(
                "visibilitychange",
                e.autoplay.onVisibilityChange
              );
          },
        },
      },
      {
        name: "effect-fade",
        params: {
          fadeEffect: {
            crossFade: !1,
          },
        },
        create: function create() {
          M(this, {
            fadeEffect: t({}, le),
          });
        },
        on: {
          beforeInit: function beforeInit(e) {
            if ("fade" === e.params.effect) {
              e.classNames.push(e.params.containerModifierClass + "fade");
              var t = {
                slidesPerView: 1,
                slidesPerColumn: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: !0,
                spaceBetween: 0,
                virtualTranslate: !0,
              };
              C(e.params, t), C(e.originalParams, t);
            }
          },
          setTranslate: function setTranslate(e) {
            "fade" === e.params.effect && e.fadeEffect.setTranslate();
          },
          setTransition: function setTransition(e, t) {
            "fade" === e.params.effect && e.fadeEffect.setTransition(t);
          },
        },
      },
      {
        name: "effect-cube",
        params: {
          cubeEffect: {
            slideShadows: !0,
            shadow: !0,
            shadowOffset: 20,
            shadowScale: 0.94,
          },
        },
        create: function create() {
          M(this, {
            cubeEffect: t({}, oe),
          });
        },
        on: {
          beforeInit: function beforeInit(e) {
            if ("cube" === e.params.effect) {
              e.classNames.push(e.params.containerModifierClass + "cube"),
                e.classNames.push(e.params.containerModifierClass + "3d");
              var t = {
                slidesPerView: 1,
                slidesPerColumn: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: !0,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: !1,
                virtualTranslate: !0,
              };
              C(e.params, t), C(e.originalParams, t);
            }
          },
          setTranslate: function setTranslate(e) {
            "cube" === e.params.effect && e.cubeEffect.setTranslate();
          },
          setTransition: function setTransition(e, t) {
            "cube" === e.params.effect && e.cubeEffect.setTransition(t);
          },
        },
      },
      {
        name: "effect-flip",
        params: {
          flipEffect: {
            slideShadows: !0,
            limitRotation: !0,
          },
        },
        create: function create() {
          M(this, {
            flipEffect: t({}, de),
          });
        },
        on: {
          beforeInit: function beforeInit(e) {
            if ("flip" === e.params.effect) {
              e.classNames.push(e.params.containerModifierClass + "flip"),
                e.classNames.push(e.params.containerModifierClass + "3d");
              var t = {
                slidesPerView: 1,
                slidesPerColumn: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: !0,
                spaceBetween: 0,
                virtualTranslate: !0,
              };
              C(e.params, t), C(e.originalParams, t);
            }
          },
          setTranslate: function setTranslate(e) {
            "flip" === e.params.effect && e.flipEffect.setTranslate();
          },
          setTransition: function setTransition(e, t) {
            "flip" === e.params.effect && e.flipEffect.setTransition(t);
          },
        },
      },
      {
        name: "effect-coverflow",
        params: {
          coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: !0,
          },
        },
        create: function create() {
          M(this, {
            coverflowEffect: t({}, pe),
          });
        },
        on: {
          beforeInit: function beforeInit(e) {
            "coverflow" === e.params.effect &&
              (e.classNames.push(e.params.containerModifierClass + "coverflow"),
              e.classNames.push(e.params.containerModifierClass + "3d"),
              (e.params.watchSlidesProgress = !0),
              (e.originalParams.watchSlidesProgress = !0));
          },
          setTranslate: function setTranslate(e) {
            "coverflow" === e.params.effect && e.coverflowEffect.setTranslate();
          },
          setTransition: function setTransition(e, t) {
            "coverflow" === e.params.effect &&
              e.coverflowEffect.setTransition(t);
          },
        },
      },
      {
        name: "thumbs",
        params: {
          thumbs: {
            swiper: null,
            multipleActiveThumbs: !0,
            autoScrollOffset: 0,
            slideThumbActiveClass: "swiper-slide-thumb-active",
            thumbsContainerClass: "swiper-container-thumbs",
          },
        },
        create: function create() {
          M(this, {
            thumbs: t(
              {
                swiper: null,
                initialized: !1,
              },
              ce
            ),
          });
        },
        on: {
          beforeInit: function beforeInit(e) {
            var t = e.params.thumbs;
            t && t.swiper && (e.thumbs.init(), e.thumbs.update(!0));
          },
          slideChange: function slideChange(e) {
            e.thumbs.swiper && e.thumbs.update();
          },
          update: function update(e) {
            e.thumbs.swiper && e.thumbs.update();
          },
          resize: function resize(e) {
            e.thumbs.swiper && e.thumbs.update();
          },
          observerUpdate: function observerUpdate(e) {
            e.thumbs.swiper && e.thumbs.update();
          },
          setTransition: function setTransition(e, t) {
            var a = e.thumbs.swiper;
            a && a.setTransition(t);
          },
          beforeDestroy: function beforeDestroy(e) {
            var t = e.thumbs.swiper;
            t && e.thumbs.swiperCreated && t && t.destroy();
          },
        },
      },
    ];
  return W.use(ue), W;
});
/*!
 * replaceUrlParam.min.js
 */

function replaceUrlParam(t, e, n) {
  var i = new RegExp("(" + e + "=).*?(&|$)"),
    o = t;
  return (o =
    t.search(i) >= 0
      ? t.replace(i, "$1" + n + "$2")
      : o + (o.indexOf("?") > 0 ? "&" : "?") + e + "=" + n);
}
/* Code plugins */

/****************************************************************
 * CODE ajaxCart
 ****************************************************************/

!(function ($, document, window, undefined) {
  /**
   * Plugin name
   */
  var _pluginName = "ajaxCart";
  /**
   * @param $element Element Wrapping container div
   * @param options Options passed to public functions
   * @return ajaxCart_plugin
   */

  var ajaxCart_plugin = function ajaxCart_plugin($element, options) {
    // Scope it
    var self = this;
    self.$body = $("body");
    self.$element = self.$body.find("[data-ajax-cart]");
    self.xhrCount = 0; // Set default options

    var defaults = {
      cart_image_size: "100x100_crop_center",
      notification_image_size: "100x",
      onAddShowNotification: true,
      onAddShowCart: true,
      renderCart: true,
    };
    var metaOptions = self.$element.data("ajax-cart");
    self.options = $.extend({}, defaults, metaOptions);

    if ($.code.debug) {
      console.log("Init ajaxCart:", self.$element, self.options);
    } // Find containers

    self.$cartForm = self.$element.find("[data-ajax-cart-form]");
    self.$ajaxCartWrapper = self.$element.find("[data-ajax-cart-wrapper]");
    self.$ajaxCartContainerProducts = self.$ajaxCartWrapper.find(
      '[data-ajax-cart-container="products"]'
    );
    self.$ajaxCartContainerTotals = self.$ajaxCartWrapper.find(
      '[data-ajax-cart-container="totals"]'
    );
    self.$ajaxCartContainerActions = self.$ajaxCartWrapper.find(
      '[data-ajax-cart-container="actions"]'
    );
    self.$ajaxCartContainerCheckoutButton = self.$ajaxCartContainerActions.find(
      "[data-ajax-cart-checkout]"
    );
    self.$ajaxCartContainerPanels = self.$ajaxCartWrapper.find(
      '[data-ajax-cart-container="panel"]'
    );
    self.$ajaxCartContainerCartIsEmpty = self.$ajaxCartWrapper.find(
      '[data-ajax-cart-container="cart-is-empty"]'
    );
    self.$cartContainerTotals = $('[data-ajax-cart-container="totals"]');
    self.$cartContainerProducts = $('[data-ajax-cart-container="products"]'); // Warnings

    self.$ajaxCartTemplateWarnings = $(
      '[data-ajax-cart-template="warnings"]'
    ).html();
    self.$ajaxCartTemplateNotifications = $(
      '[data-ajax-cart-template="notifications"]'
    ).html();
    self.$ajaxCartTemplateProducts = self.$ajaxCartContainerProducts.children();
    self.$ajaxCartTemplateTotals = self.$ajaxCartContainerTotals.children();
    self.$ajaxCartTemplate__actions = self.$ajaxCartContainerActions.children(); // Cart counter

    self.$cartIconWrapper = $("[data-ajax-cart-icon-wrapper]");
    self.$cartIconQuantity = self.$cartIconWrapper.find(
      "[data-ajax-cart-icon-quantity]"
    ); // Free shipping selectors

    self.$handleFreeShippingProgressContainer = $(
      "[data-free-shipping-progress-container]"
    );
    self.$freeShippingProgressTextReached =
      self.$handleFreeShippingProgressContainer.find(
        "[data-free-shipping-progress-text-reached]"
      );
    self.$freeShippingProgressTextNotYetReached =
      self.$handleFreeShippingProgressContainer.find(
        "[data-free-shipping-progress-text-not-yet-reached]"
      );
    self.$freeShippingProgressAmountLeft =
      self.$handleFreeShippingProgressContainer.find(
        "[data-free-shipping-progress-amount-left]"
      );
    self.$freeShippingProgressBar =
      self.$handleFreeShippingProgressContainer.find(
        "[data-free-shipping-progress-bar]"
      ); // Free product

    self.$handleCartFreeGiftContainer = $("[data-cart-free-gift-container]");
    self.cartFreeGiftProgressPrice = parseInt(
      self.$handleCartFreeGiftContainer.data("cartFreeGiftProgressPrice")
    );
    self.$cartFreeGiftButton = self.$handleCartFreeGiftContainer.find(
      "[data-cart-free-gift-button]"
    );
    self.$freeGiftVariantId = $("[data-cart-free-gift-variant-id]");
    self.dataFreeGiftVariantId = self.$freeGiftVariantId.data(
      "cartFreeGiftVariantId"
    );
    self.$freeGiftProgressAmountLeft = $(
      "[data-free-gift-progress-amount-left]"
    );
    self.$freeGiftProgressTextNotYetReached = $(
      "[data-free-gift-progress-text-not-yet-reached]"
    );
    self.$freeGiftProgressTextReached = $(
      "[data-free-gift-progress-text-reached]"
    );
    self.$freeGiftOverlay = $("[data-free-gift-overlay]");
    self.freeGiftRemoved = localStorage.getItem("freeGiftRemoved");

    if (self.freeGiftRemoved === null) {
      self.freeGiftRemoved = false;
    }

    self.freeGiftShouldBeInCart = true; // this part can be built now dynamically to allow different free gift quantity limitations

    self.freeGiftMaxQuantity = 1; // Samples

    self.$cartSamplesWrapper = $("[data-cart-samples-wrapper]");
    self.$cartSampleContainer = $("[data-cart-sample-container]"); // Get the cart

    const _self = self;
    document.addEventListener("ajaxcart:open", function (event) {
      console.log("ajax open");
      _self.getCart(false);
    });

    self.getCart(false); // handle cart page

    self.handleCartPage();
  };
  /**
   * Handle cart page
   *
   * @return void
   * @access public
   */

  ajaxCart_plugin.prototype.handleCartPage = function () {
    var self = this; // get current url

    var currentUrl = window.location.href; // if we are on cart page

    if (currentUrl.indexOf("/cart") > -1) {
      // open side cart
      // self.openCart();
    } // Handle click events

    self.handleEvents();
  };
  /**
   * Handle events
   *
   * @return void
   * @access public
   */

  ajaxCart_plugin.prototype.handleEvents = function () {
    var self = this; // Catch click on Add to cart buttons

    self.$body.on("click", "[data-ajax-cart-add-button]", function (event) {
      event.preventDefault(); // Add product to cart

      self.addToCart($(this));
    }); // Catch click on Add to cart buttons inside ajax cart

    self.$ajaxCartWrapper.on(
      "click",
      "[data-ajax-cart-add-button]",
      function (event) {
        event.preventDefault(); // Add product to cart

        self.addToCart($(this));
      }
    ); // Catch click on Add to cart buttons inside ajax cart

    self.$ajaxCartWrapper.on("change", "[data-cart-sample]", function (event) {
      // event.preventDefault();
      self.handleFreeSamples($(this));
    }); // Prevent clickThrough on ajax cart

    self.$ajaxCartWrapper.on("click", function (event) {
      event.stopPropagation();
    }); // Catch click on quantity modifiers in ajax cart

    self.$ajaxCartContainerProducts.on(
      "click",
      "[data-ajax-cart-quantity-modifier]",
      function (event) {
        self.handleQuantityUpdate(event);
      }
    ); // Update cart order gift wrapping

    self.$ajaxCartWrapper.on(
      "change",
      "[data-ajax-cart-wrap-whole-order-as-gift]",
      function (event) {
        self.handleWrapWholeOrderAsGift(event);
      }
    ); // Update cart line item property (product gift wrapping)

    self.$ajaxCartContainerProducts.on(
      "change",
      "[data-ajax-cart-wrap-this-item-as-gift]",
      function (event) {
        self.handleWrapThisItemAsGift(event);
      }
    ); // Catch click on quantity modifiers on the cart page

    self.$body.on(
      "click",
      "[data-ajax-cart-quantity-modifier]",
      function (event) {
        self.handleQuantityUpdate(event);
      }
    ); // Catch change of quantity in ajax cart

    self.$ajaxCartContainerProducts.on(
      "change",
      "[data-ajax-cart-quantity-value]",
      function (event) {
        self.handleQuantityUpdate(event);
      }
    ); // Catch change of quantity on the cart page

    self.$body.on(
      "change",
      "[data-ajax-cart-quantity-value]",
      function (event) {
        self.handleQuantityUpdate(event);
      }
    ); // Catch click on product remove in ajax cart

    self.$ajaxCartContainerProducts.on(
      "click",
      '[data-ajax-cart-template-element="remove"]',
      function (event) {
        event.preventDefault(); // Find the product row

        var $productRow = $(this)
          .closest('[data-ajax-cart-template-element="row"]')
          .slideUp(300); // Make ajax call to remove this product

        self.removeProduct($productRow); // Slide the product out of view

        $productRow.slideUp(300, function () {
          // Remove the row
          $productRow.remove();
        });
      }
    ); // Handle adding or removing the free product from ajax cart

    self.$cartFreeGiftButton.on("click", function () {
      if (
        (self.isFreeGiftOrderable && self.isFreeGiftInCart === false) ||
        (self.isFreeGiftOrderable &&
          typeof self.isFreeGiftInCart === "undefined")
      ) {
        // Add product to cart
        self.freeGiftRemoved = false;
        localStorage.setItem("freeGiftRemoved", "false");
        self.addFreeGiftToCart(self.dataFreeGiftVariantId);
      } else if (self.isFreeGiftInCart === true) {
        // Remove product from cart when it's already in the cart
        self.freeGiftRemoved = true;
        localStorage.setItem("freeGiftRemoved", "true");
        self.removeFreeGiftFromCart(self.dataFreeGiftVariantId);
      }
    }); // Check every minute to remove the free gift when the timeslot is reached

    setInterval(function () {
      self.handleFreeGiftTimer(self.cart);
    }, 60000);
  };
  /**
   * Remove a product row
   *
   * @return void
   * @access public
   */

  ajaxCart_plugin.prototype.removeProduct = function ($row) {
    var self = this; // Set quantity input to 0

    $row.find("[data-ajax-cart-quantity-value]").val(0); // Find product id

    var variantInputId = $row.find("[data-ajax-cart-quantity-id]").val();
    var currentLineIndex = $row
      .find("[data-ajax-cart-template-element-line-index]")
      .data("ajaxCartTemplateLineIndex");
    var postData = {
      line: currentLineIndex,
      quantity: 0,
    };

    if ($.code.debug) {
      console.log("removeProduct Update ajaxCart:", postData);
    } // set parameter for postAjaxCartUpdates to true

    var remove_product = true; // Post the updates

    self.postAjaxCartUpdates(postData, remove_product);
  };
  /**
   * Show a notification of the added product
   *
   * @return void
   * @access public
   */

  ajaxCart_plugin.prototype.handleQuantityUpdate = function (event) {
    event.preventDefault();
    var self = this;
    var $trigger = $(event.currentTarget);
    var $wrapper = $trigger.closest("[data-ajax-cart-quantity-modifiers]");
    var ajaxCartTemplateElement = $trigger.closest(
      '[data-ajax-cart-template-element="row"]'
    );
    var currentLine = ajaxCartTemplateElement.find(
      "[data-ajax-cart-template-line-index]"
    );
    var deleteOnCurrentLineItem = false;

    if (currentLine.length) {
      var currentLineIndex = currentLine.data("ajaxCartTemplateLineIndex");
      deleteOnCurrentLineItem = true;
    } // Find quantity input

    var $quantityInput = $wrapper.find("[data-ajax-cart-quantity-value]");
    var $variantInput = $wrapper.find("[data-ajax-cart-quantity-id]"); // if triggered by +/- button

    if ($trigger.data("ajax-cart-quantity-modifier")) {
      // Update quantity
      var oldQuantity = parseInt($quantityInput.val()); // Quantity of 1 is minimum

      var newQuantity = Math.max(
        oldQuantity + parseInt($trigger.data("ajax-cart-quantity-modifier")),
        1
      );
      $quantityInput.val(newQuantity);
    } else {
      // if triggered by manual input
      var newQuantity = parseInt($quantityInput.val());
    } // if nothing changed

    if (newQuantity == oldQuantity) {
      return;
    }

    if ($trigger.val()) {
      var newQuantity = parseInt($trigger.val());
    }

    var postData = {
      id: $variantInput.val(),
      quantity: newQuantity,
    }; // Overwrite id based logic to line item logic

    if (deleteOnCurrentLineItem) {
      var postData = {
        line: currentLineIndex,
        quantity: newQuantity,
      };
    }

    if ($.code.debug) {
      console.log("handleQuantityUpdate Update ajaxCart:", postData);
    } // Post the form

    self.postAjaxCartUpdates(postData);
  };
  /**
   * Hand wrap whole order as gift
   * @param {*} event
   */

  ajaxCart_plugin.prototype.handleWrapWholeOrderAsGift = function (event) {
    var self = this;

    if (!event) {
      return false;
    } // Get trigger and checkbox state

    var $trigger = $(event.currentTarget);
    var currentCheckboxState = $trigger.is(":checked"); // Disable trigger

    $trigger.prop("disabled", true); // Update cart attributes

    Shopify.updateCartAttributes(
      {
        wrapWholeOrderAsGift: currentCheckboxState ? true : "",
      },
      function () {
        self.getCart();
        $trigger.prop("disabled", false);
      }
    );
  };
  /**
   * handleWrapThisItemAsGift
   * @param {*} event
   */

  ajaxCart_plugin.prototype.handleWrapThisItemAsGift = function (event) {
    var self = this;
    var $trigger = $(event.currentTarget);
    $trigger.prop("disabled", true);
    var $wrapper = $trigger.closest('[data-ajax-cart-template-element="row"]');
    var currentCheckboxState = $trigger.is(":checked");
    var currentLineItem = $wrapper
      .find("[data-ajax-cart-template-variant-id]")
      .data("ajaxCartTemplateLineIndex");
    var currentLineQuantity = $wrapper
      .find("[data-ajax-cart-quantity-value]")
      .val(); // Create postData to send to cart change

    var postData = {
      line: currentLineItem,
      quantity: currentLineQuantity,
      properties: {
        _empty: true,
      },
    };

    if (currentCheckboxState) {
      postData.properties = {
        wrapThisItemAsGift: currentCheckboxState,
      };
    } // Post it and enable button when done

    $.post("/cart/change.js", postData)
      .done(function () {
        self.getCart();
      })
      .always(function () {
        $trigger.prop("disabled", false);
      });
  };
  /**
   * Update Cart Icon Quantity
   *
   * @return void
   * @access public
   */

  ajaxCart_plugin.prototype.updateCartIconQuantity = function (newQuantity) {
    var self = this; // Update counter badge text and data attribute

    self.$cartIconQuantity
      .text(newQuantity)
      .data("ajax-cart-icon-quantity", newQuantity);
  };
  /**
   * Fill Template
   *
   * @return void
   * @access public
   */

  ajaxCart_plugin.prototype.fillTemplate = function (
    $html,
    data,
    imageSize,
    index
  ) {

    var self = this; // Update index because line items index counts from 1

    index = index + 1; // Fill data in template

    var dataTitle = "";

    if (data.title) {
      // Strip [prefix]
      dataTitle = data.title.replace(/ *\[[^)]*\] */g, " ").trim();
    } // Target and update with new data

    var item_name = data.product_title;
    var v_opt = document.querySelector(`#product-v-select option[data-id="${data.variant_id}"]`);
    if(v_opt) {
      item_name = v_opt.dataset.mfTitle || item_name;
    }
    
    $html
      .find('[data-ajax-cart-template-element="variant_id"]')
      .attr("data-ajax-cart-template-line-index", index);
    $html
      .find('[data-ajax-cart-template-element="variant_id"]')
      .attr("data-ajax-cart-template-variant-id", data.variant_id);
    $html
      .find('[data-ajax-cart-template-element="title"]')
      .html(item_name);
    $html
      .find('[data-ajax-cart-template-element="variant-title"]')
      .html(data.variant_title);
    $html
      .find('[data-ajax-cart-template-element="warning"]')
      .html(data.warning);
    $html
      .find('[data-ajax-cart-template-element="quantity"]')
      .html(data.quantity);
    $html.find('[data-ajax-cart-template-element="vendor"]').html(data.vendor);
    $html
      .find('[data-ajax-cart-template-element="item-link"]')
      .attr("href", data.url);
    $html
      .find('[data-ajax-cart-template-element="remove"]')
      .attr("href", "/cart/change?quantity=0&id=" + data.id);
    $html
      .find('[data-ajax-cart-template-element="remove"]')
      .attr("data-datalayer-remove-from-cart", data.variant_id);
    if(data.properties) {
      for(var p in data.properties) {
        if(p == 'Preorder') {
          $html
          .find('[data-ajax-cart-template-element="preorder"]')
          .html(p);
        }
        else if(p == 'Shipping Note') {
          $html
          .find('[data-ajax-cart-template-element="shipping_note"]')
          .html(data.properties[p]);    
        }
      }
      // if((Object.keys(data.properties)).includes('Preorder')) {
      //   $html
      //   .find('[data-ajax-cart-template-element="preorder"]')
      //   .html('Preorder');
      // }
      // console.log(data.properties);
      // if((Object.keys(data.properties)).includes('Shipping Note')) {
      //   $html
      //   .find('[data-ajax-cart-template-element="shipping_note"]')
      //   .html('Preorder');
      // }
    }
    if (data.original_price > data.final_price) {
      $html
        .find('[data-ajax-cart-template-element="old_price"]')
        .html(Shopify.formatMoney(data.original_price));
    }
    if (data.final_price > 0) {
      $html
        .find('[data-ajax-cart-template-element="price"]')
        .html(Shopify.formatMoney(data.final_price));
    } else {
      $html.find('[data-ajax-cart-template-element="price"]').html("FREE ");
      if (data?.properties) {
        if ('_gwp_enabled' in data.properties) {
          $html.addClass("cart-gwp-product");
        }
      }
      $html.addClass("ajax-cart-free-product");
    }
    $html.find("[data-ajax-cart-quantity-value]").val(data.quantity);
    $html.find("[data-ajax-cart-quantity-id]").attr("value", data.variant_id);

    if (data.properties && data.properties?.Promo) {
      $html.addClass("hidden");
    }

    // if (data?.handle?.indexOf('sample') > -1 || data?.handle?.indexOf('Sample') > -1) {
    //   $html.addClass('hidden');
    // }

    if (data.properties && data.properties.wrapThisItemAsGift == "true") {
      $html
        .find("[data-ajax-cart-wrap-this-item-as-gift]")
        .prop("checked", true);
    } else if (
      data.properties &&
      data.properties.wrapThisItemAsGift == "false"
    ) {
      $html
        .find("[data-ajax-cart-wrap-this-item-as-gift]")
        .prop("checked", false);
    } // Hide some elements when the price is 0

    if (data.price === 0) {
      $html.find("[data-ajax-cart-quantity-modifiers]").addClass("hidden");
    } // Disable -button when quantity = 1

    if (data.quantity == 1) {
      $html
        .find('[data-ajax-cart-quantity-modifier="-1"]')
        .prop("disabled", true);
    } // Resize the image

    if (data.image) {
      var newSrc = Shopify.resizeImage(data.image, imageSize);
      $html
        .find('[data-ajax-cart-template-element="image"] img')
        .attr("src", newSrc)
        .attr("alt", dataTitle)
        .attr("title", dataTitle);
    }

    return $html;
  };
  /**
   * Show cart warning
   *
   * @return void
   * @access public
   */

  ajaxCart_plugin.prototype.showWarning = function (warning) {
    var self = this; // Close currently opened fancybox (like Quickshops etc)

    $.fancybox.close(); // Create the warning (must be wrapped in a single div for fancyBox)

    var warning_html = warning
      .replace("All 1 ", "All ")
      .replace("[", "- ")
      .replace("]", "");
    var warningObj = {
      warning: warning_html,
    }; // Clone the warning template

    var $html = $(self.$ajaxCartTemplateWarnings).clone(); // Fill the template with data

    var $response_html = self.fillTemplate(
      $html,
      warningObj,
      self.options.notification_image_size
    ); // Show the notification

    $.fancybox.open($response_html, {
      hash: false,
      touch: false,
      baseClass: "ajax-cart-warning-popup",
    });
  };
  /**
   * Handle Google Analytics datalayer event
   *
   * @return void
   * @access public
   * @param {Object} product_variant
   * @param {String} event_name
   * @param {Boolean} remove_complete_product
   */

  ajaxCart_plugin.prototype.handleTrackingEvent = function (
    product_variant,
    event_name,
    remove_complete_product
  ) {
    // Needed when removing the product when there is a free gift enabled
    if (product_variant == null) {
      return;
    }

    $.ajax({
      url: "".concat(product_variant.url, "&view=ajax"),
      type: "GET",
      error: function error(_error) {
        if ($.code.debug) {
          console.log("handleTrackingEvent GET product error:", _error);
        }
      },
    }).done(function (product_data) {
      if ($.code.debug) {
        console.log(
          "handleTrackingEvent Get product success:",
          JSON.parse(product_data)
        );
      } // parse the received product data

      var parsed_data = JSON.parse(product_data); // create datalayer object
      var item = parsed_data.current_product_data;

      var item_name = parsed_data.product_data.title;
      var v_opt = document.querySelector(`#product-v-select option[data-id="${item.id}"]`);
      if(v_opt) {
        item_name = v_opt.dataset.mfTitle || item_name;
      }

      var products = [
        {
          item_name: item_name,
          item_id: item.barcode,
          price:
            item.compare_at_price != null && item.compare_at_price > item.price
              ? Shopify.formatMoney(item.compare_at_price, "{{amount}}")
              : Shopify.formatMoney(item.price, "{{amount}}"),
          item_brand: parsed_data.product_data.vendor,
          quantity: remove_complete_product ? product_variant.quantity : 1,
          item_category: parsed_data.product_data.type,
          item_variant: item.id,
          currency: Shopify.currency.active,
          discount:
            item.compare_at_price != null && item.compare_at_price > item.price
              ? Shopify.formatMoney(
                  item.compare_at_price - item.price,
                  "{{amount}}"
                )
              : "0.0",
        },
      ];

      let item_data = products[0];

      var data = {
        event: event_name,
        ecommerce: {
          currency: Shopify.currency.active,
          value: item_data.price || 0,
          items: products,
        },
      }; // push the datalayer

      console.log("ATC datalayer --- ", event_name);
      console.log(data);

      if ($.code.debug) {
        console.log("handleTrackingEvent datalayer push:", data);
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push(data);
      setTimeout(() => {
        if (event_name == 'add_to_cart' && window.location.href.indexOf("/cart") > -1) {
          window.location.reload();
        }
      }, 1000)
    });
  };
  /**
   * Add product to cart
   *
   * @return void
   * @access public
   */

  ajaxCart_plugin.prototype.addToCart = function ($el) {
    var self = this; // Find the form

    var $form = $el.closest("form");
    var orderedQuantity = $form.find("[data-ajax-cart-quantity]").val();

    if (isNaN(parseFloat(orderedQuantity))) {
      return;
    }

    self.freeGiftShouldBeInCart = true;
    var addData = $form.serialize();

    if ($.code.debug) {
      console.log("Add to Cart:", addData, orderedQuantity);
    }

    self.handleAddToCart(addData);
  };
  /**
   * Handle add to cart Ajax
   *
   * @return void
   * @access public
   */

  ajaxCart_plugin.prototype.handleAddToCart = function (addData) {
    var self = this; // Sequence number for the current invocation of function

    var seqNumber = ++self.xhrCount;

    $.ajax({
      url: "/cart/add.js",
      type: "POST",
      data: addData,
      dataType: "json",
      beforeSend: function beforeSend() {
        if ($.code.debug) {
          console.log("Send to Cart: " + seqNumber, addData);
        }
      },
      error: function error(XMLHttpRequest) {
        if ($.code.debug) {
          console.log("Add to Cart error:", XMLHttpRequest);
        } // Show a warning

        var responseJSON = XMLHttpRequest.responseJSON; // self.showWarning(responseJSON.description);
      },
    })
      .done(function (data) {
        self.setDeleteFreeGiftTimer();

        if ($.code.debug) {
          console.log("Add to Cart " + seqNumber + " success:", data);
        } // If this is the last ajax Call

        if (seqNumber === self.xhrCount) {
          // handle Google Analytics event tracking

          self.handleTrackingEvent(data, "add_to_cart"); // Store the added product to Shopify global cart object

          var returnedData = $.grep(
            window.cart.cartItems,
            function (element, index) {
              return element.id === data.id;
            }
          );

          if (returnedData.length > 0) {
            returnedData[0].quantity = returnedData[0].quantity + 1;
          } else {
            window.cart.cartItems.push(data);
          } // Show the notification

          self.openCart();
        }
      })
      .always(function (data) {
        // If ( $.code.debug ) { console.log( 'Add to Cart always:', data ); }
        if (seqNumber === self.xhrCount) {
          // Get the cart
          self.getCart(self.options.onAddShowCart);
        }
      });
  };
  /**
   * Hides the free samples ui.
   */

  ajaxCart_plugin.prototype.hideFreeSamples = function () {
    var self = this;
    self.$cartSamplesWrapper.hide();
  };
  /**
   * Show the free samples ui.
   */

  ajaxCart_plugin.prototype.showFreeSamples = function () {
    var self = this;
    self.$cartSamplesWrapper.show();
  };

  ajaxCart_plugin.prototype.hideFreeShipping = function () {
    var self = this;
    self.$handleFreeShippingProgressContainer
      .closest(".ajax-cart-panel")
      .hide();
  };

  ajaxCart_plugin.prototype.showFreeShipping = function () {
    var self = this;
    self.$handleFreeShippingProgressContainer
      .closest(".ajax-cart-panel")
      .show();
  };
  /**
   * Check and update UI based on digital gift card
   */

  ajaxCart_plugin.prototype.checkIfDigitalGiftCardIsInCart = function () {
    var self = this;

    if ($.code.debug) {
      console.log("checkIfDigitalGiftCardIsInCart checkpoint");
    } // Set default gift cart counter

    var countGiftCardProducts = 0; // Set default to false

    var cartContainsSample = false; // Collect sample variantIds

    var $allSamples = self.$cartSampleContainer.find('input[type="checkbox"]');
    var sampleVariantIds = [];
    var sampleVariantIdToDelete = ""; // Fill with possible sample variantIds in cart

    for (var i = 0; i < $allSamples.length; i++) {
      var sampleVariantId = parseInt($allSamples[i].value);
      sampleVariantIds.push(sampleVariantId);
    } // Check all items in cart

    self.cart.items.forEach(function (item) {
      // Check if the product is a gift card
      if (item.properties !== null) {
        // Look for the set or empty gift_card key in properties
        if ("gift_card_from_name" in item.properties) {
          countGiftCardProducts = countGiftCardProducts + 1;
        }
      }

      if (sampleVariantIds.length > 0) {
        // Check if product id is sample variant id
        if (sampleVariantIds.includes(item.variant_id)) {
          cartContainsSample = true;
          sampleVariantIdToDelete = item.variant_id;
        }
      }
    }); // Add 1 for the sample so the ui updates

    if (cartContainsSample) {
      countGiftCardProducts = countGiftCardProducts + 1;
    } // Debug gift card count

    if ($.code.debug) {
      console.log("self.cart.items.length " + self.cart.items.length);
      console.log("countGiftCardProducts " + countGiftCardProducts);
      console.log("sampleVariantIdToDelete " + sampleVariantIdToDelete);
    } // Check if we have a least 1 gift card product, and check the total cart items length with the total giftcard products

    if (
      countGiftCardProducts > 0 &&
      countGiftCardProducts == self.cart.items.length
    ) {
      self.hideFreeShipping();
      self.hideFreeSamples(); // Check if we have sampleVariantId to delete

      if (sampleVariantIdToDelete != "") {
        // Find checked variantId checkbox
        var sampleCheckbox = $(
          'input[name="sample"][value="' + sampleVariantIdToDelete + '"]'
        ); // Trigger event to uncheck product

        sampleCheckbox.trigger("click");
      }
    } else {
      self.showFreeShipping();
      self.showFreeSamples();
    }
  };
  /**
   *
   * @param {*} cart
   */

  ajaxCart_plugin.prototype.handleFreeShipping = function (cart) {
    var self = this; // Read the free shipping price from data attribute

    var freeShippingPrice = self.$handleFreeShippingProgressContainer.data(
      "free-shipping-progress-price"
    ); // From cents to €

    var percentage =
      ((cart.total_price / 100) * 100) / (freeShippingPrice / 100); // Price difference

    var priceDifference = (freeShippingPrice - cart.total_price) / 100; // Prevent negative amount

    if (priceDifference <= 0) {
      priceDifference = 0;
    }

    if (freeShippingPrice > 0) {
      self.updateFreeShippingProgressBar(
        percentage,
        priceDifference,
        freeShippingPrice
      );
    } else {
      self.updateFreeShippingProgressBar(0, priceDifference, freeShippingPrice);
    }
  };
  /**
   *
   * @param {*} percentage
   * @param {*} priceDifference
   */

  ajaxCart_plugin.prototype.updateFreeShippingProgressBar = function (
    percentage,
    priceDifference,
    freeShippingPrice
  ) {
    var self = this; // Check percentage result
    const amountLeft = freeShippingPrice / 100 - priceDifference;
    if (percentage >= 100) {
      // Set the percentage back to 100%
      percentage = 100; // Toggle text

      self.$freeShippingProgressTextReached.removeClass("hidden");
      self.$freeShippingProgressTextNotYetReached.addClass("hidden");
    } else {
      // Toggle text
      self.$freeShippingProgressTextReached.addClass("hidden");
      self.$freeShippingProgressTextNotYetReached.removeClass("hidden");
    } // Update the remaining amount untill free product

    var currencySymbol = theme.moneyFormat.split("{")[0];
    self.$freeShippingProgressAmountLeft.text(currencySymbol + priceDifference); // Update the width of the progress-bar
    var dataFreeInfo = document.querySelector("[data-free-shipping-progress-amount-left-to-free]");
    if (dataFreeInfo) {
      dataFreeInfo.innerText = currencySymbol + priceDifference;
    }
    self.$freeShippingProgressBar
.css("width", percentage + "%").attr("aria-valuenow", percentage);
  };
  /**
   * Update wrap whole order as gift
   * @param {object} cart
   * @returns void
   */

  ajaxCart_plugin.prototype.updateWrapWholeOrderAsGift = function (cart) {
    var self = this;

    if (!cart || !cart.attributes) {
      return false;
    }

    var $checkbox = self.$ajaxCartWrapper.find(
      "[data-ajax-cart-wrap-whole-order-as-gift]"
    ); // Update checkbox

    if ($checkbox.length >= 1) {
      var _cart$attributes;

      if (
        ((_cart$attributes = cart.attributes) === null ||
        _cart$attributes === void 0
          ? void 0
          : _cart$attributes.wrapWholeOrderAsGift) == "true"
      ) {
        $checkbox.prop("checked", true);
      } else {
        $checkbox.removeAttr("checked");
      }
    }
  };
  /**
   * Handles the free gift logic
   *
   * @param {object} cart
   * @returns void
   */

  ajaxCart_plugin.prototype.handleFreeGiftWithPurchase = function (cart) {
    var self = this; // Free Gift with Purchase Discount

    var fgwpDiscount = window.theme.fgwpDiscount || {};

    if (fgwpDiscount.enabled || fgwpDiscount.admin) {
      var targetVariantInCart = cart.items.findIndex(
        (i) => i.id.toString() === fgwpDiscount.target_variant_id.toString()
      );
      var targetVariantYInCart = null;
      if(fgwpDiscount.target_variant_y_id != null) {
        targetVariantYInCart = cart.items.findIndex(
          (i) => i.id.toString() === fgwpDiscount.target_variant_y_id.toString()
        );
      }
      var freeVariantInCart = cart.items.findIndex(
        (i) => i.id.toString() === fgwpDiscount.free_variant_id.toString()
      );

      if(targetVariantYInCart == null) {
        if (targetVariantInCart > -1 && freeVariantInCart < 0) {
          self.handleAddToCart("quantity=1&id=" + fgwpDiscount.free_variant_id);
        }
      }
      else {
        if (targetVariantInCart > -1 && targetVariantYInCart > -1 && freeVariantInCart < 0) {
          self.handleAddToCart("quantity=1&id=" + fgwpDiscount.free_variant_id);
        }
      }
    }
  };
  /**
   *
   * @param {*} cart
   */

  ajaxCart_plugin.prototype.handleFreeGift = function (cart) {
    var self = this;
    var freeGiftPrice = self.cartFreeGiftProgressPrice;
    var currentTotalPrice = cart.total_price; // Calculate the price difference between the current and set free product progress price

    var priceDifference = (freeGiftPrice - currentTotalPrice) / 100; // Prevent negative amount

    if (priceDifference <= 0) {
      priceDifference = 0;
    } // Update the remaining amount untill free product

    var currencySymbol = theme.moneyFormat.split("{")[0];
    self.$freeGiftProgressAmountLeft.text(currencySymbol + priceDifference);

    if (isNaN(priceDifference)) {
      return false;
    } // Check the price difference so we know when to enable or disable the free product

    if (priceDifference == 0) {
      // if free gift was not removed before by the user
      if (self.freeGiftRemoved == false) {
        self.freeGiftShouldBeInCart = true;
      }

      if (self.freeGiftShouldBeInCart == true) {
        // Add free product to cart when we have the free product variant id and the free product is not inside the cart
        self.$freeGiftProgressTextNotYetReached.addClass("hidden");
        self.$freeGiftProgressTextReached.removeClass("hidden");
        self.$freeGiftOverlay.addClass("cart-item-overlay--hidden"); // enable the switch

        if (self.dataFreeGiftVariantId) {
          self.enableFreeGift();
        }
      }
    } else {
      self.$freeGiftProgressTextNotYetReached.removeClass("hidden");
      self.$freeGiftProgressTextReached.addClass("hidden");
      self.$freeGiftOverlay.removeClass("cart-item-overlay--hidden"); // Remove free product from cart when the percentage is lower and the free product is still orderable or inside the cart

      if (self.dataFreeGiftVariantId) {
        self.disableFreeGift(self.dataFreeGiftVariantId);
      }
    }
  };
  /**
   * Sets and overwrites setDeleteFreeGiftTimer in localStorage, used for reference when comparing time in milliseconds
   * @returns void
   */

  ajaxCart_plugin.prototype.setDeleteFreeGiftTimer = function () {
    var self = this; // Get and set the Date.now in localStorage

    var milliseconds = Date.now();
    localStorage.setItem("setDeleteFreeGiftTimer", milliseconds);

    if ($.code.debug) {
      console.log("setDeleteFreeGiftTimer", milliseconds);
    }
  };
  /**
   * Compares and delete the free gift when the time difference is reached
   * @param {object} cart
   */

  ajaxCart_plugin.prototype.handleFreeGiftTimer = function (cart) {
    var self = this; // Get now in milliseconds

    var milliseconds = Date.now(); // Calculate offset

    var offsetInMinutes = 15;
    var offsetInMilliseconds = offsetInMinutes * 60000;
    var timestamp = parseInt(localStorage.getItem("setDeleteFreeGiftTimer")); // Just in case it's not valid or set

    if (isNaN(timestamp)) {
      return;
    }

    if ($.code.debug) {
      console.log("Now in milliseconds", milliseconds);
      console.log("offsetInMinutes", offsetInMinutes);
      console.log("timestamp", timestamp);
      console.log("offsetInMilliseconds", offsetInMilliseconds);
    } // Based on latest time plus the offset

    var timestamp = timestamp + offsetInMilliseconds; // Delete the product from cart when the timestamp has passed the

    if (milliseconds > timestamp) {
      // Loop cart.items
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i]; // Check if item has the property we are looking for, if so delete

        if (item.properties != null) {
          if ("_free_gift_product" in item.properties) {
            var freeItemProperty = item.properties._free_gift_product;

            if (typeof freeItemProperty !== "undefined") {
              self.removeFreeGiftFromCart(item.variant_id, true);
            }
          }
        }
      }
    }
  };
  /**
   * enables the option to add a free product.
   */

  ajaxCart_plugin.prototype.enableFreeGift = function () {
    var self = this;
    self.isFreeGiftOrderable = true; // Enable button

    self.$cartFreeGiftButton.prop("disabled", false);
    self.$cartFreeGiftButton.removeClass("hidden");

    if ($.code.debug) {
      console.log("self.cart", self.cart);
    }

    var freeGiftShouldBeAdded = true; // loop trough cart items and check if free gift should not be added

    $(self.cart.items).each(function (i, value) {
      // check if free gift id
      if (value.id == self.dataFreeGiftVariantId) {
        // get properties
        var itemProperties = value.properties;
        $(itemProperties).each(function (i, property) {
          // check if property is defined
          var freeItemProperty = property._free_gift_product;

          if (typeof freeItemProperty !== "undefined") {
            freeGiftShouldBeAdded = false;
          }
        });
      }
    });

    if ($.code.debug) {
      console.log("Free gift should be added:", freeGiftShouldBeAdded);
    } // Add free gift

    if (freeGiftShouldBeAdded && !self.freeGiftRemoved) {
      self.addFreeGiftToCart(self.dataFreeGiftVariantId);
    }
  };
  /**
   * Disables the option to add the free gift.
   * @param {*} variant_id
   */

  ajaxCart_plugin.prototype.disableFreeGift = function (variant_id) {
    var self = this;
    self.isFreeGiftOrderable = false; // Disable free product button

    self.$cartFreeGiftButton.prop("disabled", true);
    self.$cartFreeGiftButton.addClass("hidden");
    var freeGiftShouldBeRemoved = false; // loop trough cart items and check if free gift should not be added

    $(self.cart.items).each(function (i, value) {
      // check if free gift id
      if (value.id == self.dataFreeGiftVariantId) {
        // get properties
        var itemProperties = value.properties;
        $(itemProperties).each(function (i, property) {
          // check if property is defined
          var freeItemProperty = property._free_gift_product;

          if (typeof freeItemProperty !== "undefined") {
            freeGiftShouldBeRemoved = true;
          }
        });
      }
    });

    if ($.code.debug) {
      console.log("Free gift should be removed:", freeGiftShouldBeRemoved);
    } // Remove free product if it's still there

    if (freeGiftShouldBeRemoved) {
      self.removeFreeGiftFromCart(variant_id);
    }
  };
  /**
   * @description Update free product ui state when the product is already in cart.
   */

  ajaxCart_plugin.prototype.toggleFreeGiftIsAlreadyInCart = function () {
    var self = this;

    if (self.isFreeGiftInCart) {
      self.$cartFreeGiftButton.addClass("checked");
      self.$cartFreeGiftButton.removeClass("hidden");
    } else {
      self.$cartFreeGiftButton.removeClass("checked"); // self.$cartFreeGiftButton.addClass("hidden");
    }
  };
  /**
   * addFreeGiftToCart
   * @description Adds free product to cart and updates the state.
   * @param {*} variant_id
   */

  ajaxCart_plugin.prototype.addFreeGiftToCart = function (variant_id) {
    var self = this; // create new array

    var items = []; // create new item object

    var item = {
      quantity: 1,
      id: variant_id,
      properties: {
        _free_gift_product: self.freeGiftMaxQuantity,
      },
    }; // push to array

    items.push(item); // disable free gift toggle button

    self.$cartFreeGiftButton.prop("disabled", true); // Create or update the free product and update the attribute to check on

    $.post("/cart/add.json", {
      items: items,
    }).done(function (response) {
      self.setDeleteFreeGiftTimer(); // Update free product button state

      self.toggleFreeGiftIsAlreadyInCart(); // render cart

      self.getCart();
    });
  };
  /**
   * removeFreeGiftFromCart
   * @description removes the free product from the cart and handles some ui state
   * @param {*} variant_id
   */

  ajaxCart_plugin.prototype.removeFreeGiftFromCart = function (
    variant_id,
    reload
  ) {
    var self = this; // disable free gift toggle button

    self.$cartFreeGiftButton.prop("disabled", true);
    var newItemData = {
      id: variant_id,
      quantity: 0,
    };
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: newItemData,
      dataType: "json",
    }).done(function () {
      // Free product is now not in cart
      self.isFreeGiftInCart = false; // free should not be in the cart

      self.freeGiftShouldBeInCart = false; // Update free product ui state

      self.toggleFreeGiftIsAlreadyInCart(); // update the cart

      self.getCart();

      if (reload) {
        window.location.reload();
      }
    });
  };
  /**
   *
   * @param {*} $el
   */

  ajaxCart_plugin.prototype.handleFreeSamples = function ($el) {
    var self = this; // Current

    var sampleVariantId = $el.val();
    var sampleIdSelector = $el.attr("id"); // Deselect other checkboxes

    var $allButSelectedSamples = self.$cartSampleContainer.find(
      'input:checked:not("#' + sampleIdSelector + '")'
    );
    $allButSelectedSamples.prop("checked", false); // alle items loopen check if checked set 0 or 1;

    var $allSamples = self.$cartSampleContainer.find('input[type="checkbox"]'); // Create object

    var data = {}; // Go over all the samples and add the variant id to the data object

    for (var i = 0; i < $allSamples.length; i++) {
      var sample = $allSamples[i];
      var sampleVariantId = $allSamples[i].value;
      var sampleCheckBoxState = sample.checked; // Set the quantity of the sample based on checked or unchecked

      if (sampleCheckBoxState) {
        data[sampleVariantId] = 1;
      } else {
        data[sampleVariantId] = 0;
      }
    }

    cart.cartItems.map((item) => {
      if (item.variant_id != sampleVariantId) {
        data[item.variant_id] = item.quantity;
      }
    });

    if ($.code.debug) {
      console.log("handleFreeSamples data", data);
    } // send updates

    $.ajax({
      type: "POST",
      url: "/cart/clear.js",
      success: function () {
        $.post("/cart/update.json", {
          updates: data,
        }).done(function () {
          self.getCart();
        });
      },
      dataType: "json",
    });
  };
  /**
   * Post cart updates;
   *
   * @return void
   * @access public
   */

  ajaxCart_plugin.prototype.postAjaxCartUpdates = function (newItemData) {
    var remove_product =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var self = this; // Sequence number for the current invocation of function

    var seqNumber = ++self.xhrCount;
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: newItemData,
      dataType: "json",
      success: function success(cart) {
        // If this is the last ajax Call
        if (seqNumber === self.xhrCount) {
          // Google Analytics datalayer logic
          // check if stored cart has same length as the new cart data
          // then we know there was an update on the quantity of one of the items
          if (cart.items.length === window.cart.cartItems.length) {
            var changed_line_item;
            var datalayer_event_name;
            var line_item; // find the line item that was changed

            for (var i = 0; i < cart.items.length; i++) {
              var newCartItem = cart.items[i];
              changed_line_item = window.cart.cartItems.filter(function (
                cartItem
              ) {
                return (
                  cartItem.variant_id === newCartItem.id &&
                  cartItem.quantity != newCartItem.quantity
                );
              }); // keep looping until changed_line_item is found

              if (changed_line_item.length) {
                // set datalayer event name based on the quantity difference of the changed_line_item
                datalayer_event_name =
                  changed_line_item[0].quantity < newCartItem.quantity
                    ? "add_to_cart"
                    : "remove_from_cart";
                break;
              }
            }

            if (changed_line_item.length) {
              // handle Google Analytics event tracking
              line_item = changed_line_item[0];
              self.handleTrackingEvent(line_item, datalayer_event_name);
            } // check if the complete product should be removed with all product quantity
          } else if (remove_product) {
            datalayer_event_name = "remove_from_cart";
            line_item = window.cart.cartItems[newItemData.line - 1]; // handle Google Analytics event tracking

            self.handleTrackingEvent(
              line_item,
              datalayer_event_name,
              remove_product
            );
          } // update the global stored cart items

          window.cart.cartItems = cart.items;
          var cartItemQuantity = 0; // Loop all cart items from the received cart object

          Object.keys(cart.items).forEach(function (itemKey, itemIndex) {
            // If this is the item that was updated
            if (cart.items[itemKey].id == newItemData.id) {
              // Store the new data for this item
              cartItemQuantity = cart.items[itemKey].quantity;
            }
          }); // If item quantity was updated as expected

          if (cartItemQuantity == newItemData.quantity) {
            if ($.code.debug) {
              console.log("Cart update " + seqNumber + " success:", cart);
            }

            self.updateCarts(cart); // If item quantity did not update, it's because there was not enough inventory
          } else {
            if ($.code.debug) {
              console.log(
                "Cart update failed: " +
                  newItemData.id +
                  " expected quantity: " +
                  newItemData.quantity +
                  ", but got: " +
                  cartItemQuantity
              );
            } // Add the product to trigger the default message from Shopify

            self.handleAddToCart("quantity=1&id=" + newItemData.id);
          }
        }
        var cartFreeSampleItemArr = [];
        for (const item of document.querySelectorAll('[data-ajax-cart-template-element="price"]')) {
          if (item.textContent.includes('FREE')) {
            cartFreeSampleItemArr.push(item)
          }
        }
        console.log('cartFreeSampleItemArr', cartFreeSampleItemArr.length)
        if (cart.items.length == cartFreeSampleItemArr.length && cartFreeSampleItemArr.length > 0) {
          document.querySelectorAll('[data-ajax-cart-template-element="remove"]').forEach((ele) => {
            ele.click();
          });
        }
      },
      error: function error(cart) {
        // If ( $.code.debug ) { console.log( 'Add to Cart always:', newItemData ); }
        if (seqNumber === self.xhrCount) {
          // Get the cart
          self.getCart(self.options.onAddShowCart);
        }
      },
    });
  };
  /**
   * Update the cart page and the ajax cart
   *
   * @return void
   * @access public
   */

  ajaxCart_plugin.prototype.updateCarts = function (cart) {
    var self = this;
    self.cart = cart; // If we're on the cart page, with the cart-form still visible but no products in it (user removed the last product)

    console.log("Update cart....... .......... ............");
    // console.log(cart);

    setTimeout(() => {
      if(localStorage.getItem("is_adding_discount") == 'true') {
        localStorage.setItem("is_adding_discount", 'false');
        self.getCart(false);
      }
    }, 500);

    if (
      window.location.href.indexOf("/cart") > -1 &&
      $("#cartform").length &&
      cart.item_count == 0
    ) {
      // Reload the page to show the empty cart message
      window.location.reload();
      return;
    } // handle wrap whole order as gift

    self.updateWrapWholeOrderAsGift(cart); // handle free product

    self.handleFreeGift(cart);
    self.handleFreeGiftTimer(cart); // handle free shipping progress

    self.handleFreeShipping(cart); // Update ajax cart

    self.updateAjaxCartProducts(cart.items);
    self.updateAjaxCartTotals(cart);
    self.updateAjaxCartActions(cart);
    self.handleCartAttributes(cart.items); // Update cart page

    self.updateCartProducts(cart.items);
    self.updateCartTotals(cart);
    self.updateCartIconQuantity(cart.item_count);
    self.handleCartState(cart);
    self.checkIfDigitalGiftCardIsInCart();

    // self.handleFreeGiftWithPurchase(cart);

    var cartEvent = new CustomEvent("theme:loading:end", { detail: "cart" });
    document.dispatchEvent(cartEvent);
  };
  /**
   * Handle Cart state
   *
   * @return void
   * @access public
   */

  ajaxCart_plugin.prototype.handleCartState = function (cart) {
    var self = this; // handle ajaxCartContainerCheckoutButton and empty state

    if (cart.total_price > 0) {
      // Show the ajax cart empty state
      self.$ajaxCartContainerCartIsEmpty.addClass("hidden"); // Enable the checkout button
      // self.$ajaxCartContainerCheckoutButton is not working here..

      $("[data-ajax-cart-checkout]").removeClass("disabled"); // Show the checkboxes option

      self.$cartSamplesWrapper.removeClass("hidden");
    } else {
      // Remove samples from cart
      if (
        self.$cartSampleContainer.find('input[type="checkbox"]:checked')
          .length > 0
      ) {
        // Uncheck all sample checkboxes
        self.$cartSampleContainer
          .find('input[type="checkbox"]:checked')
          .prop("checked", false); // Remove by single js event not every checkbox

        self.$cartSampleContainer
          .find('.cart-item:first-child input[type="checkbox"]')
          .trigger("change");
        return;
      } // Hide the checkboxes option

      self.$cartSamplesWrapper.addClass("hidden"); // Disable the checkout button

      $("[data-ajax-cart-checkout]").addClass("disabled"); // Show ajax cart empty state

      self.$ajaxCartContainerCartIsEmpty.removeClass("hidden");
    }
  };
  /**
   * Render the cart
   *
   * @return void
   * @access public
   */

  ajaxCart_plugin.prototype.getCart = function (openTheCart) {
    var self = this;
    Shopify.getCart(function (cart) {
      if ($.code.debug) {
        console.log("ajaxCart:", cart);
      }
      
      self.cart = cart;
      self.updateCarts(cart);

      if (openTheCart) {
        self.openCart();
      } // enable free gift toggle button

      self.$cartFreeGiftButton.prop("disabled", false);
    });
  };

  ajaxCart_plugin.prototype.handleCartAttributes = function (items) {
    var self = this; // Set default

    var cartContainsItemsWithPropertyWrapThisItemAsGift = ""; // Check if the items contain wrapThisItemAsGift

    for (var i = 0; i < items.length; i++) {
      if (
        items[i].properties !== null &&
        items[i].properties.wrapThisItemAsGift
      ) {
        cartContainsItemsWithPropertyWrapThisItemAsGift = true;
        break;
      }
    } // Add or remove cart attribute

    Shopify.updateCartAttributes(
      {
        wrapThisItemAsGift: cartContainsItemsWithPropertyWrapThisItemAsGift,
      },
      function () {}
    );
  };
  /**
   * Update the ajax cart products
   *
   * @return void
   * @access public
   */

  ajaxCart_plugin.prototype.updateAjaxCartProducts = function (cartProducts) {
    var self = this;
    self.$ajaxCartContainerProducts.empty(); // Get sample checkboxes

    var $sampleCheckboxes = self.$cartSampleContainer.find(
      'input[type="checkbox"]'
    );
    var sampleVariantIds = [];
    $.each($sampleCheckboxes, function (i, sample) {
      var sampleVariantId = sample.value;
      sampleVariantIds.push(sampleVariantId);
    });

    if ($.code.debug) {
      console.log("sampleVariantIds", sampleVariantIds);
      console.log(
        "JSON.stringify sampleVariantIds",
        JSON.stringify(sampleVariantIds)
      );
    }

    var sampleVariantIdsString = JSON.stringify(sampleVariantIds);
    $.each(cartProducts, function (i, productData) {
      if ($.code.debug) {
        console.log("self.dataFreeGiftVariantId", self.dataFreeGiftVariantId);
        console.log("productData.variant_id ", productData.variant_id);
      } // Skip the rendering of the free gift and sample

      if (
        productData.variant_id !== self.dataFreeGiftVariantId &&
        sampleVariantIdsString.includes(productData.variant_id) === false
      ) {
        // Clone the product template
        var $html = self.$ajaxCartTemplateProducts.clone(); // Fill the template with data

        var $product_html = self.fillTemplate(
          $html,
          productData,
          self.options.cart_image_size,
          i
        ); // Add product to container

        self.$ajaxCartContainerProducts.append($product_html);
      } else if (productData.variant_id === self.dataFreeGiftVariantId) {
        // The free product is currently in cart so enable it and toggle the correct ui state.
        self.isFreeGiftInCart = true;
        self.toggleFreeGiftIsAlreadyInCart();
      }
    });

    var cartItems = window.cart.cartItems;
    toggleSamplePack(cartItems);

  };
  /**
   * Update the cart page products
   *
   * @return void
   * @access public
   */

  ajaxCart_plugin.prototype.updateCartProducts = function (cartProducts) {
    var self = this;
    self.$ajaxCartContainerProducts.find("[data-cart-line]").each(function () {
      var $row = $(this);
      var row_data = false; // Get row ID

      var rowId = $row.data("cart-line"); // Get data for this row from cart data

      $.each(cartProducts, function (index, item_data) {
        if (item_data.variant_id == rowId) {
          row_data = item_data;
          return false;
        }
      }); // Update row data

      if (row_data) {
        console.log(row_data);
        $row.find("[data-ajax-cart-quantity-value]").val(row_data.quantity);
        $row
          .find('[data-ajax-cart-template-element="line-price"]')
          .html(Shopify.formatMoney(row_data.final_line_price)); // Disable -button when quantity = 1

        var isMinimum = row_data.quantity == 1;
        $row
          .find('[data-ajax-cart-quantity-modifier="-1"]')
          .prop("disabled", isMinimum); // Product does not exist in cart
      } else {
        $row.remove();
      }
    });
  };
  /**
   * Update the ajax cart totals
   *
   * @return void
   * @access public
   */

  ajaxCart_plugin.prototype.updateAjaxCartTotals = function (cart) {
    var self = this; // Clone the total template

    var $html = self.$ajaxCartTemplateTotals.clone(); // Fill the template with data

    var $ajax_cart_totals_html = self.fillTemplate($html, cart); // Render the Total

    self.$ajaxCartContainerTotals.empty().append($ajax_cart_totals_html);
  };
  /**
   * Update the ajax cart Actions
   *
   * @return void
   * @access public
   */

  ajaxCart_plugin.prototype.updateAjaxCartActions = function (cart) {
    var self = this;

    if (cart.item_count > 0) {
      self.$ajaxCartContainerPanels.show();
    } else {
      self.$ajaxCartContainerPanels.hide();
    }
  };
  /**
   * Update the cart page totals
   *
   * @return void
   * @access public
   */

  ajaxCart_plugin.prototype.updateCartTotals = function (cart) {
    var self = this; // Only show or hide the 'You're saving' and 'total'

    if (cart.total_discount > 0) {
      self.$cartContainerTotals
        .find("[data-ajax-cart-template-discount]")
        .removeClass("ajax-cart-summary__item--hidden");
      $("[data-ajax-cart-promo-message]").addClass("hidden");
    } else {
      self.$cartContainerTotals
        .find("[data-ajax-cart-template-discount]")
        .addClass("ajax-cart-summary__item--hidden");
      $("[data-ajax-cart-promo-message]").removeClass("hidden");
    } // Update fields with current cart data

    self.$cartContainerTotals
      .find('[data-ajax-cart-template-element="total_discount"]')
      .html(Shopify.formatMoney(cart.total_discount));
    self.$cartContainerTotals
      .find('[data-ajax-cart-template-element="original_total_price"]')
      .html(Shopify.formatMoney(cart.original_total_price));
    self.$cartContainerTotals
      .find('[data-ajax-cart-template-element="total_price"]')
      .html(Shopify.formatMoney(cart.total_price));

    // Update Rewards
    const rewardsDiv = document.querySelector("[data-drawer-credit]");
    const credit = cart.items_subtotal_price / 100;
    if (rewardsDiv) {
      rewardsDiv.innerHTML = rewardsDiv.dataset.drawerCredit.replace(
        "[credits]",
        credit
      );
    }
  };
  /**
   * Open the cart
   *
   * @return void
   * @access public
   */

  ajaxCart_plugin.prototype.openCart = function () {
    var self = this; // close fancyboxes

    $.fancybox.close(); // Open the cart

    self.$body.addClass("ajax-cart-is-open");
  };
  /**
   * Close the cart
   *
   * @return void
   * @access public
   */

  ajaxCart_plugin.prototype.closeCart = function () {
    var self = this; // close fancyboxes

    $.fancybox.close(); // Close the cart

    self.$body.removeClass("ajax-cart-is-open");
  };
  /**
   * ajaxCart plugin
   *
   * @return jQuery objects
   */

  $.fn.ajaxCart = function (options) {
    // Put args in array
    var args = Array.prototype.slice.call(arguments, 1); // Initialize the items

    return this.each(function () {
      // Store the element the plugin is set on
      var $element = $(this); // Guard if plugin was already initted

      var instance = $element.data("plugin_" + _pluginName); // If plugin was not innited

      if (!instance) {
        // Init plugin on element and set guard data on element
        $element.data(
          "plugin_" + _pluginName,
          new ajaxCart_plugin($element, options)
        );
      } else {
        // If instance already created call method from plugin
        if (typeof options === "string") {
          instance[options].apply(instance, args);
        }
      }
    });
  };
})(jQuery, document, window);
/****************************************************************
 * CODE collapsible
 ****************************************************************/

!(function ($, document, window, undefined) {
  /**
   * Plugin name
   */
  var _pluginName = "collapsible";
  /**
   * @param $element Element Wrapping container div
   * @param options Options passed to public functions
   * @return collapsible_plugin
   */

  var collapsible_plugin = function collapsible_plugin($element, options) {
    // Scope it
    var self = this;
    self.$element = $element; // Set default options

    var defaults = {
      jsAnimation: false,
      // Open and close animation by JS, if false provide custom css to handle the .collapsible__is-open state
      openOnHover: false,
      // Open Parents on mouseOver and close on mouseLeave
      closeOnMouseleave: false,
      // Close all Parents when mouse leaves the Wrapper
      closeSiblings: false,
      // Close sibling Parents when opening a Parent - value must be a screen width! When >= screenwidth, Parents will close
      closeAll: false,
      // Close all other Parents in wrapper when opening a Parent
      addOpenClassTo: false, // Define class for which open state class will be added
    }; // Get options from element data

    var dataOptions = self.$element.data("collapsible-wrapper"); // Merge data options with default options

    self.options = $.extend({}, defaults, dataOptions);

    if ($.code.debug) {
      console.log("Init collapsible:", self.$element, self.options);
    } // Start the collapsible

    self.init();
  };
  /**
   * Init
   *
   * @return void
   * @access public
   */

  collapsible_plugin.prototype.init = function () {
    var self = this; // Catch custom events on Parents [data-collapsible-parent] and on the element itself

    self.$element
      .on({
        collapsibleOpen: function collapsibleOpen(event) {
          self.open($(event.target));
        },
        collapsibleClose: function collapsibleClose(event) {
          self.close($(event.target));
        },
      })
      .on(
        {
          collapsibleOpen: function collapsibleOpen(event) {
            self.open($(event.target));
          },
          collapsibleClose: function collapsibleClose(event) {
            self.close($(event.target));
          },
        },
        "[data-collapsible-parent]"
      ); // Catch click on Triggers [data-collapsible-trigger]

    self.$element
      .on(
        {
          click: function click(event) {
            event.stopPropagation();
            var $parent = $(this).closest("[data-collapsible-parent]"); // If Parent is closed - open it

            if (!$parent.hasClass("collapsible__is-open")) {
              event.preventDefault();
              $parent.trigger("collapsibleOpen");
            } else {
              // Else if Parent is not a link, close it
              var $trigger = $(this);

              if (!$trigger.is("a")) {
                $parent.trigger("collapsibleClose");
              } // Else follow the link
            }
          },
        },
        "[data-collapsible-trigger]"
      )
      .not("[data-collapsible-wrapper] [data-collapsible-trigger]"); // Catch click on Trigger Icon [data-collapsible-trigger-icon]

    self.$element
      .on(
        {
          click: function click(event) {
            event.stopPropagation();
            event.preventDefault();
            var $parent = $(this).closest("[data-collapsible-parent]"); // If Parent is closed - open it

            if (!$parent.hasClass("collapsible__is-open")) {
              // Self.open( $parent );
              $parent.trigger("collapsibleOpen");
            } else {
              // Else close it
              $parent.trigger("collapsibleClose");
            }

            return false;
          },
        },
        "[data-collapsible-trigger-icon]"
      )
      .not("[data-collapsible-wrapper] [data-collapsible-icon]"); // Catch hover on [data-collapsible-parent]

    if (self.options.openOnHover) {
      self.$element
        .on(
          {
            mouseenter: function mouseenter(event) {
              // No hover effects on touch devices
              if ($("html").hasClass("touch")) {
                return;
              }

              $(this).trigger("collapsibleOpen");
            },
            mouseleave: function mouseleave(event) {
              // No hover effects on touch devices
              if ($("html").hasClass("touch")) {
                return;
              }

              $(this).trigger("collapsibleClose");
            },
          },
          "[data-collapsible-parent]"
        )
        .not("[data-collapsible-wrapper] [data-collapsible-parent]");
    } // Catch mouseleave on [data-collapsible-wrapper]

    if (self.options.closeOnMouseleave) {
      self.$element.on({
        mouseleave: function mouseleave() {
          self.reset();
        },
      });
    }
  };
  /**
   * open subnav
   *
   * @return void
   * @access public
   */

  collapsible_plugin.prototype.open = function ($parent) {
    var self = this; // Find target

    var $target = $parent.find("> [data-collapsible-target]:first"); // add header shadow

    if ($(self.options.addOpenClassTo).length >= 1) {
      $(self.options.addOpenClassTo).addClass("navigation-is-open");
    }

    var headerNav = $target.closest('.header-navigation');
    if(headerNav) {
      headerNav.addClass('nav-expanded');
    }

    if ($target.length && self.options.jsAnimation) {
      // Animate target open
      var totalHeight = 0;
      $target.children().each(function () {
        totalHeight = totalHeight + $(this).outerHeight(true);
      });
      $target.stop().animate(
        {
          maxHeight: totalHeight,
        },
        function () {
          // Toggle class on parent
          $parent.addClass("collapsible__is-open");
          $target.css({
            maxHeight: "",
          });
        }
      );
    } else {
      // Toggle class on parent
      let close_target = document.querySelector('.header-navigation .collapsible__is-open');
      if(close_target) {
        close_target.classList.remove('collapsible__is-open');
      }
      $parent.addClass("collapsible__is-open"); // Close siblings if Window Width >= self.options.closeSiblings

      if (
        self.options.closeSiblings > 0 &&
        $.code.ww >= self.options.closeSiblings
      ) {
        $parent.siblings().each(function (index, el) {
          self.close($(this));
        });
      }
    }
  };
  /**
   * close subnav
   *
   * @return void
   * @access public
   */

  collapsible_plugin.prototype.close = function ($parent) {
    var self = this; // Find target

    var $target = $parent.find("> [data-collapsible-target]:first"); // remove header shadow

    if ($(self.options.addOpenClassTo).length >= 1) {
      $(self.options.addOpenClassTo).removeClass("navigation-is-open");
    }

    if ($target.length && self.options.jsAnimation) {
      // Animate target closed
      var totalHeight = 0;
      $target.children().each(function () {
        totalHeight = totalHeight + $(this).outerHeight(true);
      });
      $target
        .stop()
        .css({
          maxHeight: totalHeight,
        })
        .animate(
          {
            maxHeight: 0,
          },
          function () {
            // Toggle class on parent and close all children
            $parent
              .removeClass("collapsible__is-open")
              .find(".collapsible__is-open")
              .removeClass("collapsible__is-open");
            $target.css({
              maxHeight: "",
            });
          }
        );
    } else {
      // Toggle class on parent and close all children
      $parent
        .removeClass("collapsible__is-open")
        .find(".collapsible__is-open")
        .removeClass("collapsible__is-open");
    }
  };
  /**
   * reset navigation elements
   *
   * @return void
   * @access public
   */

  collapsible_plugin.prototype.reset = function () {
    var self = this;
    self.$element.find("[data-collapsible-trigger]").each(function (index, el) {
      var $parent = $(this).closest("[data-collapsible-parent]");

      if ($parent.hasClass("collapsible__is-open")) {
        $parent.trigger("collapsibleClose");
      }
    });
  };
  /**
   * collapsible plugin
   *
   * @return jQuery objects
   */

  $.fn.collapsible = function (options) {
    // Put args in array
    var args = Array.prototype.slice.call(arguments, 1); // Initialize the items

    return this.each(function () {
      // Store the element the plugin is set on
      var $element = $(this); // Guard if plugin was already initted

      var instance = $element.data("plugin_" + _pluginName); // If plugin was not innited

      if (!instance) {
        // Init plugin on element and set guard data on element
        $element.data(
          "plugin_" + _pluginName,
          new collapsible_plugin($element, options)
        );
      } else {
        // If instance already created call method from plugin
        if (typeof options === "string") {
          instance[options].apply(instance, args);
        }
      }
    });
  };
})(jQuery, document, window);
/****************************************************************
 * CODE Cookie plugin
 ****************************************************************/

!(function ($, document, window, undefined) {
  /**
   * Plugin name
   */
  var _pluginName = "cookiePlugin";
  /**
   * @param $element Element Wrapping container div
   * @param $wrapper Element Wrapping shopify section div
   * @return cookiePlugin_plugin
   */

  var cookiePlugin_plugin = function cookiePlugin_plugin($element, options) {
    var self = this; // scope

    self.$element = $element;
    self.$wrapper = self.$element.closest(".shopify-section");
    self.$acceptButton = self.$element.find("[data-cookie-plugin-accept]"); // retreive acceptance cookie

    self.acceptanceCookie = Cookies.get("general_cookies_accepted"); // debugger

    if ($.code.debug) {
      console.log("Init cookie plugin:", self.$element);
    } // init cookiePlugin

    self.init();
  };
  /**
   * Init the cookiePlugin plugin
   *
   * @return void
   */

  cookiePlugin_plugin.prototype.init = function () {
    var self = this; // check acceptance cookie

    if (typeof self.acceptanceCookie === "undefined") {
      self.showCookieNotice();
    }
  };
  /**
   * show cookie notice
   *
   * @return void
   */

  cookiePlugin_plugin.prototype.showCookieNotice = function () {
    var self = this;
    self.$wrapper.removeClass("cookie-notice--hidden");
    self.$wrapper.addClass("cookie-notice--visible");
    self.handleEvents();
  };
  /**
   * handle events
   *
   * @return void
   */

  cookiePlugin_plugin.prototype.handleEvents = function () {
    var self = this; // catch click on accept button

    self.$acceptButton.on("click", function () {
      // retrieve how many days cookie should be valid for
      self.cookieIsValidFor = self.$element.data("cookie-plugin").cookieValid; // write cookie

      Cookies.set("general_cookies_accepted", true, {
        expires: self.cookieIsValidFor,
      }); // hide cookie Notice

      self.hideCookieNotice();
    });
  };
  /**
   * hide cookie notice
   *
   * @return void
   */

  cookiePlugin_plugin.prototype.hideCookieNotice = function () {
    var self = this;
    self.$wrapper.removeClass("cookie-notice--visible");
    self.$wrapper.addClass("cookie-notice--hidden");
  };
  /**
   * cookiePlugin plugin
   *
   * @return jQuery objects
   */

  $.fn.cookiePlugin = function (options) {
    // put args in array
    var args = Array.prototype.slice.call(arguments, 1); // initialize the items

    return this.each(function () {
      // store the element the plugin is set on
      var $element = $(this); // guard if plugin was already initted

      var instance = $element.data("plugin_" + _pluginName); // if plugin was not innited

      if (!instance) {
        // init plugin on element and set guard data on element
        $element.data(
          "plugin_" + _pluginName,
          new cookiePlugin_plugin($element, options)
        );
      } else {
        // if instance already created call method from plugin
        if (typeof options === "string") {
          instance[options].apply(instance, args);
        }
      }
    });
  };
})(jQuery, document, window);
/****************************************************************
 * CODE Country Popup
 ****************************************************************/

!(function ($, document, window, undefined) {
  /**
   * Plugin name
   */
  var _pluginName = "countryPopup";
  /**
   * @param $element Element Wrapping container div
   * @param options Options passed to public functions
   * @return countryPopup_plugin
   */

  var countryPopup_plugin = function countryPopup_plugin($element, options) {
    // scope
    var self = this;
    self.$element = $element;
    var country_popup_wrapper_identifier = "#country-message";
    self.country_popup_wrapper = self.$element.find(
      country_popup_wrapper_identifier
    );
    self.button_stay = self.country_popup_wrapper.find(
      "[data-country-message-stay]"
    ); // guard: check country popup exists

    if (self.country_popup_wrapper.length == 0) {
      return;
    } // guard: check fancybox object exists

    if (_typeof($.fancybox) != "object") {
      return;
    } // get options

    var defaults = {
      current_country_code: "",
      location_api_url: "",
      location_field_name: "",
      popup_messages: {},
    };
    var metaOptions = self.country_popup_wrapper.data(
      "country-message-options"
    );
    self.options = $.extend({}, defaults, metaOptions); // set country popup cookie identifier

    self.country_popup_cookie_identifier = "country_switcher"; // set fancybox

    self.fancybox = $.fancybox;

    if ($.code.debug) {
      console.log(
        "Init country popup:",
        self.country_popup_wrapper,
        self.options
      );
    } // init country popup

    self.init(); // section loaded reload popup

    $(document).on("shopify:section:load", function (e) {
      if (e.detail.sectionId == "site-country-popup") {
        self.fancybox.close();
        self.init();
      }
    });
  };
  /**
   * Init the country popup plugin
   *
   * @return void
   */

  countryPopup_plugin.prototype.init = function () {
    // scope
    var self = this; // if country popup days is set to zero, remove cookie if exists

    if (parseInt(self.options.expires_in_days) == 0) {
      Cookies.remove(self.country_popup_cookie_identifier);
    } // Get element

    self.countryPopupCookie = Cookies.get(self.country_popup_cookie_identifier); // Render country popup if given

    if (!self.mayRenderCountryPopup()) {
      return false;
    } // get country location

    self.getLocation(function () {
      if (
        self.options.force_redirect === true &&
        !window.Shopify.designMode &&
        self.country_code != self.options.current_country_code
      ) {
        // Force the redirect based on self.country_code
        window.location.href =
          self.options.popup_messages[self.country_code].country_url;
      } else {
        // render the country popup
        self.renderCountryPopup();
      }
    }); // button close popup

    $(self.button_stay).on("click", function () {
      self.closeCountryPopup();
    });
  };
  /**
   * Check if the country popup may be rendered and that there is a message to show
   *
   * @return boolean
   */

  countryPopup_plugin.prototype.mayRenderCountryPopup = function () {
    // scope
    var self = this; // guard: check if popup cookie is set

    if (self.countryPopupCookie) {
      return false;
    } // guard: check if there are messages given

    if (self.options.popup_messages.length == 0) {
      return false;
    }

    return true;
  };
  /**
   * Get country location from cookie or GeoAPI
   *
   * @return string country_code
   */

  countryPopup_plugin.prototype.getLocation = function (callback) {
    // scope
    var self = this; // get country code from cookie

    self.country_code = Cookies.get(
      self.country_popup_cookie_identifier + "-country_code"
    ); // if country code is given, return the code

    if (self.country_code) {
      return callback();
    } // get country code from api, if done call the callback

    self.getCountryCodeFromAPI().done(function (country_code) {
      self.setCountryCode(country_code);
      return callback();
    });
    return self.country_code;
  };
  /**
   * Get country code from API service
   *
   * @return string country_code
   */

  countryPopup_plugin.prototype.getCountryCodeFromAPI = function () {
    // scope
    var self = this;
    var default_api_url =
      "//extreme-ip-lookup.com/json/?key=RExP6HcRfIVdtn4etzLu";
    var country_code_api = self.options.location_api_url || default_api_url;
    var country_code_fieldname_identifier =
      self.options.location_field_name || "country_code"; // guard: get country code api url from options

    if (country_code_api == "") {
      return self;
    } // guard: get country code field name

    if (country_code_fieldname_identifier == "") {
      return self;
    } // get country code from api

    return $.getJSON(country_code_api).then(function (response) {
      if (
        typeof response[country_code_fieldname_identifier] != "undefined" &&
        response[country_code_fieldname_identifier] != ""
      ) {
        return response[country_code_fieldname_identifier];
      }
    });
  };
  /**
   * Render the country popup
   *
   * @return string country_code
   */

  countryPopup_plugin.prototype.setCountryCode = function (country_code) {
    // scope
    var self = this; // guard: check country code is given

    if (typeof country_code == "undefined" || country_code == "") {
      return "";
    } // set the country code

    self.country_code = country_code; // create a cookie with the country code

    var inOneHourMinutes = new Date(new Date().getTime() + 60 * 1000);
    Cookies.set(
      self.country_popup_cookie_identifier + "-country_code",
      country_code,
      {
        expires: inOneHourMinutes,
      }
    );
    return country_code;
  };
  /**
   * Internal function for when calling done from a cookie state
   * @param  callback
   * @return object
   */

  countryPopup_plugin.prototype.done = function (callback) {
    // scope
    var self = this;

    if (
      (typeof calback === "undefined" ? "undefined" : _typeof(calback)) ==
      "object"
    ) {
      callback(self.country_code);
    }

    return self;
  };
  /**
   * Render the country popup
   *
   * @return string country_code
   */

  countryPopup_plugin.prototype.renderCountryPopup = function () {
    // scope
    var self = this; // check country code is given

    if (self.country_code == "" || self.options.current_country_code == "") {
      return;
    } // guard: if the given country_Code is the same as the shop country code then skip!

    if (self.country_code == self.options.current_country_code) {
      return;
    }

    var countryData; // get the data by country code if available

    if (typeof self.options.popup_messages[self.country_code] != "undefined") {
      countryData = self.options.popup_messages[self.country_code]; // if country option does not exists shop ROW
    } else if (typeof self.options.popup_messages["ROW"] != "undefined") {
      countryData = self.options.popup_messages["ROW"]; // guard: no country data to render
    } else {
      return;
    } // populate the wrapper with the country data

    var href = document.location.href.split(".com/");

    var href_seg = href[1];

    $(self.country_popup_wrapper)
      .find("[data-country-message-title]")
      .text(countryData.country_title || "");
    $(self.country_popup_wrapper)
      .find("[data-country-message-name-title]")
      .text(countryData.country_name || "");
    $(self.country_popup_wrapper)
      .find("[data-country-message-text]")
      .text(countryData.country_body || "");
    $(self.country_popup_wrapper)
      .find("[data-country-message-url]")
      .attr("href", countryData.country_url.replace(/\/$/, "") + "/" + href_seg || "");
    $(self.country_popup_wrapper)
      .find("[data-country-message-label]")
      .text(countryData.country_button || "");
    $(self.country_popup_wrapper)
      .find("[data-country-message-stay]")
      .val(countryData.country_stay || ""); // open fancybox

    self.fancybox.open(self.country_popup_wrapper, {
      afterClose: function afterClose() {
        self.closeCountryPopup();
      },
    });
  };
  /**
   * Close country popup
   *
   * @return void
   */

  countryPopup_plugin.prototype.closeCountryPopup = function () {
    // scope
    var self = this;
    Cookies.set(self.country_popup_cookie_identifier, true, {
      expires: self.options.expires_in_days,
    });
    self.fancybox.close();
  };
  /**
   * countryPopup plugin
   *
   * @return jQuery objects
   */

  $.fn.countryPopup = function (options) {
    // put args in array
    var args = Array.prototype.slice.call(arguments, 1); // initialize the items

    return this.each(function () {
      // store the element the plugin is set on
      var $element = $(this); // guard if plugin was already initted

      var instance = $element.data("plugin_" + _pluginName); // if plugin was not innited

      if (!instance) {
        // init plugin on element and set guard data on element
        $element.data(
          "plugin_" + _pluginName,
          new countryPopup_plugin($element, options)
        );
      } else {
        // if instance already created call method from plugin
        if (typeof options === "string") {
          instance[options].apply(instance, args);
        }
      }
    });
  };
})(jQuery, document, window);
/****************************************************************
 * CODE datalayer handler
 ****************************************************************/

!(function ($, document, window, undefined) {
  /**
   * Plugin name
   */
  var _pluginName = "datalayer";
  /**
   * @param $element Element Wrapping container div
   * @param options Options passed to public functions
   * @return datalayer_plugin
   */

  var datalayer_plugin = function datalayer_plugin($element, options) {
    // scope
    var self = this;
    self.$element = $element;

    if ($.code.debug) {
      console.log("Init datalayer handler");
    } // init datalayer listview handler

    var list_view_selector = "[data-datalayer-listview]";
    self.listView(list_view_selector); // init datalayer offTheGridListView handler

    var off_the_grid_list_view_selector =
      "[data-datalayer-off-the-grid-listview]";
    self.offTheGridListView(off_the_grid_list_view_selector); // init datalayer product click handler

    var product_click_selector =
      "[data-datalayer-product-link], [data-datalayer-spotlight-link]";
    self.productClick(product_click_selector); // init datalayer view PDP

    var product_pdp_view_selector = "[data-datalayer-view-pdp]";
    self.viewPdp(product_pdp_view_selector); // init datalayer side cart opener listener

    var checkout_sidecart_selector = "[data-datalayer-sidecart-listener]";
    var checkout_start_selector = "[data-datalayer-checkout-start]";
    self.cartDrawerListener(
      checkout_sidecart_selector,
      checkout_start_selector
    );
  };
  /**
   * Init listView
   *
   * @return void
   */

  datalayer_plugin.prototype.listView = function (selector) {
    var self = this;
    self.observeElements(selector, self.listViewAction);
  };
  /**
   * Init offTheGridListView
   *
   * @return void
   * @param {String} selector
   */

  datalayer_plugin.prototype.offTheGridListView = function (selector) {
    var self = this;
    self.observeElements(selector, self.offTheGridListViewAction);
  };

  datalayer_plugin.prototype.cartDrawerCheckoutAction = function (
    observe_el,
    second_target,
    self
  ) {
    var self = self; // get the latest cart so this can be used for send the latest cart information via the datalayer

    $.ajax({
      type: "GET",
      url: "/cart?view=compare",
      dataType: "json",
    })
      .done(function (cart) {
        if ($.code.debug) {
          console.log(
            "cartDrawerCheckoutAction -- GET cart successfully 🕺🏻",
            cart
          );
        } // init the checkout listener

        setTimeout(function () {
          self.checkoutStartListener(second_target, cart);
        }, 100);
      })
      .fail(function (error) {
        if ($.code.debug) {
          console.log("cartDrawerCheckoutAction -- GET cart fail ⚠️", error);
        }
      });
  };
  /**
   * Mutation Observer Helper
   *
   * @return void
   * @param {Object} target
   * @param {String} conditions
   * @param {String} action
   */

  datalayer_plugin.prototype.mutationObserver = function (
    target,
    conditions,
    action,
    second_target
  ) {
    var self = this;
    var observer = new MutationObserver(function (events) {
      for (var index = 0; index < events.length; index++) {
        var event = events[index];
        var targetEl = event.target; // if mutation on the element equals the class condition trigger the action

        if (targetEl.classList.contains(conditions)) {
          action(target, second_target, self);
        }
      }
    });
    observer.observe(target, {
      attributeFilter: ["class"],
      childList: false,
      characterData: false,
      subtree: false,
    });
  };
  /**
   * Init cart drawer listener
   *
   * @return void
   * @param {String} selector
   */

  datalayer_plugin.prototype.cartDrawerListener = function (
    selector,
    checkout_selector
  ) {
    var self = this;
    var element = document.querySelector(selector);
    if (!element) return;
    var observe_element = document.querySelector("body");
    var element_condition_attribute = element.getAttribute(
      "data-toggle-element-class"
    );
    var class_condition_object = JSON.parse(element_condition_attribute); // init mutationObserver function with defined conditions

    self.mutationObserver(
      observe_element,
      class_condition_object.class,
      self.cartDrawerCheckoutAction,
      checkout_selector
    );
  };
  /**
   * Init product click
   *
   * @return void
   * @param {String} selectors
   */

  datalayer_plugin.prototype.productClick = function (selectors) {
    var self = this;
    var elements = document.querySelectorAll(selectors);
    if (!elements.length) return;
    elements.forEach(function (element) {
      element.addEventListener("click", function (event) {
        event.preventDefault(); // check if clicked element has the data-datalayer-item attrbiute which contains all the product info

        if (this.getAttribute("data-datalayer-item") != null) {
          var item_data = this.getAttribute("data-datalayer-item");
          var list_view_data = this.getAttribute(
            "data-datalayer-listview-item"
          );
          var item_list_view_index = this.getAttribute(
            "data-datalayer-product-list-index"
          ); // else search the attribute on the parent elements
        } else {
          var item_data = this.closest("[data-datalayer-item]").getAttribute(
            "data-datalayer-item"
          );
          var list_view_data = this.closest(
            "[data-datalayer-listview-item]"
          ).getAttribute("data-datalayer-listview-item");
          var item_list_view_index = this.closest(
            "[data-datalayer-product-list-index]"
          ).getAttribute("data-datalayer-product-list-index");
        }

        var parsed_list_item = self.parseData(list_view_data);
        var parsed_item = self.parseData(item_data);
        var products_list_object = self.createProductListObject(
          parsed_item,
          item_list_view_index
        );
        var data = {
          event: "select_item",
          ecommerce: {
            currency: Shopify.currency.active,
            items: products_list_object,
          },
          item_list_name: parsed_list_item.listview_list_name,
          item_list_id: parsed_list_item.listview_list_id,
        }; // PUSH THE DATA TO DATALAYER

        self.pushData(data); // change url

        var url_value = this.closest("a").getAttribute("href");
        document.location = url_value;
      });
    });
  };
  /**
   * Init view PDP
   *
   * @return void
   * @param {String} selector
   */

  datalayer_plugin.prototype.viewPdp = function (selector) {
    var self = this;
    var element = document.querySelector(selector);
    if (!element) return;
    var item_data = element.getAttribute("data-datalayer-item");
    var parsed_item_data = self.parseData(item_data);
    var default_variant_id = element.getAttribute("data-default-variant-id");
    var products = [];
    products.push(self.createProductObject(parsed_item_data, default_variant_id));
    var data = {
      event: "view_item",
      ecommerce: {
        currency: Shopify.currency.active,
        items: products,
      },
    }; // PUSH THE DATA TO DATALAYER

    self.pushData(data);
  };
  /**
   * Observe elements
   *
   * @return void
   */

  datalayer_plugin.prototype.observeElements = function (selectors, action) {
    var self = this;
    var targets = document.querySelectorAll(selectors);
    if (!targets.length) return;

    var lazyLoad = function lazyLoad(target) {
      var io = new IntersectionObserver(function (entries, observer) {
        var _self = self;
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var target = entry.target;
            action(target, _self);
            observer.disconnect();
          }
        });
      });
      io.observe(target);
    };

    targets.forEach(lazyLoad);
  };
  /**
   * List View Action
   *
   * @return void
   */

  datalayer_plugin.prototype.listViewAction = function (target, self) {
    var target_data = target.querySelector("[data-datalayer-listview-item]"); // Return when element is not found

    if (target_data === null) {
      return;
    }

    var list_view_data = target_data.getAttribute(
      "data-datalayer-listview-item"
    );
    var list_view_index = target_data.getAttribute(
      "data-datalayer-product-list-index"
    );
    var item_data = target_data.getAttribute("data-datalayer-item");

    if (!list_view_data && !item_data) {
      return false;
    }

    var parsed_list_item = self.parseData(list_view_data);
    var item = self.parseData(item_data);
    var products_list_object = self.createProductListObject(
      item,
      list_view_index
    );
    var data = {
      event: "view_item_list",
      ecommerce: {
        currency: Shopify.currency.active,
        items: products_list_object,
      },
      item_list_name: parsed_list_item.listview_list_name,
      item_list_id: parsed_list_item.listview_list_id,
    }; // PUSH THE DATA TO DATALAYER

    // self.pushData(data);
  };
  /**
   * Off the grid List View Action
   *
   * @return void
   */

  datalayer_plugin.prototype.offTheGridListViewAction = function (
    target,
    self
  ) {
    var self = self;
    var selector;

    if (
      target.getAttribute(
        "data-datalayer-off-the-grid-listview-collection-page"
      ) != null
    ) {
      selector =
        "[data-datalayer-off-the-grid-listview] [data-datalayer-collection-item]";
    } else {
      selector = "[data-datalayer-off-the-grid-listview] [data-datalayer-item]";
    }

    self.observeElements(selector, self.offTheGridListViewItemAction);
  };
  /**
   * Off The Grid List View Item Action
   *
   * @return void
   */

  datalayer_plugin.prototype.offTheGridListViewItemAction = function (
    target,
    self
  ) {
    var target_data = target.closest("[data-datalayer-listview-item]");
    var list_view_data = target_data.getAttribute(
      "data-datalayer-listview-item"
    );
    var list_view_index = target.getAttribute(
      "data-datalayer-product-list-index"
    );
    var item_data = target.getAttribute("data-datalayer-item");

    if (!list_view_data) {
      return false;
    }

    var parsed_list_item = self.parseData(list_view_data);
    var parsed_item_data = self.parseData(item_data);
    var products_list_object = self.createProductListObject(
      parsed_item_data,
      list_view_index
    );
    var data = {
      event: "view_item_list",
      ecommerce: {
        currency: Shopify.currency.active,
        items: products_list_object,
      },
      item_list_name: parsed_list_item.listview_list_name,
      item_list_id: parsed_list_item.listview_list_id,
    }; // PUSH THE DATA TO DATALAYER

    // self.pushData(data);
  };
  /**
   * Checkout start event handler
   *
   * @return void
   * @param {String} selector
   * @param {Object} cart_drawer
   */

  datalayer_plugin.prototype.checkoutStartListener = function (
    selector,
    cart_drawer
  ) {
    var self = this;
    var element = document.querySelector(selector);
    if (!element) return; // handle the click on the checkout button

    var handleClick = function handleClick(event) {
      event.preventDefault(); // set cart total based on total price in cart_drawer

      var cart_total = Shopify.formatMoney(
        cart_drawer.total_price,
        "{{amount}}"
      ); // create product array based on items in cart_drawer

      var current_cart = cart_drawer.items;
      var products = [];
      current_cart.forEach(function (cart_item) {
        products.push(self.createProductObject(cart_item));
      }); // create datalayer object

      var data = {
        event: "begin_checkout",
        ecommerce: {
          currency: Shopify.currency.active,
          items: products,
          coupon: "",
          value: cart_total,
        },
      }; // PUSH THE DATA TO DATALAYER

      self.pushData(data); // redirect user to checkout

      window.location = element.getAttribute("href");
    }; // remove existing listner from element

    var removeClickEventListener = function removeClickEventListener() {
      element.removeEventListener("click", handleClick, true);
    }; // add listener to element

    var addClickEventListener = function addClickEventListener() {
      element.addEventListener("click", handleClick, true);
    }; // check if the element and the listener still exists

    var checkIfListnerExists = function checkIfListnerExists() {
      element = document.querySelector(selector);

      if (
        typeof element != "undefined" &&
        element != null &&
        element.getAttribute("data-listen-mouse-click")
      ) {
        return;
      } else {
        element.setAttribute("data-listen-mouse-click", true);
        removeClickEventListener();
        addClickEventListener();
      }
    }; // keeping checking every 250ms

    setInterval(function () {
      checkIfListnerExists();
    }, 250);
  };
  /**
   * Create product object for the datalayer
   *
   * @return void
   * @param {Object} item
   * @param {Object} products
   */

  datalayer_plugin.prototype.createProductObject = function (item, v_id) {
    var self = this;

    var item_name = item.title;
    var v_opt = document.querySelector(`#product-v-select option[data-id="${v_id}"]`);
    if(v_opt) {
      item_name = v_opt.dataset.mfTitle || item_name;
    }

    var product = {
      item_name: item_name,
      item_id: item.variants != null ? item.variants[0].barcode : null,
      price:
        item.compare_at_price != null && item.compare_at_price > item.price
          ? Shopify.formatMoney(item.compare_at_price, "{{amount}}")
          : Shopify.formatMoney(item.price, "{{amount}}"),
      item_brand: item.vendor,
      quantity: item.quantity ? item.quantity : 1,
      item_category: item.type,
      item_variant: v_id ? v_id : 
        (item.variants != null && item.variants.length
          ? item.variants[0].id
          : item.variant_id),
      currency: Shopify.currency.active,
      discount:
        item.compare_at_price != null && item.compare_at_price > item.price
          ? Shopify.formatMoney(
              item.compare_at_price - item.price,
              "{{amount}}"
            )
          : "0.0",
    };
    return product;
  };
  /**
   * Create product list object for the datalayer
   *
   * @return void
   * @param {Object} item
   * @param {Number} listIndex
   * @param {Number} index
   */

  datalayer_plugin.prototype.createProductListObject = function (item) {
    var listIndex =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var index =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var self = this;
    var productsList = [];
    productsList = [
      {
        item_name: item.title,
        item_id: item.id,
        price:
          item.compare_at_price != null && item.compare_at_price > item.price
            ? Shopify.formatMoney(item.compare_at_price, "{{amount}}")
            : Shopify.formatMoney(item.price, "{{amount}}"),
        item_brand: item.vendor,
        quantity: 1,
        item_category: item.type,
        item_variant: item.variants ? item.variants[0].id : item.id,
        currency: Shopify.currency.active,
        discount:
          item.compare_at_price != null && item.compare_at_price > item.price
            ? Shopify.formatMoney(
                item.compare_at_price - item.price,
                "{{amount}}"
              )
            : "0.0",
        index: listIndex,
      },
    ];
    return productsList;
  };
  /**
   * push data to the datalayer
   *
   * @return void
   * @param {Object} data
   */

  datalayer_plugin.prototype.pushData = function (data) {
    // push the datalayer
    if ($.code.debug) {
      console.log("pushData to datalayer with data:", data);
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  };
  /**
   * parse JSON data
   *
   * @return void
   * @param {String} data
   */

  datalayer_plugin.prototype.parseData = function (data) {
    return JSON.parse(data);
  };
  /**
   * datalayer plugin
   *
   * @return jQuery objects
   */

  $.fn.datalayer = function (options) {
    // put args in array
    var args = Array.prototype.slice.call(arguments, 1); // initialize the items

    return this.each(function () {
      // store the element the plugin is set on
      var $element = $(this); // guard if plugin was already initted

      var instance = $element.data("plugin_" + _pluginName); // if plugin was not innited

      if (!instance) {
        // init plugin on element and set guard data on element
        $element.data(
          "plugin_" + _pluginName,
          new datalayer_plugin($element, options)
        );
      } else {
        // if instance already created call method from plugin
        if (typeof options === "string") {
          instance[options].apply(instance, args);
        }
      }
    });
  };
})(jQuery, document, window);
/****************************************************************
 * CODE header announcements
 ****************************************************************/

!(function ($, document, window, undefined) {
  /**
   * Plugin name
   */
  var _pluginName = "headerAnnouncements";
  /**
   * @param $element Element Wrapping container div
   * @param options Options passed to public functions
   * @return headerAnnouncements_plugin
   */

  var headerAnnouncements_plugin = function headerAnnouncements_plugin(
    $element,
    options
  ) {
    // Scope it
    var self = this;
    self.$element = $element;
    self.$body = $("body");
    self.elementHeight = self.$element.outerHeight(); // debug

    if ($.code.debug) {
      console.log(
        "Init header announcements:",
        self.$element,
        self.elementHeight
      );
    } // add class to body

    self.$body.addClass("has-announcements"); // check if scrolled

    self.checkIfScrolled(); // handle scoll elements

    self.handleEvents();
  };
  /**
   * Check if scrolled on refresh
   *
   * @return void
   * @access public
   */

  headerAnnouncements_plugin.prototype.checkIfScrolled = function () {
    var self = this; // get scrolled distance

    var scrolledDistance = $(window).scrollTop(); // check if usp should be hidden

    if (scrolledDistance >= 40) {
      self.hideAnnouncements();
    }
  };
  /**
   * Handle scroll events
   *
   * @return void
   * @access public
   */

  headerAnnouncements_plugin.prototype.handleEvents = function () {
    var self = this; // guard

    var announcementsHidden = false; // on windows scroll

    $(window).scroll(function (event) {
      // get scrolled distance
      var scrolledDistance = $(window).scrollTop(); // check if announcements should be hidden

      if (scrolledDistance >= self.elementHeight && !announcementsHidden) {
        self.hideAnnouncements();
        announcementsHidden = true;
      } // check if announcements should be shown

      if (scrolledDistance == 0) {
        self.showAnnouncements();
        announcementsHidden = false;
      }
    });
  };
  /**
   * Hide header announcements
   *
   * @return void
   * @access public
   */

  headerAnnouncements_plugin.prototype.hideAnnouncements = function () {
    var self = this; // hide announcements
    // remove class from body

    // self.$body.removeClass("has-announcements--is-shown");
    // self.$body.addClass("has-announcements--is-hidden");
  };
  /**
   * Show header announcements
   *
   * @return void
   * @access public
   */

  headerAnnouncements_plugin.prototype.showAnnouncements = function () {
    var self = this; // show announcements
    // add class to body

    // self.$body.addClass("has-announcements--is-shown");
    // self.$body.removeClass("has-announcements--is-hidden");
  };
  /**
   * headerAnnouncements plugin
   *
   * @return jQuery objects
   */

  $.fn.headerAnnouncements = function (options) {
    // Put args in array
    var args = Array.prototype.slice.call(arguments, 1); // Initialize the items

    return this.each(function () {
      // Store the element the plugin is set on
      var $element = $(this); // Guard if plugin was already initted

      var instance = $element.data("plugin_" + _pluginName); // If plugin was not innited

      if (!instance) {
        // Init plugin on element and set guard data on element
        $element.data(
          "plugin_" + _pluginName,
          new headerAnnouncements_plugin($element, options)
        );
      } else {
        // If instance already created call method from plugin
        if (typeof options === "string") {
          instance[options].apply(instance, args);
        }
      }
    });
  };
})(jQuery, document, window);
/****************************************************************
 * CODE productVideos
 ****************************************************************/

!(function ($, document, window, undefined) {
  /**
   * Plugin name
   */
  var _pluginName = "productVideos";
  /**
   * @param $element Element Wrapping container div
   * @param options Options passed to public functions
   * @return productRecommendations_plugin
   */

  var productVideos_plugin = function productVideos_plugin($element, options) {
    var self = this;
    self.$element = $element;
    self.init();
  };
  /**
   * Init
   *
   * @return void
   * @access public
   */

  productVideos_plugin.prototype.init = function () {
    var self = this; // Catch click event

    self.$element
      .find('[data-product-video="button"]')
      .on("click", self.handleProductVideo); //

    self.$element
      .find('[data-product-video="sound"]')
      .on("click", self.toggleVideoSound); // Pause all the videos when the slide has changed

    self.$element.on(
      "productVideoSlideChange",
      self.handleProductVideoSlideChange
    );
  };
  /**
   * handleProductVideo
   * Handles the single product video interaction.
   */

  productVideos_plugin.prototype.handleProductVideo = function () {
    var self = this; // Select the elements inside the current wrapper

    var $productVideoWrapper = $(this).closest(
      '[data-product-video="wrapper"]'
    );
    var productVideoOptions = $productVideoWrapper.data(
      "product-video-options"
    );
    var $productVideoButtons = $productVideoWrapper.find(
      '[data-product-video="button"]'
    );
    var $productVideoSource = $productVideoWrapper.find(
      '[data-product-video="source"]'
    );
    var $productVideoYoutube = $productVideoWrapper.find("iframe");
    var $productVideoOverlay = $productVideoWrapper.find(
      ".product-video__overlay"
    );

    if ($.code.debug) {
      console.log("productVideoOptions", productVideoOptions);
    } // Check on type

    switch (productVideoOptions.media_type) {
      // mp4
      case "video":
        if ($productVideoSource.hasClass("video-is-playing")) {
          $productVideoSource[0].pause();
          $productVideoSource.removeClass("video-is-playing");
          $productVideoButtons.removeClass("product-video__button--active");
        } else {
          $productVideoSource[0].play();
          $productVideoSource.addClass("video-is-playing");
          $productVideoButtons.addClass("product-video__button--active");
        }

        break;
      // youtube

      case "external_video":
        $productVideoYoutube.toggleClass("video-is-playing");
        $productVideoButtons.toggleClass("product-video__button--active");

        if ($productVideoYoutube.hasClass("video-is-playing")) {
          $productVideoYoutube.attr(
            "src",
            $productVideoYoutube.attr("src") + "&autoplay=1"
          );
        } else {
          $productVideoYoutube[0].src = $productVideoYoutube[0].src.replace(
            "&autoplay=1",
            ""
          );
        }

        break;

      default:
        break;
    }
  };

  productVideos_plugin.prototype.toggleVideoSound = function () {
    var self = this;
    var $productVideoWrapper = $(this).closest(
      '[data-product-video="wrapper"]'
    );
    var productVideoOptions = $productVideoWrapper.data(
      "product-video-options"
    );
    var $productVideoSource = $productVideoWrapper.find(
      '[data-product-video="source"]'
    );

    switch (productVideoOptions.media_type) {
      case "video":
        $productVideoSource[0].muted = !$productVideoSource[0].muted;

      default:
        break;
    }
  };
  /**
   * Stop videos from playing when changing slides
   */

  productVideos_plugin.prototype.handleProductVideoSlideChange = function () {
    var self = this;
    $.each(
      $('[data-product-video="source"]'),
      function (i, productVideoSource) {
        productVideoSource.pause();
        productVideoSource.classList.remove("video-is-playing");
      }
    );
    $('[data-product-video="button"]').removeClass(
      "product-video__button--active"
    );
  };
  /**
   * productVideos plugin
   *
   * @return jQuery objects
   */

  $.fn.productVideos = function (options) {
    // Put args in array
    var args = Array.prototype.slice.call(arguments, 1); // Initialize the items

    return this.each(function () {
      // Store the element the plugin is set on
      var $element = $(this); // Guard if plugin was already initted

      var instance = $element.data("plugin_" + _pluginName); // If plugin was not innited

      if (!instance) {
        // Init plugin on element and set guard data on element
        $element.data(
          "plugin_" + _pluginName,
          new productVideos_plugin($element, options)
        );
      } else {
        // If instance already created call method from plugin
        if (typeof options === "string") {
          instance[options].apply(instance, args);
        }
      }
    });
  };
})(jQuery, document, window);
/****************************************************************
 * CODE product
 ****************************************************************/

!(function ($, document, window, undefined) {
  /**
   * Plugin name
   */
  var _pluginName = "product";
  /**
   * @param $element Element Wrapping container div
   * @param options Options passed to public functions
   * @return product_plugin
   */

  var product_plugin = function product_plugin($element, options) {
    // Scope it
    var self = this;
    self.$element = $element; // Create product Options

    var defaultOptions = {
      onMasterSelectChange: {
        updateSpecs: true,
        // On variant change, update the specs
        updateVariantImagesInSwiper: true,
        // On variant change, show the image of the variant
        triggerOnPageLoad: true, // Trigger a variant change when the PDP is loaded with a variant parameter to show the image of the variant
      },
      easyzoom: {
        loadingNotice: "",
        errorNotice: "",
      },
      fancybox: {
        hash: false,
        backFocus: false,
        baseClass: "product-detail-popup",
        thumbs: {
          autoStart: true,
          hideOnClose: true,
        },
      },
    };
    var metaOptions = self.$element.data("product-options");
    self.options = $.extend({}, defaultOptions, metaOptions);

    if ($.code.debug) {
      console.log("Init product:", self.$element, self.options);
    } // Get elements

    self.productImagesSwiper = $(".product-images-slider");
    self.productImagesSwiperNav = $(".product-images-slider-nav");
    self.$specsWrapper = self.$element.find("[data-product-specs-wrapper]");
    self.$specs = self.$element.find("[data-product-specs]");
    self.specs_data = self.$specs.data("product-specs");

    if (self.productImagesSwiper.length) {
      // Init product Swipers
      self.initProductSwipers();
    } else {
      // Init productzoom on product image
      self.initProductZoom(); // Init productzoom popup gallery

      self.initProductFancyboxGallery();
    } // Capture masterSelectChange from slate variants.js

    self.$element.on("masterSelectChange", function (event) {
      if ($.code.debug) {
        console.log("masterSelectChange:", event.variant);
      } // Get variant id from event

      var variant_id = event.variant.id; // Update the specs

      if (self.options.onMasterSelectChange.updateSpecs) {
        self.updateSpecs(variant_id);
      } // Tell slideshow to go to slide i

      if (self.options.onMasterSelectChange.updateVariantImagesInSwiper) {
        self.goToVariant(variant_id);
      }
    });
  };
  /**
   * Init the product zoom
   *
   * @return void
   * @access public
   */

  product_plugin.prototype.initProductZoom = function () {
    var self = this; // Init easyzoom

    self.$element.find("[data-product-easy-zoom]").each(function () {
      $(this).easyZoom(self.options.easyzoom);
    });
  };
  /**
   * Update Product Specs
   *
   * @return void
   * @access public
   */

  product_plugin.prototype.updateSpecs = function (currentVariantId) {
    var self = this;

    if (
      !self.$specs.length ||
      !self.specs_data.specs ||
      !self.specs_data.row_template ||
      !self.specs_data.divider
    ) {
      return;
    } // Loop the specs

    $.each(self.specs_data.specs, function (index, value) {
      var variantSpecs = value.split(self.specs_data.divider);
      var variantId = variantSpecs[0].split(":::")[1];

      if (variantId == currentVariantId) {
        var rowHtml = self.specs_data.row_template;
        var specHtml = ""; // Loop the specs to create html from the template

        $.each(variantSpecs, function (i, specs) {
          var pair = variantSpecs[i];
          var key = pair.split(":::")[0];
          var value = pair.split(":::")[1]; // Skip the variant ID

          if (key == "variant_id") {
            return;
          }

          specHtml =
            specHtml + rowHtml.replace("[key]", key).replace("[value]", value);
        }); // Insert the html

        self.$specs.html(specHtml); // break the loop

        return false;
      }
    });
  };
  /**
   * Init the product fancybox Image popup slideshow
   *
   * @return void
   * @access public
   */

  product_plugin.prototype.initProductFancyboxGallery = function () {
    var self = this; // Init fancybox on all Product images, except for slide duplicates

    self.$element
      .find("[data-fancybox]")
      .not(".swiper-slide-duplicate [data-fancybox]")
      .fancybox(self.options.fancybox);
  };
  /**
   * Init the product slideshow
   *
   * @return void
   * @access public
   */

  product_plugin.prototype.initProductSwipers = function () {
    var self = this;
    var swiperOptions = {}; // If thumbnails must be a swiper

    if (
      typeof self.productImagesSwiperNav.data("swiper-options") != "undefined"
    ) {
      // Init thumbnail Swiper
      self.productImagesSwiperNav.swiperLoader(); // Get the thumbnail Swiper Instance

      var productImagesSwiperNavInstance = self.productImagesSwiperNav.find(
        ".swiper-container:first"
      )[0].swiper; // Set thumbnail instance as thumbs in options for Product image Swiper

      swiperOptions = {
        thumbs: {
          swiper: productImagesSwiperNavInstance,
        },
      };
    } else {
      // Find all thumbnails
      var $thumbs = self.productImagesSwiperNav.find("[data-product-thumb]"); // Catch click on a thumbnail

      self.productImagesSwiperNav.on(
        "click",
        "[data-product-thumb]",
        function () {
          var slideIndex = $thumbs.index($(this)); // Tell Product images Swiper to show that image

          self.productImagesSwiper.swiperLoader("goToSlide", slideIndex);
        }
      );
    } // Init Product images Swiper

    self.productImagesSwiper.swiperLoader(swiperOptions); // Get Swiper options for gotovariant

    self.swiperOptions = self.productImagesSwiper.data("swiper-options"); // Get the Product image Swiper Instance

    self.productImagesSwiperInstance = self.productImagesSwiper.find(
      ".swiper-container:first"
    )[0].swiper; // If the PDP is loaded with a variant parameter, show the image of the variant

    if (self.options.onMasterSelectChange.triggerOnPageLoad) {
      // Find the current variant
      var currentVariantId = self.$element.find('[name="id"]').val();
      self.goToVariant(currentVariantId, 0);
    } // Init productzoom on product image

    self.initProductZoom(); // Init productzoom popup gallery

    self.initProductFancyboxGallery();
  };
  /**
   * Slideshow GoToVariant
   *
   * @return void
   * @access public
   */

  product_plugin.prototype.goToVariant = function (variantId, speed) {
    var self = this;

    if (typeof self.productImagesSwiperInstance == "undefined") {
      return;
    } // Loop the slides in self.productImagesSwiperInstance

    self.productImagesSwiperInstance.slides.each(function (slideIndex) {
      // Get variant Ids for this slide
      var ids = $(this).data("product-variant-image");

      if (typeof ids == "undefined") {
        return;
      }

      for (var index = 0; index < ids.length; index++) {
        var id = ids[index]; // If this slide has the variantId

        if (id == variantId) {
          if (self.swiperOptions.loop) {
            slideIndex -= 1;
          } // Tell slider to go to this slide


          // Disabled by Raftel tech

          // self.productImagesSwiper.swiperLoader("goToSlide", slideIndex, speed); // Stop loop

          return false;
        }
      }
    });
  };
  /**
   * product plugin
   *
   * @return jQuery objects
   */

  $.fn.product = function (options) {
    // Put args in array
    var args = Array.prototype.slice.call(arguments, 1); // Initialize the items

    return this.each(function () {
      // Store the element the plugin is set on
      var $element = $(this); // Guard if plugin was already initted

      var instance = $element.data("plugin_" + _pluginName); // If plugin was not innited

      if (!instance) {
        // Init plugin on element and set guard data on element
        $element.data(
          "plugin_" + _pluginName,
          new product_plugin($element, options)
        );
      } else {
        // If instance already created call method from plugin
        if (typeof options === "string") {
          instance[options].apply(instance, args);
        }
      }
    });
  };
})(jQuery, document, window);
/****************************************************************
 * CODE productQuickbuy
 ****************************************************************/

!(function ($, document, window, undefined) {
  /**
   * Plugin name
   */
  var _pluginName = "productQuickbuy";
  /**
   * @param $element Element Wrapping container div
   * @return productQuickbuy_plugin
   */

  var productQuickbuy_plugin = function productQuickbuy_plugin($element) {
    // Scope it
    var self = this;
    self.$element = $element;
    self.$body = $("body"); // inits

    self.$quickBuyHtml = "";

    if ($.code.debug) {
      console.log("Init productQuickbuy:", self.$element);
    } // Handle click events

    self.handleEvents();
  };
  /**
   * Handle click events
   *
   * @return void
   * @access public
   */

  productQuickbuy_plugin.prototype.handleEvents = function () {
    var self = this; // catch click on quickbuy

    self.$element.on("click", function () {
      // retrieve product handle
      var productHandle = $(this).data("product-quick-buy");
      console.log(productHandle); // retrieve product trough ajax

      self.getAjaxProduct(productHandle);
    });
  };
  /**
   * Get product by ajax
   *
   * @return void
   * @access public
   */

  productQuickbuy_plugin.prototype.getAjaxProduct = function (productHandle) {
    var self = this; // build ajax url

    var productAjaxurl = "/products/" + productHandle + "?view=quickbuy";
    $.ajax({
      url: productAjaxurl,
      type: "GET",
    }) // when
      .done(function (data) {
        // assign content
        self.$quickBuyHtml = data;
        self.openPopup();
      }) // if failed to load
      .fail(function (data) {
        // message for failed product load
        self.$quickBuyHtml =
          "<p>Apologies, product could not be loaded. Please, try again later.</p>"; // output in debugger

        if ($.code.debug) {
          console.log("productQuickbuy Ajax load FAIL:", data);
        }

        self.openPopup();
      })
      .always(function (data) {});
  };
  /**
   * Open popup
   *
   * @return void
   * @access public
   */

  productQuickbuy_plugin.prototype.openPopup = function () {
    self = this; // open fancybox

    $.fancybox.open(self.$quickBuyHtml, {
      hideScrollbar: false,
      hash: false,
      touch: false,
      autoFocus: false,
      backFocus: false,
      baseClass: "ajax-cart-warning-popup",
      // Toggle extra body & header-wrapper class for notifications
      beforeShow: function beforeShow() {
        $("body").removeClass("fancybox-active");
      },
      afterClose: function afterClose() {},
    }); // register slate product section

    var sections = new slate.Sections();
    sections.register("product", theme.Product);
  };
  /**
   * productQuickbuy plugin
   *
   * @return jQuery objects
   */

  $.fn.productQuickbuy = function (options) {
    // Put args in array
    var args = Array.prototype.slice.call(arguments, 1); // Initialize the items

    return this.each(function () {
      // Store the element the plugin is set on
      var $element = $(this); // Guard if plugin was already initted

      var instance = $element.data("plugin_" + _pluginName); // If plugin was not innited

      if (!instance) {
        // Init plugin on element and set guard data on element
        $element.data(
          "plugin_" + _pluginName,
          new productQuickbuy_plugin($element, options)
        );
      } else {
        // If instance already created call method from plugin
        if (typeof options === "string") {
          instance[options].apply(instance, args);
        }
      }
    });
  };
})(jQuery, document, window);
/**
 * Minified by jsDelivr using UglifyJS v3.3.25.
 * Original file: /npm/js-cookie@2.2.0/src/js.cookie.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */

!(function (e) {
  var n = !1;

  if (
    ("function" == typeof define && define.amd && (define(e), (n = !0)),
    "object" ==
      (typeof exports === "undefined" ? "undefined" : _typeof(exports)) &&
      ((module.exports = e()), (n = !0)),
    !n)
  ) {
    var o = window.Cookies,
      t = (window.Cookies = e());

    t.noConflict = function () {
      return (window.Cookies = o), t;
    };
  }
})(function () {
  function g() {
    for (var e = 0, n = {}; e < arguments.length; e++) {
      var o = arguments[e];

      for (var t in o) {
        n[t] = o[t];
      }
    }

    return n;
  }

  return (function e(l) {
    function C(e, n, o) {
      var t;

      if ("undefined" != typeof document) {
        if (1 < arguments.length) {
          if (
            "number" ==
            typeof (o = g(
              {
                path: "/",
              },
              C.defaults,
              o
            )).expires
          ) {
            var r = new Date();
            r.setMilliseconds(r.getMilliseconds() + 864e5 * o.expires),
              (o.expires = r);
          }

          o.expires = o.expires ? o.expires.toUTCString() : "";

          try {
            (t = JSON.stringify(n)), /^[\{\[]/.test(t) && (n = t);
          } catch (e) {}

          (n = l.write
            ? l.write(n, e)
            : encodeURIComponent(String(n)).replace(
                /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
                decodeURIComponent
              )),
            (e = (e = (e = encodeURIComponent(String(e))).replace(
              /%(23|24|26|2B|5E|60|7C)/g,
              decodeURIComponent
            )).replace(/[\(\)]/g, escape));
          var i = "";

          for (var c in o) {
            o[c] && ((i += "; " + c), !0 !== o[c] && (i += "=" + o[c]));
          }

          return (document.cookie = e + "=" + n + i);
        }

        e || (t = {});

        for (
          var a = document.cookie ? document.cookie.split("; ") : [],
            s = /(%[0-9A-Z]{2})+/g,
            f = 0;
          f < a.length;
          f++
        ) {
          var p = a[f].split("="),
            d = p.slice(1).join("=");
          this.json || '"' !== d.charAt(0) || (d = d.slice(1, -1));

          try {
            var u = p[0].replace(s, decodeURIComponent);
            if (
              ((d = l.read
                ? l.read(d, u)
                : l(d, u) || d.replace(s, decodeURIComponent)),
              this.json)
            )
              try {
                d = JSON.parse(d);
              } catch (e) {}

            if (e === u) {
              t = d;
              break;
            }

            e || (t[u] = d);
          } catch (e) {}
        }

        return t;
      }
    }

    return (
      ((C.set = C).get = function (e) {
        return C.call(C, e);
      }),
      (C.getJSON = function () {
        return C.apply(
          {
            json: !0,
          },
          [].slice.call(arguments)
        );
      }),
      (C.defaults = {}),
      (C.remove = function (e, n) {
        C(
          e,
          "",
          g(n, {
            expires: -1,
          })
        );
      }),
      (C.withConverter = e),
      C
    );
  })(function () {});
});
/****************************************************************
 * CODE enhancedSearch
 ****************************************************************/

!(function ($, document, window, undefined) {
  /**
   * Plugin name
   */
  var _pluginName = "enhancedSearch";
  /**
   * @param $element Element Wrapping container div
   * @return enhancedSearch_plugin
   */

  var enhancedSearch_plugin = function enhancedSearch_plugin(
    $element,
    options
  ) {
    // Scope it
    var self = this; // Find elements

    self.$element = $element;
    self.type = self.$element.data("enhanced-search");
    self.$input = self.$element.find('input[type="search"]'); // Set options

    var defaults = {
      wildcard: true,
      // Always add wildcard *
      predictiveSearch: true,
      // Use predicitve search
      show_all: "Show all results",
      // Translatable string
      type: "product",
      // product, page, article or collection
      limit: 10,
      // Default: 10. Min: 1. Max: 10.
      options: {
        unavailable_products: "last",
        // show, hide or last
        fields: "title,product_type,variants.title", // Specifies the list of fields to search on. Valid fields are: author, body, product_type, tag, title, variants.barcode, variants.sku, variants.title, and vendor. The default fields searched on are: title, product_type, variants.title, and vendor.
      },
    };
    var metaOptions = self.$element.data("enhanced-search");
    self.options = $.extend({}, defaults, metaOptions);

    if ($.code.debug) {
      console.log("Init Enhanced Search:", self.$element, self.options);
    }

    if (self.options.wildcard) {
      self.initWildcard();
    }

    if (self.options.predictiveSearch) {
      self.initPredictiveSearch();
    }
  };
  /**
   * Search with product dropdown
   */

  enhancedSearch_plugin.prototype.initPredictiveSearch = function () {
    var self = this; // Current Ajax request.

    var currentAjaxRequest = null; // Grabbing text input.

    var $input = self.$element.find('input[name="q"]'); // Create a list

    self.$dropdown = $(
      '<ul class="search-dropdown-results" data-enhanced-search="results"></ul>'
    ); // Adding a list for showing search results.

    $(self.$dropdown).appendTo(self.$element); // Listening to keyup and change on the text field within these search forms.

    $input.attr("autocomplete", "off").on("keyup change", function () {
      // What are the search self.terms
      self.terms = $input.val(); // If that's a new term and it contains at least 2 characters.

      if (
        self.terms.length > 2 &&
        self.terms != $input.attr("data-old-self.terms")
      ) {
        // Saving old query.
        $input.attr("data-old-self.terms", self.terms); // Killing any Ajax request that's currently being processed.

        if (currentAjaxRequest != null) {
          currentAjaxRequest.abort();
        }

        currentAjaxRequest = jQuery
          .getJSON("/search/suggest.json", {
            q: self.terms,
            resources: self.options,
          })
          .done(function (response) {
            self.renderResults(response);
          });
      }
    });
    $input.keydown(function (e) {
      if (!self.dropdownVisible) {
        // on key arrow down and if results are filled
        if (
          e.which == 40 &&
          self.$element.find('[data-enhanced-search="results"]').children()
            .length
        ) {
          self.openDropdown();
        } else {
          return;
        }
      }

      var i = self.$dropdown.find(".is-active").index();

      switch (e.which) {
        case 38:
          // up
          i--;
          break;

        case 40:
          // down
          i++;
          break;

        case 27:
          self.closeDropdown();
          break;

        case 13:
          // enter
          if (self.$dropdown.find("li.is-active").length) {
            e.preventDefault();
            var url = self.$dropdown.find("li.is-active a").attr("href");
            document.location.href = url;
          }

          break;

        default:
          return;
        // exit this handler for other keys
      }

      self.$dropdown
        .find("li:eq(" + i + ")")
        .addClass("is-active")
        .siblings(".is-active")
        .removeClass("is-active");
    }); // Clicking outside makes the results disappear.

    $("body").on("click", function () {
      self.closeDropdown();
    });
  };
  /**
   * Render results in dropdown
   */

  enhancedSearch_plugin.prototype.renderResults = function (response) {
    var self = this;

    if ($.code.debug) {
      console.log(response);
    }

    var pageSuggestions = response.resources.results.pages;
    var productSuggestions = response.resources.results.products;
    var articleSuggestions = response.resources.results.articles;
    var collectionSuggestions = response.resources.results.collections; // Reset results

    self.$dropdown.empty(); // Result: product

    if (productSuggestions && productSuggestions.length > 0) {
      $.each(productSuggestions, function (index, item) {
        var link = $('<a class="search-result__product"></a>').attr(
          "href",
          item.url
        ); // if (item.featured_image.url) {
        //   link.append('<span class="thumbnail"><img src="' + Shopify.resizeImage(item.featured_image.url, '100x100') + '" /></span>');
        // } else {
        //   link.append('<span class="thumbnail no-image"></span>');
        // }

        link.append('<span class="title">' + item.title + "</span>"); // link.append('<span class="price">' + Shopify.formatMoney(item.price) + '</span>');

        link.wrap('<li class="search-dropdown-results__item"></li>');
        self.$dropdown.append(link.parent());
      });
    } // Result: article

    if (articleSuggestions && articleSuggestions.length > 0) {
      $.each(articleSuggestions, function (index, item) {
        var link = $('<a class="search-result__article"></a>').attr(
          "href",
          item.url
        ); // if (item.featured_image.url) {
        //   link.append('<span class="thumbnail"><img src="' + Shopify.resizeImage(item.featured_image.url, '100x100') + '" /></span>');
        // } else {
        //   link.append('<span class="thumbnail no-image"></span>');
        // }

        link.append('<span class="title">' + item.title + "</span>");
        link.wrap('<li class="search-dropdown-results__item"></li>');
        self.$dropdown.append(link.parent());
      });
    } // Result: page

    if (pageSuggestions && pageSuggestions.length > 0) {
      $.each(pageSuggestions, function (index, item) {
        var link = $('<a class="search-result__page"></a>').attr(
          "href",
          item.url
        ); // link.append('<span class="thumbnail no-image"></span>');

        link.append('<span class="title">' + item.title + "</span>");
        link.wrap('<li class="search-dropdown-results__item"></li>');
        self.$dropdown.append(link.parent());
      });
    } // Result: collection

    if (collectionSuggestions && collectionSuggestions.length > 0) {
      $.each(collectionSuggestions, function (index, item) {
        var link = $('<a class="search-result__collection"></a>').attr(
          "href",
          item.url
        ); // if (item.featured_image.url) {
        //   link.append('<span class="thumbnail"><img src="' + Shopify.resizeImage(item.featured_image.url, '100x100') + '" /></span>');
        // } else {
        //   link.append('<span class="thumbnail no-image"></span>');
        // }

        link.append('<span class="title">' + item.title + "</span>");
        link.wrap('<li class="search-dropdown-results__item"></li>');
        self.$dropdown.append(link.parent());
      });
    } // If results

    if (self.$dropdown.children().length) {
      var query = self.createQuery(); // Show all results

      self.$dropdown.append(
        '<li class="search-dropdown-results__item search-show_all"><a href="/search' +
          query +
          '">' +
          self.options.show_all +
          "</a></li>"
      );
      self.openDropdown(); // If no results
    } else {
      self.closeDropdown();
    }
  };
  /**
   * Open predictiveSearch dropdown
   */

  enhancedSearch_plugin.prototype.openDropdown = function () {
    var self = this;
    self.$element
      .find('[data-enhanced-search="results"]')
      .addClass("search-dropdown__is-open");
    self.dropdownVisible = true;
  };
  /**
   * Close predictiveSearch dropdown
   */

  enhancedSearch_plugin.prototype.closeDropdown = function () {
    var self = this;
    self.$element
      .find('[data-enhanced-search="results"]')
      .removeClass("search-dropdown__is-open");
    self.dropdownVisible = false;
  };
  /**
   * Create query from form elements
   */

  enhancedSearch_plugin.prototype.createQuery = function () {
    var self = this;
    var query = ""; // Loop all inputs

    self.$element.find("input").each(function (index, input) {
      var name = $(input).attr("name");
      var val = $(input).val();
      query += "&" + name + "=" + val;

      if (self.options.wildcard && name == "q" && val.indexOf("*") < 0) {
        query += "*";
      }
    });
    return query.replace("&", "?");
  };
  /**
   * search with automatic Wildcard
   */

  enhancedSearch_plugin.prototype.initWildcard = function () {
    var self = this;
    var canSubmit = false; // on submit form

    self.$element.on("submit", function (e) {
      // prevent default
      e.preventDefault(); // Create a search query

      self.terms = self.createQuery(); // submit form

      location.href = "/search" + self.terms;
    });
  };
  /**
   * enhancedSearch plugin
   *
   * @return jQuery objects
   */

  $.fn.enhancedSearch = function (options) {
    // put args in array
    var args = Array.prototype.slice.call(arguments, 1); // initialize the items

    return this.each(function () {
      // store the element the plugin is set on
      var $element = $(this); // guard if plugin was already initted

      var instance = $element.data("plugin_" + _pluginName); // if plugin was not innited

      if (!instance) {
        // init plugin on element and set guard data on element
        $element.data(
          "plugin_" + _pluginName,
          new enhancedSearch_plugin($element, options)
        );
      } else {
        // if instance already created call method from plugin
        if (typeof options === "string") {
          instance[options].apply(instance, args);
        }
      }
    });
  };
})(jQuery, document, window);
/****************************************************************
 * CODE swiperLoader
 ****************************************************************/

!(function ($, document, window, undefined) {
  /**
   * Plugin name
   */
  var _pluginName = "swiperLoader";
  /**
   * @param $element Element Wrapping container div
   * @param options Options passed to public functions
   * @return swiperLoader_plugin
   */

  var swiperLoader_plugin = function swiperLoader_plugin($element, options) {
    // scope it
    var self = this;
    self.$element = $element; // Set default options, for more options check: https://idangero.us/swiper/api/

    var defaults = {
      loop: false,
      initialSlide: 0,
      // Index number of initial slide.
      speed: 300,
      // Duration of transition between slides (in ms)
      direction: "horizontal",
      // Could be 'horizontal' or 'vertical' (for vertical slider).
      autoHeight: false,
      // Set to true and slider wrapper will adopt its height to the height of the currently active slide
      roundLengths: true,
      // Set to true to round values of slides width and height to prevent blurry texts on usual resolution screens (if you have such)
      effect: "slide",
      // Transition effect. Could be "slide", "fade", "cube", "coverflow" or "flip"
      spaceBetween: 0,
      // Distance between slides in px.
      slidesPerView: 1,
      // Number of slides per view (slides visible at the same time on slider's container).
      centeredSlides: false,
      // 	If true, then active slide will be centered, not always on the left side.
      centerInsufficientSlides: false,
      // When enabled it center slides if the amount of slides less than `slidesPerView`. Not intended to be used loop mode
      grabCursor: false,
      // This option may a little improve desktop usability. If true, user will see the "grab" cursor when hover on Swiper
      touchEventsTarget: "wrapper",
      // Target element to listen touch events on. Can be 'container' (to listen for touch events on swiper-container) or 'wrapper' (to listen for touch events on swiper-wrapper)
      watchOverflow: true,
      // When enabled Swiper will be disabled and hide navigation buttons on case there are not enough slides for sliding
      shortSwipes: true,
      // Set to false if you want to disable short swipes
      threshold: 10,
      // Threshold value in px. If "touch distance" will be lower than this value then swiper will not move
      navigation: {
        nextEl: ".swiper-button-next",
        //	string / HTMLElement	null	String with CSS selector or HTML element of the element that will work like "next" button after click on it
        prevEl: ".swiper-button-prev",
        // string / HTMLElement	null	String with CSS selector or HTML element of the element that will work like "prev" button after click on it
        hideOnClick: false,
        //	Toggle navigation buttons visibility after click on Slider's container
        disabledClass: "swiper-button-disabled",
        // CSS class name added to navigation button when it becomes disabled
        hiddenClass: "swiper-button-hidden", // CSS class name added to navigation button when it becomes hidden
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        //String with type of pagination. Can be "bullets", "fraction", "progressbar" or "custom"
        bulletElement: "span",
        //	Defines which HTML tag will be use to represent single pagination bullet. Only for bullets pagination type.
        hideOnClick: false,
        // Toggle (hide/true) pagination container visibility after click on Slider's container
        clickable: true, //	If true then clicking on pagination button will cause transition to appropriate slide. Only for bullets pagination type
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: true,
        //	Hide scrollbar automatically after user interaction
        draggable: true,
        //	Set to true to enable make scrollbar draggable that allows you to control slider position
        snapOnRelease: true,
        //	Set to false to unsnap slider position to slides when you release scrollbar
        dragSize: "auto",
        // string/number	Size of scrollbar draggable element in px
        lockClass: "swiper-scrollbar-lock",
        //	Scrollbar element additional CSS class when it is disabled
        dragClass: "swiper-scrollbar-drag", //	Scrollbar draggable element CSS class
      },
    }; // get options from element

    var metaOptions = self.$element.data("swiper-options");
    self.options = $.extend({}, defaults, metaOptions, options);

    if ($.code.debug) {
      console.log("Init swiper:", self.$element, self.options);
    }

    self.$element.removeClass("row");
    self.$sliderContainer = self.$element.find(".swiper-container:first"); // Add elements from options

    if (self.options.scrollbar) {
      self.$sliderContainer.append('<div class="swiper-scrollbar"></div>');
    }

    if (self.options.navigation) {
      self.$sliderContainer.append(
        '<div class="swiper-button-prev"></div><div class="swiper-button-next"></div>'
      );
    }

    if (self.options.pagination) {
      self.$sliderContainer.append('<div class="swiper-pagination"></div>');
    } // start the swiper

    self.swiperInst = new Swiper(self.$sliderContainer[0], self.options); // Custom next navigation (must be [data-swiper] > [data-swiper-nav="next"])

    self.$element.on("click", '[data-swiper-nav="next"]', function () {
      self.swiperInst.slideNext();
    }); // Custom prev navigation (must be [data-swiper] > [data-swiper-nav="prev"])

    self.$element.on("click", '[data-swiper-nav="prev"]', function () {
      self.swiperInst.slidePrev();
    }); // Trigger custom event

    self.swiperInst.on("slideChange", function () {
      self.$element.trigger("productVideoSlideChange");
    });
  };
  /**
   * Edit slide
   *
   * @return void
   * @access public
   */

  swiperLoader_plugin.prototype.editSlide = function ($slide) {
    var self = this;
    var index = $(self.swiperInst.slides).index($slide);
    self.goToSlide(index - 1);
  };
  /**
   * Go To slide
   *
   * @return void
   * @access public
   */

  swiperLoader_plugin.prototype.goToSlide = function (index, speed) {
    var self = this; // If no speed is defined, use the speed from options (speed can be 0)

    if (!speed && speed !== 0) {
      speed = self.options.speed;
    } // slide to index

    if (self.options.loop) {
      self.swiperInst.slideToLoop(index, speed);
    } else {
      self.swiperInst.slideTo(index, speed);
    }
  };
  /**
   * swiperLoader plugin
   *
   * @return jQuery objects
   */

  $.fn.swiperLoader = function (options) {
    // put args in array
    var args = Array.prototype.slice.call(arguments, 1); // initialize the items

    return this.each(function () {
      // store the element the plugin is set on
      var $element = $(this); // guard if plugin was already initted

      var instance = $element.data("plugin_" + _pluginName); // if plugin was not innited

      if (!instance) {
        // init plugin on element and set guard data on element
        $element.data(
          "plugin_" + _pluginName,
          new swiperLoader_plugin($element, options)
        );
      } else {
        // if instance already created call method from plugin
        if (typeof options === "string") {
          instance[options].apply(instance, args);
        }
      }
    });
  };
})(jQuery, document, window);
/****************************************************************
 * CODE tabs
 ****************************************************************/

!(function ($, document, window, undefined) {
  /**
   * Plugin name
   */
  var _pluginName = "tabs";
  /**
   * @param $element Element Wrapping container div
   * @param options Options passed to public functions
   * @return tabs_plugin
   */

  var tabs_plugin = function tabs_plugin($element, options) {
    // Scope it
    var self = this;
    self.$element = $element; // Get options

    var defaults = {};
    var metaOptions = self.$element.data("tabs");
    self.options = $.extend({}, defaults, metaOptions);

    if ($.code.debug) {
      console.log("Init tabs:", self.$element, self.options);
    } // Start the tabs

    self.init();
  };
  /**
   * Init
   *
   * @return void
   * @access public
   */

  tabs_plugin.prototype.init = function () {
    var self = this;
    self.$tabsContent = self.$element.find("[data-tabs-content]");
    self.$tabsNav = self.$element.find("[data-tabs-nav]");

    if (self.options.create) {
      self.createTabs();
    } // Catch click on desktop tab navigation

    self.$tabsNav.on(
      {
        click: function click(event) {
          event.preventDefault();

          if (!$(this).is(".is-active")) {
            $(this).trigger("open");
          }
        },
        open: function open() {
          var title = $(this).data("tabs-link"); // Close the active tab and open the clicked tab after that

          self.closeActiveTab(title, self.openTab(title)); // Open the clicked tag link

          self.openTabNavLink(title);
        },
      },
      "[data-tabs-link]"
    ); // Catch click on mobile tab navigation

    self.$tabsContent.on("click", "[data-tabs-link]", function (event) {
      var title = $(this).data("tabs-link");

      if ($(this).hasClass("is-active")) {
        // Close the tab and link in content
        self.closeTab(title);
      } else {
        // Open the tab and link in content
        self.openTab(title);
      }
    }); // Catch open tab by url hash

    if (window.location.hash) {
      var hash = window.location.hash.substring(1);
      self.$tabsNav.find('[data-tabs-link="' + hash + '"]').trigger("open");
    } else {
      self.$tabsNav.find("[data-tabs-link]:first").trigger("open");
    }
  };
  /**
   * create tabs
   *
   * @return void
   * @access public
   */

  tabs_plugin.prototype.createTabs = function () {
    var self = this;
    self.$tabsContent.find("h2").each(function (i, tabDivider) {
      // Get tab title from h2
      var tabTitle = $(tabDivider).text();
      var tabLink = tabTitle
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/-$/, "")
        .replace(/^-/, ""); // Make tab html

      var $parent = $(tabDivider).closest(".tabs-content-pane");
      var $link = $(
        '<div class="tabs-content-link" data-tabs-link="' +
          tabLink +
          '"><span>' +
          tabTitle +
          "</span></div>"
      );
      $parent.attr("data-tabs-content-pane", tabLink);
      $link.insertBefore($parent);
      $(tabDivider).remove(); // Add to tab nav

      self.$tabsNav
        .find("ol")
        .append(
          '<li class="tabs-nav-item" data-tabs-link="' +
            tabLink +
            '"><a href="#' +
            tabLink +
            '">' +
            tabTitle +
            "</a></li>"
        );
    });
  };
  /**
   * close tab
   *
   * @return void
   * @access public
   */

  tabs_plugin.prototype.closeActiveTab = function (title, callback) {
    var self = this;
    var $activeTab = self.$tabsNav
      .find(".is-active")
      .not('[data-tabs-link="' + title + '"]'); // If there is an active tab

    if ($activeTab.length) {
      // Get title
      var activeTitle = $activeTab.data("tabs-link"); // Don't reopen self

      if (activeTitle == title) {
        return;
      }

      self.closeTab(activeTitle);
      self.closeTabNavLink(activeTitle);
    }

    if (typeof callback == "function") {
      callback();
    }
  };
  /**
   * close tab
   *
   * @return void
   * @access public
   */

  tabs_plugin.prototype.closeTab = function (title) {
    var self = this; // Close the tab

    self.$tabsContent
      .find('[data-tabs-content-pane="' + title + '"]')
      .removeClass("is-active"); // Close the tablink in content (on mobile)

    self.$tabsContent
      .find('[data-tabs-link="' + title + '"]')
      .removeClass("is-active"); // Remove body class if data-tabs-body-class exists

    if (self.$element.data("tabs-body-class") !== "undefined") {
      if (self.$element.find(".tabs-content-pane.is-active").length < 1) {
        $("body").removeClass(self.$element.data("tabs-body-class"));
      }

      setTimeout(function () {
        if (self.$element.find(".tabs-content-pane.is-active").length < 1) {
          self.$element.closest(".ingredients-facts").removeClass("is-open");
        }
      }, 500);
    }
  };
  /**
   * close link in tab nav
   *
   * @return void
   * @access public
   */

  tabs_plugin.prototype.closeTabNavLink = function (title) {
    var self = this; // Close the tablink in nav

    self.$tabsNav
      .find('[data-tabs-link="' + title + '"]')
      .removeClass("is-active");
  };
  /**
   * open tab
   *
   * @return void
   * @access public
   */

  tabs_plugin.prototype.openTab = function (title) {
    var self = this; // Open new tab

    self.$tabsContent
      .find('[data-tabs-content-pane="' + title + '"]')
      .addClass("is-active"); // Close the tablink in content (on mobile)

    self.$tabsContent
      .find('[data-tabs-link="' + title + '"]')
      .addClass("is-active"); // Add body class if data-tabs-body-class exists

    if (self.$element.data("tabs-body-class") !== "undefined") {
      if (self.$element.find(".tabs-content-pane.is-active").length >= 1) {
        $("body").addClass(self.$element.data("tabs-body-class"));
        self.$element.closest(".ingredients-facts").addClass("is-open");
      }
    }
  };
  /**
   * open tablink in Nav
   *
   * @return void
   * @access public
   */

  tabs_plugin.prototype.openTabNavLink = function (title) {
    var self = this; // Open new tab

    self.$tabsNav
      .find('[data-tabs-link="' + title + '"]')
      .addClass("is-active");
  };
  /**
   * Reset the tab navigation and tabs
   *
   * @return void
   * @access public
   */

  tabs_plugin.prototype.reset = function () {
    var self = this; // If there is no active tab in navigation or content

    if (
      self.$tabsNav.find(".is-active").length == 0 ||
      self.$tabsContent.find(".is-active").length == 0
    ) {
      // Remove all active classes
      self.$element.find(".is-active").removeClass("is-active"); // open the first tab in navigation

      self.$tabsNav.find("[data-tabs-link]").first().trigger("click");
    }
  };
  /**
   * tabs plugin
   *
   * @return jQuery objects
   */

  $.fn.tabs = function (options) {
    // Put args in array
    var args = Array.prototype.slice.call(arguments, 1); // Initialize the items

    return this.each(function () {
      // Store the element the plugin is set on
      var $element = $(this); // Guard if plugin was already initted

      var instance = $element.data("plugin_" + _pluginName); // If plugin was not innited

      if (!instance) {
        // Init plugin on element and set guard data on element
        $element.data(
          "plugin_" + _pluginName,
          new tabs_plugin($element, options)
        );
      } else {
        // If instance already created call method from plugin
        if (typeof options === "string") {
          instance[options].apply(instance, args);
        }
      }
    });
  };
})(jQuery, document, window);
/****************************************************************
 * CODE toggleElementClass
 ****************************************************************/

!(function ($, document, window, undefined) {
  /**
   * Plugin name
   */
  var _pluginName = "toggleElementClass";
  /**
   * @param $element Element Wrapping container div
   * @param options Options passed to public functions
   * @return toggleElementClass_plugin
   */

  var toggleElementClass_plugin = function toggleElementClass_plugin(
    $element,
    options
  ) {
    // scope it
    var self = this;
    self.$element = $element;

    if ($.code.debug) {
      console.log("Init toggleElementClass:", self.$element);
    } // Catch click on element

    self.$element.on("click", function (event) {
      self.getOptions(self.$element);

      if (!self.$target.length || !self.options.class) {
        return;
      }

      self.handleEvents(event);
      self.toggleTheClass();
    });
  };
  /**
   * get options
   *
   * @return void
   * @access public
   */

  toggleElementClass_plugin.prototype.getOptions = function ($element) {
    var self = this;

    if (self.options) {
      return;
    }

    var defaults = {
      target: "body",
      stopPropagation: true,
      preventDefault: true,
    };
    var metaOptions = $element.data("toggle-element-class");
    self.options = $.extend({}, defaults, metaOptions);
    self.$target = $(self.options.target);
  };
  /**
   * Handle events
   *
   * @return void
   * @access public
   */

  toggleElementClass_plugin.prototype.handleEvents = function (event) {
    var self = this;

    if (self.options.preventDefault) {
      event.preventDefault();
    }

    if (self.options.stopPropagation) {
      event.stopPropagation();
    }
  };
  /**
   * Toggle the Class
   *
   * @return void
   * @access public
   */

  toggleElementClass_plugin.prototype.toggleTheClass = function () {
    var self = this;

    if (self.$target.hasClass(self.options.class)) {
      // if class is set, remove it
      self.removeTheClass();
    } else {
      // if class is not set, add it
      self.addTheClass();
    }
  };
  /**
   * Add the Class
   *
   * @return void
   * @access public
   */

  toggleElementClass_plugin.prototype.addTheClass = function () {
    var self = this; // Get the options again in case this is called from outside

    self.getOptions(self.$element);
    self.$target.addClass(self.options.class);
  };
  /**
   * Remove the Class
   *
   * @return void
   * @access public
   */

  toggleElementClass_plugin.prototype.removeTheClass = function () {
    var self = this; // Get the options again in case this is called from outside

    self.getOptions(self.$element);
    self.$target.removeClass(self.options.class);
  };
  /**
   * toggleElementClass plugin
   *
   * @return jQuery objects
   */

  $.fn.toggleElementClass = function (options) {
    // put args in array
    var args = Array.prototype.slice.call(arguments, 1); // initialize the items

    return this.each(function () {
      // store the element the plugin is set on
      var $element = $(this); // guard if plugin was already initted

      var instance = $element.data("plugin_" + _pluginName); // if plugin was not innited

      if (!instance) {
        // init plugin on element and set guard data on element
        $element.data(
          "plugin_" + _pluginName,
          new toggleElementClass_plugin($element, options)
        );
      } else {
        // if instance already created call method from plugin
        if (typeof options === "string") {
          instance[options].apply(instance, args);
        }
      }
    });
  };
})(jQuery, document, window);
/****************************************************************
 * CODE init
 ****************************************************************/

$.code.init = function () {
  // Set global variables
  $.code.setVars(); // Set debugging flag

  $.code.debug = false; // Handle window resizing

  $.code.windowResizeHandler();
  /**
   * init plugins
   */
  // Init ajax cart

  $("body").ajaxCart(); // Init Swipers

  $("[data-swiper]").swiperLoader(); // Init collapsible panes

  $("[data-collapsible-wrapper]").collapsible(); // Init enhanced search

  $("[data-enhanced-search]").enhancedSearch(); // Init class togglers

  $("[data-toggle-element-class]").toggleElementClass(); // Init tabs

  $("[data-tabs]").tabs(); // Init country popup

  $("body").countryPopup(); // Init datalayer handler

  $("body").datalayer();
  $("[data-cookie-plugin]").cookiePlugin(); // Init product videos

  $("[data-product-videos]").productVideos(); // account register

  if ($("body.template-register")) {
    var handlePasswordVisibility = function handlePasswordVisibility() {
      $("[data-password-real]").toggleClass("hidden");
      $("[data-password-fake]").toggleClass("hidden");
    };

    var syncPasswordInput = function syncPasswordInput() {
      var currentValue = $(this).val();
      $("[data-password-input]").val(currentValue);
    }; // catch password visibility toggle

    $("[data-password-toggle]").on("click", handlePasswordVisibility); // sync password visual encrypt

    $("[data-password-fake], [data-password-real]").on(
      "keyup",
      syncPasswordInput
    );
  } // Init header announcements

  $("[data-header-announcements]").headerAnnouncements(); // Init product quickBuy

  $("[data-product-quick-buy]").productQuickbuy(); // Scroll to element on page load

  var $scrollEl = $("[data-scroll-here]");

  if ($scrollEl.length) {
    $("html, body").animate(
      {
        scrollTop: $scrollEl.offset().top,
      },
      500
    );
  }

  $("[data-scroll-to-anchor]").on("click", function (event) {
    event.preventDefault();
    var target = $(this).attr("href");
    document.querySelector(target).scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "center",
    });
  });
  /**
   * Handle the toggle header interface
   */

  $("[data-toggle-search]").on("click", function (event) {
    // Prevent default a href link
    event.preventDefault();
    var body = $("body"); // Set the name of the class we use to toggle

    var headerSearchIsOpenClass = "search-open"; // Input selector

    var headerSearchInput = $("#search"); // Toggle the class by default

    body.toggleClass(headerSearchIsOpenClass); // Check if header search is open

    if (body.hasClass(headerSearchIsOpenClass)) {
      // Wait for the animation to finish, otherwise the focus won't work
      setTimeout(function () {
        headerSearchInput.focus();
      }, 240);
    }
  }); // Catch change of currency switcher

  $("body").on("change", '[data-currency="switcher"] select', function () {
    $(this).parents("form").submit();
  });
  /**
   * Show newsletter Pop-up
   */

  var $newsletterPopup = $("[data-newsletter-popup]");
  var hideNewsletterPopupCookie = Cookies.get("hide_newsletter_popup"); // overwrite popup cookie if ?open-newsletter-popup in url

  if (window.location.search.includes("open-newsletter-popup")) {
    hideNewsletterPopupCookie = false;
  } // only open newsletter popup in customiser if needed

  if ($.code.themeEditor) {
    hideNewsletterPopupCookie = true;
  }

  if ($newsletterPopup.length > 0 && !hideNewsletterPopupCookie) {
    if ($.code.debug) {
      console.log("Init newsletter popup", $newsletterPopup);
    } // show popup after x sec

    var seconds = parseInt($newsletterPopup.data("newsletter-popup-time"));

    if (!seconds) {
      seconds = 30;
    }

    var time = seconds * 1000; // overwrite timer if ?open-newsletter-popup in url

    if (window.location.search.includes("open-newsletter-popup")) {
      time = 2.5 * 1000;
    }

    setTimeout(function () {
      $("body").addClass("newsletters-popup-active");
      setTimeout(function () {
        $("body").addClass("newsletters-popup-animate");
      }, 100);
    }, time);
  } // Close popup

  var $closeNewsletterPopup = $("[data-newsletter-close-popup]");
  $closeNewsletterPopup.on("click", function (e) {
    e.preventDefault();
    $("body").removeClass("newsletters-popup-animate");
    setTimeout(function () {
      $("body").removeClass("newsletters-popup-active");
    }, 500); //  hide newsletter popup for 10 days

    var isDay = new Date(new Date().getTime() + 60 * 1000 * 60 * 24 * 10);
    Cookies.set("hide_newsletter_popup", true, {
      expires: isDay,
    });
  });
  /**
   * Handle YotPo loyalty newsletter subscription & set hide newsletter popup cookie
   */

  var $newsletterFormEl = $("[data-yotpo-newsletter-form]");

  if ($newsletterFormEl.length > 0) {
    // fallback selector for register form
    $newsletterFormEl = $("[data-yotpo-newsletter-form-placeholder]").closest(
      "form"
    );
  }

  if ($newsletterFormEl.length > 0) {
    if ($.code.debug) {
      console.log("YotPo newsletter init", $newsletterFormEl);
    } // listen to form submission

    $($newsletterFormEl).on("submit", function (event) {
      // prevent default form behaviour
      event.preventDefault(); // get and set data needed for YotPo loyalty custom action

      var formData = new FormData(event.target);
      var emailValue = formData.get("email");
      var accceptsMarketingValue = true;
      var yotPoConfiguration = $(event.target).data("yotpo-configuration"); // fallback for register form

      if (yotPoConfiguration == null) {
        accceptsMarketingValue = formData.get("customer[accepts_marketing]");
        emailValue = formData.get("customer[email]");
        yotPoConfiguration = $(event.target)
          .find("[data-yotpo-configuration]")
          .data("yotpo-configuration");
      }

      if (!yotPoConfiguration.actionName) {
        yotPoConfiguration = JSON.parse(yotPoConfiguration);
      } // check if the email input field has a value

      if (emailValue && emailValue.length > 0 && accceptsMarketingValue) {
        // hide newsletter popup for a month
        var isMonth = new Date(new Date().getTime() + 60 * 1000 * 24 * 30);
        Cookies.set("hide_newsletter_popup", true, {
          expires: isMonth,
        });
        var actionName = yotPoConfiguration.actionName.length
          ? yotPoConfiguration.actionName
          : "";
        var bodyParams = {
          type: "CustomAction",
          customer_email: emailValue,
          action_name: actionName,
        };
        $.ajax({
          url: "https://loyalty.yotpo.com/api/v2/actions?guid="
            .concat(yotPoConfiguration.guid, "&api_key=")
            .concat(yotPoConfiguration.apiKey),
          type: "POST",
          data: bodyParams,
          dataType: "json",
        })
          .done(function (data) {
            if ($.code.debug) {
              console.log("Newsletter - YotPo Loyalty success 🕺🏻:", data);
            }
          })
          .fail(function (XMLHttpRequest) {
            if ($.code.debug) {
              console.log(
                "Newsletter - YotPo Loyalty fail ⚠️:",
                XMLHttpRequest
              );
            }
          })
          .always(function () {
            // Submit the form to subscribe to newsletter list
            event.target.submit();
          }); // if there is no email address, then submit the newsletter form to Klaviyo
      } else {
        // Submit the form to subscribe to Klaviyo newsletter list
        event.target.submit();
      }
    });
  }
  /**
   * Redirects
   * @description Redirect the user to different place after successful registration
   * @returns void
   */

  $(function () {
    // REDIRECT AFTER REGISTER SUBMIT
    // Set localStorage on register form submit
    $("#registerForm").on("submit", function () {
      // Check element get value
      var $registerSuccessfulReturnToUrl = $("#register_successful_return_to"); // Check if element is available

      if ($registerSuccessfulReturnToUrl.length > 0) {
        // Set localStorage item
        localStorage.setItem(
          "register_successful_return_to_url",
          $registerSuccessfulReturnToUrl.val()
        );
      }
    }); // Check when recaptcha challenge

    if ($("#g-recaptcha").length > 0) {
      // Get saved url
      var localStorageRegisterSuccessfulReturnToUrl = localStorage.getItem(
        "register_successful_return_to_url"
      ); // Check if the localStorage with register_successful_return_to_url is set

      if (localStorageRegisterSuccessfulReturnToUrl) {
        // Add hidden value to the form to change the return_to url
        var $input_return_to = $(
          '<input type="hidden" name="return_to" value="' +
            localStorageRegisterSuccessfulReturnToUrl +
            '" />'
        );
        $input_return_to.insertBefore(
          $('.shopify-challenge__container input[type="submit"]')
        );
      }
    } // When not on the register or challenge page

    if (
      $(".template-customers-register").length == 0 &&
      $(".template-captcha").length == 0
    ) {
      // Get saved item from localStorage
      var localStorageRegisterSuccessfulReturnToUrl = localStorage.getItem(
        "register_successful_return_to_url"
      ); // Remove 'register_successful_return_to_url' from localStorage

      localStorage.removeItem("register_successful_return_to_url"); // Update url when saved localStorage item is set and not matching the same page

      if (
        localStorageRegisterSuccessfulReturnToUrl &&
        localStorageRegisterSuccessfulReturnToUrl != window.location.pathname
      ) {
        window.location.href = localStorageRegisterSuccessfulReturnToUrl;
      }
    }
  });
};
/**
 * Functions to be called after window resizing is finished
 */

$.code.onWindowResize = function () {
  var self = this; // Get new global window width

  $.code.ww = $(window).width();
};
/**
 * Handle window resizing
 */

$.code.windowResizeHandler = function () {
  // Call window resize functions 200ms after window stops being resized
  var timeoutOffset = false;
  $(window).resize(function () {
    if (timeoutOffset !== false) {
      clearTimeout(timeoutOffset);
    }

    timeoutOffset = setTimeout(function () {
      $.code.onWindowResize();
    }, 200);
  });
};
/**
 * Set global variables
 */

$.code.setVars = function () {
  var self = this;

  if (
    window.location.host.indexOf("localhost") > -1 ||
    window.location.host.indexOf("myshopify") > -1 ||
    window.location.host.indexOf("shopifypreview") > -1
  ) {
    $.code.debug = true;
  }

  if ($.code.debug) {
    console.log("Init CODE js with debugging");
  } // Get window width

  $.code.onWindowResize(); // Check for localstorage

  $.code.localStorage = $.code.localStorageTest(); // Set if page is in theme editor

  if (Shopify.designMode) {
    $.code.themeEditor = true;
    $("body").addClass("theme-editor");

    if ($.code.debug) {
      console.log("Theme editor active");
    }
  }
};
/**
 * Test for localStorage
 */

$.code.localStorageTest = function () {
  var test = "test";

  try {
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
};
/**
 * Initialize CODE JS
 */

$.code.init();
$(function () {
  $("[data-close-ingredients-overlay]").on("click", function () {
    if ($("body").hasClass("ingredients__show_overlay")) {
      $("body").removeClass("ingredients__show_overlay");
    }
  });
});
/**
 * shopify Theme editor Events
 */

if ($.code.themeEditor) {
  $("body").addClass("theme-editor");
  $(document)
    .on("shopify:section:load", function (e) {
      var $parentSection = $("#shopify-section-" + e.detail.sectionId);
      var blockId = e.detail.blockId; // Re-init featured product

      if ($parentSection.hasClass("product-featured-section")) {
        $('[data-section-type="product"]', $parentSection).product();
      } // Re-init swiper

      if ($parentSection.hasClass("swiper-section")) {
        $("[data-swiper]", $parentSection).swiperLoader();
      } // Re-init tabs

      if ($parentSection.find("[data-tabs]")) {
        $("[data-tabs]", $parentSection).tabs();
      } // Remove overlay class

      if ($("body").hasClass("ingredients__show_overlay")) {
        $("body").removeClass("ingredients__show_overlay");
      }
    })
    .on("shopify:section:reorder", function (e) {})
    .on("shopify:section:unload", function (e) {
      var $parentSection = $("#shopify-section-" + e.detail.sectionId);
      var blockId = e.detail.blockId;
    })
    .on("shopify:section:select", function (e) {
      var $parentSection = $("#shopify-section-" + e.detail.sectionId);
      var blockId = e.detail.blockId; // show newsletter popup

      if ($parentSection.find("[data-newsletter-popup]").length >= 1) {
        $("body").addClass("newsletters-popup-active");
        setTimeout(function () {
          $("body").addClass("newsletters-popup-animate");
        }, 100);
      }
    })
    .on("shopify:block:select", function (e) {
      var $parentSection = $("#shopify-section-" + e.detail.sectionId);
      var blockId = e.detail.blockId; // Edit swiper slide

      if ($parentSection.hasClass("swiper-section")) {
        var $slide = $(e.target);
        $("[data-swiper]", $parentSection).swiperLoader("editSlide", $slide);
      }
    })
    .on("shopify:block:deselect", function (e) {
      var $parentSection = $("#shopify-section-" + e.detail.sectionId);
      var blockId = e.detail.blockId;
    });
}


function toggleSamplePack (cartItems) {
  var $cartFreeSample = document.querySelector('.sidebar-free-sample');
  
  var cart_f_item = '';
  if (cartItems.length >= 1) {
    cart_f_item = cartItems[0];
  }
  if($cartFreeSample) {
    if (cartItems.length == 0) {
      $cartFreeSample.setAttribute('data--hidden', 'true');
    }
    else if (cartItems.length == 1 && cart_f_item.gift_card) {
      $cartFreeSample.setAttribute('data--hidden', 'true');
    }
    else {
      console.log("hererer");
      $cartFreeSample.removeAttribute('data--hidden');
    }
  }
  

}